export const CCI_List = `<?xml version="1.0" encoding="UTF-8"?>
<?xml-stylesheet type='text/xsl' href='cci2html.xsl'?>
<cci_list xmlns="http://iase.disa.mil/cci">
  <metadata>
    <version>2023-06-07</version>
    <publishdate>2023-06-07</publishdate>
  </metadata>
  <cci_items>
    <cci_item id="CCI-000001">
      <status>draft</status>
      <publishdate>2009-05-13</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops an access control policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-1.1 (i and ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000002">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate the organization-level; mission/business process-level; and/or system-level access control policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-1.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-1 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-1 a 1 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000003">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current access control policy for organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-1.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000004">
      <status>draft</status>
      <publishdate>2009-05-13</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops procedures to facilitate the implementation of the access control policy and associated access controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-1.1 (iv  and  v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000005">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate procedures to facilitate the implementation of the organization-level; mission/business process-level; and/or system-level access control policy and associated access controls to the organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-1.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000006">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current access control procedures for organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-1.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000007">
      <status>draft</status>
      <publishdate>2009-05-13</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system accounts by identifying account types (i.e., individual, group, system, application, guest/anonymous, and temporary).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000008">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes conditions for group membership.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000009">
      <status>draft</status>
      <publishdate>2009-05-13</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system accounts by identifying authorized users of the information system and specifying access privileges.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000010">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require approvals by organization-defined personnel or roles for requests to create accounts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 e" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000011">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Create, enable, modify, disable, and remove system accounts in accordance with organization-defined procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 f" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 f" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000012">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review accounts for compliance with account management requirements per organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 j" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 j" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 j" />
      </references>
    </cci_item>
    <cci_item id="CCI-000013">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system accounts by notifying account managers when temporary accounts are no longer required and when information system users are terminated, transferred, or information system usage or need-to-know/need-to-share changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-000014">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system accounts by granting access to the system based on a valid access authorization; intended system usage; and other attributes as required by the organization or associated missions/business functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 i" />
      </references>
    </cci_item>
    <cci_item id="CCI-000015">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Support the management of system accounts using (organization-defined automated mechanisms).</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000016">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Automatically remove or disable temporary and emergency accounts after an organization-defined time-period for each type of account.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000017">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disable accounts when the accounts have been inactive for the organization-defined time-period.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (3) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000018">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Automatically audit account creation actions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (4).1 (i and ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000019">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that users log out in accordance with the organization-defined time-period of expected inactivity or description of when to log out.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (5).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (5) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000020">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system dynamically manages user privileges and associated access authorizations.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000021">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce dual authorization for organization-defined privileged commands and/or other organization-defined actions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-3 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000022">
      <status>draft</status>
      <publishdate>2009-05-13</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system enforces one or more organization-defined nondiscretionary access control policies over an organization-defined set of users and resources.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-3 (3).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-3 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000023">
      <status>draft</status>
      <publishdate>2009-11-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops an organization-wide information security program plan that provides sufficient information about the program management controls and common controls (including specification of parameters for any assignment and selection operations either explicitly or by reference) to enable an implementation that is unambiguously compliant with the intent of the plan, and a determination of the risk to be incurred if the plan is implemented as intended.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-1.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000024">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent access to organization-defined security-relevant information except during secure, non-operable system states.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-3 (5).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-3 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000025">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system enforces information flow control using explicit security attributes on information, source, and destination objects as a basis for flow control decisions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000026">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use protected processing domains to enforce organization-defined information flow control policies as a basis for flow control decisions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000027">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined information flow control policies.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000028">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent encrypted information from bypassing organization-defined flow control mechanisms by employing organization-defined procedures or methods.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000029">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined limitations on embedding data types within other data types.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (5).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000030">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce information flow control based on organization-defined metadata.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000031">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce one-way information flows using hardware-based flow control mechanisms.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (7)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (7).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000032">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce information flow control using organization-defined security policy filters as a basis for flow control decisions for organization-defined information flows.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (8)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (8).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (8) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000033">
      <status>draft</status>
      <publishdate>2009-05-13</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system enforces the use of human review for organization-defined security policy filters when the system is not capable of making an information flow control decision.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (9).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000034">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the capability for privileged administrators to enable and disable organization-defined security or privacy filters under organization-defined conditions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (10)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000035">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the capability for privileged administrators to configure the organization-defined security or privacy policy filters to support different security or privacy policies.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (11)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (11).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (11)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000036">
      <status>draft</status>
      <publishdate>2009-05-19</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization separates organization-defined duties of individuals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-5 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-5.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000037">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements separation of duties through assigned information system access authorizations.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-5.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-5 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000038">
      <status>draft</status>
      <publishdate>2009-05-19</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization explicitly authorizes access to organization-defined security functions and security-relevant information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-6 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000039">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that users of system accounts, or roles, with access to organization-defined security functions or security-relevant information, use non-privileged accounts or roles, when accessing nonsecurity functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-6 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000040">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization audits any use of privileged accounts, or roles, with access to organization-defined security functions or security-relevant information, when accessing other system functions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-6 (2).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000041">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authorize network access to organization-defined privileged commands only for organization-defined compelling operational needs.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-6 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000042">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document the rationale for authorized network access to organization-defined privileged commands in the security plan for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-6 (3).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000043">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the maximum number of consecutive invalid logon attempts to the information system by a user during an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-7 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-7" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-7.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-000044">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce the organization-defined limit of consecutive invalid logon attempts by a user during the organization-defined time period.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-7 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-7 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-7.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000045">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines in the security plan, explicitly or by reference, the time period for lock out mode or delay period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-7.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000046">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization selects either a lock out mode for the organization-defined time period or delays the next login prompt for the organization-defined delay period for information system responses to consecutive invalid access attempts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-7.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000047">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system delays next login prompt according to the organization-defined delay algorithm, when the maximum number of unsuccessful attempts is exceeded, automatically locks the account/node for an organization-defined time period or locks the account/node until released by an Administrator IAW organizational policy.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-7.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000048">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Display an organization-defined system use notification message or banner to users before granting access to the system that provides privacy and security notices consistent with applicable federal laws, Executive Orders, directives, policies, regulations, standards, and guidelines.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-8 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-8 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000049">
      <status>draft</status>
      <publishdate>2009-05-19</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines a system use notification message or banner displayed before granting access to the system that provides privacy and security notices consistent with applicable federal laws, Executive Orders, directives, policies, regulations, standards, and guidance and states that: (i) users are accessing a U.S. Government information system; (ii) system usage may be monitored, recorded, and subject to audit; (iii) unauthorized use of the system is prohibited and subject to criminal and civil penalties; and (iv) use of the system indicates consent to monitoring and recording.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-8.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000050">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Retain the notification message or banner on the screen until users acknowledge the usage conditions and take explicit actions to log on to or further access the system.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-8 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-8 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-8.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000051">
      <status>draft</status>
      <publishdate>2009-05-19</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization approves the information system use notification message before its use.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-8.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000052">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Notify the user, upon successful logon (access) to the system, of the date and time of the last logon (access).</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-9" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-9" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-9.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-000053">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Notify the user, upon successful logon/access, of the number of unsuccessful logon/access attempts since the last successful logon/access.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-9 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-9 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-9 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000054">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Limit the number of concurrent sessions for each organization-defined account and/or account type to an organization-defined number.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-10" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-10" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-10.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-000055">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the maximum number of concurrent sessions to be allowed for each organization-defined account and/or account type.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-10" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-10" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-10.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-000056">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Retain the device lock until the user reestablishes access using established identification and authentication procedures.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-11 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-11 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-11.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-11 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000057">
      <status>draft</status>
      <publishdate>2009-05-19</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system initiates a session lock after the organization-defined time period of inactivity.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-11 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-11 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-11.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-11 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000058">
      <status>draft</status>
      <publishdate>2009-05-19</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system provides the capability for users to directly initiate session lock mechanisms.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-11 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-11" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-11 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000059">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time-period of inactivity after which the system initiates a device lock.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-11 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-11 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-11.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-11 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000060">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conceal, via the device lock, information previously visible on the display with a publicly viewable image.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-11 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-11 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-11 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-11 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000061">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify organization-defined user actions that can be performed on the system without identification or authentication consistent with organizational missions/business functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-14 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-14 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-14.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-14 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000062">
      <status>draft</status>
      <publishdate>2009-05-19</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization permits actions to be performed without identification and authentication only to the extent necessary to accomplish mission/business objectives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-14 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-14 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000063">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines allowed methods of remote access to the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000064">
      <status>draft</status>
      <publishdate>2009-05-19</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes usage restrictions and implementation guidance for each allowed remote access method.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000065">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authorize remote access to the system prior to allowing such connections.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000066">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization enforces requirements for remote connections to the information system.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000067">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ automated mechanisms to monitor remote access methods.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000068">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement cryptographic mechanisms to protect the confidentiality of remote access sessions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000069">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Route all remote accesses through authorized and managed network access control points.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000070">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authorize the execution of privileged commands via remote access only in a format that provides assessable evidence for organization-defined needs.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000071">
      <status>draft</status>
      <publishdate>2009-05-19</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization monitors for unauthorized remote connections to the information system on an organization-defined frequency.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17 (5).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000072">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect information about remote access mechanisms from unauthorized use and disclosure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000073">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide information security program plan that provides an overview of the requirements for the security program and a description of the security program management controls and common controls in place or planned for meeting those requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-1.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000074">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide information security program plan that is approved by a senior official with responsibility and accountability for the risk being incurred to organizational operations (including mission, functions, image, and reputation), organizational assets, individuals, other organizations, and the Nation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-1 a 4" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-1 a 4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-1.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000075">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the organization-wide information security program plan on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-1 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-1.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000076">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the organization-wide information security program plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-1 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-1.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000077">
      <status>draft</status>
      <publishdate>2009-11-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization updates the plan to address organizational changes and problems identified during plan implementation or security control assessments.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-1 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-1.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-1 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000078">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Appoint a Senior Information Security Officer with the mission and resources to coordinate, develop, implement, and maintain an organization-wide information security program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-2.1 (i and ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000079">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that remote sessions for accessing an organization-defined list of security functions and security-relevant information employ organization-defined additional security measures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17 (7).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000080">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the resources needed to implement the information security programs in capital planning and investment requests and document all exceptions to this requirement.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-3 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-3 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-3.1 (i and ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000081">
      <status>draft</status>
      <publishdate>2009-11-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs a business case/Exhibit 300/Exhibit 53 to record the resources required.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-3 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-3.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000082">
      <status>draft</status>
      <publishdate>2009-05-19</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes usage restrictions for organization-controlled mobile devices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-19 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000083">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish implementation guidance for organization-controlled mobile devices, to include when such devices are outside of controlled areas.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-19 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-19 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000084">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authorize connection of mobile devices to organizational systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-19 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-19 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000085">
      <status>draft</status>
      <publishdate>2009-05-19</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization monitors for unauthorized connections of mobile devices to organizational information systems.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000086">
      <status>draft</status>
      <publishdate>2009-05-19</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization enforces requirements for the connection of mobile devices to organizational information systems.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000087">
      <status>draft</status>
      <publishdate>2009-05-19</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization disables information system functionality that provides the capability for automatic execution of code on mobile devices without user direction.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000088">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization issues specially configured mobile devices to individuals traveling to locations that the organization deems to be of significant risk in accordance with organizational policies and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-000089">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization applies organization-defined inspection and preventative measures to mobile devices returning from locations that the organization deems to be of significant risk in accordance with organizational policies and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19.1 (viii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-000090">
      <status>draft</status>
      <publishdate>2009-05-19</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization restricts the use of writable, removable media in organizational information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000091">
      <status>draft</status>
      <publishdate>2009-05-19</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prohibits the use of personally-owned, removable media in organizational information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000092">
      <status>draft</status>
      <publishdate>2009-05-19</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prohibits the use of removable media in organizational information systems when the media has no identifiable owner.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000093">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish organization-defined terms and conditions, and/or identify organization-defined controls asserted to be implemented on external systems, consistent with the trust relationships established with other organizations owning, operating, and/or maintaining external systems, allowing authorized individuals to access the system from the external systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-20 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-20 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-20.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-20 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000094">
      <status>draft</status>
      <publishdate>2009-05-19</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes terms and conditions, consistent with any trust relationships established with other organizations owning, operating, and/or maintaining external information systems, allowing authorized individuals to process organization-controlled information using the external information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-20.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-20 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000095">
      <status>draft</status>
      <publishdate>2009-05-19</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prohibits authorized individuals from using an external information system to access the information system except in situations where the organization can verify the implementation of required security controls on the external system as specified in the organization's information security policy and security plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-20 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-20 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000096">
      <status>draft</status>
      <publishdate>2009-05-19</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prohibits authorized individuals from using an external information system to access the information system or to process, store, or transmit organization-controlled information except in situations where the organization has approved information system connection or processing agreements with the organizational entity hosting the external information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-20 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-20 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000097">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Restrict the use of organization-controlled portable storage devices by authorized individuals on external systems using organization-defined restrictions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-20 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-20 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-20 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-20 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000098">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enable authorized users to determine whether access authorizations assigned to the sharing partner match the information's access and use restrictions for organization-defined information sharing circumstances where user discretion is required.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-21 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-21 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-21.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-21 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000099">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined automated mechanisms to enforce information-sharing decisions by authorized users based on access authorizations of sharing partners and access restrictions on information to be shared.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-21 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-21 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-21 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-21 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000100">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization level, mission/business process-level, or system-level awareness and training policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-1.1 (i and ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000101">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization level, mission/business process-level, or system-level awareness and training policy to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-1.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-1 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-1 a 1 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000102">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current security awareness and training policy in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-1.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-1 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-000103">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document procedures to facilitate the implementation of the awareness and training policy and associated awareness and training controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-1.1 (iv and v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000104">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate organization-level; mission/business process-level; or system-level awareness and training procedures to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-1.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000105">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current security awareness and training procedures in accordance with an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-1.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000106">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide basic security literacy training to system users (including managers, senior executives, and contractors) as part of initial training for new users.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-2 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000107">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide practical exercises in literacy training that simulate events and incidents.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-2 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-2 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000108">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide role-based security training to personnel with organization-defined roles and responsibilities before authorizing access to the system, information, or performing assigned duties.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-3 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-3.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-000109">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide role-based security training to personnel with organization-defined roles and responsibilities when required by system changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-3 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-3.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000110">
      <status>draft</status>
      <publishdate>2009-05-20</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides refresher role-based security training to personnel with assigned security roles and responsibilities in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-3 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-3.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000111">
      <status>draft</status>
      <publishdate>2009-05-20</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines a frequency for providing refresher role-based security training.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-3 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-3.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000112">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide basic security awareness training to system users (including managers, senior executives, and contractors) when required by system changes or following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-2 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000113">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document individual security training activities, including security awareness training and specific system security training.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-4 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-4 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000114">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor individual information security training activities, including security awareness training and specific security training.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-4 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-4 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000115">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes contact with selected groups and associations within the security community to facilitate ongoing security education and training; to stay up to date with the latest recommended security practices, techniques, and technologies; and to share current security-related information including threats, vulnerabilities, and incidents.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-5.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-000116">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization institutionalizes contact with selected groups and associations within the security community to facilitate ongoing security education and training; to stay up to date with the latest recommended security practices, techniques, and technologies; and to share current security-related information including threats, vulnerabilities, and incidents.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-5.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-000117">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level audit and accountability policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-1.1 (I  and  ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-1 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 a 1 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000118">
      <status>draft</status>
      <publishdate>2009-05-20</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization disseminates a formal, documented, audit and accountability policy to elements within the organization having associated audit and accountability roles and responsibilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-1.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000119">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current audit and accountability policy on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-1.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000120">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document procedures to facilitate the implementation of the audit and accountability policy and associated audit and accountability controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-1.1 (iv and v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000121">
      <status>draft</status>
      <publishdate>2009-05-20</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization disseminates formal, documented, procedures to elements within the organization having associated audit and accountability roles and responsibilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-1.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000122">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current audit and accountability procedures on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-1.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000123">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify the organization-defined event types that the system is capable of logging in support of the audit function.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-2 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000124">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Coordinate the event logging function with other organizational entities requiring audit-related information to guide and inform the selection criteria for events to be logged.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-2 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-2.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000125">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide a rationale for why the event types selected for logging are deemed to be adequate for support after-the-fact investigations of incidents.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-2 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-2.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000126">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Specify the organization-defined event types (subset of the event types defined in AU-2a) along with the frequency of (or situation requiring logging for each identified event type.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-2 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-2.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000127">
      <status>draft</status>
      <publishdate>2009-05-20</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization reviews and updates the list of organization-defined audited events on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-2 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000128">
      <status>draft</status>
      <publishdate>2009-05-20</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization includes execution of privileged functions in the list of events to be audited by the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-2 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000129">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines in the auditable events that the information system must be capable of auditing based on a risk assessment and mission/business needs.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000130">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that audit records containing information that establishes what type of event occurred.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-3 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-3.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000131">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that audit records containing information that establishes when the event occurred.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-3 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-3.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000132">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that audit records containing information that establishes where the event occurred.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-3 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-3.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000133">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that audit records containing information that establishes the source of the event.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-3 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-3.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000134">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that audit records containing information that establishes the outcome of the event.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-3 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-3.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000135">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Generate audit records containing the organization-defined additional information that is to be included in the audit records.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-3 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000136">
      <status>draft</status>
      <publishdate>2009-05-20</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization centrally manages the content of audit records generated by organization-defined information system components.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-3 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000137">
      <status>draft</status>
      <publishdate>2009-05-20</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization allocates audit record storage capacity.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-000138">
      <status>draft</status>
      <publishdate>2009-05-20</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization configures auditing to reduce the likelihood of storage capacity being exceeded.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-4.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-000139">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Alert organization-defined personnel or roles within an organization-defined time period in the event of an audit logging process failure.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-5 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-5 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000140">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Take organization-defined actions upon audit failure include, shutting down the system, overwriting oldest audit records, and stopping the generation of audit records.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-5 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-5.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000141">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Make available for expenditure, the planned information security resources.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-3 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-3 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-3.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000142">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process to ensure that plans of action and milestones for the information security program and the associated organizational systems are maintained.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-4 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-4 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-000143">
      <status>draft</status>
      <publishdate>2009-05-20</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system provides a warning when allocated audit record storage volume reaches an organization-defined percentage of maximum audit record storage capacity.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-5 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000144">
      <status>draft</status>
      <publishdate>2009-05-20</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system provides a real-time alert when organization-defined audit failure events occur.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-5 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000145">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce configurable network communications traffic volume thresholds reflecting limits on audit log storage capacity by delaying or rejecting network traffic above those organization-defined thresholds.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-5 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-5 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000146">
      <status>draft</status>
      <publishdate>2009-05-20</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the percentage of maximum audit record storage capacity that when exceeded, a warning is provided.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-5 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000147">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the audit logging failure events requiring real-time alerts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-5 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-5 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-5 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000148">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and analyze system audit records on an organization-defined frequency for indications of organization-defined inappropriate or unusual activity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-6 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-6.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000149">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Report any findings to organization-defined personnel or roles for indications of organization-defined inappropriate or unusual activity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-6 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-6.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000150">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization adjusts the level of audit review, analysis, and reporting within the information system when there is a change in risk to organizational operations, organizational assets, individuals, other organizations, or the Nation based on law enforcement information, intelligence information, or other credible sources of information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-6.2" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000151">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for the review and analysis of system audit records for organization-defined inappropriate or unusual activity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-6 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-6.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000152">
      <status>draft</status>
      <publishdate>2009-05-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system integrates audit review, analysis, and reporting processes to support organizational processes for investigation and response to suspicious activities.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-6 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000153">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Analyze and correlate audit records across different repositories to gain organization-wide situational awareness.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-6 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000154">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the capability to centrally review and analyze audit records from multiple components within the system.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-6 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-6 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-6 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000155">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization integrates analysis of audit records with analysis of vulnerability scanning information, performance data, and network monitoring information to further enhance the ability to identify inappropriate or unusual activity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-6 (5).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-6 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000156">
      <status>draft</status>
      <publishdate>2009-05-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system provides an audit reduction capability.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-7.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-000157">
      <status>draft</status>
      <publishdate>2009-05-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system provides a report generation capability.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-7.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-000158">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the capability to process, sort, and search audit records for events of interest based on organization-defined audit fields within audit records.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-7 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-7 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-7 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000159">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use internal system clocks to generate time stamps for audit records.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-8 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-8 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-8.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-000160">
      <status>draft</status>
      <publishdate>2009-05-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system synchronizes internal information system clocks on an organization-defined frequency with an organization-defined authoritative time source.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-8 (1).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-8 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000161">
      <status>draft</status>
      <publishdate>2009-05-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency for the synchronization of internal information system clocks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-8 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-8 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-8 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000162">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect audit information from unauthorized access.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-9" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-9.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-9" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000163">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect audit information from unauthorized modification.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-9" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-9.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-000164">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect audit information from unauthorized deletion.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-9" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-9.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-9" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000165">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Write audit records to hardware-enforced, write-once media.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-9 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-9 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-9 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000166">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide irrefutable evidence that an individual (or process acting on behalf of an individual) falsely denying having performed organization-defined actions to be covered by non-repudiation.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-10" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-10" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-10.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-000167">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Retain audit records for an organization-defined time period to provide support for after-the-fact investigations of incidents and to meet regulatory and organizational information retention requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-11" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-11" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-11.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-11" />
      </references>
    </cci_item>
    <cci_item id="CCI-000168">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period for retention of audit records, which is consistent with its records retention policy, to provide support for after-the-fact investigations of incidents and meet regulatory and organizational information retention requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-11" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-11" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-11.1 (i and ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-11" />
      </references>
    </cci_item>
    <cci_item id="CCI-000169">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide audit record generation capability for the event types the system is capable of auditing as defined in AU-2 a. on organization-defined information system components.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-12 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-12 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-12.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-12 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000170">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process to ensure that plans of action and milestones for the security program and associated organizational systems document the remedial information security actions to adequately respond to risk to organizational operations and assets, individuals, other organizations, and the Nation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-4 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-4 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-4.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-000171">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Allow organization-defined personnel or roles to select the event types that are to be logged by specific components of the system.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-12 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-12 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-12.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-12 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000172">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Generate audit records for the event types defined in AU-2 c that include the audit record content defined in AU-3.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-12 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-12.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-12 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-12 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000173">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the level of tolerance for relationship between time stamps of individual records in the audit trail that will be used for correlation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-12 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-12 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-12 (1).1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000174">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Compile audit records from organization-defined information system components into a system-wide (logical or physical) audit trail that is time-correlated to within an organization-defined level of tolerance for relationship between time stamps of individual records in the audit trail.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-12 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-12 (1).1 (iii and v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-12 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000175">
      <status>draft</status>
      <publishdate>2009-05-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system authenticators for users and devices by verifying, as part of the initial authenticator distribution, the identity of the individual and/or device receiving the authenticator.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000176">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage system authenticators by establishing initial authenticator content for authenticators issued by the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000177">
      <status>draft</status>
      <publishdate>2009-05-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system authenticators for users and devices by establishing and implementing administrative procedures for initial authenticator distribution, for lost/compromised, or damaged authenticators, and for revoking authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000178">
      <status>draft</status>
      <publishdate>2009-05-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system authenticators for users and devices by changing default content of authenticators upon information system installation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000179">
      <status>draft</status>
      <publishdate>2009-05-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system authenticators by establishing minimum lifetime restrictions for authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 f" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-000180">
      <status>draft</status>
      <publishdate>2009-05-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system authenticators by establishing maximum lifetime restrictions for authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 f" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-000181">
      <status>draft</status>
      <publishdate>2009-05-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system authenticators by establishing reuse conditions for authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 f" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-000182">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage system authenticators by changing or refreshing authenticators in accordance with the organization-defined time period by authenticator type or when organization-defined events occur.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 g" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 g" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-000183">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage system authenticators by protecting authenticator content from unauthorized disclosure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 h" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 h" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-000184">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manages system authenticators by requiring individuals to take, and having devices implement, specific security controls to protect authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 i" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 i" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 h" />
      </references>
    </cci_item>
    <cci_item id="CCI-000185">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For public key-based authentication, validate certificates by constructing and verifying a certification path to an accepted trust anchor including checking certificate status information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (2) (b) (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (2) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000186">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For public key-based authentication, enforce authorized access to the corresponding private key.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (2) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (2) (a) (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000187">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For public key-based authentication, map the authenticated identity to the account of the individual or group.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (2) (c)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (2) (a) (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000188">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires that the registration process to receive an organizational-defined type of authenticator be carried out in person before a designated registration authority with authorization by a designated organizational official (e.g., a supervisor).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000189">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated tools to determine if authenticators are sufficiently strong to resist attacks intended to discover or otherwise compromise the authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000190">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires vendors/manufacturers of information system components to provide unique authenticators or change default authenticators prior to delivery.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (5).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000191">
      <status>deprecated</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization enforces password complexity by the number of special characters used.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000192">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system enforces password complexity by the minimum number of upper case characters used.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000193">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system enforces password complexity by the minimum number of lower case characters used.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000194">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system enforces password complexity by the minimum number of numeric characters used.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000195">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system, for password-based authentication, when new passwords are created, enforces that at least an organization-defined number of characters are changed.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000196">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system, for password-based authentication, stores only cryptographically-protected passwords.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (c)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000197">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For password-based authentication, transmit passwords only cryptographically-protected channels.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (c)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (1) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000198">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system enforces minimum password lifetime restrictions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (d)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000199">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system enforces maximum password lifetime restrictions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (d)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000200">
      <status>draft</status>
      <publishdate>2009-05-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system prohibits password reuse for the organization-defined number of generations.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (e)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (e)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000201">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect authenticators commensurate with the security category of the information to which use of the authenticator permits access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000202">
      <status>draft</status>
      <publishdate>2009-05-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures unencrypted static authenticators are not embedded in access scripts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (7)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (7).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000203">
      <status>draft</status>
      <publishdate>2009-05-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures unencrypted static authenticators are not stored on function keys.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (7)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (7).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000204">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security controls required to manage the risk of compromise due to individuals having accounts on multiple information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (8)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (8).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000205">
      <status>draft</status>
      <publishdate>2009-05-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system enforces minimum password length.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000206">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obscure feedback of authentication information during the authentication process to protect the information from possible exploitation and use by unauthorized individuals.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-6" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-6" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-6.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-000207">
      <status>draft</status>
      <publishdate>2009-11-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops and maintains an inventory of its information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-5" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-5.1 (i and ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-000208">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization determines normal time-of-day and duration usage for information system accounts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (5).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000209">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop the results of information security measures of performance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-6" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-6" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-6.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-000210">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor the results of information security measures of performance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-6" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-6" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-6.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-000211">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Report on the results of information security measures of performance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-6" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-6" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-6.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-000212">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an enterprise architecture with consideration for information security and the resulting risk to organizational operations, organizational assets, individuals, other organizations, and the Nation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-7" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-7" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-7.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-000213">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce approved authorizations for logical access to information and system resources in accordance with applicable access control policies.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-3.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000214">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes a Discretionary Access Control (DAC) policy that limits propagation of access rights.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-3 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-3 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000215">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes a Discretionary Access Control (DAC) policy that includes or excludes access to the granularity of a single user.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-3 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-3 (4) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000216">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Address information security issues in the development and documentation of a critical infrastructure and key resources protection plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-8" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-8" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-8.1 (I  and  iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-000217">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a time period after which inactive accounts are automatically disabled.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000218">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system, when transferring information between different security domains, identifies information flows by data type specification and usage.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (12).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000219">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, decompose information into organization-defined policy-relevant subcomponents for submission to policy enforcement mechanisms.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (13)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (13).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (13)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000221">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system enforces security policies regarding information on interconnected systems.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (16).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (16)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000223">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system binds security attributes to information to facilitate information flow policy enforcement.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (17).1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (17) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000224">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system tracks problems associated with the security attribute binding.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (17).1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (17) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000225">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ the principle of least privilege, allowing only authorized accesses for users (or processes acting on behalf of users) which are necessary to accomplish assigned organizational tasks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-6.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-6" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-000226">
      <status>draft</status>
      <publishdate>2009-09-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system provides the capability for a privileged administrator to configure organization-defined security policy filters to support different security policies.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-6 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-6 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000227">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a comprehensive strategy to manage security risk to organizational operations and assets, individuals, other organizations, and the Nation associated with the operation and use of information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-9 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-9 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-9.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-9 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000228">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the risk management strategy consistently across the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-9 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-9 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-9.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000229">
      <status>draft</status>
      <publishdate>2009-11-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents the security state of organizational information systems and the environments in which those systems operate through security authorization processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-10 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-10.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-10 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000230">
      <status>draft</status>
      <publishdate>2009-11-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization tracks the security state of organizational information systems and the environments in which those systems operate through security authorization processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-10 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-10.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-10 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000231">
      <status>draft</status>
      <publishdate>2009-11-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization reports the security state of organizational information systems and the environments in which those systems operate through security authorization processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-10 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-10.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-10 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000232">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document and provide supporting rationale in the security plan for the system, user actions not requiring identification and authentication.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-14 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-14 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-14.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-14 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000233">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate individuals to fulfill specific roles and responsibilities within the organizational risk management process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-10 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-10 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-10.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-10 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000234">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Integrate the authorization processes into an organization-wide risk management program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-10 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-10 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-10.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-10 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000235">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Define organizational mission and business processes with consideration for information security and the resulting risk to organizational operations, organizational assets, individuals, other organizations, and the Nation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-11 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-11 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-11.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-11 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000236">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Determine information protection needs arising from the defined mission and business processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-11 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-11 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-11.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-11 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000237">
      <status>draft</status>
      <publishdate>2009-06-23</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system accounts by specifically authorizing and monitoring the use of guest/anonymous accounts and temporary accounts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-000238">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency to review and update the current assessment, authorization, and monitoring policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-1.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-1" />
      </references>
    </cci_item>
    <cci_item id="CCI-000239">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process; system-level assessment, authorization, and monitoring policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-1.1 (i and ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-1 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 a 1 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000240">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminates to organization-defined personnel or roles an organization-level; mission/business process; system-level assessment, authorization, and monitoring policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-1.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000241">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current assessment, authorization, and monitoring policy on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-1.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-1 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-000242">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document procedures to facilitate the implementation of the assessment, authorization, and monitoring policy and associated assessment, authorization, and monitoring controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-1.1 (iv and v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000243">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate to organization-defined personnel or roles procedures to facilitate the implementation of the assessment, authorization, and monitoring policy and associated assessment, authorization, and monitoring controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-1.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000244">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current assessment, authorization, and monitoring procedures on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-1.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000245">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a security assessment plan for the information system and its environment of operation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000246">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a control assessment plan that describes the scope of the assessment including controls and control enhancements under assessment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 b 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000247">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a control assessment plan that describes the scope of the assessment including assessment procedures to be used to determine control effectiveness.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 b 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000248">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a control assessment plan that describes the scope of the assessment including assessment environment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 b 3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 a 3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000249">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organizations security assessment plan describes the assessment team.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000250">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization's security assessment plan describes assessment roles and responsibilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000251">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Assess the controls in the systems and its environment of operation on an organization-defined frequency, to determine the extent to which the controls are implemented correctly, operating as intended, and producing the desired outcome with respect to meeting the security requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-2.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000252">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency on which the security controls in the system and its environment of operation are assessed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-2.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000253">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Produce a control assessment report that document the results of the assessment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-2.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000254">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the results of the control assessment to organization-defined individuals or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 f" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-2.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000255">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ independent assessors or assessment teams to conduct control assessments.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-2 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-2 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000256">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include as part of the control assessments, announced or unannounced, on an organization-defined frequency, in-depth monitoring; security instrumentation; automated security test cases; vulnerability scanning; malicious user testing; insider threat assessment; performance and load testing; data leakage or data loss assessment; and/or organization-defined other forms of assessment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-2 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000257">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization authorizes connections from the information system to other information systems through the use of Interconnection Security Agreements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-3 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-3.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000258">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document, as part of each exchange agreement, the interface characteristics.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-3 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-3.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-3 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000259">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document, as part of each exchange agreement,, the security requirements, controls and responsibilities for each system, and the impact level of the information communicated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-3 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-3 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-3.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000260">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents, for each interconnection, the nature of the information communicated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-3 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-3.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000261">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization monitors the information system connections on an ongoing basis to verify enforcement of security requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-3.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000262">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prohibits the direct connection of an organization-defined unclassified, national security system to an external network without the use of an organization-defined boundary protection device.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-3 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000263">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prohibits the direct connection of a classified, national security system to an external network without the use of organization-defined boundary protection device.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-3 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000264">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a plan of action and milestones for the system to document the planned remediation actions of the organization to correct weaknesses or deficiencies noted during the assessment of the controls and to reduce or eliminate known vulnerabilities in the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-5 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-5 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-5-1 (i)  and  (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000265">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to update the existing plan of action and milestones for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-5 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-5 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-5-1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000266">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update, on an organization-defined frequency, the existing plan of action and milestones based on the findings from control assessments, independent audits or reviews, and continuous monitoring activities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-5 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-5 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-5-1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000267">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure the accuracy of the plan of action and milestones for the system using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-5 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-5 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-5 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000268">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure the currency of the plan of action and milestones for the system using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-5 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-5 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-5 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000269">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure the availability of the plan of action and milestones for the system using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-5 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-5 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-5 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000270">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Assign a senior official as the authorizing official for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-6 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-6 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-6.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000271">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure the authorizing official for the system authorizes the system to operate before commencing operations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-6 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-6 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-6.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000272">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update the authorization on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-6 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-6 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-6.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-6 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000273">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to update the authorizations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-6 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-6 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-6.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-6 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000274">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a continuous monitoring strategy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-7" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-7.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-7" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-000275">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements a continuous monitoring program that includes a configuration management process for the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-7.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000276">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements a continuous monitoring program that includes a configuration management process for the information system constituent components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-7.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000277">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements a continuous monitoring program that includes a determination of the security impact of changes to the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-7.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000278">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements a continuous monitoring program that includes a determination of the security impact of changes to the environment of operation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-7.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000279">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement ongoing control assessments in accordance with the continuous monitoring strategy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-7 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-7.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-7 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000280">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a continuous monitoring program that includes reporting the security status to organization-defined personnel or roles on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-7 g" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-7.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-7 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-000281">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to report the security status to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-7 g" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-7.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-7 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-000282">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ independent assessors or assessment teams to monitor the controls in the system on an ongoing basis.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-7 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-7 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-7 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000283">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization plans announced or unannounced assessments (in-depth monitoring, malicious user testing, penetration testing, red team exercises, or other organization-defined forms of security assessment), on an organization-defined frequency, to ensure compliance with all vulnerability mitigation procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-7 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000284">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization schedules announced or unannounced assessments (in-depth monitoring, malicious user testing, penetration testing, red team exercises, or other organization-defined forms of security assessment), on an organization-defined frequency, to ensure compliance with all vulnerability mitigation procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-7 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000285">
      <status>draft</status>
      <publishdate>2009-09-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization conducts announced or unannounced assessments (in-depth monitoring, malicious user testing, penetration testing, red team exercises, or other organization-defined forms of security assessment), on an organization-defined frequency, to ensure compliance with all vulnerability mitigation procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-7 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000286">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the configuration management policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-1.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-1" />
      </references>
    </cci_item>
    <cci_item id="CCI-000287">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level configuration management policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-1.1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-1 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 a 1 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000288">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization disseminates formal, documented configuration management policy to elements within the organization having associated configuration management roles and responsibilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-1.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000289">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update, on an organization-defined frequency, the configuration management policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-1.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000290">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document procedures to facilitate the implementation of the organization-level; mission/business process-level; and/or system-level configuration management policy and the associated configuration management controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-1.1 (iv) (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000291">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization disseminates formal, documented procedures to facilitate the implementation of the configuration management policy and associated configuration management controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-1.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000292">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update, on an organization-defined frequency, the procedures to facilitate the implementation of the organization-level; mission/business process-level; and/or system-level configuration management policy and associated configuration management controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-1.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000293">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a current baseline configuration of the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000294">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents a baseline configuration of the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000295">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain, under configuration control, a current baseline configuration of the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000296">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the baseline configuration of the system on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 b 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-000297">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the baseline configuration of the system when required due to organization-defined circumstances.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 b 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000298">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization reviews and updates the baseline configuration of the information system as an integral part of information system component installations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2 (1) (c)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2 (1) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000299">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization reviews and updates the baseline configuration of the information system as an integral part of information system component upgrades.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2 (1) (c)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2 (1) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000300">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain complete configuration of the system using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000301">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain current configuration of the system using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000302">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain accurate configuration of the system using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000303">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain available configuration of the system using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000304">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Retain organization-defined number of previous versions of baseline configurations of the system to support rollback.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000305">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a list of software programs not authorized to execute on the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-7 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000306">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization maintains the list of software programs not authorized to execute on the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-7 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000307">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs an allow-all, deny-by-exception authorization policy to identify software allowed to execute on the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000308">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops the list of software programs authorized to execute on the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-7 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2 (5).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2 (5) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000309">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization maintains the list of software programs authorized to execute on the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-7 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2 (5).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2 (5) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000310">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs a deny-all, permit-by-exception authorization policy to identify software allowed to execute on the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2 (5).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000311">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain a baseline configuration for system development environments that is managed separately from the operational baseline configuration.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000312">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain a baseline configuration for system test environments that is managed separately from the operational baseline configuration.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000313">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Determine and document the types of changes to the system that are configuration-controlled.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000314">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Approve or disapprove configuration-controlled changes to the system, with explicit consideration for security impact analyses.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000315">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents approved configuration-controlled changes to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000316">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Retain records of configuration-controlled changes to the system for an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 e" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000317">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization reviews records of configuration-controlled changes to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000318">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor and review activities associated with configuration-controlled changes to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 f" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-000319">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Coordinate and provides oversight for configuration change control activities through an organization-defined configuration change control element that convenes at the organization-defined frequency, and/or for any organization-defined configuration change conditions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 g" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3.1 (vii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 f" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-000320">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to convene the configuration change control element.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 g" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 g" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-000321">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines configuration change conditions that prompt the configuration change control element to convene.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 g" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 f" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-000322">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use organization-defined automated mechanisms to document proposed changes to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000323">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use organization-defined automated mechanisms to notify organization-defined approval authorities of proposed changes to the system and request change approval.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000324">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use organization-defined automated mechanisms to highlight proposed changes to the system that have not been approved or disapproved by an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (1) (c)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 (1) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (1) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000325">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use organization-defined automated mechanisms to prohibit changes to the system until designated approvals are received.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (1) (d)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 (1) (d)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (1) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000326">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use organization-defined automated mechanisms to document all changes to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (1) (e)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 (1) (e)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (1) (e)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000327">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Tests changes to the system before finalizing the implementation of the changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000328">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Validate changes to the system before finalizing the implementation of the changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000329">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document changes to the system before finalizing the implementation of the changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000330">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement changes to the current system baseline using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000331">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Deploy the updated system baseline across the installed base using organization-defined automated mechanism.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000332">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require an organization-defined security representative to be a member of the organization-defined configuration change control element.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000333">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Analyze changes to the system to determine potential security impacts prior to change implementation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-4" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-4.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-000334">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization analyzes new software in a separate test environment before installation in an operational environment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-4 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000335">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>After system changes, verify that the impacted controls are implemented correctly, meeting the security requirements for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-4 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000336">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>After system changes, verify that the impacted controls are operating as intended, meeting the security requirements for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-4 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000337">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>After system changes, verify that the impacted controls are producing the desired outcome with regard to meeting the security requirements for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-4 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000338">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines physical access restrictions associated with changes to the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-000339">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents physical access restrictions associated with changes to the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-000340">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Approve physical access restrictions associated with changes to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-5" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-000341">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce physical access restrictions associated with changes to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-5" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-000342">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines logical access restrictions associated with changes to the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-000343">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents logical access restrictions associated with changes to the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-000344">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Approve logical access restrictions associated with changes to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-5" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-000345">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce logical access restrictions associated with changes to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-5" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-000346">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms to enforce access restrictions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000347">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms to support auditing of the enforcement actions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000348">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines a frequency with which to conduct reviews of information system changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000349">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization reviews information system changes per organization-defined frequency to determine whether unauthorized changes have occurred.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000350">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization reviews information system changes upon organization-defined circumstances to determine whether unauthorized changes have occurred.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000351">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines critical software programs that the information system will prevent from being installed if such software programs are not signed with a recognized and approved certificate.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000352">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system prevents the installation of organization-defined critical software programs that are not signed with a certificate that is recognized and approved by the organization.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000353">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines system components requiring enforcement of a dual authorization for system changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-5 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000354">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce dual authorization for implementing changes to organization-defined system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-5 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000355">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization limits information system developer/integrator privileges to change hardware components directly within a production environment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (5).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (5) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000356">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization limits information system developer/integrator privileges to change software components directly within a production environment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (5).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (5) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000357">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization limits information system developer/integrator privileges to change firmware components directly within a production environment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (5).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (5) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000358">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization limits information system developer/integrator privileges to change system information directly within a production environment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (5).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (5) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000359">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency to review information system developer/integrator privileges.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (5).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000360">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency to reevaluate information system developer/integrator privileges.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (5).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000361">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization reviews information system developer/integrator privileges per organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (5).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000362">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization reevaluates information system developer/integrator privileges per organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (5).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000363">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines security configuration checklists to be used to establish and document configuration settings for the information system technology products employed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-6 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000364">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes configuration settings for information technology products employed within the information system using organization-defined security configuration checklists.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-6 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000365">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents configuration settings for information technology products employed within the information system using organization-defined security configuration checklists that reflect the most restrictive mode consistent with operational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-6 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000366">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security configuration settings.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-6 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000367">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify any deviations from the established configuration settings for organization-defined system components based on organization-defined operational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-6 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000368">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document any deviations from the established configuration settings for organization-defined system components based on organization-defined operational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-6 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000369">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Approve any deviations from the established configuration settings for organization-defined system components based on organization-defined operational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-6 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000370">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage configuration settings for organization-defined system components using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000371">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Apply configuration settings for organization-defined system components using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000372">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify configuration settings for organization-defined system components using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000373">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines configuration settings for which unauthorized changes are responded to by automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000374">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms to respond to unauthorized changes to organization-defined configuration settings.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000375">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization incorporates detection of unauthorized, security-relevant configuration changes into the organizations incident response capability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000376">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures unauthorized, security-relevant configuration changes detected are monitored.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000377">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures unauthorized, security-relevant configuration changes detected are corrected.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000378">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures unauthorized, security-relevant configuration changes detected are available for historical purposes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000379">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system (including modifications to the baseline configuration) demonstrates conformance to security configuration guidance (i.e., security checklists) prior to being introduced into a production environment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000380">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines prohibited or restricted functions, system ports, protocols, software and/or services for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-7.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-7" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000381">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Configure the system to provide only organization-defined mission essential capabilities.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-7.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-000382">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Configure the system to prohibit or restrict the use of organization-defined prohibited or restricted functions, system ports, protocols, software, and/or services.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-7.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-7" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000383">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency of information system reviews to identify and eliminate unnecessary functions, ports, protocols and/or services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-7 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000384">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review the system per organization-defined frequency to identify unnecessary and nonsecure functions, ports, protocols, software, and services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-7 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-7 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000385">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization reviews the information system per organization-defined frequency to eliminate unnecessary functions, ports, protocols, and/or services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-7 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000386">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms to prevent program execution on the information system in accordance with the organization-defined specifications.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-7 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000387">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines registration requirements for functions, ports, protocols, and services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM- 7(3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-7 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000388">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure compliance with organization-defined registration requirements for functions, ports, protocols, and services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-7 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-7 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000389">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops an inventory of information system components that accurately reflects the current information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000390">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents an inventory of information system components that accurately reflects the current information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000391">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization maintains an inventory of information system components that accurately reflects the current information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000392">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops an inventory of information system components that includes all components within the authorization boundary of the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000393">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents an inventory of information system components that includes all components within the authorization boundary of the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000394">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization maintains an inventory of information system components that is consistent with the authorization boundary of the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000395">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops an inventory of information system components that is at the level of granularity deemed necessary for tracking and reporting.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 a 3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000396">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents an inventory of information system components that is at the level of granularity deemed necessary for tracking and reporting.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 a 3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000397">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization maintains an inventory of information system components that is at the level of granularity deemed necessary for tracking and reporting.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000398">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines information deemed necessary to achieve effective system component accountability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 a 5" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 a 4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000399">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops an inventory of information system components that includes organization-defined information deemed necessary to achieve effective information system component accountability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 a 4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000400">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents an inventory of information system components that includes organization-defined information deemed necessary to achieve effective information system component accountability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 a 4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000401">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization maintains an inventory of information system components that includes organization-defined information deemed necessary to achieve effective property accountability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000402">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops an inventory of information system components that is available for review by designated organizational officials.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000403">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents an inventory of information system components that is available for review by designated organizational officials.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000404">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization maintains an inventory of information system components that is available for review by designated organizational officials.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000405">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops an inventory of information system components that is available for audit by designated organizational officials.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000406">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents an inventory of information system components that is available for audit by designated organizational officials.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000407">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization maintains an inventory of information system components that is available for audit by designated organizational officials.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000408">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update the inventory of system components as part of component installations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000409">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update the inventory of system components as part of component removals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000410">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update the inventory of system components as part of system updates.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000411">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain the currency of the inventory of system components using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000412">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain the completeness of the inventory of system components using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000413">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain the accuracy of the inventory of system components using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000414">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain the availability of the inventory of system components using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000415">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of employing automated mechanisms to detect the presence of unauthorized hardware, software, and firmware components within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000416">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Detect the presence of unauthorized hardware, software, and firmware components within the system using organization-defined automated mechanisms, on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000417">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization disables network access by unauthorized components/devices or notifies designated organizational officials.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8 (3).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000418">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include in the system component inventory information, a means for identifying by name, position, and/or role, individuals responsible and accountable for administering those components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000419">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization verifies that all components within the authorization boundary of the information system are not duplicated in other information system component inventories.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8 (5).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000420">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include assessed component configurations and any approved deviations to current deployed configurations in the system component inventory.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-8 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-8 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000421">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a configuration management plan for the information system that addresses roles, responsibilities, and configuration management processes and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-9 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-9.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-9 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000422">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents a configuration management plan for the information system that addresses roles, responsibilities, and configuration management processes and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-9 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-9.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-9 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000423">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a configuration management plan for the system that addresses roles, responsibilities, and configuration management processes and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-9 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-9 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-9.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-9 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000424">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a configuration management plan for the information system that defines the configuration items for the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-9 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-9.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000425">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents a configuration management plan for the information system that defines the configuration items for the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-9 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-9.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000426">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a configuration management plan for the system that defines the configuration items for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-9 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-9 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-9.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000427">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a configuration management plan for the information system when in the system development life cycle the configuration items are placed under configuration management.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-9.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000428">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents a configuration management plan for the information system when in the system development life cycle the configuration items are placed under configuration management.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-9.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000429">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements a configuration management plan for the information system when in the system development life cycle the configuration items are placed under configuration management.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-9.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000430">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a configuration management plan for the information system that establishes the means for identifying configuration items throughout the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-9.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-9 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000431">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents a configuration management plan for the information system that establishes the means for identifying configuration items throughout the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-9.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-9 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000432">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements a configuration management plan for the information system that establishes the means for identifying configuration items throughout the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-9.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-9 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000433">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a configuration management plan for the information system that establishes a process for managing the configuration of the configuration items.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-9.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-9 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000434">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents a configuration management plan for the information system that establishes a process for managing the configuration of the configuration items.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-9.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-9 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000435">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements a configuration management plan for the information system that establishes a process for managing the configuration of the configuration items.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-9.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-9 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000436">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Assign responsibility for developing the configuration management process to organizational personnel that are not directly involved in system development.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-9 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-9 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-9 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000437">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the current contingency planning policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-1.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-1" />
      </references>
    </cci_item>
    <cci_item id="CCI-000438">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organizational-level; mission/business process-level; and/or system-level contingency planning policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-1.1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-1 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 a 1 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000439">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organizational-level; mission/business process-level; and/or system-level contingency planning policy to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-1.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-1 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 a 1 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000440">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current contingency planning policy in accordance with an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-1.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000441">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document procedures to facilitate the implementation of the contingency planning policy and associated contingency planning controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-1.1 (iv) (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000443">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a contingency plan for the system that identifies essential missions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-000444">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a contingency plan for the system that identifies essential business functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000445">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a contingency plan for the system that identifies associated contingency requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-000446">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a contingency plan for the system that provides recovery objectives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000447">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a contingency plan for the system that provides restoration priorities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000448">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a contingency plan for the system that provides metrics.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000449">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a contingency plan for the system that addresses contingency roles, responsibilities, assigned individuals with contact information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 a 3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000450">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a contingency plan for the information system that addresses maintaining essential missions despite an information system disruption.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 a 4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000451">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a contingency plan for the information system that addresses maintaining essential business functions despite an information system disruption.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 a 4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.1 I)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000452">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a contingency plan for the information system that addresses maintaining essential missions despite an information system compromise.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 a 4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000453">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a contingency plan for the information system that addresses maintaining essential business functions despite an information system compromise.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 a 4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000454">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a contingency plan for the information system that addresses maintaining essential missions despite an information system failure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 a 4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000455">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a contingency plan for the information system that addresses maintaining essential business functions despite an information system failure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 a 4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000456">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a contingency plan for the system that addresses eventual, full information system restoration without deterioration of the controls originally planned and implemented.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 a 5" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 a 5" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000457">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a contingency plan for the system that is reviewed and approved by organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 a 6" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 a 7" />
      </references>
    </cci_item>
    <cci_item id="CCI-000458">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the key contingency personnel (identified by name and/or by role) and organizational elements designated to receive copies of the contingency plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000459">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Distributes copies of the contingency plan to an organization-defined list of key contingency personnel (identified by name and/or by role) and organizational elements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000460">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Coordinate contingency planning activities with incident handling activities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000461">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review the contingency plan for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000462">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Reviews the contingency plan for the system in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000463">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Updates the contingency plan to address changes to the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 e" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000464">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Updates the contingency plan to address changes to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 e" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000465">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Updates the contingency plan to address changes to the environment of operation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 e" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000466">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Updates the contingency plan to address problems encountered during contingency plan implementation, execution, or testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 e" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000468">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Communicates contingency plan changes to an organization-defined list of key contingency personnel (identified by name and/or by role) and organizational elements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 f" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2.2 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 f" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-000469">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Coordinate contingency plan development with organizational elements responsible for related plans.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000470">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct capacity planning so that necessary capacity for information processing exists during contingency operations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000471">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct capacity planning so that necessary capacity for telecommunications exists during contingency operations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000472">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct capacity planning so that necessary capacity for environmental support exists during contingency operations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000473">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period for planning the resumption of essential missions as a result of contingency plan activation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000474">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period for planning the resumption of essential business functions as a result of contingency plan activation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000475">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Plan for the resumption of all or essential mission functions within the organization-defined time period of contingency plan activation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000476">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Plan for the resumption of all or essential business functions within the organization-defined time period of contingency plan activation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000477">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the time period for planning the resumption of all missions as a result of contingency plan activation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000478">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the time period for planning the resumption of all business functions as a result of contingency plan activation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000479">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization plans for the resumption of all missions within an organization-defined time period of contingency plan activation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000480">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization plans for the resumption of all business functions within an organization-defined time period of contingency plan activation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000481">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Plan for the continuance of all or essential missions with little or no loss of operational continuity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (5).1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000482">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Plan for the continuance of all or essential business functions with little or no loss of operational continuity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (5).1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000483">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Plan for the transfer of all or essential mission functions to alternate processing and/or storage sites with minimal or no loss of operational continuity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (6).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000484">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Plan for the transfer of all or essential business functions to alternate processing and/or storage sites with minimal or no loss of operational continuity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (6).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000485">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of contingency training to system users.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-3 a 3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-3 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-3.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000486">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide contingency training to system users consistent with assigned roles and responsibilities within an organization-defined time period of assuming a contingency role or responsibility.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-3 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-3 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-3.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000487">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide contingency training to system users consistent with assigned roles and responsibilities in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-3 a 3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-3 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-3.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000488">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Incorporate simulated events into contingency training to facilitate effective response by personnel in crisis situations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-3 (1).1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000489">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ mechanisms used in operations to provide a more thorough and realistic contingency training environment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-3 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000490">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to test the contingency plan for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-4 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-4 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-4.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-000491">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency to exercise the contingency plan for the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-4.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-000492">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines contingency plan tests to be conducted for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-4 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-4 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-000493">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines contingency plan exercises to be conducted for the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-000494">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test the contingency plan for the system in accordance with organization-defined frequency using organization-defined tests to determine the effectiveness of the plan and the organizational readiness to execute the plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-4 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-4 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000495">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization exercises the contingency plan using organization-defined exercises in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000496">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review the contingency plan test results.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-4 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-4 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-4.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000497">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Initiate corrective actions, if needed, after reviewing the contingency plan test results.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-4 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-4 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-4.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000498">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Coordinate contingency plan testing with organizational elements responsible for related plans.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-4 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000499">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization coordinates contingency plan exercises with organizational elements responsible for related plans.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-4 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000500">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test the contingency plan at the alternate processing site to familiarize contingency personnel with the facility and available resources.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-4 (2) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-4 (2) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-4 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000501">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization exercises the contingency plan at the alternate processing site to familiarize contingency personnel with the facility and available resources and to evaluate the site's capabilities to support contingency operations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-4 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000502">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test the contingency plan using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-4 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-4 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-4 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000503">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms to more thoroughly and effectively exercise the contingency plan by providing more complete coverage of contingency issues, selecting more realistic exercise scenarios and environments, and more effectively stressing the information and supported missions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-4 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000504">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include a full recovery and reconstitution of the system to a known state as part of contingency plan testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-4 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-4 (4)4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-4 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-4 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000505">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish an alternate storage site, including necessary agreements to permit the storage of system backup information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-6 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-6 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-6.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-000506">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization initiates necessary alternate storage site agreements to permit the storage and recovery of information system backup information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-6.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-000507">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify an alternate storage site that is sufficiently separated from the primary storage site to reduce susceptibility to the same threats.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-6 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000508">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Configure the alternate storage site to facilitate recovery operations in accordance with recovery time and recovery point objectives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-6 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000509">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify potential accessibility problems to the alternate storage site in the event of an area-wide disruption or disaster.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-6 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000510">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time-period consistent with recovery time and recovery point objectives for essential missions/business functions to permit the transfer and resumption of organization-defined system operations at an alternate processing site when the primary processing capabilities are unavailable.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-7 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-7.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-7" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000511">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the time period for achieving the recovery time objectives for business functions within which processing must be resumed at the alternate processing site.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-7.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-000512">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes an alternate processing site.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-7.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000513">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish an alternate processing site including necessary agreements to permit the transfer and resumption of organization-defined system operations for essential mission functions within an organization-defined time period consistent with recovery time and recovery point objectives when the primary processing capabilities are unavailable.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-7 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-7.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-7 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000514">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish an alternate processing site including necessary agreements to permit the transfer and resumption of organization-defined system operations for essential business functions within an organization-defined time period consistent with recovery time and recovery point objectives when the primary processing capabilities are unavailable.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-7 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-7 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-7.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000515">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Make available at the alternate processing site, the equipment and supplies required to transfer and resume operations or put contracts in place to support delivery to the site within the organization-defined time period for transfer and resumption.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-7 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-7.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-7 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000516">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify an alternate processing site that is sufficiently separated from the primary processing site to reduce susceptibility to the same threats.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-7 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-7 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-7 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000517">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify potential accessibility problems to the alternate processing site in the event of an area-wide disruption or disaster.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-7 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000518">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop alternate processing site agreements that contain priority-of-service provisions in accordance with availability requirements (including recovery time objectives).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-7 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-7 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-7 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-7 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000519">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prepare the alternate processing site so that the site can serve as the operational site supporting essential missions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-7 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-7 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-7 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-7 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000520">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prepare the alternate processing site so that the site can serve as the operational site supporting essential business functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-7 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-7 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-7 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-7 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000521">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide controls at the alternate processing site that are equivalent to those at the primary site.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-7 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-7 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-7 (5).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-7 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000522">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time-period within which to permit the resumption of organization-defined system operations for essential mission functions when the primary telecommunications capabilities are unavailable at either the primary or alternate processing or storage sites.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-8" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-000523">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time-period within which to permit the resumption of organization-defined system operations for essential business functions when the primary telecommunications capabilities are unavailable at either the primary or alternate processing or storage sites.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-8" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-000524">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish alternate telecommunication services, including necessary agreements to permit the resumption of organization-defined system operations for essential mission functions within an organization-defined time period when the primary telecommunications capabilities are unavailable at either the primary or alternate processing or storage sites.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-8.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-000525">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish alternate telecommunication services, including necessary agreements to permit the resumption of organization-defined system operations for essential business functions within an organization-defined time period when the primary telecommunications capabilities are unavailable at either the primary or alternate processing or storage sites.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-8.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-8" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-000526">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop primary telecommunications service agreements that contain priority-of-service provisions in accordance with availability requirements (including recovery time objectives).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-8 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-8 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000527">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop alternate telecommunications service agreements that contain priority-of-service provisions in accordance with availability requirements (including recovery time objectives).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-8 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-8 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000528">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requests Telecommunications Service Priority for all telecommunications services used for national security emergency preparedness in the event that the primary telecommunications services are provided by a common carrier.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-8 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-8 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000529">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requests Telecommunications Service Priority for all telecommunications services used for national security emergency preparedness in the event that the alternate telecommunications services are provided by a common carrier.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-8 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-8 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000530">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obtain alternate telecommunications services to reduce the likelihood of sharing a single point of failure with primary telecommunications services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-8 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-8 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000531">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obtain alternate telecommunications services from providers that are separated from primary service providers to reduce susceptibility to the same threats.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-8 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-8 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000532">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require primary telecommunications service providers to have contingency plans.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-8 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-8 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000533">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require alternate telecommunications service providers to have contingency plans.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-8 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-8 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000534">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of conducting user-level information backups to support recovery time objectives and recovery point objectives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-9 (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-9 (6).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-9 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000535">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct backups of user-level information contained in organization-defined system components per organization-defined frequency that is consistent with recovery time and recovery point objectives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-9 (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-9.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-9 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000536">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of conducting system-level information backups to support recovery time objectives and recovery point objectives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-9 (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-9.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-9 (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000537">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct backups of system-level information contained in the system per organization-defined frequency that is consistent with recovery time and recovery point objectives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-9 (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-9.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-9 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000538">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of conducting system documentation backups, including security-related documentation, to support recovery time objectives and recovery point objectives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-9 (c)  " />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-9.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-9 (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000539">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct backups of system documentation, including security-related documentation, per an organization-defined frequency that is consistent with recovery time and recovery point objectives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-9 (c)  " />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-9.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-9 (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000540">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects the confidentiality, integrity, and availability of backup information at storage locations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-9 (d)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-9.2" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-9 (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000541">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to test backup information to verify media reliability and information integrity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-9 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-9 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-9 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000542">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test backup information per an organization-defined frequency to verify media reliability and information integrity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-9 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-9 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000543">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use a sample of backup information in the restoration of selected system functions as part of contingency plan testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-9 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000544">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization stores backup copies of the operating system in a separate facility or in a fire-rated container that is not colocated with the operational system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-9 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000545">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization stores backup copies of critical information system software in a separate facility or in a fire-rated container that is not colocated with the operational system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-9 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000546">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization stores backup copies of the information system inventory (including hardware, software, and firmware components) in a separate facility or in a fire-rated container that is not colocated with the operational system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-9 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000547">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time-period and transfer rate of the system backup information to the alternate storage site consistent with the recovery time and recovery point objectives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-9 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-9 (5).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-9 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000548">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Transfer system backup information to the alternate storage site in accordance with the organization-defined time period and transfer rate consistent with the recovery time and recovery point objectives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-9 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-9 (5).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-9 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000549">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain a redundant secondary system that is not collocated with the primary system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-9 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-9 (6).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-9 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000550">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides for the recovery and reconstitution of the information system to a known state after a disruption.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-10" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-10.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-000551">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides for the recovery and reconstitution of the information system to a known state after a compromise.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-10" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-10.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-000552">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides for the recovery and reconstitution of the information system to a known state after a failure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-10" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-10.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-000553">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement transaction recovery for systems that are transaction-based.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-10 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-10 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-10 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-10 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000554">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines in the security plan, explicitly or by reference, the circumstances that can inhibit recovery and reconstitution of the information system to a known state.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-10 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-10 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000555">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides compensating security controls for organization-defined circumstances that can inhibit recovery and reconstitution of the information system to a known state.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-10 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-10 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000556">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines restoration time periods within which to restore system components from configuration-controlled and integrity-protected information representing a known, operational state for the components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-10 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-10 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-10 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-10 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000557">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the capability to restore information system components within organization-defined restoration time periods from configuration-controlled and integrity-protected information representing a known, operational state for the components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-10 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-10 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-10 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-10 (4).1" />
      </references>
    </cci_item>
    <cci_item id="CCI-000558">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the real-time or near-real-time failover capability to be provided for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-13 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-13 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-10 (5).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-10 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000559">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide real-time or near-real-time organization-defined failover capability for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-13 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-13 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-10 (5).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-10 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000560">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects backup and restoration hardware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-10 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-10 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-10 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000561">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects backup and restoration firmware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-10 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-10 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-10 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000562">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects backup and restoration software.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-10 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-10 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-10 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000563">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and or system-level planning policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-1.1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000564">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-level; mission/business process-level; and or system-level planning policy to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-1.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-1 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-1 a 1 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000565">
      <status>deprecated</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization reviews/updates, per organization-defined frequency, a formal, documented security planning policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-1.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000566">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document procedures to facilitate the implementation of the planning policy and associated planning controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-1.1 (iv) (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000567">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminates planning procedures to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-1.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000568">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current planning procedures in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-1.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000570">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a security plan for the information system that is consistent with the organization's enterprise architecture; explicitly defines the authorization boundary for the system; describes the operational context of the information system in terms of mission and business processes; provides the security category and impact level of the information system, including supporting rationale; describes the operational environment for the information system; describes relationships with, or connections to, other information systems; provides an overview of the security requirements for the system; and describes the security controls in place or planned for meeting those requirements, including a rationale for the tailoring and supplemental decisions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000571">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security and privacy plans for the system that are reviewed and approved by the authorizing official or designated representative prior to plan implementation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 a 15" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 a 9" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000572">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for reviewing the plans for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000573">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review the plans in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000574">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update the plans to address changes to the system and environment of operation or problems identified during plan implementation or control assessments.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000576">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a security Concept of Operations (CONOPS) for the information system containing, at a minimum: the purpose of the system; a description of the system architecture; the security authorization schedule; and the security categorization and associated factors considered in determining the categorization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2 (1).1 (i) (ii) (iii) (iv) (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000577">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the CONOPS.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-7 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-7 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2 (1).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000578">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the CONOPS in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-7 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-7 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2 (1).1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000580">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a functional architecture for the information system that identifies and maintains external interfaces.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000581">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a functional architecture for the information system that identifies and maintains the information being exchanged across the interfaces.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000582">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a functional architecture for the information system that identifies and maintains the protection mechanisms associated with each interface.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000583">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a functional architecture for the information system that identifies and maintains user roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000584">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a functional architecture for the information system that identifies and maintains the access privileges assigned to each role.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000585">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a functional architecture for the information system that identifies and maintains unique security requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 (2) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000586">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a functional architecture for the information system that identifies and maintains types of information processed by the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 (2) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000587">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a functional architecture for the information system that identifies and maintains types of information stored by the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 (2) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000588">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a functional architecture for the information system that identifies and maintains types of information transmitted by the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 (2) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000589">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a functional architecture for the information system that identifies and maintains any specific protection needs in accordance with applicable federal laws, Executive Orders, directives, policies, regulations, standards, and guidance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 (2) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000590">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a functional architecture for the information system that identifies and maintains restoration priority of information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 (2) (e)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000591">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a functional architecture for the information system that identifies and maintains restoration priority of information system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-2 (2) (e)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000592">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish the rules that describe their responsibilities and expected behavior, for information and system usage, for individuals requiring access to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-4 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-4 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000593">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Receive a documented acknowledgement from such individuals, indicating that they have read, understand, and agree to abide by the rules of behavior, before authorizing access to information and the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-4 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-4 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000594">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include in the rules of behavior, restrictions on the use of social media, social networking sites, and external sites/applications.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-4 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-4 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000595">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include in the rules of behavior, restrictions on posting organizational information on public websites.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-4 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-4 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000596">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization includes in the rules of behavior, explicit restrictions on sharing information system account information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-4 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000597">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization conducts a privacy impact assessment on the information system in accordance with OMB policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-5.1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-000598">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization plans and coordinates security-related activities affecting the information system before conducting such activities in order to reduce the impact on organizational operations (i.e., mission, functions, image, and reputation).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-6.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-000599">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization plans and coordinates security-related activities affecting the information system before conducting such activities in order to reduce the impact on organizational assets.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-6.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-000600">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization plans and coordinates security-related activities affecting the information system before conducting such activities in order to reduce the impact on organizational individuals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-6.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-000601">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the current system and services acquisition policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-1.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-1" />
      </references>
    </cci_item>
    <cci_item id="CCI-000602">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level system and services acquisition policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-1.1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000603">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate to organization-defined personnel or roles an organization-level; mission/business process-level; and/or system-level system and services acquisition policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-1.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000604">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current system and services acquisition policy in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-1.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000605">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document procedures to facilitate the implementation of the system and services acquisition policy and associated system and services acquisition controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-1.1 (iv) (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000606">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate to organization-defined personnel or roles procedures to facilitate the implementation of the system and services acquisition policy and associated system and services acquisition controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-1.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000607">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current system and services acquisition procedures in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-1.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000608">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization includes a determination of information security requirements for the information system in mission process planning.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000609">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization includes a determination of information security requirements for the information system in business process planning.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000610">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Determine the resources required to protect the system or system service as part of the organizational capital planning and investment control process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-2 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000611">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document the resources required to protect the system or system service as part of the organizational capital planning and investment control process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-2 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000612">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Allocate the resources required to protect the system or system service as part of the organizational capital planning and investment control process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-2 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000613">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish a discrete line item for information security in organizational programming documentation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-2 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-2.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000614">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish a discrete line item for information security in organizational budgeting documentation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-2 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-2.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000615">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage the system using an organization-defined system development life cycle that incorporates information security considerations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-3 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-3.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000616">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Define and document information system security roles and responsibilities throughout the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-3 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-3.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000617">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents information system security roles and responsibilities throughout the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-3.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000618">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify individuals having information system security roles and responsibilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-3 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-3.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000619">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization includes security functional requirements/specifications, explicitly or by reference, in information system acquisition contracts based on an assessment of risk and in accordance with applicable federal laws, Executive Orders, directives, policies, regulations, and standards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-4.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000620">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization includes security-related documentation requirements, explicitly or by reference, in information system acquisition contracts based on an assessment of risk and in accordance with applicable federal laws, Executive Orders, directives, policies, regulations, and standards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-4.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000621">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization includes developmental and evaluation-related assurance requirements, explicitly or by reference, in information system acquisition contracts based on an assessment of risk and in accordance with applicable federal laws, Executive Orders, directives, policies, regulations, and standards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-4.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-4 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000623">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to provide a description of the functional properties of the controls to be implemented.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-4 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000624">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires in acquisition documents that vendors/contractors provide information describing the design details of the security controls to be employed within the information system, information system components, or information system services (including functional interfaces among control components) in sufficient detail to permit analysis and testing of the controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-4 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000625">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires in acquisition documents that vendors/contractors provide information describing the implementation details of the security controls to be employed within the information system, information system components, or information system services (including functional interfaces among control components) in sufficient detail to permit analysis and testing of the controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-4 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000626">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires software vendors/manufacturers to minimize flawed or malformed software by demonstrating that their software development process employs state-of-the-practice software and security engineering methods.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-4 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000627">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires software vendors/manufacturers to minimize flawed or malformed software by demonstrating that their software development process employs quality control processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-4 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000628">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires software vendors/manufacturers to minimize flawed or malformed software by demonstrating that their software development processes employ validation techniques.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-4 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000629">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures each information system component acquired is explicitly assigned to an information system, and that the owner of the system acknowledges this assignment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-4 (4).1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-4 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000630">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires in acquisition documents, that information system components are delivered in a secure, documented configuration, and that the secure configuration is the default configuration for any software reinstalls or upgrades.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-4 (5).1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-4 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000631">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ only government off-the-shelf or commercial off-the-shelf information assurance and information assurance-enabled information technology products that compose an NSA-approved solution to protect classified information when the networks used to transmit the information are at a lower classification level than the information being transmitted.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (6) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-4 (6).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-4 (6) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (6) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000632">
      <status>deprecated</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs only commercial off-the-shelf (COTS) information assurance (IA) and IA-enabled information technology products that compose an NSA-approved solution to protect classified information when the networks used to transmit the information are at a lower classification level than the information being transmitted.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-4 (6).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-4 (6) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000633">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that government off-the-shelf or commercial-off-the-shelf information assurance and information assurance-enabled information technology products have been evaluated and/or validated by NSA or in accordance with NSA-approved procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (6) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (6) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-4 (6).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-4 (6) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000634">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Limit the use of commercially provided information assurance and information assurance-enabled information technology products to those products that have been successfully evaluated against a National Information Assurance partnership (NIAP)-approved Protection Profile for a specific technology type, if such a profile exists.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (7) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-4 (7).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-4 (7) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (7) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000635">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require, if no NIAP-approved Protection Profile exists for a specific technology type but a commercially provided information technology product relies on cryptographic functionality to enforce its security policy, that the cryptographic module is FIPS-validated or NSA-approved.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (7) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-4 (7).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-4 (7) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (7) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000636">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization obtains administrator documentation for the information system that describes secure configuration, installation, and operation of the information system; effective use and maintenance of the security features/functions; and known vulnerabilities regarding configuration and use of administrative (i.e., privileged) functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000637">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects, as required, administrator documentation for the information system that describes secure configuration, installation, and operation of the information system; effective use and maintenance of the security features/functions; and known vulnerabilities regarding configuration and use of administrative (i.e., privileged) functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000638">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization makes available to authorized personnel administrator documentation for the information system that describes secure configuration, installation, and operation of the information system; effective use and maintenance of the security features/functions; and known vulnerabilities regarding configuration and use of administrative (i.e., privileged) functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000639">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization obtains user documentation for the information system that describes user-accessible security features/functions and how to effectively use those security features/functions; methods for user interaction with the information system, which enables individuals to use the system in a more secure manner; and user responsibilities in maintaining the security of the information and information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000640">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects, as required, user documentation for the information system that describes user-accessible security features/functions and how to effectively use those security features/functions; methods for user interaction with the information system, which enables individuals to use the system in a more secure manner; and user responsibilities in maintaining the security of the information and information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000641">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization makes available to authorized personnel user documentation for the information system that describes user-accessible security features/functions and how to effectively use those security features/functions; methods for user interaction with the information system, which enables individuals to use the system in a more secure manner; and user responsibilities in maintaining the security of the information and information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000642">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document attempts to obtain system, system component, or system service documentation when such documentation is either unavailable or nonexistent.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-5 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-5 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000643">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization obtains vendor/manufacturer documentation that describes the functional properties of the security controls employed within the information system with sufficient detail to permit analysis and testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5 (1).1 (i) SA-5(2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000644">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects, as required, vendor/manufacturer documentation that describes the functional properties of the security controls employed within the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5 (1).1 (i) SA-5(2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000645">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization makes available to authorized personnel vendor/manufacturer documentation that describes the functional properties of the security controls employed within the information system with sufficient detail to permit analysis and testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5 (1).1 SA-5(2).1 SA-5(3).1 SA-5(4).1 (i)s" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000646">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization obtains vendor/manufacturer documentation that describes the security-relevant external interfaces to the information system with sufficient detail to permit analysis and testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5 (1).1 SA-5(2).1 SA-5(3).1 SA-5(4) (ii)s" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000647">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization obtains vendor/manufacturer documentation that describes the high-level design of the information system in terms of subsystems and implementation details of the security controls employed within the system with sufficient detail to permit analysis and testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000648">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects, as required, vendor/manufacturer documentation that describes the high-level design of the information system in terms of subsystems and implementation details of the security controls employed within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000650">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization obtains vendor/manufacturer documentation that describes the low-level design of the information system in terms of modules and implementation details of the security controls employed within the system with sufficient detail to permit analysis and testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000651">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects, as required, vendor/manufacturer documentation that describes the low-level design of the information system in terms of modules and implementation details of the security controls employed within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000653">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization obtains the source code for the information system to permit analysis and testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5 (5).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000654">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects, as required, the source code for the information system to permit analysis and testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5 (5).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000655">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization uses software and associated documentation in accordance with contract agreements and copyright laws.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-6.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000656">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs tracking systems for software and associated documentation protected by quantity licenses to control copying and distribution.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-6.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000657">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization controls the use of peer-to-peer file sharing technology to ensure this capability is not used for the unauthorized distribution, display, performance, or reproduction of copyrighted work.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-6.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-6 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000658">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents the use of peer-to-peer file sharing technology to ensure this capability is not used for the unauthorized distribution, display, performance, or reproduction of copyrighted work.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-6.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-6 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000659">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prohibits the use of binary executable code from sources with limited or no warranty without accompanying source code.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-6 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-6 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000660">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prohibits the use of machine executable code from sources with limited or no warranty without accompanying source code.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-6 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-6 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000661">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides exceptions to the source code requirement only when no alternative solutions are available to support compelling mission/operational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-6 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-6 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000662">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization obtains express written consent of the authorizing official for exceptions to the source code requirement.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-6 (1).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-6 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000663">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization (or information system) enforces explicit rules governing the installation of software by users.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-7.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-000664">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Apply organization-defined systems security and privacy engineering principles in the specification of the system and system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-8" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-8.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-000665">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Apply organization-defined systems security and privacy engineering principles in the design of the system and system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-8" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-000666">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Apply organization-defined systems security and privacy engineering principles in the development of the system and system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-8" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-8.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-000667">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Apply organization-defined systems security and privacy engineering principles in the implementation of the system and system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-8" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-8.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-000668">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Apply organization-defined systems security and privacy engineering principles in the modification of the system and system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-8" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-8.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-000669">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that providers of external system services comply with organizational security requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-9.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-9 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000670">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires that providers of external information system services employ organization-defined security controls in accordance with applicable federal laws, Executive Orders, directives, policies, regulations, standards, and guidance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-9.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-9 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000671">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines government oversight with regard to external information system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-9.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000672">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents government oversight with regard to external information system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-9.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000673">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines user roles and responsibilities with regard to external information system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-9.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000674">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents user roles and responsibilities with regard to external information system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-9.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000675">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization monitors security control compliance by external service providers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-9.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-9 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000676">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization conducts an organizational assessment of risk prior to the acquisition of dedicated information security services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-9 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-9 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000677">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization conducts an organizational assessment of risk prior to the outsourcing of dedicated information security services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-9 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-9 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000678">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the senior organizational official designated to approve acquisition of dedicated information security services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-9 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-9 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000679">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the senior organizational official designated to approve outsourcing of dedicated information security services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-9 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-9 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000680">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures the acquisition of dedicated information security services is approved by an organization-designated senior organizational official.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-9 (1).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-9 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000681">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures the outsourcing of dedicated information security services is approved by an organization-designated senior organizational official.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-9 (1).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-9 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000682">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system developers to perform configuration management during information system design.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000683">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system developers to perform configuration management during information system development.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000684">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system developers to perform configuration management during information system implementation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000685">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system developers to perform configuration management during information system operation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000686">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system integrators to perform configuration management during information system design.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000687">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system integrators to perform configuration management during information system development.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000688">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system integrators to perform configuration management during information system implementation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000689">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system integrators to perform configuration management during information system operation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000690">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system developers to manage and control changes to the information system during design.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000691">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system integrators to manage and control changes to the information system during design.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000692">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to implement only organization-approved changes to the system, component, or service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000693">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system integrators to implement only organization-approved changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000694">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to document approved changes to the system, component, or service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (d)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000695">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system integrators to document approved changes to the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000696">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires that information system developers track security flaws and flaw resolution.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (e)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000697">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system integrators to track security flaws and flaw resolution.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (e)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000698">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to enable integrity verification of software and firmware components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000699">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system integrators to provide an integrity check of software to facilitate organizational verification of software integrity after delivery.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000700">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide an alternate configuration management process using organizational personnel in the absence of a dedicated developer configuration management team.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000701">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides an alternative configuration management process with organizational personnel in the absence of a dedicated integrator configuration management team.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000702">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system developers, in consultation with associated security personnel (including security engineers), to create a security test and evaluation plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-11.1 SA-11(3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000703">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system developers, in consultation with associated security personnel (including security engineers), to implement a security test and evaluation plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-11.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000704">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system integrators, in consultation with associated security personnel (including security engineers), to create a security test and evaluation plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-11.1 SA-11(3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000705">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system integrators, in consultation with associated security personnel (including security engineers), to implement a security test and evaluation plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-11.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000706">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system developers, in consultation with associated security personnel (including security engineers), to implement a verifiable flaw remediation process to correct weaknesses and deficiencies identified during the security testing and evaluation process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-11.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000707">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system integrators, in consultation with associated security personnel (including security engineers), to implement a verifiable flaw remediation process to correct weaknesses and deficiencies identified during the security testing and evaluation process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-11.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000708">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system developers, in consultation with associated security personnel (including security engineers), to document the results of the security testing/evaluation processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-11.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000709">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system developers, in consultation with associated security personnel (including security engineers), to document the results of the security flaw remediation processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-11.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000710">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system integrators, in consultation with associated security personnel (including security engineers), to document the results of the security testing/evaluation processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-11.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000711">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system integrators, in consultation with associated security personnel (including security engineers), to document the results of the security flaw remediation processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-11.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000712">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system developers to employ code analysis tools to examine software for common flaws and document the results of the analysis.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-11 (1).1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000713">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system integrators to employ code analysis tools to examine software for common flaws and document the results of the analysis.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-11 (1).1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000714">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system developers to perform a vulnerability analysis to document vulnerabilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-11 (*2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000715">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system developers to perform a vulnerability analysis to document exploitation potential.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-11 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000716">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system developers to perform a vulnerability analysis to document risk mitigations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-11 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000717">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system integrators to perform a vulnerability analysis to document vulnerabilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-11 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000718">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system integrators to perform a vulnerability analysis to document exploitation potential.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-11 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000719">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system integrators perform a vulnerability analysis to document risk mitigations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-11 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000720">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system developers implement the security test and evaluation plan under the witness of an independent verification and validation agent.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-1 1(3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000721">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires information system integrators to implement the security test and evaluation plan under the witness of an independent verification and validation agent.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-1 1(3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-11 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000722">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the security safeguards to employ to protect against supply chain threats to the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-000723">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects against supply chain threats to the information system, system component, or information system service by employing organization-defined security safeguards as part of a comprehensive, defense-in-breadth information security strategy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-000724">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization purchases all anticipated information system components and spares in the initial acquisition.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000725">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization conducts a due diligence review of suppliers prior to entering into contractual agreements to acquire information system hardware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000726">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization conducts a due diligence review of suppliers prior to entering into contractual agreements to acquire information system software.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000727">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization conducts a due diligence review of suppliers prior to entering into contractual agreements to acquire information system firmware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000728">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization conducts a due diligence review of suppliers prior to entering into contractual agreements to acquire information system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000729">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization uses trusted shipping for information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000730">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization uses trusted shipping for information system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000731">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization uses trusted shipping for information technology products.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000732">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization uses trusted warehousing for information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000733">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization uses trusted warehousing for information system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000734">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization uses trusted warehousing for information technology products.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000735">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs a diverse set of suppliers for information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000736">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs a diverse set of suppliers for information system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000737">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs a diverse set of suppliers for information technology products.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000738">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs a diverse set of suppliers for information system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000739">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs standard configurations for information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (5).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000740">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs standard configurations for information system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (5).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000741">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs standard configurations for information technology products.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (5).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000742">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization minimizes the time between purchase decisions and delivery of information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000743">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization minimizes the time between purchase decisions and delivery of information system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000744">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization minimizes the time between purchase decisions and delivery of information technology products.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000745">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs independent analysis and penetration testing against delivered information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (7).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000746">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs independent analysis and penetration testing against delivered information system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (7).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000747">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs independent analysis and penetration testing against delivered information technology products.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-12 (7).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-12 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000748">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines level of trustworthiness for the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-13.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-13" />
      </references>
    </cci_item>
    <cci_item id="CCI-000749">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires that the information system meets the organization-defined level of trustworthiness.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-13.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-13" />
      </references>
    </cci_item>
    <cci_item id="CCI-000750">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the list of critical information system components that require re-implementation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-14.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-14" />
      </references>
    </cci_item>
    <cci_item id="CCI-000751">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization determines the organization-defined list of critical information system components that require re-implementation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-14" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-14 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000752">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization re-implements organization-defined critical information system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-14.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-14 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000753">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization identifies information system components for which alternative sourcing is not viable.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-14 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-14 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000754">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines measures to be employed to prevent critical security controls for information system components from being compromised.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-14 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-14 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000755">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs organization-defined measures to ensure critical security controls for the information system components are not compromised.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-14 (1).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-14 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000756">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops an identification and authentication policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-1.1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000757">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-level; mission/business process-level; and/or system-level identification and authentication policy to organization-defined personnel.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-1.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000758">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current identification and authentication policy in accordance with the organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-1.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000759">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for reviewing and updating the identification and authentication policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-1.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000760">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops procedures to facilitate the implementation of the identification and authentication policy and associated identification and authentication controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-1.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000761">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization disseminates to organization-defined personnel or roles procedures to facilitate the implementation of the identification and authentication policy and associated identification and authentication controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-1.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000762">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current identification and authentication procedures in accordance with the organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-1.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000763">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for reviewing and updating the identification and authentication procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-1.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000764">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Uniquely identify and authenticate organizational users and associate that unique identification with processes acting on behalf of those users.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-2.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000765">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement multifactor authentication for network access to privileged accounts.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-2 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-2 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000766">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement multifactor authentication for network access to non-privileged accounts.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000767">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system implements multifactor authentication for local access to privileged accounts.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-2 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000768">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system implements multifactor authentication for local access to non-privileged accounts.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-2 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000769">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization allows the use of group authenticators only when used in conjunction with an individual/unique authenticator.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-2 (5).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-2 (5) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000770">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires individuals to be authenticated with an individual authenticator when a group authenticator is employed.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-2 (5).2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-2 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000771">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system uses multifactor authentication for network access to privileged accounts where one of the factors is provided by a device separate from the information system being accessed.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-2 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-2 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000772">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system uses multifactor authentication for network access to non-privileged accounts where one of the factors is provided by a device separate from the information system being accessed.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-2 (7).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-2 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000773">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines replay-resistant authentication mechanisms to be used for network access to privileged accounts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-2 (8).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-2 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000774">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system uses organization-defined replay-resistant authentication mechanisms for network access to privileged accounts.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-2 (8).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-2 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000775">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines replay-resistant authentication mechanisms to be used for network access to non-privileged accounts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-2 (9).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-2 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000776">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system uses organization-defined replay-resistant authentication mechanisms for network access to non-privileged accounts.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-2 (9).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-2 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000777">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines devices and/or types of devices for which identification and authentication is required before establishing a connection.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-3.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000778">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Uniquely identify organization-defined devices and/or types of devices before establishing a local, remote, and/or network connection.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-3.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000779">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system authenticates devices before establishing remote network connections using bidirectional authentication between devices that is cryptographically based.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-3 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000780">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system authenticates devices before establishing wireless network connections using bidirectional authentication between devices that is cryptographically based.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-3 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000781">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system authenticates devices before establishing network connections using bidirectional authentication between devices that is cryptographically based.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-3 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000782">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization standardizes, with regard to dynamic address allocation, Dynamic Host Control Protocol (DHCP) lease information and the time assigned to DHCP-enabled devices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-3 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000783">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Audit lease information when assigned to a device.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-3 (3) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-3 (3) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-3 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000784">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system identifiers for users and devices by receiving authorization from a designated organizational official to assign a user identifier.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000785">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system identifiers for users and devices by receiving authorization from a designated organizational official to assign a device identifier.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000786">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system identifiers for users and devices by selecting an identifier that uniquely identifies an individual.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000787">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system identifiers for users and devices by selecting an identifier that uniquely identifies a device.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000788">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system identifiers for users and devices by assigning the user identifier to the intended party.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-4 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000789">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system identifiers for users and devices by assigning the device identifier to the intended device.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-4 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000790">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines a time period for which the reuse of user identifiers is prohibited.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000791">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines a time period for which the reuse of device identifiers is prohibited.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000792">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system identifiers for users and devices by preventing reuse of user identifiers for an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000793">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system identifiers for users and devices by preventing reuse of device identifiers for an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000794">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines a time period of inactivity after which the identifier is disabled.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-4 e" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-4.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-4 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000795">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system identifiers by disabling the identifier after an organization-defined time period of inactivity.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-4 e" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-4 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000796">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit the use of system account identifiers that are the same as public identifiers for individual accounts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-4 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000797">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires that registration to receive a user ID and password include authorization by a supervisor.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-4 (2) (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000798">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires that registration to receive a user ID and password be done in person before a designated registration authority.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-4 (2) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000799">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires multiple forms of certification of individual identification, such as documentary evidence or a combination of documents and biometrics, be presented to the registration authority.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-4 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-4 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000800">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines characteristics for identifying individual status.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-4 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-4 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-4 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-4 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000801">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage individual identifiers by uniquely identifying each individual as organization-defined characteristics identifying individual status.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-4 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-4 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-4 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-4 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000802">
      <status>draft</status>
      <publishdate>2009-09-17</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system dynamically manages identifiers, attributes, and associated access authorizations.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-4 (5).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-4 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000803">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement mechanisms for authentication to a cryptographic module that meet the requirements of applicable laws, Executive Orders, directives, policies, regulations, standards, and guidance for such authentication.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-7" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-7" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-7.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-000804">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Uniquely identify and authenticate non-organizational users or processes acting on behalf of non-organizational users.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-8" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-8" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-8.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-000805">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level incident response policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-1.1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000806">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-level; mission/business process-level; and/or system-level incident response policy to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-1.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000807">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current incident response policy in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-1.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000808">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the current incident response policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-1.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000809">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document procedures to facilitate the implementation of incident response policy and associated incident response controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-1.1 (iv) (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000810">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate the incident response procedures to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-1.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000811">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current incident response procedures in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-1.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000812">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the current incident response procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-1.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000813">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide incident response training to system users consistent with assigned roles and responsibilities within an organization-defined time period of assuming an incident response role or responsibility.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-2 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-2 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-000814">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide incident response training in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-2 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-2.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-2 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000815">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for incident response training.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-2 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-2.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000816">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Incorporate simulated events into incident response training to facilitate effective response by personnel in crisis situations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-2 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-2 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-2 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000817">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide an incident response training environment using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000818">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test the effectiveness of the incident response capability for the system on an organization-defined frequency using organization-defined tests.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-3.1 (iii) (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000819">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for incident response tests.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-3.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000820">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines tests for incident response.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-3.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000821">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test the incident response capability using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-3 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000822">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement an incident handling capability for incidents that is consistent with the incident response plan and includes preparation, detection and analysis, containment, eradication, and recovery.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000823">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Coordinate incident handling activities with contingency planning activities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-4.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-4 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000824">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization incorporates lessons learned from ongoing incident handling activities into incident response procedures, training, and testing/exercises.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-4 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000825">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Support the incident handling process using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-4 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000826">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include organization-defined types of dynamic reconfiguration for organization-defined system components as part of the incident response capability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-4 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000827">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify organization-defined classes of incidents for which organization-defined actions are to be taken to ensure continuation of organizational mission and business functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-4 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-4 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000828">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify actions to take in response to organization-defined classes of incidents to ensure continuation of organizational missions and business functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-4 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000829">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Correlate incident information and individual incident responses to achieve an organization-wide perspective on incident awareness and response.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-4 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-4 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000830">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines security violations that, if detected, initiate a configurable capability to automatically disable the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-4 (5).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-4 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000831">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a configurable capability to automatically disable the system if organization-defined security violations are detected.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-4 (5).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-4 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000832">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Track and document incidents.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-5" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-5.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-5" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-000833">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms to assist in the tracking of security incidents.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-5 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-5 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000834">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a time period for personnel to report suspected incidents to the organizational incident response capability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-6 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-6 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-6.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000835">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require personnel to report suspected incidents to the organizational incident response capability within the organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-6 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-6 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-6.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000836">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Report incident information to organization-defined authorities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-6 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-6 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-6.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000837">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Report incidents using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-6 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000838">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Report system vulnerabilities associated with reported incidents to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-6 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000839">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide an incident response support resource, integral to the organizational incident response capability, that offers advice and assistance to users of the system for the handling and reporting of incidents.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-7" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-7" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-7.1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-000840">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms to increase the availability of incident response-related information and support.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-7 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-7 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000841">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish a direct, cooperative relationship between its incident response capability and external providers of system protection capability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-7 (2) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-7 (2) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-7 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-7 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000842">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify organizational incident response team members to the external providers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-7 (2) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-7 (2) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-7 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-7 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000843">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops an incident response plan that provides the organization with a roadmap for implementing its incident response capability; describes the structure and organization of the incident response capability; provides a high-level approach for how the incident response capability fits into the overall organization; meets the unique requirements of the organization, which relate to mission, size, structure, and functions; defines reportable incidents; provides metrics for measuring the incident response capability within the organization; and defines the resources and management support needed to effectively maintain and mature an incident response capability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-8.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000844">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an incident response plan that is reviewed and approved by organization-defined personnel or roles on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 a 9" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-8 a 8" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-8.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000845">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines incident response personnel (identified by name and/or by role) and organizational elements to whom copies of the incident response plan are distributed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-8 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-8.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000846">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Distributes copies of the incident response plan to organization-defined incident response personnel (identified by name and/or by role) and organizational elements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-8 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-8.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000847">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency for reviewing the incident response plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-8 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-8.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000848">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization reviews the incident response plan on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-8 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-8.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000849">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update the incident response plan to address system and organizational changes or problems encountered during plan implementation, execution, or testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-8 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-8.2 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-8 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000850">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Communicate incident response plan changes to organization-defined incident response personnel (identified by name and/or by role) and organizational elements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-8 e" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-8.2 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-8 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000851">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the current system maintenance policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-1.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-1" />
      </references>
    </cci_item>
    <cci_item id="CCI-000852">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level maintenance policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-1.1 (i and ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-1 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-1 a 1 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000853">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-level; mission/business process-level; and/or system-level maintenance policy to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-1.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-1 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-000854">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current maintenance policy in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-1.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-1 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-000855">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document procedures to facilitate the implementation of the system maintenance policy and associated system maintenance controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-1.1 (iv and v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000856">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate procedures to facilitate the implementation of the system maintenance policy and associated system maintenance controls to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-1.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-000857">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current maintenance procedures in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-1.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000858">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization schedules, performs, documents, and reviews records of maintenance and repairs on information system components in accordance with manufacturer or vendor specifications and/or organizational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000859">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization approves and monitors all maintenance activities, whether performed on site or remotely and whether the equipment is serviced on site or removed to another location.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-2 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000860">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that organization-defines personnel or roles explicitly approve the removal of the system or system components from organizational facilities for off-site maintenance, repair, or replacement.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-2 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-2.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000861">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Sanitize equipment to remove organization-defined information from associated media prior to removal from organizational facilities for off-site maintenance, repairs or replacement.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-2 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-2.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-2 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000862">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Check all potentially impacted controls to verify that the controls are still functioning properly following maintenance, repair or replacement actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-2 e" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-2.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-2 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000863">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization maintains maintenance records for the information system that include the date and time of maintenance, the name of the individual performing the maintenance, the name of escort, if necessary, a description of the maintenance performed, and a list of equipment removed or replaced (including identification numbers, if applicable).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-2 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-2 (1) (a)(b)(c)(d)(e)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000864">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms to schedule, conduct, and document maintenance and repairs as required.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-2 (2).1(i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000865">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Approve the use of system maintenance tools.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-3 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-3.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000866">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Control the use of system maintenance tools.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-3 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-3.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000867">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor the use of system maintenance tools.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-3 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-3.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000868">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization maintains, on an ongoing basis, information system maintenance tools.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-3.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-000869">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Inspect the maintenance tools used by maintenance personnel for improper or unauthorized modifications.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-3 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000870">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Check media containing diagnostic and test programs for malicious code before the media are used in the system.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-3 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000871">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent the unauthorized removal of maintenance equipment containing organizational information by: (a) verifying that there is no organizational information contained on the equipment; (b) sanitizing or destroying the equipment; (c) retaining the equipment within the facility; or (d) obtaining an exemption from organization-defined personnel or roles explicitly authorizing removal of the equipment from the facility.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-3 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-3 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-3 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000872">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms to restrict the use of maintenance tools to authorized personnel only.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-3 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000873">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Approve nonlocal maintenance and diagnostic activities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000874">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor nonlocal maintenance and diagnostic activities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000875">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization controls non-local maintenance and diagnostic activities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000876">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Allow the use of nonlocal maintenance and diagnostic tools only as consistent with organizational policy and documented in the security plan for the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000877">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ strong authentication in the establishment of nonlocal maintenance and diagnostic sessions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000878">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain records for nonlocal maintenance and diagnostic activities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000879">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization terminates sessions and network connections when nonlocal maintenance is completed.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 e" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000880">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization audits non-local maintenance and diagnostic sessions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000881">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents, in the security plan for the information system, the policies and procedures for the establishment and use of nonlocal maintenance and diagnostic connections.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000882">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that nonlocal maintenance and diagnostic services be performed from a system that implements a security capability comparable to the capability implemented on the system being serviced.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000883">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Remove the component to be serviced from the system prior to nonlocal maintenance or diagnostic services; sanitize the component (for organizational information).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 (3) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 (3) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000884">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect nonlocal maintenance sessions by employing organization-defined authenticators that are replay resistant.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000885">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires that maintenance personnel notify organization-defined personnel when non-local maintenance is planned (i.e., date/time).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4 (5).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 (5) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000886">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to be notified of the date and time of planned nonlocal maintenance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 (5) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4 (5).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 (5) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000887">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the approval of each nonlocal maintenance session by organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 (5) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 (5) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4 (5).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000888">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs cryptographic mechanisms to protect the integrity and confidentiality of non-local maintenance and diagnostic communications.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000889">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs remote disconnect verification at the termination of non-local maintenance and diagnostic sessions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4 (7).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000890">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish a process for maintenance personnel authorization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-5 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-5 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-5.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000891">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain a list of authorized maintenance organizations or personnel.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-5 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-5 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000892">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that personnel performing maintenance on the information system have required access authorizations or designates organizational personnel with required access authorizations and technical competence deemed necessary to supervise information system maintenance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-5.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000893">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement procedures for the use of maintenance personnel that lack appropriate security clearances or are not U.S. citizens.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-5 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-5 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-5 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000894">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Requires maintenance personnel who do not have needed access authorizations, clearances, or formal access approvals to be escorted and supervised during the performance of maintenance and diagnostic activities on the system by approved organizational personnel who are fully cleared, have appropriate access authorizations, and are technically qualified.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-5 (1) (a) (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-5 (1) (a) (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-5 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-5 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000895">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that, prior to initiating maintenance or diagnostic activities by personnel who do not have needed access authorizations, clearances or formal access approvals, all volatile information storage components within the system be sanitized and all nonvolatile storage media be removed or physically disconnected from the system and secured.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-5 (1) (a) (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-5 (1) (a) (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-5 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-5 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000896">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires that in the event an information system component cannot be sanitized, the procedures contained in the security plan for the system be enforced.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-5 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-5 (1) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000897">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that personnel performing maintenance and diagnostic activities on a system processing, storing, or transmitting classified information possess security clearances and formal access approvals for at least the highest classification level and for all compartments of information on the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-5 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-5 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-5 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000898">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that personnel performing maintenance and diagnostic activities on a system processing, storing, or transmitting classified information are U.S. citizens.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-5 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-5 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-5 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000899">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that cleared foreign nationals with appropriate security clearances are used to conduct maintenance and diagnostic activities on classified systems only when the systems are jointly owned and operated by the United States and foreign allied governments, or owned and operated solely by foreign allied governments.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-5 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-5 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-5 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-5 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000900">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that that approvals, consents, and detailed operational conditions regarding the use of foreign nationals to conduct maintenance and diagnostic activities on classified systems are fully documented within Memoranda of Agreements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-5 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-5 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-5 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-5 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000901">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines a list of security-critical information system components and/or key information technology components for which it will obtain maintenance support and/or spare parts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-6.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-000902">
      <status>draft</status>
      <publishdate>2009-09-18</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines a time period for obtaining maintenance support and/or spare parts for security-critical information system components and/or key information technology components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-6.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-000903">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obtain maintenance support and/or spare parts for organization-defined system components within an organization-defined time period of failure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-6" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-6" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-6.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-000904">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level physical and environmental protection policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-1.1 (i and ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000905">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate a physical and environmental protection policy to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-1.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000906">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current physical and environmental protection policy in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-1.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000907">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the physical and environmental protection policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-1.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000908">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document procedures to facilitate the implementation of the physical and environmental protection policy and associated physical and environmental protection controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-1.1 (iv and v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000909">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate physical and environmental protection procedures to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-1.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000910">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current physical and environmental protection procedures in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-1.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000911">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the physical and environmental protection procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-1.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000912">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a list of individuals with authorized access to the facility where the system resides.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-2 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-2 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000913">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Issue authorization credentials for facility access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-2 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-2.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000914">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review the access list detailing authorized facility access by individuals in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-2 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-2.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000915">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review the access list detailing authorized facility access by individuals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-2 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-2.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000916">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authorize physical access to the facility where the system resides based on position or role.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-2 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-2 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-2 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000917">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require two forms of identification from an organization-defined list of acceptable forms of identification for visitor access to the facility where the system resides.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000918">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization restricts physical access to the facility containing an information system that processes classified information to authorized personnel with appropriate clearances and access authorizations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-2 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000919">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization enforces physical access authorizations at organization-defined entry/exit points to the facility where the information system resides.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-3.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000920">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify individual access authorizations before granting access to the facility.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-3.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000921">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization controls ingress/egress to the facility where the information system resides using one or more organization-defined physical access control systems/devices or guards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-3.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000922">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization controls access to areas officially designated as publicly accessible in accordance with the organization's assessment of risk.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-3.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-3 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-000923">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Secure keys, combinations, and other physical access devices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 e" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-3.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-3 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-000924">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Inventory organization-defined physical access devices on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 f" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 f" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-3.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-3 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-000925">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for conducting inventories of organization-defined physical access devices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 f" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 f" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-3.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-3 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-000926">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Change combinations and keys in accordance with organization-defined frequency and/or when keys are lost, combinations are compromised, or when individuals possessing the keys or combinations are transferred or terminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 g" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 g" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-3.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-3 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-000927">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for changing combinations and keys.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 g" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 g" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-3.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-3 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-000928">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce physical access authorizations to the system in addition to the physical access controls for the facility where the system resides at organization-defined physical spaces containing one or more components of the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-3 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000929">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Perform security checks in accordance with organization-defined frequency at the physical boundary of the facility or system for unauthorized exfiltration of information or removal of information system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-3 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000930">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ guards to control every physical access point to the facility where the system resides 24 hours per day, 7 days per week.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-3 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000931">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use lockable physical casings to protect organization-defined system components from unauthorized physical access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-3 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000932">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines system components to be protected from unauthorized physical access using lockable physical casings.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-3 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000933">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined anti-tamper technologies to deter and/or prevent physical tampering or alteration of organization-defined hardware components within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-3 (5).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-3 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000934">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs a penetration testing process that includes unannounced attempts to bypass or circumvent security controls associated with physical access points to the facility on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-3 (6).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-3 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000935">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency of unannounced attempts to be included in a penetration testing process to bypass or circumvent security controls associated with physical access points to the facility.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-3 (6).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-3 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000936">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Controls physical access to organization-defined system distribution and transmission lines within organizational facilities using organization-defined security controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-4" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-4.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-000937">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Control physical access to output from organization-defined output devices to prevent unauthorized individuals from obtaining the output.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-5" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-5" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-5.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-000938">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization monitors physical access to the information system to detect and respond to physical security incidents.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-6.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000939">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review physical access logs in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-6 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-6.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000940">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for reviewing physical access logs.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-6 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-6.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000941">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Coordinate results of reviews and investigations with the organization's incident response capability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-6 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-6.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-6 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000942">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor physical access to the facility where the system resides using physical intrusion alarms and surveillance equipment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-6 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000943">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms to recognize potential intrusions and initiate designated response actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-6 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000944">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization controls physical access to the information system by authenticating visitors before authorizing access to the facility where the information system resides other than areas designated as publicly accessible.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-7.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-000945">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization escorts visitors and monitors visitor activity, when required.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-7 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000946">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires two forms of identification for visitor access to the facility.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-7 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000947">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain visitor access records to the facility where the system resides for an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-8 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-8 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-8.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000948">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review visitor access records in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-8 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-8 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000949">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review the visitor access records for the facility where the system resides.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-8 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-8 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000950">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain and review visitor access records using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-8 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-8 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-8 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-8 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000951">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization maintains a record of all physical access, both visitor and authorized individuals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-8 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000952">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect power equipment and power cabling for the system from damage and destruction.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-9" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-9" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-9.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-000953">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs redundant and parallel power cabling paths.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-9 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000954">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ automatic voltage controls for organization-defined critical system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-9 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-9 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000955">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines critical system components that require automatic voltage controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-9 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-9 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000956">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provides the capability of shutting off power to the organization-defined system or individual system components in emergency situations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-10 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-10 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-10.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-10 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000957">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Place emergency shutoff switches or devices in an organization-defined location by system or system component to facilitate access for authorized personnel.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-10 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-10 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-10.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-10 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000958">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a location for emergency shutoff switches or devices by system or system component.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-10 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-10 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-10.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-10 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000959">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect emergency power shutoff capability from unauthorized activation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-10 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-10 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-10.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-10 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000960">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides a short-term uninterruptible power supply to facilitate an orderly shutdown of the information system in the event of a primary power source loss.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-11.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-11" />
      </references>
    </cci_item>
    <cci_item id="CCI-000961">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide an alternate power supply for the system that is activated manually or automatically and that can maintain minimally required operational capability in the event of an extended loss of the primary power source.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-11 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-11 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-11 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-11 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000962">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides a long-term alternate power supply for the information system that is self-contained and not reliant on external power generation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-11 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-11 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000963">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ and maintains automatic emergency lighting for the information system that activates in the event of a power outage or disruption and that covers emergency exits and evacuation routes within the facility.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-12" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-12.1 (i) (ii)(iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-000964">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides emergency lighting for all areas within the facility supporting essential missions and business functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-12 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000965">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ and maintain fire detection and suppression systems that are supported by an independent energy source.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-13" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-13" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-13.1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-13" />
      </references>
    </cci_item>
    <cci_item id="CCI-000966">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs fire detection devices/systems for the information system that activate automatically and notify the organization and emergency responders in the event of a fire.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-13 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-13 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000967">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs fire suppression devices/systems for the information system that provide automatic notification of any activation to the organization and emergency responders.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-13 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-13 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000968">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ an automatic fire suppression capability for the system when the facility is not staffed on a continuous basis.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-13 (2) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-13 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-13 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-13 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000969">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that the facility undergoes, on an organization-defined frequency, fire marshal inspections and promptly resolves identified deficiencies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-13 (4).1 (ii and iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-13 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000970">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines a frequency for fire marshal inspections.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-13 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-13 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000971">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain temperature; humidity; pressure; radiation; and/or organization-defined environmental control levels within the facility where the system resides at organization-defined acceptable levels.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-14 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-14 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-14.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-14 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000972">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines acceptable temperature, humidity, pressure, radiation, and/or organization-defined environmental control levels to be maintained within the facility where the system resides.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-14 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-14 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-14.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-14 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000973">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor environmental control levels in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-14 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-14 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-14.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-14 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000974">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for monitoring environmental control levels.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-14 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-14 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-14.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-14 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000975">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined automatic environmental controls in the facility to prevent fluctuations potentially harmful to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-14 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-14 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-14 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-14 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000976">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ environmental control monitoring that provides an alarm or notification of changes potentially harmful to personnel or equipment to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-14 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-14 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-14 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-14 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000977">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect the system from damage resulting from water leakage by providing master shutoff or isolation valves that are accessible.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-15" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-15" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-15.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-15" />
      </references>
    </cci_item>
    <cci_item id="CCI-000978">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect the system from damage resulting from water leakage by providing master shutoff or isolation valves that are working properly.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-15" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-15" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-15.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-15" />
      </references>
    </cci_item>
    <cci_item id="CCI-000979">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>Key personnel have knowledge of the master water shutoff or isolation valves.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-15" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-15" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-15.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-15" />
      </references>
    </cci_item>
    <cci_item id="CCI-000980">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs mechanisms that, without the need for manual intervention, protect the information system from water damage in the event of a water leak.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-15 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-15 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000981">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authorize organization-defined types of system components entering and exiting the facility.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-16 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-16" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-16.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-000982">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization monitors organization-defined types of information system components entering and exiting the facility.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-16" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-16.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-000983">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Control organization-defined types of system components entering and exiting the facility.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-16 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-16" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-16.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-000984">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain records of system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-16 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-16" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-16.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-000985">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined controls at alternate work sites.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-17 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-17 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-17.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-17 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000986">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines management, operational, and technical information system security controls to be employed at alternate work sites.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-17.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-17 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000987">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Assess as feasible, the effectiveness of controls at alternate work sites.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-17 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-17 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-17.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-17 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-000988">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide a means for employees to communicate with information security personnel in case of incidents.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-17 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-17 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-17.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-17 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-000989">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Position system components within the facility to minimize potential damage from organization-defined physical and environmental hazards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-18" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-18" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-18.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-18" />
      </references>
    </cci_item>
    <cci_item id="CCI-000990">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization positions information system components within the facility to minimize potential damage from environmental hazards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-18.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-18" />
      </references>
    </cci_item>
    <cci_item id="CCI-000991">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Position system components within the facility to minimize the opportunity for unauthorized access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-18" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-18" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-18.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-18" />
      </references>
    </cci_item>
    <cci_item id="CCI-000992">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization plans the location or site of the facility where the information system resides with regard to physical and environmental hazards, and for existing facilities, considers the physical and environmental hazards in its risk mitigation strategy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-18 (1).1 (i and ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-18 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000993">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect the system from information leakage due to electromagnetic signals emanations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-19" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-19" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-19.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-19" />
      </references>
    </cci_item>
    <cci_item id="CCI-000994">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that information system components, associated data communications, and networks are protected in accordance with national emissions and TEMPEST policies and procedures based on the security category or classification of the information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-19 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-19 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-19 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-000995">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level media protection policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-1.1 (i and ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000996">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminates a media protection policy to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-1.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000997">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current media protection policy in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-1.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000998">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for reviewing and updating the current media protection policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-1.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-000999">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document procedures to facilitate the implementation of the media protection policy and associated media protection controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-1.1 (iv and v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001000">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate to organization-defined personnel or roles procedures to facilitate the implementation of the media protection policy and associated media protection controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-1.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001001">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current media protection procedures in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-1.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001002">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for reviewing and updating the current media protection procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-1.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001003">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Restrict access to organization-defined types of digital and/or non-digital media to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001004">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines types of digital and/or non-digital media for which the organization restricts access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001005">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines personnel or roles from which to restrict access to organization-defined types of digital and/or non-digital media.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001006">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines security measures for restricting access to media.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001007">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Restrict access to media storage areas using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-2 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001008">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Log access attempts and access granted using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-2 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001009">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system uses cryptographic mechanisms to protect and restrict access to information on portable digital media.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-2 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001010">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Marks system media indicating the distribution limitations, handling caveats, and applicable security markings (if any) of the information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-3 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-3 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-3.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001011">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Exempt organization-defined types of system media from marking as long as the media remain within organization-defined controlled areas.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-3 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-3.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-3 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001012">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines types of system media to exempt from marking as long as the media remain within organization-defined controlled areas.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-3 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-3 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-3.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001013">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines controlled areas where organization-defined types of system media are exempt from being marked.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-3 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-3.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-3 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001014">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization physically controls and securely stores organization-defined types of digital and/or non-digital media within organization-defined controlled areas.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-4 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-4.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001015">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines types of digital and/or non-digital media to physically control and securely store within organization-defined controlled areas.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-4 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-4 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001016">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines controlled areas where organization-defined types of digital and/or non-digital media are physically controlled and securely stored.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-4 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-4 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001017">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines security measures for securing media storage.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001018">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects information system media until the media are destroyed or sanitized using approved equipment, techniques, and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-4 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001019">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs cryptographic mechanisms to protect information in storage.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-4 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001020">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects and controls organization-defined types of information system media during transport outside of controlled areas using organization-defined security safeguards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-5 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001021">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines types of system media protected and controlled during transport outside of controlled areas.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-5 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-5 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-5" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001022">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines controls to be used to protect and control organization-defined types of system media during transport outside of controlled areas.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-5 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-5 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-5.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001023">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain accountability for system media during transport outside of controlled areas.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-5 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-5 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-5.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001024">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Restrict the activities associated with the transport of system media to authorized personnel.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-5 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-5 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-5.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-5 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001025">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document activities associated with the transport of system media.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-5 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-5 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-5 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001026">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ an identified custodian during transport of system media outside of controlled areas.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-5 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-5 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-5 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001027">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system implements cryptographic mechanisms to protect the confidentiality and integrity of information stored on digital media during transport outside of controlled areas.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-5 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-5 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-5 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001028">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Sanitize organization-defined system media prior to disposal, release out of organizational control, or release for reuse using organization-defined sanitization techniques and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-6 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-6.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-001029">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization tracks, documents, and verifies media sanitization and disposal actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-6 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001030">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization tests sanitization equipment and procedures in accordance with the organization-defined frequency to verify that the intended sanitization is being achieved.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-6 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001031">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for testing sanitization equipment and procedures to ensure that the intended sanitization is being achieved.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-6 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001032">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Apply nondestructive sanitization techniques to portable storage devices prior to connecting such devices to the information system in accordance with organization-defined circumstances requiring sanitization of portable storage devices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-6 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001033">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines circumstances requiring sanitization of portable storage devices prior to connecting such devices to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-6 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001034">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization sanitizes information system media containing Controlled Unclassified Information (CUI) or other sensitive information in accordance with applicable organizational and/or federal standards and policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-6 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-6 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001035">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization sanitizes information system media containing classified information in accordance with NSA standards and policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-6 (5).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-6 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001036">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization destroys information system media that cannot be sanitized.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-6 (6).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-6 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001037">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; system-level risk assessment policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-1.1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001038">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-level; mission/business process-level; system-level risk assessment policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-1.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001039">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current risk assessment policy in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-1.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001040">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the current risk assessment policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-1.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001041">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document procedures to facilitate the implementation of the risk assessment policy and associated risk assessment controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-1.1 (iv) (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001042">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate risk assessment procedures to facilitate the implementation of the risk assessment policy and associated risk assessment controls to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-1.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001043">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current risk assessment procedures in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-1.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001044">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the current risk assessment procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-1.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001045">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization categorizes information and the information system in accordance with applicable federal laws, Executive Orders, directives, policies, regulations, standards, and guidance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-2 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001046">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document the security categorization results including supporting rationale in the security plan for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-2 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001047">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify the security categorization decision is reviewed and approved by the authorizing official or authorizing official designated representative.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-2 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-2.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001048">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct a risk assessment, including determining the likelihood and magnitude of harm, from the unauthorized access, use, disclosure, disruption, modification, or destruction of the system, the information it processes, stores, or transmits, and any related information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-3 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-3.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001049">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document risk assessment results in the organization-defined document.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-3 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-3.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-3 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001050">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review risk assessment results on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-3 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-3.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-3 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001051">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for reviewing risk assessment results.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-3 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-3.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001052">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update the risk assessment on an organization-defined frequency or when there are significant changes to the system, its environment of operation, or other conditions that may impact the security or privacy state of the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-3 e" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-3" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-3 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-001053">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for updating the risk assessment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-3 e" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-3" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-3 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-001054">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor and scan for vulnerabilities in the system and hosted applications on an organization-defined frequency and/or randomly in accordance with organization-defined process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001055">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for scanning for vulnerabilities in the system and hosted applications, and/or randomly in accordance with organization-defined process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001056">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor and scan for vulnerabilities in the system and hosted applications when new vulnerabilities potentially affecting the system/applications are identified and reported.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001057">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ vulnerability monitoring tools and techniques that facilitate interoperability among tools and automate parts of the vulnerability management process by using standards for: enumerating platforms, software flaws, and improper configurations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 b 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-001058">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Analyze vulnerability scan reports and results from vulnerability monitoring.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001059">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Remediate legitimate vulnerabilities in organization-defined response times in accordance with an organizational assessment risk.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001060">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines response times for remediating legitimate vulnerabilities in accordance with an organization assessment of risk.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001061">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Share information obtained from the vulnerability monitoring process and control assessments with organization-defined personnel or roles to help eliminate similar vulnerabilities in other systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 e" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-001062">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs vulnerability scanning tools that include the capability to readily update the information system vulnerabilities to be scanned.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5  (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001063">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update the system vulnerabilities scanned on an organization-defined frequency, prior to a new scan, and/or when new vulnerabilities are identified and reported.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001064">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for updating the system vulnerabilities scanned.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001065">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs vulnerability scanning procedures that can demonstrate the breadth of coverage (i.e., information system components scanned).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001066">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Determine information about the system that is discoverable.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001067">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement privileged access authorization to organization-identified system components for organization-defined vulnerability scanning activities.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5 (5).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001068">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Compare the results of multiple vulnerability scans using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001069">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms to detect the presence of unauthorized software on organizational information systems and notify designated organizational officials in accordance with the organization-defined frequency.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5 (7).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001070">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines a frequency for employing automated mechanisms to detect the presence of unauthorized software on organizational information systems and notify designated organizational officials.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5 (7).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001071">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review historic audit logs to determine if a vulnerability identified in the organization-defined system has been previously exploited within an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 (8)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5 (8).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001072">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs an independent penetration agent or penetration team to conduct a vulnerability analysis on the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5 (9).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 (9) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001073">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs an independent penetration agent or penetration team to perform penetration testing on the information system based on the vulnerability analysis to determine the exploitability of identified vulnerabilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5 (9).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 (9) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001074">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a system and communications protection policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-1.1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001075">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminates to organization-defined personnel or roles the organization-level; mission/business process-level; and/or system-level system and communications protection policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 a 1  " />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-1.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001076">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current system and communications protection policy in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-1.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001077">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for reviewing and updating the current system and communications protection policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-1.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001078">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops system and communications protection procedures to facilitate the implementation of the system and communications protection policy and associated system and communications protection controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-1.1 (iv) (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001079">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminates to organization-defined personnel or roles the procedures to facilitate the implementation of the system and communications protection policy and associated system and communications protection controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-1.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001080">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current system and communications protection procedures in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-1.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001081">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for reviewing and updating the current system and communications protection procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-1.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001082">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Separate user functionality, including user interface services, from system management functionality.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-2.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001083">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent the presentation of system management functionality at an interface for non-privileged users.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-2 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-2 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-2 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001084">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Isolate security functions from nonsecurity functions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-3.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-001085">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ hardware separation mechanisms to implement security function isolation.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-3 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001086">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Isolate security functions enforcing access and information flow control from both nonsecurity functions and from other security functions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-3 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001087">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements an information system isolation boundary to minimize the number of nonsecurity functions included within the boundary containing security functions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-3 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001088">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements security functions as largely independent modules that avoid unnecessary interactions between modules.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-3 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001089">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement security functions as a layered structure minimizing interactions between layers of the design and avoiding any dependence by lower layers on the functionality or correctness of higher layers.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-3 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-3 (5).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-3 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-3 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001090">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent unauthorized and unintended information transfer via shared system resources.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-4" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-4.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-001091">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system does not share resources that are used to interface with systems operating at different security levels.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-4 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001092">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system protects against or limits the effects of the organization-defined or referenced types of denial of service attacks.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-001093">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the types of denial of service events for protecting against or limiting the effects of the denial-of-service events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-5 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-5" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-5.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-001094">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Restrict the ability of individuals to launch organization-defined denial of service attacks against other systems.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-5 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-5 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-5 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001095">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage capacity, bandwidth, or other redundancy to limit the effects of information flooding types of denial of service attacks.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-5 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-5 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-5 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001096">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system limits the use of resources by priority.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-6.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-001097">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor and control communications at the external managed interfaces to the system and at key managed interfaces within the system.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001098">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Connect to external networks or systems only through managed interfaces consisting of boundary protection devices arranged in accordance with an organizational security architecture.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001099">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization physically allocates publicly accessible information system components to separate subnetworks with separate physical network interfaces.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001100">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system prevents public access into the organization's internal networks except as appropriately mediated by managed interfaces employing boundary protection devices.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001101">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Limit the number of external network connections to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001102">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a managed interface for each external telecommunication service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001103">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish a traffic flow policy for each managed interface for each external telecommunication service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (4).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001104">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs security controls as needed to protect the confidentiality and integrity of the information being transmitted.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (4).1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (4) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001105">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document each exception to the traffic flow policy with a supporting mission or business need and duration of that need.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (4) (d)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (4).1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (4) (d)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (4) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001106">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review exceptions to the traffic flow policy on an organization-defined frequency for each external telecommunication service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (4) (e)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (4).1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (4) (e)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (4) (e)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001107">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for the review of exceptions to the traffic flow policy for each external telecommunication service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (4) (e)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (4) (e)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (4) (e)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001108">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Remove traffic flow policy exceptions that are no longer supported by an explicit mission or business need for each external telecommunication service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (4) (e)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (4).1 (vii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (4) (f)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (4) (e)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001109">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Deny network communications traffic by default and allow network communications traffic by exception at managed interfaces; and/or for organization-defined systems.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (5).1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001110">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prevents the unauthorized release of information outside of the information system boundary or any unauthorized communication through the information system boundary when there is an operational failure of the boundary protection mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (6).1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001111">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system prevents remote devices that have established a non-remote connection with the system from communicating outside of that communications path with resources in external networks.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (7).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001112">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Route organization-defined internal communications traffic to organization-defined external networks through authenticated proxy servers at managed interfaces.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (8)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (8).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001113">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the internal communications traffic to be routed to external networks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (8)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (8).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001114">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the external networks to which organization-defined internal communications traffic should be routed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (8)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (8).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001115">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system, at managed interfaces, denies network traffic and audits internal users (or malicious code) posing a threat to external information systems.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (9).1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001116">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent the unauthorized exfiltration of information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (10)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (10).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (10) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001117">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system checks incoming communications to ensure the communications are coming from an authorized source and routed to an authorized destination.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (11).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001118">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system implements host-based boundary protection mechanisms for servers, workstations, and mobile devices.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (12).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001119">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Isolate organization-defined information security tools, mechanisms, and support components from other internal system components by implementing physically separate subnetworks with managed interfaces to other components of the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (13)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (13)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (13).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001120">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information security tools, mechanisms, and support components to be isolated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (13)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (13).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (13)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001121">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect against unauthorized physical connections at organization-defined managed interfaces.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (14)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (14).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (14)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (14)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001122">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the managed interfaces where boundary protections against unauthorized physical connections are to be implemented.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (14)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (14).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (14)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001123">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Route networked, privileged accesses through a dedicated, managed interface for purposes of access control and auditing.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (15)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (15).1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (15)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (15)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001124">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent discovery of specific system components that represent a managed interface.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (16)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (16)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (16).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (16)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001125">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce adherence to protocol formats.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (17)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (17).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (17)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (17)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001126">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent systems from entering unsecure states in the event of an operational failure of a boundary protection device.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (18)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (18)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (18)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (18)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001127">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system protects the integrity of transmitted information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-8.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-001128">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs cryptographic mechanisms to recognize changes to information during transmission unless otherwise protected by alternative physical measures.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-8 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-8 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001129">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system maintains the integrity of information during aggregation, packaging, and transformation in preparation for transmission.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-8 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001130">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system protects the confidentiality of transmitted information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-9.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-001131">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs cryptographic mechanisms to prevent unauthorized disclosure of information during transmission unless otherwise protected by alternative physical measures.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-9 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001132">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system maintains the confidentiality of information during aggregation, packaging, and transformation in preparation for transmission.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-9 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-9 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001133">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Terminate the network connection associated with a communications session at the end of the session or after an organization-defined time period of inactivity.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-10" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-10" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-10.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-001134">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period of inactivity after which the system terminates a network connection associated with a communications session.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-10" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-10" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-10.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-001135">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide a physically or logically isolated trusted communication path for communication between the user and the trusted components of the system.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-11 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-11" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-11.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-11" />
      </references>
    </cci_item>
    <cci_item id="CCI-001136">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines security functions include information system authentication and reauthentication.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-11.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-11" />
      </references>
    </cci_item>
    <cci_item id="CCI-001137">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes cryptographic keys for required cryptography employed within the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-12.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-001138">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages cryptographic keys for required cryptography employed within the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-12.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-001139">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain availability of information in the event of the loss of cryptographic keys by users.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-12 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001140">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization produces, controls, and distributes symmetric cryptographic keys using NIST-approved or NSA-approved key management technology and processes.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-12 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-12 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001141">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization produces, controls, and distributes symmetric and asymmetric cryptographic keys using NSA-approved key management technology and processes.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-12 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001142">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization produces, controls, and distributes asymmetric cryptographic keys using approved PKI Class 3 certificates or prepositioned keying material.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-12 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-12 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001143">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization produces, controls, and distributes asymmetric cryptographic keys using approved PKI Class 3 or Class 4 certificates and hardware security tokens that protect the user's private key.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-12 (5).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-12 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001144">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system implements required cryptographic protections using cryptographic modules that comply with applicable federal laws, Executive Orders, directives, policies, regulations, standards, and guidance.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-13.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-13" />
      </references>
    </cci_item>
    <cci_item id="CCI-001145">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs, at a minimum, FIPS-validated cryptography to protect unclassified information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-13 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-13 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001146">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs NSA-approved cryptography to protect classified information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC013 (2(.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-13 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001147">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs, at a minimum, FIPS-validated cryptography to protect information when such information must be separated from individuals who have the necessary clearances yet lack the necessary access approvals.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-13 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-13 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001148">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs FIPS-validated or NSA-approved cryptography to implement digital signatures.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-10 (5).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-10 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-13 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-13 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001149">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system protects the integrity and availability of publicly available information and applications.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-14.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-14" />
      </references>
    </cci_item>
    <cci_item id="CCI-001150">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit remote activation of collaborative computing devices and applications, excluding the organization-defined exceptions where remote activation is to be allowed.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-15 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-15 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-15.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-15 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001151">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines exceptions to the prohibition of collaborative computing devices where remote activation is to be allowed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-15 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-15 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-15.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-15 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001152">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide an explicit indication of use to users physically present at collaborative computing devices.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-15 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-15 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-15.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-15 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001153">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide physical or logical disconnect of collaborative computing devices in a manner that supports ease of use.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-15 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-15 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-15 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-15 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001154">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system or supporting environment blocks both inbound and outbound traffic between instant messaging clients that are independently configured by end users and external service providers.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-15 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-15 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001155">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disable or remove collaborative computing devices and applications from organization-defined systems or system components in organization-defined secure work areas.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-15 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-15 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-15 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-15 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001156">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines secure work areas where collaborative computing devices and applications are to be disabled or removed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-15 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-15 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-15 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-15 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001157">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Associate organization-defined security attributes with information exchanged between systems.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-16" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-16" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-16.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-001158">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify the integrity of transmitted security attributes.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-16 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-16 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-16 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-16 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001159">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Issue public key certificates under an organization-defined certificate policy or obtain public key certificates from an approved service provider.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-17 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-17" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-17.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-17" />
      </references>
    </cci_item>
    <cci_item id="CCI-001160">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines acceptable and unacceptable mobile code and mobile code technologies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-18.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-18 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001161">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes usage restrictions for acceptable mobile code and mobile code technologies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-18.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-18 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001162">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes implementation guidance for acceptable mobile code and mobile code technologies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-18.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-18 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001163">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authorize the use of mobile code within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-18.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-18 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001164">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor the use of mobile code within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-18.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-18 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001165">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Control the use of mobile code within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-18.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-18 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001166">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify organization-defined unacceptable mobile code.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-18 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-18 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001167">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that the development of mobile code to be deployed in information systems meets organization-defined mobile code requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-18 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-18 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001168">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines mobile code requirements for the acquisition, development, and use of mobile code.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-18 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-18 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001169">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent the download of organization-defined unacceptable mobile code.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-18 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-18 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001170">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevents the automatic execution of mobile code in organization-defined software applications.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-18 (4).1 (iii) (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-18 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001171">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines software applications in which automatic mobile code execution is to be prohibited.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-18 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-18 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001172">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines actions to be enforced before executing mobile code.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-18 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-18 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001173">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes usage restrictions for Voice over Internet Protocol (VoIP) technologies based on the potential to cause damage to the information system if used maliciously.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-19 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-19.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-19 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001174">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes implementation guidance for Voice over Internet Protocol (VoIP) technologies based on the potential to cause damage to the information system if used maliciously.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-19 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-19.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-19 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001175">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization authorizes the use of VoIP within the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-19 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-19.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-19 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001176">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization monitors the use of VoIP within the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-19 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-19.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-19 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001177">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization controls the use of VoIP within the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-19 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-19.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-19 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001178">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide additional data origin authentication artifacts along with the authoritative name resolution data the system returns in response to external name/address resolution queries.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-20 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-20.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-20" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-20 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001179">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provides the means to indicate the security status of child zones, when operating as part of a distributed, hierarchical namespace.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-20 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-20 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-20 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-20 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001180">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system performs data origin authentication and data integrity verification on the name/address resolution responses the system receives from authoritative sources when requested by client systems.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-21.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-21" />
      </references>
    </cci_item>
    <cci_item id="CCI-001181">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system performs data origin authentication and data integrity verification on all resolution responses received whether or not local client systems explicitly request this service.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-21 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-21 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001182">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure the systems that collectively provide name/address resolution service for an organization are fault-tolerant.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-22" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-22" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-22.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-22" />
      </references>
    </cci_item>
    <cci_item id="CCI-001183">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure the systems that collectively provide name/address resolution service for an organization implement internal/external role separation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-22" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-22" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-22.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-22" />
      </references>
    </cci_item>
    <cci_item id="CCI-001184">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect the authenticity of communications sessions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-23" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-23.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-23" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-23" />
      </references>
    </cci_item>
    <cci_item id="CCI-001185">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Invalidate session identifiers upon user logout or other session termination.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-23 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-23 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-23 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-23 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001186">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system provides a readily observable logout capability whenever authentication is used to gain access to web pages.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-23 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-23 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001187">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system generates a unique session identifier for each session.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-23 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-23 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001188">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Generate a unique session identifier for each session with organization-defined randomness requirements.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-23 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-23 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-23 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-23 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001189">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines randomness requirements for generating unique session identifiers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-23 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-23 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-23 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-23 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001190">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Fail to an organization-defined known-system state for the following failures on the indicated components while preserving organization-defined system state information in failure.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-24" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-24" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-24.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-24" />
      </references>
    </cci_item>
    <cci_item id="CCI-001191">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the known system state the system should fail to in the event of an organization-defined system failure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-24" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-24.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-24" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-24" />
      </references>
    </cci_item>
    <cci_item id="CCI-001192">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines types of system failures for which should fail to an organization-defined known system state.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-24" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-24.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-24" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-24" />
      </references>
    </cci_item>
    <cci_item id="CCI-001193">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines system state information that should be preserved in the event of a system failure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-24" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-24" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-24.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-24" />
      </references>
    </cci_item>
    <cci_item id="CCI-001194">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ minimal functionality and information storage on organization-defined information system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-25" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-25" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-25.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-25" />
      </references>
    </cci_item>
    <cci_item id="CCI-001195">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include components within organizational systems specifically designed to be the target of malicious attacks for detecting, deflecting, and analyzing such attacks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-26" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-26" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-26.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-26" />
      </references>
    </cci_item>
    <cci_item id="CCI-001196">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include system components that proactively seek to identify network-based malicious code or malicious websites.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-35" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-35" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-26 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-26 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001197">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include within organizational systems organization-defined platform-independent applications.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-27" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-27" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-27.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-27" />
      </references>
    </cci_item>
    <cci_item id="CCI-001198">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines applications that are platform independent.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-27" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-27" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-27.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-27" />
      </references>
    </cci_item>
    <cci_item id="CCI-001199">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protects the confidentiality and/or integrity of organization-defined information at rest.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-28" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-28.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-28" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-28" />
      </references>
    </cci_item>
    <cci_item id="CCI-001200">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs cryptographic mechanisms to prevent unauthorized disclosure of information at rest unless otherwise protected by alternative physical measures.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-28 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-28 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001201">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ a diverse set of information technologies for organization-defined system components in the implementation of the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-29" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-29" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-29.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-29" />
      </references>
    </cci_item>
    <cci_item id="CCI-001202">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs virtualization techniques to present information system components as other types of components, or components with differing configurations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-30.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-30" />
      </references>
    </cci_item>
    <cci_item id="CCI-001203">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ virtualization techniques to support the deployment of a diversity of operating systems that are changed on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-29 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-29 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-30 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-30 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001204">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of changes to operating systems and applications to support a diversity of deployments.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-29 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-29 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-30 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-30 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001205">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs randomness in the implementation of the virtualization techniques.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-30 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-30 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001206">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires that information system developers/integrators perform a covert channel analysis to identify those aspects of system communication that are potential avenues for covert storage and timing channels.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-31.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-31" />
      </references>
    </cci_item>
    <cci_item id="CCI-001207">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test a subset of the identified covert channels to determine which channels are exploitable.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-31 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-31 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-31 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-31 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001208">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization partitions the information system into components residing in separate physical domains (or environments) as deemed necessary.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-32.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-32" />
      </references>
    </cci_item>
    <cci_item id="CCI-001209">
      <status>draft</status>
      <publishdate>2009-09-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system protects the integrity of information during the processes of data aggregation, packaging, and transformation in preparation for transmission.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-33.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-33" />
      </references>
    </cci_item>
    <cci_item id="CCI-001210">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For organization-defined system components, load and execute the operating environment from hardware-enforced, read-only media.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-34 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-34 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-34.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-34 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001211">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For organization-defined system components, load and execute organization-defined applications from hardware-enforced, read-only media.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-34 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-34 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-34.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-34 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001212">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines system components on which the operating environment and organization-defined applications are loaded and executed from hardware-enforced, read-only media.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-34" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-34" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-34.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-34" />
      </references>
    </cci_item>
    <cci_item id="CCI-001213">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines applications that will be loaded and executed from hardware-enforced, read-only media.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-34 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-34 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-34.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-34 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001214">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined system components with no writeable storage that is persistent across component restart or power on/off.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-34 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-34 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-34 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-34 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001215">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components to be employed with no writeable storage.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-34 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-34 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-34 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-34 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001216">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect the integrity of information prior to storage on read-only media.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-34 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-34 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-34 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-34 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001217">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system level system and information integrity policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-1.1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001218">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-level; mission/business process-level; and/or system level system and information integrity policy to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-1.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001219">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current system and information integrity policy in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-1.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001220">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document procedures to facilitate the implementation of the organization-level; mission/business process-level; and/or system level system and information integrity policy and associated system integrity controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-1.1 (iv) (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001221">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate to organization-defined personnel or roles procedures to facilitate the implementation of the system and information integrity policy and associated system and information integrity controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-1.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001222">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current system and information integrity procedures in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-1.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001223">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for reviewing and updating the current system and information integrity policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-1.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001224">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for reviewing and updating the current system and information integrity procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-1.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001225">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify system flaws.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001226">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Report system flaws.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001227">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Correct system flaws.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001228">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test software updates related to flaw remediation for effectiveness before installation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001229">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test software updates related to flaw remediation for potential side effects before installation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-2.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001230">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Incorporate flaw remediation into the organizational configuration management process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-2.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001231">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization centrally manages the flaw remediation process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-2 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001232">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization installs software updates automatically.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-2 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001233">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms on an organization-defined frequency to determine the state of information system components with regard to flaw remediation.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-2 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001234">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines a frequency for employing automated mechanisms to determine the state of information system components with regard to flaw remediation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-2 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001235">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Measure the time between flaw identification and flaw remediation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-2 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001236">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines benchmarks for the time taken to apply corrective actions after flaw identification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 (3) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-2 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001237">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated patch management tools to facilitate flaw remediation to organization-defined information system components.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-2 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001238">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines information system components for which automated patch management tools are to be employed to facilitate flaw remediation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-2 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001239">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs malicious code protection mechanisms at information system entry and exit points to detect and eradicate malicious code transported by electronic mail, electronic mail attachments, web accesses, removable media, or other common means or inserted through the exploitation of information system vulnerabilities.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-3.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001240">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization updates malicious code protection mechanisms whenever new releases are available in accordance with organizational configuration management policy and procedures.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-3.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001241">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Configure malicious code protection mechanisms to perform periodic scans of the system on an organization-defined frequency.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 c 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-3.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001242">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization configures malicious code protection mechanisms to perform real-time scans of files from external sources at endpoints as the files are downloaded, opened, or executed in accordance with organizational security policy.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 c 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-3.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001243">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Configure malicious code protection mechanisms to block malicious code; quarantine malicious code; and/or take organization-defined action(s) in response to malicious code detection.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 c 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-3.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-3 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001244">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines one or more actions to perform in response to malicious code detection, such as blocking malicious code, quarantining malicious code, or sending alerts to administrators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 c 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-3.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001245">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Address the receipt of false positives during malicious code detection and eradication, and the resulting potential impact on the availability of the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-3.1 (vii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-3 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001246">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization centrally manages malicious code protection mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-3 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001247">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system automatically updates malicious code protection mechanisms.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-3 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001248">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system prevents non-privileged users from circumventing malicious code protection capabilities.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-3 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001249">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update malicious code protection mechanisms only when directed by a privileged user.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-3 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-3 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001250">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization does not allow users to introduce removable media into the information system.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-3 (5).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-3 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001251">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test malicious code protection mechanisms on an organization-defined frequency by introducing a known benign code into the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 (6) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (6) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-3 (6).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-3 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001252">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization monitors events on the information system in accordance with organization-defined monitoring objectives and detects information system attacks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001253">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the objectives of monitoring for attacks and indicators of potential attacks on the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001254">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization identifies unauthorized use of the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001255">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Invoke internal monitoring capabilities or deploy monitoring devices strategically within the system to collect organization-determined essential information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-001256">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Invoke internal monitoring capabilities or deploy monitoring devices at ad hoc locations within the system to track specific types of transactions of interest to the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001257">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Adjust the level of system monitoring activity when there is a change in increased risk to organizational operations and assets, individuals, other organizations, or the Nation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 e" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-001258">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obtain legal opinion with regard to system monitoring activities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 f" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-001259">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization interconnects and configures individual intrusion detection tools into a systemwide intrusion detection system using common protocols.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001260">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ automated tools to support near real-time analysis of events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001261">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated tools to integrate intrusion detection tools into access control and flow control mechanisms for rapid response to attacks by enabling reconfiguration of these mechanisms in support of attack isolation and elimination.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001262">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system monitors inbound and outbound communications for unusual or unauthorized activities or conditions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001263">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system provides near real-time alerts when any of the organization-defined list of compromise or potential compromise indicators occurs.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (5).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001264">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the indicators of compromise or potential compromise which will result in system alerts being provided to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (5).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001265">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system prevents non-privileged users from circumventing intrusion detection and prevention capabilities.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001266">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Notify an organization-defined incident response personnel (identified by name and/or by role) of detected suspicious events.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (7)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (7).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (7) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001267">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines incident response personnel (identified by name and/or by role) to be notified of detected suspicious events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (7) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (7)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (7).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001268">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the least-disruptive actions to be taken by system to terminate suspicious events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (7)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (7).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (7) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001269">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects information obtained from intrusion monitoring tools from unauthorized access, modification, and deletion.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (8).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001270">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test intrusion monitoring tools at an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (9)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (9).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (9)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001271">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for testing intrusion monitoring tools.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (9)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (9)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (9).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001272">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization makes provisions so encrypted traffic is visible to information system monitoring tools.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (10).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001273">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Analyze outbound communications traffic at the external interfaces to the system to discover anomalies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (11)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (11).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (11)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001274">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Alert organization-defined personnel or roles using organization-defined automated mechanisms when inappropriate or unusual activities with security or privacy implications.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (12)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (12).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (12)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001275">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the activities which will trigger alerts to security personnel of inappropriate or unusual activities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (12)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (12)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (12).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001276">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Analyze communications traffic and event patterns for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (13) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (13).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (13) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (13) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001277">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop profiles representing common traffic and event patterns.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (13) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (13).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (13) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (13) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001278">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization uses the traffic/event profiles in tuning system monitoring devices to reduce the number of false positives to an organization-defined measure of false positives and the number of false negatives to an organization-defined measure of false negatives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (13).1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (13) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001279">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the respective measurements to which the organization must tune system monitoring devices to reduce the number of false positives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (13).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (13) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001280">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the respective measurements to which the organization must tune system monitoring devices to reduce the number of false negatives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (13).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (13) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001281">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs a wireless intrusion detection system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (14).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (14)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001282">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ an intrusion detection system to monitor wireless communications traffic as the traffic passes from wireless to wireline networks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (15)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (15).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (15)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (15)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001283">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Correlate information from monitoring tools employed throughout the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (16)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (16).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (16)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (16)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001284">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Correlate information from monitoring physical, cyber, and supply chain activities to achieve integrated, organization-wide situational awareness.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (17)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (17).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (17)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (17)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001285">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Receive system security alerts, advisories, and directives from organization-defined external organizations on an ongoing basis.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-5 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-5 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-5.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001286">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Generate internal security alerts, advisories, and directives as deemed necessary.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-5 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-5 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001287">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate security alerts, advisories, and directives to organization-defined personnel or roles, organization-defined elements within the organization, and/or organization-defined external organizations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-5 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-5 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-5.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-5 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001288">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the organization will disseminate security alerts, advisories, and directives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-5 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-5 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-5.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-5 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001289">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement security directives in accordance with established time frames, or notify the issuing organization of the degree of noncompliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-5 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-5 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-5.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-5 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001290">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Broadcast security alert and advisory information throughout the organization using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-5 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-5 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-5 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001291">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system verifies the correct operation of security functions in accordance with organization-defined conditions and in accordance with organization-defined frequency (if periodic verification).</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-6.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-001292">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the appropriate conditions, including the system transitional states if applicable, for verifying the correct operation of security functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-6.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-001293">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the information system responses and alternative action(s) to anomalies discovered during security function verification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-6.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-001294">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Alert organization-defined personnel or roles of failed security verification tests.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-6 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-6 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001295">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement automated mechanisms to support the management of distributed security function testing.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-6 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001296">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Report the results of security function verification to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-6 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001297">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system detects unauthorized changes to software and information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-7.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-001298">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization reassesses the integrity of software and information by performing, on an organization-defined frequency, integrity scans of the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-7 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001299">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency of integrity scans to be performed on the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-7 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001300">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ automated tools that provide notification to organization-defined personnel or roles upon discovering discrepancies during integrity verification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-7 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001301">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ centrally managed integrity verification tools.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-7 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-7 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001302">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires use of tamper-evident packaging for organization-defined information system components during organization-defined conditions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-7 (4).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-7 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001303">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines information system components that require tamper-evident packaging.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-7 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-7 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001304">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines conditions (i.e., transportation from vendor to operational site, during operation, both) under which tamper-evident packaging must be used for organization-defined information system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-7 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-7 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001305">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs spam protection mechanisms at information system entry and exit points to detect and take action on unsolicited messages transported by electronic mail, electronic mail attachments, web accesses, removable media, or other common means.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-8.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001306">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization updates spam protection mechanisms when new releases are available in accordance with organizational configuration management policy and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-8 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-8.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001307">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization centrally manages spam protection mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-8 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-8 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-8 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001308">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Automatically update spam protection mechanisms on an organization-defined frequency.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-8 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-8 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-8 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001309">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization restricts the capability to input information to the information system to authorized personnel.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-9.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-001310">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Checks the validity of organization-defined information inputs to the system.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-10" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-10" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-10.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-001311">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system identifies potentially security-relevant error conditions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-11.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-11 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001312">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Generates error messages that provide information necessary for corrective actions without revealing information that could be exploited.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-11 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-11 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-11.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-11 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001313">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines sensitive or potentially harmful information that should not be contained in error logs and administrative messages.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-11.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-11 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001314">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Reveal error messages only to organization-defined personnel or roles.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-11 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-11 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-11.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-11 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001315">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage information within the system and information output from the system in accordance with applicable federal laws, Executive Orders, directives, policies, regulations, standards, and operational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-12" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-12.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-001316">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects the information system from harm by considering mean time to failure rates for an organization-defined list of information system components in specific environments of operation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-13.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-13 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001317">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines a list of information system components for which mean time to failure rates should be considered to protect the information system from harm.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-13.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-13 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001318">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide substitute system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-13 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-13 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-13.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-13 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001319">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Takes system components out of service by transferring component responsibilities to a substitute component no later than an organization-defined fraction or percentage of mean time to failure (MTTF).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-13 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-13 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-13 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-13 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001320">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the maximum fraction or percentage of mean time to failure (MTTF) used to determine when system components are taken out of service by transferring component responsibilities to substitute components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-13 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-13 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-13 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-13 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001321">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit processes from executing without supervision for more than an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (16)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (16)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-13 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-13 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001322">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a time period that is the longest a process is allowed to execute without supervision.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (16)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (16)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-13 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-13 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001323">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manually initiate transfers between active and standby system components when the use of the active component reaches an organization-defined percentage of the mean time to failure..</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-13 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-13 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-13 (3).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-13 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001324">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the minimum frequency at which the organization manually initiates a transfer between active and standby information system components if the mean time to failure (MTTF) exceeds the organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-13 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-13 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-13 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001325">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines a time period that the mean time to failure (MTTF) must exceed before the organization manually initiates a transfer between active and standby information system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-13 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-13 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-13 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001326">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>If system component failures are detected, ensure standby components are successfully and transparently installed within an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-13 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-13 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-13 (4).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-13 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001327">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a time period for a standby system component to be successfully and transparently installed for the system component that has failed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-13 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-13 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-13 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-13 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001328">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>If system component failures are detected, activate an organization-defined alarm, automatically shut down the system, and/or organization-defined action.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-13 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-13 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-13 (4).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-13 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001329">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the alarm to be activated when a system component failure is detected.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-13 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-13 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-13 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-13 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001330">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit the use of unclassified mobile devices in facilities containing systems processing, storing, or transmitting classified information unless specifically permitted by the authorizing official.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-19 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-19 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001331">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit the connection of unclassified mobile devices to classified systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-19 (4) (b) (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-19 (4) (b) (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19 (4).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001332">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Connection of unclassified mobile devices to unclassified systems requires approval from the authorizing official.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-19 (4) (b) (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-19 (4) (b) (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19 (4).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001333">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use of internal or external modems or wireless interfaces within the unclassified mobile devices is prohibited.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-19 (4) (b) (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-19 (4) (b) (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19 (4).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001334">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require unclassified mobile devices used in facilities containing systems processing, storing, or transmitting classified information and the information stored on those devices be subject to random reviews and inspections by organization-defined security officials.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-19 (4) (b) (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-19 (4) (b) (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19 (4).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001335">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines security officials to perform reviews and inspections of unclassified mobile devices in facilities containing systems processing, storing, or transmitting classified information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-19 (4) (b) (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-19 (4) (b) (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001336">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Retain individual training records for an organization-defined time-period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-4 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-4 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001337">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period for retaining individual training records.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-4 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-4 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-4.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001338">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system associates the identity of the information producer with the information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-10 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-10 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001339">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system validates the binding of the information producer's identity to the information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-10 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-10 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001340">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain reviewer or releaser identity and credentials within the established chain of custody for all information reviewed or released.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-10 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-10 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-10 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-10 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001341">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Validate the binding of the information reviewer identity to the information at the transfer or release points prior to release or transfer between organization-defined security domains.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-10 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-10 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-10 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-10 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001342">
      <status>deprecated</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs either FIPS-validated or NSA-approved cryptography to implement digital signatures.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-10 (5).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-10 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001343">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system invokes a system shutdown in the event of an audit failure, unless an alternative audit capability exists.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-5 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-5 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001344">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization specifies the permitted actions for each authorized information system process, role, and/or user in the audit and accountability policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-6 (7).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-6 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001345">
      <status>deprecated</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms to alert security personnel of any organization-defined inappropriate or unusual activities with security implications.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-6 (8).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-6 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001346">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines a list of inappropriate or unusual activities with security implications that are to result in alerts to security personnel.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-6 (8).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-6 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001347">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization performs, in a physically dedicated information system, full-text analysis of privileged functions executed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-6 (9).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-6 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001348">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Store audit records on an organization-defined frequency in a repository that is part of a physically different system or system component that the system or component being audited.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-9 (2).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001349">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for storing audit records in a repository that is part of a physically different system or system component than the system or component being audited.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-9 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001350">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement cryptographic mechanisms to protect the integrity of audit information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-9 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-9 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-9 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001351">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authorize access to management of audit logging functionality to only an organization-defined subset of privileged users or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-9 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-9 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-9 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001352">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects the audit records of non-local accesses to privileged accounts and the execution of privileged functions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-9 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-9 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001353">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Produce a system-wide (logical or physical) audit trail composed of audit records in a standardized format.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-12 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-12 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-12 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-12 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001354">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system accounts by deactivating temporary accounts that are no longer required.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 h" />
      </references>
    </cci_item>
    <cci_item id="CCI-001355">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system accounts by deactivating accounts of terminated or transferred users.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 h" />
      </references>
    </cci_item>
    <cci_item id="CCI-001356">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization monitors for atypical usage of information system accounts.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (5).1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (5) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001357">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization reports atypical usage to designated organizational officials.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (5).1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (5) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001358">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish privileged user accounts in accordance with a role-based access scheme; or an attribute-based access scheme.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (7) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (7).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (7) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (7) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001359">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization tracks privileged role assignments.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (7).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (7) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001360">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor privileged role assignments.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (7) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (7).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (7) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (7) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001361">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a time period after which temporary accounts are automatically terminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001362">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system enforces a Discretionary Access Control (DAC) policy that allows users to specify and control sharing by named individuals or groups of individuals, or by both.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-3 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001363">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes a Discretionary Access Control (DAC) policy that allows users to specify and control sharing by named individuals or groups of individuals, or by both.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-3 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-3 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001365">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a time period after which emergency accounts are automatically terminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001366">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines user information to be encrypted or stored off-line in a secure location.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-3 (6).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-3 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001367">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines system information to be encrypted or stored off-line in a secure location.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-3 (6).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-3 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001368">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce approved authorizations for controlling the flow of information within the system based on organization-defined information flow control policies.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-001371">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines security or privacy policy filters requiring fully enumerated formats which are to be implemented when transferring information between different security domains.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (14)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (14)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (14).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (14)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001372">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, implement organization-defined security or privacy policy filters requiring fully enumerated formats that restrict data structure and content.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (14)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (14).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (14)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (14)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001373">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, examine the information for the presence of organization-defined unsanctioned information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (15)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (15)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (15).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (15)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001374">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, prohibit the transfer of such information in accordance with the organization-defined security pr privacy policy.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (15)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (15).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (15)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (15)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001376">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system uniquely identifies source domains for information transfer.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (17).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (17) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001377">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system uniquely authenticates source domains for information transfer.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (17).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (17) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001380">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents separation of duties of individuals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-5 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001382">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the number of consecutive, unsuccessful login attempts to the mobile device.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-7 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001383">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system provides additional protection for mobile devices accessed via login by purging information from the device after an organization-defined number of consecutive, unsuccessful login attempts to the mobile device.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-7 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001384">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For publicly accessible systems, display system use information with organization-defined conditions before granting further access to the publicly accessible system.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-8 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-8 c 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-8.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001385">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For publicly accessible systems, displays references, if any, to monitoring that are consistent with privacy accommodations for such systems that generally prohibit those activities.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-8 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-8 c 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-8.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001386">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For publicly accessible systems, displays references, if any, to recording that are consistent with privacy accommodations for such systems that generally prohibit those activities.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-8 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-8 c 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-8.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001387">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For publicly accessible systems, displays references, if any, to auditing that are consistent with privacy accommodations for such systems that generally prohibit those activities.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-8 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-8 c 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-8.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001388">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For publicly accessible systems, includes a description of the authorized uses of the system.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-8 c 3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-8 c 3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-8.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001389">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period that the system notifies the user of the number of successful logon/access attempts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-9 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-9 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001390">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period that the system notifies the user of the number of unsuccessful logon/access attempts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-9 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-9 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001391">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Notify the user, upon successful logon, of the number of successful logons/accesses during the organization-defined time period.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-9 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-9 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001392">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Notify the user, upon successful logon, of the number of unsuccessful logon/access attempts during the organization-defined time period.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-9 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-9 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001393">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security-related characteristics/parameters of the user's account which, when changed, will result in a notification being provided to the user during the organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-9 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-9 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-9 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001394">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period during which organization-defined security-related changes to the user's account are to be tracked.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-9 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-9 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-9 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001395">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Notify the user, upon successful logon, of changes to organization-defined security-related characteristics/parameters of the user's account during the organization-defined time-period.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-9 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-9 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-9 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001396">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines security attributes for which the information system supports and maintains the bindings for information in storage.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-16.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-001397">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines security attributes for which the information system supports and maintains the bindings for information in process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-16.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-001398">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines security attributes for which the information system supports and maintains the bindings for information in transmission.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-16.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-001399">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system supports and maintains the binding of organization-defined security attributes to information in storage.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-16.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-001400">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system supports and maintains the binding of organization-defined security attributes to information in process.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-16.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-001401">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system supports and maintains the binding of organization-defined security attributes to information in transmission.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-16.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-001402">
      <status>draft</status>
      <publishdate>2009-09-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization monitors for unauthorized remote access to the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001403">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Automatically audit account modification actions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (4).1 (i and ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001404">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Automatically audit account disabling actions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (4).1 (i and ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001405">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Automatically audit account removal actions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (4).1 (i and ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001406">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a time period of expected inactivity when users are required to log out.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (5).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (5) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001407">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Administer privileged user accounts in accordance with a role-based access scheme; or an attribute-based access scheme.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (7) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (7) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (7).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (7) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001408">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines privileged commands for which dual authorization is to be enforced.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-3" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001409">
      <status>draft</status>
      <publishdate>2009-09-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines nondiscretionary access control policies to be enforced over the organization-defined set of users and resources, where the rule set for each policy specifies access control information employed by the policy rule set (e.g., position, nationality, age, project, time of day) and required relationships among the access control information to permit access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-3 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001410">
      <status>draft</status>
      <publishdate>2009-09-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the set of users and resources over which the information system is to enforce nondiscretionary access control policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-3 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001411">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines security-relevant information to which the information system prevents access except during secure, non-operable system states.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-3 (5).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-3 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001412">
      <status>draft</status>
      <publishdate>2009-09-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization encrypts or stores off-line, in a secure location, organization-defined user information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-3 (6).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-3 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001413">
      <status>draft</status>
      <publishdate>2009-09-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization encrypts or stores off-line, in a secure location, organization-defined system information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-3 (6).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-3 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001414">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce approved authorizations for controlling the flow of information between connected systems based on organization-defined information flow control policies.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-001415">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines limitations for the embedding of data types within other data types.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (5).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001416">
      <status>draft</status>
      <publishdate>2009-09-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines one-way information flows to be enforced by the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (7)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (7).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001417">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines security policy filters to be enforced and used as a basis for flow control decisions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (8)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (8).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (8) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001418">
      <status>draft</status>
      <publishdate>2009-09-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines security policy filters for which the information system enforces the use of human review.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (9).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001419">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security functions or security-relevant information to which users of system accounts, or roles, have access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-6 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001420">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the privileged commands to which network access is to be authorized only for organization-defined compelling operational needs.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-6 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001421">
      <status>draft</status>
      <publishdate>2009-09-25</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization limits authorization to super user accounts on the information system to designated system administration personnel.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-6 (5).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-6 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001422">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit privileged access to the system by non-organizational users.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-6 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-6 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001423">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period in which the organization-defined maximum number of consecutive invalid logon attempts occur.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-7 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-7" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-7.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-001424">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Dynamically associate security attributes with organization-defined subjects in accordance with organization-defined security policies as information is created and combined.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-16 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-16 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001425">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provides authorized individuals (or processes acting on behalf of individuals) the capability to change the value of associated security attributes.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-16 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-16 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001426">
      <status>draft</status>
      <publishdate>2009-09-25</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system maintains the binding of security attributes to information with sufficient assurance that the information--attribute association can be used as the basis for automated policy actions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-16 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-16 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001427">
      <status>draft</status>
      <publishdate>2009-09-25</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system allows authorized users to associate security attributes with information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-16 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-16 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001428">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Displays security attributes in human-readable form on each object that the system transmits to output devices to identify organization-identified special dissemination, handling, or distribution instructions using organization-identified human-readable, standard naming conventions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-16 (5).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-16 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001429">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identifies special dissemination, handling, or distribution instructions for identifying security attributes on output.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-16 (5).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-16 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001430">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identifies human-readable, standard naming conventions for identifying security attributes on output.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-16 (5).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-16 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001431">
      <status>draft</status>
      <publishdate>2009-09-25</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines a frequency for monitoring for unauthorized remote connections to the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17 (5).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001432">
      <status>draft</status>
      <publishdate>2009-09-25</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization takes appropriate action if an unauthorized remote connection to the information system is discovered.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17 (5).1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001433">
      <status>draft</status>
      <publishdate>2009-09-25</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines a list of security functions and security-relevant information that for remote access sessions have organization-defined security measures employed and are audited.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17 (7).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001434">
      <status>draft</status>
      <publishdate>2009-09-25</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines additional security measures to be employed when an organization-defined list of security functions and security-relevant information is accessed remotely.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17 (7).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001435">
      <status>draft</status>
      <publishdate>2009-09-25</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines networking protocols within the information system deemed to be nonsecure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17 (8).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001436">
      <status>draft</status>
      <publishdate>2009-09-25</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization disables organization-defined networking protocols within the information system deemed to be nonsecure except for explicitly identified components in support of specific operational requirements.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17 (8).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001437">
      <status>draft</status>
      <publishdate>2009-09-25</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents the rationale for the execution of privileged commands and access to security-relevant information in the security plan for the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001438">
      <status>draft</status>
      <publishdate>2009-09-25</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes usage restrictions for wireless access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-18 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-18.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-18 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001439">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish implementation guidance for wireless access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-18 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-18.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-18 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-18 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001440">
      <status>draft</status>
      <publishdate>2009-09-25</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization monitors for unauthorized wireless access to the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-18.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-18 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001441">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authorize each type of wireless access to the system prior to allowing such connections.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-18 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-18.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-18 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-18 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001442">
      <status>draft</status>
      <publishdate>2009-09-25</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization enforces requirements for wireless connections to the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-18.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-18 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001443">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect wireless access to the system using authentication of users and/or devices.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-18 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-18 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-18 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-18 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001444">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect wireless access to the system using encryption.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-18 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-18 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-18 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-18 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001445">
      <status>draft</status>
      <publishdate>2009-09-25</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization monitors for unauthorized wireless connections to the information system on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-18 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-18 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001446">
      <status>draft</status>
      <publishdate>2009-09-25</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization scans for unauthorized wireless access points on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-18 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-18 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001447">
      <status>draft</status>
      <publishdate>2009-09-25</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines a frequency of monitoring for unauthorized wireless connections to information system, including scans for unauthorized wireless access points.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-18 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-18 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001448">
      <status>draft</status>
      <publishdate>2009-09-25</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization takes appropriate action if an unauthorized wireless connection is discovered.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-18 (2).1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-18 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001449">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disable, when not intended for use, wireless networking capabilities internally embedded within system components prior to issuance and deployment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-18 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-18 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-18 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-18 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001450">
      <status>draft</status>
      <publishdate>2009-09-25</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization does not allow users to independently configure wireless networking capabilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-18 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-18 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001451">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Select radio antennas and calibrate transmission power levels to reduce the probability that signals from wireless access points can be received outside of organization-controlled boundaries.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-18 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-18 (5).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-18 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-18 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001452">
      <status>draft</status>
      <publishdate>2009-05-25</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system enforces the organization-defined time period during which the limit of consecutive invalid access attempts by a user is counted.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-7.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001453">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement cryptographic mechanisms to protect the integrity of remote access sessions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001454">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that remote sessions for accessing an organization-defined list of security functions and security-relevant information are audited.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17 (7).1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001455">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization explicitly identifies components needed in support of specific operational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17 (8).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001456">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines locations that the organization deems to be of significant risk in accordance with organizational policies and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-001457">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines inspection and preventative measures to be applied on mobile devices returning from locations that the organization deems to be of significant risk in accordance with organizational policies and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19.1 (vii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-001458">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Requires that if classified information is found on mobile devices, the incident handling policy be followed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-19 (4) (b) (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-19 (4) (b) (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-19 (4).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-19 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001459">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines system components that provide audit record generation capability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-12 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-12 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-12.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-12 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001460">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor organization-defined open source information and/or information sites per organization-defined frequency for evidence of unauthorized disclosure of organizational information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-13 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-13" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-13.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-13" />
      </references>
    </cci_item>
    <cci_item id="CCI-001461">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for monitoring open source information and/or information sites for evidence of unauthorized exfiltration or disclosure of organizational information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-13 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-13" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-13.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-13" />
      </references>
    </cci_item>
    <cci_item id="CCI-001462">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system provides the capability for authorized users to capture/record and log content related to a user session.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-14 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-14.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-14 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001463">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system provides the capability to remotely view/hear all content related to an established user session in real time.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-14.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-14 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001464">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Initiates session audits automatically at system start-up.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-14 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-14 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-14 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-14 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001465">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes terms and conditions, consistent with any trust relationships established with other organizations owning, operating, and/or maintaining external information systems, allowing authorized individuals to store organization-controlled information using the external information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-20.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-20 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001466">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes terms and conditions, consistent with any trust relationships established with other organizations owning, operating, and/or maintaining external information systems, allowing authorized individuals to transmit organization-controlled information using the external information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-20.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-20 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001467">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prohibits authorized individuals from using an external information system to process organization-controlled information except in situations where the organization can verify the implementation of required security controls on the external system as specified in the organization's information security policy and security plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-20 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-20 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001468">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prohibits authorized individuals from using an external information system to store organization-controlled information except in situations where the organization can verify the implementation of required security controls on the external system as specified in the organization's information security policy and security plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-20 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-20 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001469">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prohibits authorized individuals from using an external information system to transmit organization-controlled information except in situations where the organization can verify the implementation of required security controls on the external system as specified in the organization's information security policy and security plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-20 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-20 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001470">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines information sharing circumstances where user discretion is required.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-21 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-21 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-21.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-21 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001471">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined automated mechanisms or manual processes required to assist users in making information sharing/collaboration decisions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-21 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-21 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-21.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-21 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001472">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms or manual processes required to assist users in making information sharing/collaboration decisions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-21 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-21 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-21.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-21 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001473">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate individuals authorized to post information onto a publicly accessible system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-22 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-22 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-22.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-22 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001474">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Train authorized individuals to ensure that publicly accessible information does not contain nonpublic information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-22 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-22 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-22.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-22 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001475">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review the proposed content of information prior to posting onto the publicly accessible system to ensure that nonpublic information is not included.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-22 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-22 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-22.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-22 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001476">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review the content on the publicly accessible system for nonpublic information on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-22 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-22 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-22.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-22 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001477">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for reviewing the content on the publicly accessible system for nonpublic information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-22 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-22 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-22.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-22 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001478">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Remove nonpublic information from the publicly accessible system, if discovered.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-22 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-22 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-22.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-22 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-001479">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides refresher security awareness training to all information system users (including managers, senior executives, and contractors) in accordance with the organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-2 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-2.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001480">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency for providing refresher security awareness training to all information system users (including managers, senior executives, and contractors).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001481">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide organization-defined personnel or roles with initial training in the employment and operation of environmental controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-3 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001482">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide organization-defined personnel or roles with refresher training in the employment and operation of environmental controls in accordance with the organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-3 (1).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001483">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for providing employees with refresher training in the employment and operation of environmental controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-3 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001484">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of (or situation requiring) logging for each identified event.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-2 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-2.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001485">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the event types for logging within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-2 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-2.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-2 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001486">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines a frequency for reviewing and updating the list of organization-defined auditable events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-2 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001487">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that audit records containing information that establishes the identity of any individuals, subjects, or objects/entities associated with the event.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-3 f" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-3.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-001488">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the additional information to be included in the audit records.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-3 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001489">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines information system components for which generated audit records are centrally managed by the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-3 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001490">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the actions to be taken by the system upon audit failure, including shutting down the system, overwriting oldest audit records, and stopping the generation of audit records.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-5 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-5.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001491">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Correlate information from audit records with information obtained from monitoring physical access to further enhance the ability to identify suspicious, inappropriate, unusual, or malevolent activity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-6 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-6 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-6 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001492">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines an authoritative time source for the synchronization of internal information system clocks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-8 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-8 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-8 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001493">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect audit tools from unauthorized access.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-9" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-9.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-9" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001494">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect audit tools from unauthorized modification.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-9" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-9.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-001495">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect audit tools from unauthorized deletion.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-9" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-9.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-9" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-001496">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement cryptographic mechanisms to protect the integrity of audit tools.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-9 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-9 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001497">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for the review and update to the baseline configuration of the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 b 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-001498">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a time period after which proposed changes to the system that have not been approved or disapproved are highlighted.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (1) (c)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 (1) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (1) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001499">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Limit privileges to change software resident within software libraries.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-5 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (6).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001500">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system automatically implements organization-defined safeguards and countermeasures if security functions (or mechanisms) are changed inappropriately.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (7).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001501">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines safeguards and countermeasures to be employed by the information system if security functions (or mechanisms) are changed inappropriately.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-5 (7).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-5 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001502">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization monitors changes to the configuration settings in accordance with organizational policies and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-6 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001503">
      <status>draft</status>
      <publishdate>2009-09-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization controls changes to the configuration settings in accordance with organizational policies and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-6 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001504">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level personnel security policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-1.1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001505">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-level; mission/business process-level; and/or system-level personnel security policy to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-1.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001506">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current personnel security policy in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-1.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001507">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the current personnel security policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-1.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001508">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the current personnel security procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-1.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001509">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document procedures to facilitate the implementation of the personnel security policy and associated personnel security controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-1.1 (iv) (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001510">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate personnel security procedures to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-1.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001511">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current personnel security procedures in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-1.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001512">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Assign a risk designation to all organizational positions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-2 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001513">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish screening criteria for individuals filling organizational positions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-2 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-2.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001514">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update position risk designations in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-2 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-2.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001515">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update position risk designations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-2 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-2.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001516">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Screen individuals prior to authorizing access to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-3 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-3 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-3.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001517">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Rescreen individuals with authorized access to the system in accordance with organization-defined conditions requiring rescreening, and where rescreening is so indicated, on the organization-defined frequency of rescreening.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-3 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-3 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-3.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001518">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the conditions requiring rescreening of individuals with authorized access to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-3 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-3 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-3.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001519">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for rescreening individuals with authorized access to the information system when organization-defined conditions requiring rescreening are met.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-3 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-3 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-3.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001520">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that individuals accessing a system processing, storing, or transmitting classified information are cleared and indoctrinated to the highest classification level of the information to which they have access on the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-3 (1).1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001521">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that individuals accessing a system processing, storing, or transmitting types of classified information which require formal indoctrination, are formally indoctrinated for all of the relevant types of information to which they have access on the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-3 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001522">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Upon termination of individual employment, disable system access within an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-4 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-4 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001523">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Upon termination of individual employment, conduct exit interviews that include a discussion of organization-defined information security topics.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-4 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-4 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-4.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001524">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Upon termination of individual employment, retrieve all security-related organizational system-related property.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-4 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-4 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-4.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-4 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001525">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Upon termination of individual employment, retain access to organizational information formerly controlled by the terminated individual.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-4 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-4 e" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-4.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001526">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Upon termination of individual employment, retain access to organizational systems formerly controlled by the terminated individual.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-4 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-4 e" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-4.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001527">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and confirm the ongoing operational need for current logical and physical access authorizations to systems and facilities when individuals are reassigned or transferred to other positions within the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-5 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-5 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-5.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-001528">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Initiate organization-defined transfer or reassignment actions within an organization-defined time period following the formal personnel transfer action.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-5 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-5 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-5.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-001529">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines transfer or reassignment actions to initiate within an organization-defined time period following the formal personnel transfer action.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-5 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-5 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-001530">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period within which the organization initiates organization-defined transfer or reassignment actions following the formal personnel transfer action.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-5 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-5 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-001531">
      <status>draft</status>
      <publishdate>2009-11-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that individuals requiring access to organizational information and information systems sign appropriate access agreements prior to being granted access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-6 c 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-6.1 (i) (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001532">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the access agreements for organizational systems in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-6 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-6 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-6.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001533">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update access agreements for organizational systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-6 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-6 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-6.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001534">
      <status>draft</status>
      <publishdate>2009-11-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that access to information with special protection measures is granted only to individuals who have a valid access authorization that is demonstrated by assigned official government duties.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-6 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-6 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001535">
      <status>draft</status>
      <publishdate>2009-11-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that access to information with special protection measures is granted only to individuals who satisfy associated personnel security criteria.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-6 (1).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-6 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001536">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that access to classified information requiring special protection is granted only to individuals who have a valid access authorization that is demonstrated by assigned official government duties.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-6 (2) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-6 (2) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-6 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-6 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001537">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that access to classified information requiring special protection is granted only to individuals who satisfy associated personnel security criteria.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-6 (2) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-6 (2) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-6 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-6 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001538">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that access to classified information requiring special protection is granted only to individuals who have read, understood, and signed a nondisclosure agreement.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-6 (2) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-6 (2) (c)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-6 (2).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-6 (2) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001539">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish personnel security requirements including security roles and responsibilities for external providers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-7 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-7 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-7.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001540">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document personnel security requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-7 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-7 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-7.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001541">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor provider compliance with personnel security requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-7 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-7 e" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-7.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-7 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001542">
      <status>draft</status>
      <publishdate>2009-11-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs a formal sanctions process for individuals failing to comply with established information security policies and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-8 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PS-8.1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PS-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-001543">
      <status>draft</status>
      <publishdate>2009-11-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization disseminates the most recent information security program plan to appropriate entities in the organization that includes roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-1.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001544">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage system authenticators by ensuring that authenticators have sufficient strength of mechanism for their intended use.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001545">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for reviewing and updating the access control policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-1.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001546">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for reviewing and updating the access control procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-1.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001547">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency on which it will review information system accounts for compliance with account management requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 j" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 j" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 j" />
      </references>
    </cci_item>
    <cci_item id="CCI-001548">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information flow control policies for controlling the flow of information within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-001549">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information flow control policies for controlling the flow of information between interconnected systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-001550">
      <status>draft</status>
      <publishdate>2010-05-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines approved authorizations for controlling the flow of information within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-001551">
      <status>draft</status>
      <publishdate>2010-05-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines approved authorizations for controlling the flow of information between interconnected systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-001552">
      <status>draft</status>
      <publishdate>2010-05-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines policy that allows or disallows information flows based on changing conditions or operational considerations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001553">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines security or privacy policy filters that privileged administrators have the capability to enable and disable.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (10)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (10).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001554">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security or privacy policy filters that privileged administrators have the capability to configure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (11)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (11).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (11)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001555">
      <status>draft</status>
      <publishdate>2010-05-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system uniquely identifies destination domains for information transfer.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (17).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (17) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001556">
      <status>draft</status>
      <publishdate>2010-05-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system uniquely authenticates destination domains for information transfer.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (17).1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (17) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001557">
      <status>draft</status>
      <publishdate>2010-05-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system tracks problems associated with the information transfer.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-4 (17).1 (vii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-4 (17) c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001558">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security functions (deployed in hardware, software, and firmware) for which access must be authorized.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-6 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001559">
      <status>draft</status>
      <publishdate>2010-05-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization identifies the individuals authorized to change the value of associated security attributes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-16 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-16 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001560">
      <status>draft</status>
      <publishdate>2010-05-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization identifies individuals (or processes acting on behalf of individuals) authorized to associate organization-defined security attributes with organization-defined objects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-16 (4).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-16 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001561">
      <status>draft</status>
      <publishdate>2010-05-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines managed access control points for remote access to the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001562">
      <status>draft</status>
      <publishdate>2010-05-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the appropriate action(s) to be taken if an unauthorized remote connection is discovered.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-17 (5).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-17 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001563">
      <status>draft</status>
      <publishdate>2010-05-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the appropriate action(s) to be taken if an unauthorized wireless connection is discovered.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-18 (2).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-18 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001564">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of security awareness and training policy reviews and updates.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-1.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001565">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of security awareness and training procedure reviews and updates.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-1.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001566">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide organization-defined personnel or roles with initial training in the employment and operation of physical security controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-3 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001567">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide organization-defined personnel or roles with refresher training, thereafter, in the employment and operation of physical security controls in accordance with the organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-3 (2).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001568">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for providing employees with refresher training in the employment and operation of physical security controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AT-3 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AT-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001569">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency on which the current audit and accountability policy will be reviewed and updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-1.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001570">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency on which the current audit and accountability procedures will be reviewed and updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-1.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001571">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the event types that the system is capable of logging in support of the audit function.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-2 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001572">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to be alerted in the event of an audit logging process failure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-5 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-5.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-5 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001573">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines whether to reject or delay network traffic that exceeds organization-defined thresholds.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-5 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-5 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-5 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001574">
      <status>draft</status>
      <publishdate>2010-05-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system rejects or delays, as defined by the organization, network traffic which exceed the organization-defined thresholds.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-5 (3).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001575">
      <status>draft</status>
      <publishdate>2010-05-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the system or system component for storing audit records that is a different system or system component than the system or component being audited.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-9 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-9 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001576">
      <status>deprecated</status>
      <publishdate>2010-05-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system produces a system-wide (logical or physical) audit trail of information system audit records.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-12 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-12 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001577">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information system components from which audit records are to be compiled into the system-wide audit trail.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-12 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AU-12 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AU-12 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001578">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency to review and update the current assessment, authorization, and monitoring procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-1.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001579">
      <status>draft</status>
      <publishdate>2010-05-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization conducts security control assessments using organization-defined forms of testing in accordance with organization-defined frequency and assessment techniques.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-2 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001580">
      <status>draft</status>
      <publishdate>2010-05-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization identifies connections to external information systems (i.e., information systems outside of the authorization boundary).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-3.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001581">
      <status>draft</status>
      <publishdate>2010-05-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines personnel or roles to whom the security status of the organization and the information system should be reported.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-7 g" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-7.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001582">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines other forms of control assessments other than in-depth monitoring; security instrumentation; automated security test cases; vulnerability scanning; malicious user testing; insider threat assessment; performance and load testing; data leakage or data loss assessment that should be included as part of the control assessments.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-7 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001583">
      <status>draft</status>
      <publishdate>2010-05-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization selects announced or unannounced assessments for each form of security control assessment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-7 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001584">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update configuration management procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-1.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001585">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the circumstances that require reviews and updates to the baseline configuration of the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 b 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-2 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-2 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001586">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the configuration change control element responsible for coordinating and providing oversight for configuration change control activities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 g" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-3.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-3 f" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-001587">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization, when analyzing new software in a separate test environment, looks for security impacts due to flaws, weaknesses, incompatibility, or intentional malice.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-4 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001588">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization-defined security configuration checklists reflect the most restrictive mode consistent with operational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-6 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001589">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization incorporates detection of unauthorized, security-relevant configuration changes into the organization’s incident response capability to ensure they are tracked.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-6 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001590">
      <status>deprecated</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a list of software programs authorized to execute on the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-7 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001591">
      <status>deprecated</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a list of software programs not authorized to execute on the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-7 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001592">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the rules authorizing the terms and conditions of software program usage on the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-7 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001593">
      <status>deprecated</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization maintains a list of software programs authorized to execute on the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-7 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001594">
      <status>deprecated</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization maintains a list of software programs not authorized to execute on the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-7 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001595">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization maintains rules authorizing the terms and conditions of software program usage on the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CM-7 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CM-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001596">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the current contingency planning procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-1.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001597">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate contingency planning procedures to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-1.1 (vi)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001598">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current contingency planning procedures in accordance with the organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-1.2 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-1" />
      </references>
    </cci_item>
    <cci_item id="CCI-001599">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Sustain operational continuity of essential missions until full information system restoration at primary processing and/or storage sites.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (5).1 (b)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001600">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Sustains operational continuity of essential business functions until full information system restoration at primary processing and/or storage sites.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (5).1 (b)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001601">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Sustain operational continuity of essential mission functions at alternate processing and/or storage sites until system restoration to primary processing and/or storage sites.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (6).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001602">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Sustain operational continuity of essential business functions at alternate processing and/or storage sites until system restoration at primary processing and/or storage sites.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-2 (6).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-2 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001603">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The contingency plan identifies the primary storage site hazards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-6 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001604">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Outline explicit mitigation actions for potential accessibility problems to the alternate storage site in the event of an area-wide disruption or disaster.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-6 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001605">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The contingency plan identifies the primary processing site hazards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-7 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001606">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify potential accessibility problems to outline explicit mitigation actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-7 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001607">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes alternate telecommunications services to support the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-8.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001608">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization identifies the primary provider's telecommunications service hazards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-8 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-8 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001609">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Activate the redundant secondary system that is not collocated with the primary system without loss of information or disruption to operations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-9 (6)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CP-9 (6).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CP-9 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001610">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time-period (by authenticator type) for changing/refreshing authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 g" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 g" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-001611">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the minimum number of special characters for password complexity enforcement.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001612">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the minimum number of upper case characters for password complexity enforcement.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001613">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the minimum number of lower case characters for password complexity enforcement.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001614">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the minimum number of numeric characters for password complexity enforcement.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001615">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the minimum number of characters that are changed when new passwords are created.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001616">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines minimum password lifetime restrictions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (d)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001617">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines maximum password lifetime restrictions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (d)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001618">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the number of generations for which password reuse is prohibited.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (e)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001619">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system enforces password complexity by the minimum number of special characters used.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (1).1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001620">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the types of and/or specific authenticators for which the registration process must be carried out in person before a designated registration authority with authorization by a designated organizational official (e.g., a supervisor).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001621">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined security controls to manage the risk of compromise due to individuals having accounts on multiple systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (8)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IA-5 (8).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IA-5 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001622">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization identifies personnel with incident response roles and responsibilities with respect to the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-2.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001623">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The incident response training material addresses the procedures and activities necessary to fulfill identified organizational incident response roles and responsibilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-2.1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001624">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents the results of incident response tests.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-3" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-3.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-001625">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the resulting incident handling activity changes to incident response procedures, training, and testing accordingly.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 c" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-4.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-4 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001626">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms to assist in the collection of security incident information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-5 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-5 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001627">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms to assist in the analysis of security incident information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-5 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="IR-5 (1).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="IR-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001628">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency with which to review and update the current maintenance procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-1.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001629">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms to produce up-to-date, accurate, complete, and available records of all maintenance and repair actions needed, in process, and complete.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-2 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001630">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>Designated organizational personnel review the maintenance records of the non-local maintenance and diagnostic sessions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001631">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>After the service is performed, inspect and sanitize the component (for potentially malicious software) before reconnecting the component to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 (3) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 (3) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4 (3).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001632">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect nonlocal maintenance sessions by separating the maintenance session from other network sessions with the system by either physically separated communications paths or logically separated communications paths based upon encryption.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MA-4 (4).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MA-4 (4) (a) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 (4) (b) (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001633">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines removable media types and information output requiring marking.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="MP-3.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="MP-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001634">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization identifies authorized personnel with appropriate clearances and access authorizations for gaining physical access to the facility containing an information system that processes classified information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-2 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001635">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Remove individuals from the facility access list when access is no longer required.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-2 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-2 d" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PE-2.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PE-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001636">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the current planning policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-1.2 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-001637">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current planning policy in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-1 b 1" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-1.2 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-001638">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the current planning procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-1.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-1 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001639">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization makes readily available to individuals requiring access to the information system the rules that describe their responsibilities and expected behavior with regard to information and information system usage.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-4 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PL-4.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PL-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001640">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Address information security issues in the updating of a critical infrastructure and key resources protection plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-8" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-8" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-001641">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the process for conducting random vulnerability scans on the system and hosted applications.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001642">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the organizational document in which risk assessment results are documented (e.g., security plan, privacy plan; risk assessment report).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-3 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-3.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-3 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001643">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor and scan for vulnerabilities in the system and hosted applications in accordance with the organization-defined process for random scans.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 a" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001644">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs vulnerability scanning procedures that can demonstrate the depth of coverage (i.e., vulnerabilities checked).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001645">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components to which privileged access is authorized for organization-defined vulnerability scanning activities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 (5)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="RA-5 (5).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="RA-5 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001646">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the current system and services acquisition procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 c 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-1 b 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-1.2 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-1" />
      </references>
    </cci_item>
    <cci_item id="CCI-001647">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires the use of a FIPS-validated, cryptographic module for a technology product that relies on cryptographic functionality to enforce its security policy when no U.S. Government Protection Profile exists for such a specific technology type.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-4 (7).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-4 (7) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001648">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization makes available to authorized personnel the source code for the information system to permit analysis and testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5 (5).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001649">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization identifies and documents (as appropriate) explicit rules to be enforced when governing the installation of software by users.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-7.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-001650">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires the information system developers to manage and control changes to the information system during development.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001651">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires the information system integrators to manage and control changes to the information system during development.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001652">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires the information system developers to manage and control changes to the information system during implementation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001653">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires the information system integrators to manage and control changes to the information system during implementation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001654">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires the information system developers to manage and control changes to the information system during modification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001655">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires the information system integrators to manage and control changes to the information system during modification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-10.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-10 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001656">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the security functions of the information system to be isolated from nonsecurity functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-3.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-001657">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the external boundary of the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001658">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines key internal boundaries of the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001659">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the mediation necessary for public access to the organization's internal networks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001660">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the measures to protect against unauthorized physical connections across boundary protections implemented at organization-defined managed interfaces.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-7 (14).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-7 (14)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001661">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security functions, to at a minimum, include system authentication and re-authentication, for permitting users to invoke the trusted communications path.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-11 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-11" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-11.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-11" />
      </references>
    </cci_item>
    <cci_item id="CCI-001662">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Take organization-defined corrective action when organization-defined unacceptable mobile code is identified.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 (1)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-18 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-18 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001663">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the means to enable verification of a chain of trust among parent and child domains (if the child supports secure resolution services), when operating as part of a distributed, hierarchical namespace.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-20 b" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-20 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-20 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-20 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001664">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Recognize only session identifiers that are system-generated.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-23 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-23 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-23 (3).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-23 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001665">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Preserve organization-defined system state information in the event of a system failure.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-24" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-24.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-24" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-24" />
      </references>
    </cci_item>
    <cci_item id="CCI-001666">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs cryptographic mechanisms to prevent unauthorized modification of information at rest unless otherwise protected by alternative physical measures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-28 (1).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-28 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001667">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization compares the time measured between flaw identification and flaw remediation with organization-defined benchmarks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-2 (3).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001668">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs malicious code protection mechanisms at workstations, servers, or mobile computing devices on the network to detect and eradicate malicious code transported by electronic mail, electronic mail attachments, web accesses, removable media, or other common means or inserted through the exploitation of information system vulnerabilities.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-3.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001669">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of testing malicious code protection mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (6) (a)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-3 (6).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-3 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 (6) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001670">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Take organization-defined least-disruptive actions to terminate suspicious events.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (7)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (7).1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (7) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001671">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Analyze outbound communications traffic at selected organization-defined interior points within the system to discover anomalies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (11)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 ( 11).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (11)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001672">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs a wireless intrusion detection system to identify rogue wireless devices.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (14).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (14)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001673">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ a wireless intrusion detection system to identify rogue wireless devices and to detect attack attempts and potential compromises or breaches to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (14)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-4 (14).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-4 (14)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (14)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001674">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system responds to security function anomalies in accordance with organization-defined responses and alternative action(s).</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-6.1 (v)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-001675">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles that are to receive reports on the results of security function verification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-6 (3).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001676">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines, for periodic security function verification, the frequency of the verifications.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-6.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-001677">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs spam protection mechanisms at workstations, servers, or mobile computing devices on the network to detect and take action on unsolicited messages transported by electronic mail, electronic mail attachments, web accesses, removable media, or other common means.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-8.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001678">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Retain information within the system and information output from the system in accordance with applicable federal laws, Executive Orders, directives, policies, regulations, standards, and operational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-12" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-12.1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-001679">
      <status>draft</status>
      <publishdate>2010-05-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides a mechanism to exchange active and standby roles of the components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-13.1 (iv)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-13 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001680">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide information security program plan that includes the identification and assignment of roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="PM-1.1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="PM-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001681">
      <status>deprecated</status>
      <publishdate>2011-04-26</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency at which each form of security control assessment should be conducted.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="CA-7(2).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="CA-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001682">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Automatically removes or disables emergency accounts after an organization-defined time period for each type of account.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001683">
      <status>draft</status>
      <publishdate>2011-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system notifies organization-defined personnel or roles for account creation actions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (4).1 (i and ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001684">
      <status>draft</status>
      <publishdate>2011-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system notifies organization-defined personnel or roles for account modification actions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (4).1 (i and ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001685">
      <status>draft</status>
      <publishdate>2011-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system notifies organization-defined personnel or roles for account disabling actions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (4).1 (i and ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001686">
      <status>draft</status>
      <publishdate>2011-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system notifies organization-defined personnel or roles for account removal actions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (4)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-2 (4).1 (i and ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001687">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that the use of mobile code deployed in system meets organization-defined mobile code requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-18 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-18 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001688">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify the acquisition of mobile code deployed in the system meets organization-defined mobile code requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 (2)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-18 (2).1 (ii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-18 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001689">
      <status>draft</status>
      <publishdate>2011-05-27</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization, if an information system component failure is detected, automatically shuts down the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SI-13 (4).1 (iii)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SI-13 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001690">
      <status>draft</status>
      <publishdate>2011-10-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects, as required, vendor/manufacturer documentation that describes the security-relevant external interfaces to the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001691">
      <status>draft</status>
      <publishdate>2011-10-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization makes available to authorized personnel vendor/manufacturer documentation that describes the security-relevant external interfaces to the information system with sufficient detail to permit analysis and testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5 (1).1 (i)" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001692">
      <status>draft</status>
      <publishdate>2011-10-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization makes available to authorized personnel vendor/manufacturer documentation that describes the low-level design of the information system in terms of modules and implementation details of the security controls employed within the system with sufficient detail to permit analysis and testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SA-5 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SA-5 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001693">
      <status>draft</status>
      <publishdate>2011-10-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system enforces a Discretionary Access Control (DAC) policy that limits propagation of access rights.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-3 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001694">
      <status>draft</status>
      <publishdate>2011-10-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system enforces a Discretionary Access Control (DAC) policy that includes or excludes access to the granularity of a single user.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="AC-3 (4).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="AC-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001695">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent the execution of organization-defined unacceptable mobile code.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 (3)" />
        <reference creator="NIST" title="NIST SP 800-53A" version="1" location="NIST" index="SC-18 (3).1" />
        <reference creator="NIST" title="NIST SP 800-53" version="3" location="NIST" index="SC-18 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001726">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use software in accordance with contract agreements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-10 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-10 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001727">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use software documentation in accordance with contract agreements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-10 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-10 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001728">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use software in accordance with copyright laws.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-10 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-10 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001729">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use software documentation in accordance with copyright laws.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-10 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-10 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001730">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Track the use of software protected by quantity licenses to control copying of the software.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-10 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-10 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001731">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Track the use of software documentation protected by quantity licenses to control distribution of the software documentation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-10 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-10 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001732">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Control the use of peer-to-peer file sharing technology to ensure that this capability is not used for the unauthorized distribution, display, performance, or reproduction of copyrighted work.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-10 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-10 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001733">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document the use of peer-to-peer file sharing technology to ensure that this capability is not used for the unauthorized distribution, display, performance, or reproduction of copyrighted work.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-10 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-10 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001734">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the restrictions to be followed on the use of open source software.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-10 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-10 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001735">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish organization-defined restrictions on the use of open source software.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-10 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-10 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001736">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the number of previous versions of the baseline configuration of the system required to support rollback.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001737">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components that are to have organization-defined configurations applied when located in areas of significant risk.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 (7) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2 (7) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001738">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the configurations to be implemented on systems and system components when they are located in areas of significant risk.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 (7) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2 (7) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001739">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Issue organization-defined systems or system components with organization-defined configurations to individuals traveling to locations the organization deems to be of significant risk.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 (7) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2 (7) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001740">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review proposed configuration-controlled changes to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001741">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document configuration change decisions associated with the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001742">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the approval authorities to be notified when proposed changes to the system are received.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001743">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security responses to be automatically implemented if baseline configurations are changed in an unauthorized manner.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001744">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined security responses automatically if baseline configurations are changed in an unauthorized manner.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001745">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls that are to be provided by the cryptographic mechanisms are under configuration management.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001746">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that cryptographic mechanisms used to provide organization-defined control are under configuration management.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001747">
      <status>draft</status>
      <publishdate>2013-02-28</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines critical software components the information system will prevent from being installed without verification the component has been digitally signed using a certificate that is recognized and approved by the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001748">
      <status>draft</status>
      <publishdate>2013-02-28</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines critical firmware components the information system will prevent from being installed without verification the component has been digitally signed using a certificate that is recognized and approved by the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001749">
      <status>draft</status>
      <publishdate>2013-02-28</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system prevents the installation of organization-defined software components without verification the software component has been digitally signed using a certificate that is recognized and approved by the organization.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001750">
      <status>draft</status>
      <publishdate>2013-02-28</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system prevents the installation of organization-defined firmware components without verification the firmware component has been digitally signed using a certificate that is recognized and approved by the organization.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001751">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines system-level information requiring enforcement of a dual authorization for system changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-5 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001752">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce dual authorization for implementing changes to organization-defined system-level information.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-5 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001753">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Limit privileges to change system components within a production or operational environment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-5 (5) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (5) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001754">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Limit privileges to change system-related information within a production or operational environment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-5 (5) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (5) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001755">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components for which any deviation from the established configuration settings are to be identified, documented, and approved.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-6 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001756">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the operational requirements on which the configuration settings for the organization-defined system components are to be based.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-6 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001757">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the actions to employ when responding to unauthorized changes to the organization-defined configuration settings.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001758">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the configuration settings for which to employ organization-defined actions in response to unauthorized changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001759">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Take organization-defined actions in response to unauthorized changes to organization-defined configuration settings.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001760">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of system reviews to identify unnecessary and/or nonsecure functions, ports, protocols, software, and services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001761">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the functions, ports, protocols, software, and services within the information system that are to be disabled or removed when deemed unnecessary and/or nonsecure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001762">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disable or remove organization-defined functions, ports, protocols, software, and services within the system deemed to be unnecessary and/or nonsecure.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001763">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the policies regarding software program usage and restrictions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001764">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent program execution in accordance with organization-defined policies, rules of behavior, and/or access agreements regarding software program usage and restrictions; rules authorizing the terms and conditions of software program usage.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001765">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the software programs not authorized to execute on the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001766">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify the organization-defined software programs not authorized to execute on the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001767">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ an allow-all, deny-by-exception policy to prohibit the execution of unauthorized software programs on the system.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001768">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency on which the list of unauthorized software programs will be reviewed and updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (4) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (4) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001769">
      <status>deprecated</status>
      <publishdate>2013-02-28</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency on which it will update the list of unauthorized software programs.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (4) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001770">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the list of unauthorized software programs per organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (4) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (4) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001771">
      <status>deprecated</status>
      <publishdate>2013-02-28</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization updates the list of unauthorized software programs per organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (4) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001772">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the software programs authorized to execute on the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (5) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (5) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001773">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify the organization-defined software programs authorized to execute on the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (5) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (5) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001774">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ a deny-all, permit-by-exception policy to allow the execution of authorized software programs on the system.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (5) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001775">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency on which the list of authorized software programs will be reviewed and updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (5) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (5) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001776">
      <status>deprecated</status>
      <publishdate>2013-02-28</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency on which it will update the list of authorized software programs.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (5) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001777">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the list of authorized software programs per organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (5) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (5) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001778">
      <status>deprecated</status>
      <publishdate>2013-02-28</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization updates the list of authorized software programs per organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-7 (5) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001779">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency on which the system component inventory is to be reviewed and updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001780">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the system component inventory per organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001781">
      <status>deprecated</status>
      <publishdate>2013-03-01</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency on which the information system component inventory is to be updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001782">
      <status>deprecated</status>
      <publishdate>2013-03-01</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization updates the information system component inventory per organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001783">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to be notified when unauthorized hardware, software, and firmware components are detected within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (3) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001784">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When unauthorized hardware, software, and firmware components are detected within the system, take action to disable network access by such components; isolate the components, and/or notify organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (3) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001785">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide a centralized repository for the inventory of system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001786">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Support the tracking of system components by geographic location using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001787">
      <status>draft</status>
      <publishdate>2013-03-01</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the acquired information system components that are to be assigned to an information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 (9) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001788">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Assign system components to a system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (9) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 (9) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001789">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Receive an acknowledgement from organization-defined personnel or roles of the acquired system components to a system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (9) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-8 (9) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001790">
      <status>draft</status>
      <publishdate>2013-03-01</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a configuration management plan for the information system that establishes a process for identifying configuration items throughout the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001791">
      <status>draft</status>
      <publishdate>2013-03-01</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents a configuration management plan for the information system that establishes a process for identifying configuration items throughout the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001792">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a configuration management plan for the system that establishes a process for identifying configuration items throughout the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-9 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001793">
      <status>draft</status>
      <publishdate>2013-03-01</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a configuration management plan for the information system that establishes a process for managing the configuration of the configuration items.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001794">
      <status>draft</status>
      <publishdate>2013-03-01</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents a configuration management plan for the information system that establishes a process for managing the configuration of the configuration items.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001795">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a configuration management plan for the system that establishes a process for managing the configuration of the configuration items.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-9 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001796">
      <status>draft</status>
      <publishdate>2013-03-01</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a configuration management plan for the information system that places the configuration items under configuration management.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-9 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001797">
      <status>draft</status>
      <publishdate>2013-03-01</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents a configuration management plan for the information system that places the configuration items under configuration management.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-9 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001798">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a configuration management plan for the system that places the configuration items under configuration management.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-9 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-9 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001799">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document a configuration management plan for the system that protects the configuration management plan from unauthorized disclosure and modification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-9 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-9 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001800">
      <status>deprecated</status>
      <publishdate>2013-03-01</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents a configuration management plan for the information system that protects the configuration management plan from unauthorized disclosure and modification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-9 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001801">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a configuration management plan for the system that protects the configuration management plan from unauthorized disclosure and modification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-9 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-9 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001802">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Track the use of software documentation protected by quantity licenses to control copying of the software documentation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-10 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-10 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001803">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Track the use of software protected by quantity licenses to control distribution of the software.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-10 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-10 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001804">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the policies for governing the installation of software by users.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-11 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-11 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001805">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish organization-defined policies governing the installation of software by users.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-11 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-11 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001806">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines methods to be employed to enforce the software installation policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-11 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-11 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001807">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce software installation policies through organization-defined methods.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-11 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-11 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001808">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency on which it will monitor software installation policy compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-11 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-11 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001809">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor software installation policy compliance per an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-11 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-11 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001810">
      <status>draft</status>
      <publishdate>2013-03-01</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the personnel or roles to be notified when unauthorized software is detected.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-11 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001811">
      <status>draft</status>
      <publishdate>2013-03-01</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system alerts organization-defined personnel or roles when the unauthorized installation of software is detected.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-11 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001812">
      <status>draft</status>
      <publishdate>2013-03-01</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system prohibits user installation of software without explicit privileged status.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-11 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001813">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce access restrictions using organization-defined mechanisms.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-5 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001814">
      <status>draft</status>
      <publishdate>2013-03-01</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The Information system supports auditing of the enforcement actions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001815">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls to be applied to devices when individuals return from areas of significant risk.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 (7) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2 (7) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001816">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Apply organization-defined controls to the systems or components when the individuals return from travel.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 (7) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-2 (7) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001817">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When analyzing changes to the system, looks for privacy impacts due to flaws, weaknesses, incompatibility, or intentional malice.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001818">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Analyze changes to the system in a separate test environment before installation in an operational environment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001819">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement approved configuration-controlled changes to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001820">
      <status>deprecated</status>
      <publishdate>2013-03-01</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents a configuration management policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-001821">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the organizational personnel or roles to whom the organization-level; mission/business process-level; and/or system-level configuration management policy is to be disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-001822">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate the organization-level; mission/business process-level; and/or system-level configuration management policy to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-001823">
      <status>deprecated</status>
      <publishdate>2013-03-01</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents the procedures to facilitate the implementation of the configuration management policy and associated configuration management controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001824">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the organizational personnel or roles to whom the organization-level; mission/business process-level; and/or system-level configuration management procedures are to be disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001825">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate to organization-defined personnel or roles the procedures to facilitate the implementation of the organization-level; mission/business process-level; and/or system-level configuration management policy and associated configuration management controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001826">
      <status>draft</status>
      <publishdate>2013-03-05</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the circumstances upon which the organization reviews the information system changes to determine whether unauthorized changes have occurred.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001827">
      <status>draft</status>
      <publishdate>2013-03-05</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency with which to review information system privileges.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001828">
      <status>draft</status>
      <publishdate>2013-03-05</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency with which to reevaluate information system privileges.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001829">
      <status>draft</status>
      <publishdate>2013-03-05</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization reviews information system privileges per an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001830">
      <status>draft</status>
      <publishdate>2013-03-05</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization reevaluates information system privileges per an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-5 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001831">
      <status>deprecated</status>
      <publishdate>2013-03-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents an audit and accountability policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-001832">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate the organization-level; mission/business process-level; and/or system-level audit and accountability policy to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-001833">
      <status>deprecated</status>
      <publishdate>2013-03-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents procedures to facilitate the implementation of the audit and accountability policy and associated audit and accountability controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001834">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate to organization-defined personnel or roles procedures to facilitate the implementation of the audit and accountability policy and associated audit and accountability controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001835">
      <status>deprecated</status>
      <publishdate>2013-03-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency on which it will review the audit and accountability policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 b 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-001836">
      <status>deprecated</status>
      <publishdate>2013-03-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency on which it will update the audit and accountability policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 b 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-001837">
      <status>deprecated</status>
      <publishdate>2013-03-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization reviews the audit and accountability policy on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 b 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-001838">
      <status>deprecated</status>
      <publishdate>2013-03-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization updates the audit and accountability policy on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 b 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-001839">
      <status>deprecated</status>
      <publishdate>2013-03-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency on which it will review the audit and accountability procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 b 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001840">
      <status>deprecated</status>
      <publishdate>2013-03-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency on which it will update the audit and accountability procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 b 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001841">
      <status>deprecated</status>
      <publishdate>2013-03-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization reviews the audit and accountability procedures on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 b 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001842">
      <status>deprecated</status>
      <publishdate>2013-03-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization updates the audit and accountability procedures on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 b 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001843">
      <status>deprecated</status>
      <publishdate>2013-03-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines a frequency for updating the list of organization-defined auditable events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001844">
      <status>draft</status>
      <publishdate>2013-03-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system provides centralized management and configuration of the content to be captured in audit records generated by organization-defined information system components.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001845">
      <status>deprecated</status>
      <publishdate>2013-03-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system provides centralized configuration of the content to be captured in audit records generated by organization-defined information system components.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001846">
      <status>draft</status>
      <publishdate>2013-03-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines information system components that will generate the audit records which are to be captured for centralized management of the content.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001847">
      <status>draft</status>
      <publishdate>2013-03-14</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines information system components that will generate the audit records which are to be captured for centralized configuration of the content.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001848">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the audit log retention requirements for allocating audit log storage capacity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-4" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-001849">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Allocate audit log storage capacity to accommodate organization-defined audit record retention requirements.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-4" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-001850">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency to off-load audit records onto a different system or media than the system being audited.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001851">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Transfer audit logs per organization-defined frequency to a different system, system component, or media than the system or system component conducting the logging.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001852">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel, roles and/or locations to receive a warning when allocated audit log storage volume reaches a defined percentage of maximum audit log storage capacity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001853">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period within which organization-defined personnel, roles, and/or locations are to receive warnings when allocated audit log storage volume reaches an organization-defined percentage of maximum audit log storage capacity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001854">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the percentage of maximum audit log storage capacity that is to be reached, at which time the system will provide a warning to organization-defined personnel, roles, and/or locations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001855">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide a warning to organization-defined personnel, roles, and/or locations within an organization-defined time period when allocated audit log storage volume reaches an organization-defined percentage of repository maximum audit log storage capacity.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001856">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the real-time period in which to provide an alert when organization-defined audit failure events occur.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001857">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel, roles, and/or locations to receive alerts when organization-defined audit failure events occur.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001858">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide an alert in an organization-defined real-time-period to organization-defined personnel, roles, and/or locations when organization-defined audit failure events requiring real-time alerts occur.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001859">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the network communication traffic volume thresholds reflecting limits on auditing capacity, specifying when the information system will reject or delay network traffic that exceed those thresholds.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001860">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the audit logging failures which, should they occur, will invoke an organization-defined system mode.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-5 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001861">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Invoke a full system shutdown, partial system shutdown, or degraded operational mode with limited mission or business functionality available in the event of organization-defined audit logging failures, unless an alternate audit logging capability exists.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-5 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001862">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the types of inappropriate or unusual activity to be reviewed and analyzed in the audit records.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001863">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to receive the reports of organization-defined inappropriate or unusual activity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001864">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Integrate audit review and analysis using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001865">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Integrate reporting processes using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001866">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the data/information to be collected from other sources to enhance its ability to identify inappropriate or unusual activity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-6 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001867">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Integrate analysis of audit records with analysis of vulnerability scanning information, performance data, system monitoring information, and/or organization-defined data/information collected from other sources to further enhance the ability to identify inappropriate or unusual activity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-6 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001868">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Specify the permitted actions for each information system process, role, and/or user associated with the review and analysis of audit information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-6 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001869">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Specify the permitted actions for each information system process, role, and/or user associated with the reporting of audit information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-6 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001870">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Perform a full-text analysis of logged privileged commands in a physically-distinct component or subsystem of the system, or other system that is dedicated to that analysis.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-6 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001871">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Correlate information from non-technical sources with audit record information to enhance organization-wide situational awareness.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 (9)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-6 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001872">
      <status>draft</status>
      <publishdate>2013-03-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization adjusts the level of audit review and analysis within the information system when there is a change in risk based on law enforcement information, intelligence information, or other credible sources of information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-6 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001873">
      <status>deprecated</status>
      <publishdate>2013-03-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization adjusts the level of audit analysis within the information system when there is a change in risk based on law enforcement information, intelligence information, or other credible sources of information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-6 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001874">
      <status>draft</status>
      <publishdate>2013-03-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization adjusts the level of audit reporting within the information system when there is a change in risk based on law enforcement information, intelligence information, or other credible sources of information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-6 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001875">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide an audit reduction capability that supports on-demand audit review and analysis.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-7 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001876">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide an audit reduction capability that supports on-demand reporting requirements.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-7 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001877">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide an audit reduction capability that supports after-the-fact investigations of incidents.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-7 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001878">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide a report generation capability that supports on-demand audit review and analysis.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-7 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001879">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide a report generation capability that supports on-demand reporting requirements.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-7 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001880">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide a report generation capability that supports after-the-fact investigations of security incidents.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-7 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001881">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide an audit reduction capability that does not alter original content or time ordering of audit records.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-7 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001882">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide a report generation capability that does not alter original content or time ordering of audit records.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-7 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001883">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the audit fields within audit records to be processed, sorted, and searched for events of interest by the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-7 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001884">
      <status>draft</status>
      <publishdate>2013-03-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the audit fields within audit records to be sorted for events of interest by the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001885">
      <status>draft</status>
      <publishdate>2013-03-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the audit fields within audit records to be searched for events of interest by the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001886">
      <status>draft</status>
      <publishdate>2013-03-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system provides the capability to sort audit records for events of interest based on the content of organization-defined audit fields within audit records.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001887">
      <status>draft</status>
      <publishdate>2013-03-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system provides the capability to search audit records for events of interest based on the content of organization-defined audit fields within audit records.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001888">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the granularity of time measurement for time stamps generated for audit records.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-8 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001889">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Record time stamps for audit records that meet organization-defined granularity of time measurement.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-8 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001890">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Record time stamps for audit records that use Coordinated Universal Time, have a fixed local time offset from Coordinated Universal Time, or that include the local time offset as part of the time stamp.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-8 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001891">
      <status>draft</status>
      <publishdate>2013-03-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system compares internal information system clocks on an organization-defined frequency with an organization-defined authoritative time source.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-8 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001892">
      <status>draft</status>
      <publishdate>2013-03-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the time difference which, when exceeded, will require the information system to synchronize the internal information system clocks to the organization-defined authoritative time source.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-8 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001893">
      <status>draft</status>
      <publishdate>2013-03-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system identifies a secondary authoritative time source that is located in a different geographic region than the primary authoritative time source.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001894">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the subset of privileged users who will be authorized access to the management of audit functionality.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-9 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001895">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the audit information requiring dual authorization for movement or deletion actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-9 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001896">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce dual authorization for movement and/or deletion of organization-defined audit information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-9 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001897">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the subset of privileged users or roles who will be authorized read-only access to audit information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-9 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001898">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authorize read-only access to audit information to an organization-defined subset of privileged users or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-9 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001899">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the actions to be covered by non-repudiation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-10" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-001900">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the strength of binding to be applied to the binding of the identity of the information producer with the information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-10 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-10 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001901">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Bind the identity of the information producer with the information to an organization-defined strength of binding.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-10 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-10 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001902">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the means for authorized individuals to determine the identity of the producer of the information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-10 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-10 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001903">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency on which the information system is to validate the binding of the information producer identity to the information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-10 (2) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-10 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001904">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Validates the binding of the information producer identity to the information at an organization-defined frequency.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-10 (2) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-10 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001905">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the actions to be performed in the event of an error when validating the binding of the information producer identity to the information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-10 (2) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-10 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001906">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Perform organization-defined actions in the event of an error when validating the binding of the information producer identity to the information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-10 (2) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-10 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001907">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security domains which will require the information system validate the binding of the information reviewer identity to the information at the transfer or release points prior to release/transfer.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-10 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-10 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001908">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the action the system is to perform in the event of an information reviewer identity binding validation error.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-10 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-10 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001909">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Perform organization-defined actions in the event of an information reviewer identity binding validation error.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-10 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-10 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001910">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles allowed to select which event types are to be logged by specific components of the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-12 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-12 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001911">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the selectable event criteria to be used as the basis for changes to the auditing to be performed on organization-defined system components, by organization-defined individuals or roles, within organization-defined time thresholds.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-12 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001912">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time thresholds for organization-defined individuals or roles to change the auditing to be performed based on organization-defined selectable event criteria.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-12 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001913">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the individuals or roles that are to be provided the capability to change the auditing to be performed based on organization-defined selectable event criteria, within organization-defined time thresholds.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-12 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001914">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the capability for organization-defined individuals or roles to change the logging to be performed on organization-defined system components based on organization-defined selectable event criteria within organization-defined time thresholds.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-12 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001915">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the open source information and/or information sites to be monitored for evidence of unauthorized exfiltration or disclosure of organizational information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-13 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-13" />
      </references>
    </cci_item>
    <cci_item id="CCI-001916">
      <status>draft</status>
      <publishdate>2013-03-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms to determine if organizational information has been disclosed in an unauthorized manner.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-13 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001917">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for reviewing the open source information sites being monitored.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-13 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-13 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001918">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review the open source information sites being monitored per organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-13 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-13 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001919">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the capability for organization-defined users or roles to select a user session to record; view; hear; or log the content of a user session under organization-defined circumstances.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-14 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-14" />
      </references>
    </cci_item>
    <cci_item id="CCI-001920">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the capability for authorized users to remotely view and hear content related to an established user session in real time.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-14 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-14 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001921">
      <status>draft</status>
      <publishdate>2013-03-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the alternative audit functionality to be provided in the event of a failure in the primary audit capability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-15" />
      </references>
    </cci_item>
    <cci_item id="CCI-001922">
      <status>draft</status>
      <publishdate>2013-03-15</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides an alternative audit capability in the event of a failure in primary audit capability that provides organization-defined alternative audit functionality.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-15" />
      </references>
    </cci_item>
    <cci_item id="CCI-001923">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the audit information to be coordinated among external organizations when audit information is transmitted across organizational boundaries.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-16" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-001924">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the methods to be employed when coordinating audit information among external organizations when audit information is transmitted across organizational boundaries.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-16" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-001925">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined methods for coordinating organization-defined audit information among external organizations when audit information is transmitted across organizational boundaries.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-16" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-001926">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Preserve the identity of individuals in cross-organizational audit trails.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-16 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-16 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001927">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the organizations that will be provided cross-organizational audit information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-16 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-16 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001928">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the cross-organizational sharing agreements to be established with organization-defined organizations authorized to be provided cross-organizational sharing of audit information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-16 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-16 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001929">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide cross-organizational audit information to organization-defined organizations based on organization-defined cross organizational sharing agreements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-16 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-16 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001930">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the organization-level; mission/business process-level; and/or system-level audit and accountability policy is to be disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-001931">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the audit and accountability procedures are to be disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001932">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents an identification and authentication policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-001933">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the personnel or roles to be recipients of the identification and authentication policy and the procedures to facilitate the implementation of the identification and authentication policy and associated identification and authentication controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-001934">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents procedures to facilitate the implementation of the identification and authentication policy and associated identification and authentication controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-001935">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the strength of mechanism requirements for the device that is separate from the system gaining access to privileged accounts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001936">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system implements multifactor authentication for network access to privileged accounts such that one of the factors is provided by a device separate from the system gaining access.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001937">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The device used in the information system implementation of multifactor authentication for network access to privileged accounts meets organization-defined strength of mechanism requirements.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001938">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the strength of mechanism requirements for the device that is separate from the system gaining access to non-privileged accounts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001939">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system implements multifactor authentication for network access to non-privileged accounts such that one of the factors is provided by a device separate from the system gaining access.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001940">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The device used in the information system implementation of multifactor authentication for network access to non-privileged accounts meets organization-defined strength of mechanism requirements.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001941">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement replay-resistant authentication mechanisms for access to privileged accounts and/or non-privileged accounts.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-2 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001942">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system implements replay-resistant authentication mechanisms for network access to non-privileged accounts.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001943">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system accounts for which single sign-on capability will be provided.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-2 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001944">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system services for which single sign-on capability will be provided.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-2 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001945">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide a single sign-on capability for organization-defined system accounts.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-2 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001946">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide a single sign-on capability for organization-defined system services.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-2 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001947">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the strength of mechanism requirements for the device that is separate from the system gaining access and is to provide one factor of a multifactor authentication for remote access to privileged accounts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001948">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system implements multifactor authentication for remote access to privileged accounts such that one of the factors is provided by a device separate from the system gaining access.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001949">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The device used in the information system implementation of multifactor authentication for remote access to privileged accounts meets organization-defined strength of mechanism requirements.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001950">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the strength of mechanism requirements for the device that is separate from the system gaining access and is to provide one factor of a multifactor authentication for remote access to non-privileged accounts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001951">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system implements multifactor authentication for remote access to non-privileged accounts such that one of the factors is provided by a device separate from the system gaining access.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001952">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The device used in the information system implementation of multifactor authentication for remote access to non-privileged accounts meets organization-defined strength of mechanism requirements.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001953">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Accepts Personal Identity Verification-compliant credentials.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-2 (12)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001954">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Electronically verifies Personal Identity Verification-compliant credentials.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-2 (12)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001955">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the out-of-band authentication to be implemented under organization-defined conditions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-2 (13)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001956">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the conditions for implementing organization-defined out-of-band authentication.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-2 (13)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001957">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined out-of-band authentication mechanisms under organization-defined conditions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-2 (13)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-2 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001958">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authenticate organization-defined devices and/or types of devices before establishing a local, remote, and/or network connection.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-3" />
      </references>
    </cci_item>
    <cci_item id="CCI-001959">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the devices and/or types of devices the system is to authenticate before establishing a connection.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001960">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the lease information to be assigned to devices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-3 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-3 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001961">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the lease duration to be assigned to devices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-3 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-3 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001962">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Where addresses are allocated dynamically, standardize dynamic address allocation lease information assigned to devices in accordance with organization-defined lease information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-3 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-3 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001963">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Where addresses are allocated dynamically, standardize dynamic address allocation lease duration assigned to devices in accordance with organization-defined lease duration.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-3 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-3 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001964">
      <status>deprecated</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the configuration management process that is to handle the device identification procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001965">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the configuration management process that is to handle the device authentication procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-3 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001966">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Handle device identification based on attestation is handled by the organization-defined configuration management process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-3 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001967">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authenticate organization-defined devices and/or types of devices before establishing a local, remote, and/or network connection using bidirectional authentication that is cryptographically based.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001968">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the configuration management process that is to handle the device identification procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-3 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001969">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Handle device authentication based on attestation is handled by the organization-defined configuration management process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-3 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001970">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles that authorize the assignment of individual, group, role, and device identifiers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-4 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001971">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage system identifiers by receiving authorization from organization-defined personnel or roles to assign an individual, group, role, or device identifier.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-4 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001972">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage system identifiers by selecting an identifier that identifies an individual, group, role, or device.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-4 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-001973">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage system identifiers by assigning the identifier to the intended individual, group, role, or device.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-4 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-4 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-001974">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period for which the reuse of identifiers is prohibited.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-4 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001975">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage system identifiers by preventing reuse of identifiers for an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-4 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001976">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage individual identifiers dynamically in accordance with organization-defined identifier policy.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-4 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-4 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001977">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the external organizations with which it will coordinate for cross-management of identifiers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-4 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-4 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001978">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Coordinate with organization-defined external organizations for cross-organization management of identifiers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-4 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-4 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001979">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires the registration process to receive an individual identifier be conducted in person before a designated registration authority.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-4 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001980">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage system authenticators by verifying, as part of the initial authenticator distribution, the identity of the individual, group, role, service, or device receiving the authenticator.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-001981">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage system authenticators by establishing administrative procedures for initial authenticator distribution.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001982">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system authenticators by establishing administrative procedures for lost/compromised authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001983">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system authenticators by establishing administrative procedures for damaged authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001984">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage system authenticators by establishing administrative procedures for revoking authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001985">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage system authenticators by implementing administrative procedures for initial authenticator distribution.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001986">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system authenticators by implementing administrative procedures for lost/compromised authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001987">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system authenticators by implementing administrative procedures for damaged authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001988">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage system authenticators by implementing administrative procedures for revoking authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-001989">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system authenticators by changing default content of authenticators prior to information system installation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-001990">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage system authenticators by changing authenticators for group or role accounts when membership to those accounts changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 i" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 j" />
      </references>
    </cci_item>
    <cci_item id="CCI-001991">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system, for PKI-based authentication, implements a local cache of revocation data to support path discovery and validation in case of inability to access revocation information via the network.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (2) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001992">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the personnel or roles responsible for authorizing the organization's registration authority accountable for the authenticator registration process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001993">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the registration authority accountable for the authenticator registration process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001994">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the types of and/or specific authenticators that are subject to the authenticator registration process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001995">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires that the registration process, to receive organization-defined types of and/or specific authenticators, be conducted in person, or by a trusted third-party, before an organization-defined registration authority with authorization by organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001996">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the requirements required by the automated tools to determine if password authenticators are sufficiently strong.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001997">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated tools to determine if password authenticators are sufficiently strong to satisfy organization-defined requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001998">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require developers and installers of system components to provide unique authenticators or change default authenticators prior to delivery and installation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-001999">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the external organizations to be coordinated with for cross-organization management of credentials.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002000">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization coordinates with organization-defined external organizations for cross-organization management of credentials.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002001">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Bind identities and authenticators dynamically using organization-defined binding rules.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002002">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the token quality requirements to be employed by the information system mechanisms for token-based authentication.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002003">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system, for token-based authentication, employs mechanisms that satisfy organization-defined token quality requirements.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002004">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the biometric quality requirements to be employed by the mechanisms for biometric-based authentication.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (12)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002005">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For biometric-based authentication, employ mechanisms that satisfy organization-defined biometric quality requirements.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (12)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002006">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period after which the use of cached authenticators is prohibited.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (13)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002007">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit the use of cached authenticators after an organization-defined time period.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (13)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002008">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For PKI-based authentication, employs an organization-wide methodology for managing the content of PKI trust stores installed across all platforms including networks, operating systems, browsers, and applications.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (14)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (14)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002009">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Accept Personal Identity Verification-compliant credentials from other federal agencies.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-8 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-8 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002010">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Electronically verify Personal Identity Verification-compliant credentials from other federal agencies.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-8 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-8 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002011">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system accepts FICAM-approved third-party credentials.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002012">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the information systems which will employ only FICAM-approved information system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-8 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002013">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs only FICAM-approved information system components in organization-defined information systems to accept third-party credentials.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-8 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002014">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system conforms to FICAM-issued profiles.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-8 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002015">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Accept federated or PKI credentials that meet organization-defined policy.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-8 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-8 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002016">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify federated PKI credentials that meet organization-defined policy.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-8 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-8 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002017">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the information system services requiring identification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-002018">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system services and applications requiring authentication.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-9" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-002019">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the security safeguards to be used when identifying information system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-002020">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the security safeguards to be used when authenticating information system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-002021">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Uniquely identify organization-defined system services and applications before establishing communications with devices, users, or other services or applications.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-9" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-002022">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Uniquely authenticate organization-defined system services and applications before establishing communications with devices, users, or other services or applications.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-9" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-002023">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that service providers receive identification information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002024">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that service providers validate identification information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002025">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that service providers transmit identification information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002026">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that service providers receive authentication information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002027">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that service providers validate authentication information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002028">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that service providers transmit authentication information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002029">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the services between which identification decisions are to be transmitted.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-9 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002030">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the services between which authentication decisions are to be transmitted.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-9 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002031">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that identification decisions are transmitted between organization-defined services consistent with organizational policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-9 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002032">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that authentication decisions are transmitted between organization-defined services consistent with organizational policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-9 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002033">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the specific circumstances or situations when individuals accessing the system employ organization-defined supplemental authentication techniques or mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-10" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-002034">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the supplemental authentication techniques or mechanisms to be employed in specific organization-defined circumstances or situations by individuals accessing the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-10" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-002035">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require individuals accessing the system employ organization-defined supplemental authentication techniques or mechanisms under specific organization-defined circumstances or situations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-10" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-002036">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the circumstances or situations under which users will be required to reauthenticate.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-11" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-11" />
      </references>
    </cci_item>
    <cci_item id="CCI-002037">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the circumstances or situations under which devices will be required to reauthenticate.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-11" />
      </references>
    </cci_item>
    <cci_item id="CCI-002038">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires users to reauthenticate upon organization-defined circumstances or situations requiring reauthentication.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-11" />
      </references>
    </cci_item>
    <cci_item id="CCI-002039">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires devices to reauthenticate upon organization-defined circumstances or situations requiring reauthentication.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-11" />
      </references>
    </cci_item>
    <cci_item id="CCI-002040">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires that the registration process to receive an individual identifier includes supervisor authorization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002041">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system allows the use of a temporary password for system logons with an immediate change to a permanent password.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (1) (f)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002042">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage system authenticators by protecting authenticator content from unauthorized modification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 g" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 h" />
      </references>
    </cci_item>
    <cci_item id="CCI-002043">
      <status>draft</status>
      <publishdate>2013-05-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization uses only FICAM-approved path discovery and validation products and services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (15)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002044">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines measures to be employed to ensure that long-term audit records generated by the system can be retrieved.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-11 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-11 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002045">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined measures to ensure that long-term audit records generated by the information system can be retrieved.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-11 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-11 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002046">
      <status>draft</status>
      <publishdate>2013-05-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system synchronizes the internal system clocks to the authoritative time source when the time difference is greater than the organization-defined time period.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-8 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002047">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components on which the auditing that is to be performed can be changed by organization-defined individuals or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-12 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002048">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the awareness and training policy is disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002049">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the organization-level; mission/business process-level; system-level awareness and training procedures are disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-002050">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom initial and refresher training in the employment and operation of environmental controls is to be provided.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002051">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom initial and refresher training in the employment and operation of physical security controls is to be provided.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002052">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide practical exercises in security training that reinforce training objectives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002053">
      <status>draft</status>
      <publishdate>2013-06-05</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides training to its personnel on organization-defined indicators of malicious code to recognize suspicious communications and anomalous behavior in organizational information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002054">
      <status>draft</status>
      <publishdate>2013-06-05</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines indicators of malicious code to recognize suspicious communications and anomalous behavior in organizational information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002055">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide literacy training on recognizing and reporting potential indicators of insider threat.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AT-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002056">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period the records of configuration-controlled changes are to be retained.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-002057">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel to be notified when approved changes to the system are completed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (1) (f)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (1) (f)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002058">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ automated mechanisms to notify organization-defined personnel when approved changes to the system are completed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (1) (f)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-3 (1) (f)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002059">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components for which the organization will employ automated mechanisms to centrally manage, apply, and verify configuration settings.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CM-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002060">
      <status>deprecated</status>
      <publishdate>2013-06-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops and documents a security assessment and authorization policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002061">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the organization-level; mission/business process; system-level assessment, authorization, and monitoring policy is to be disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002062">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the assessment, authorization, monitoring procedures are to be disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-002063">
      <status>draft</status>
      <publishdate>2013-06-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the level of independence for assessors or assessment teams to conduct security control assessments of organizational information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002064">
      <status>draft</status>
      <publishdate>2013-06-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization selects one or more security assessment techniques to be conducted.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002065">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency at which to conduct control assessments.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002066">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Leverage the results of control assessments of the organization-defined system performed by an organization-defined external organization when the assessment meets organization-defined requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002067">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system for which the results of control assessments will be leveraged.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002068">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the external organizations from which control assessment results for organization-defined systems will be accepted.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002069">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the requirements the control assessments for organization-defined systems from organization-defined external organizations must meet.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002070">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a control assessment plan that describes the scope of the assessment including assessment team, and assessment roles and responsibilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 b 3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-002071">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the individuals or roles to whom the results of the control assessment are to be provided.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 f" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002072">
      <status>draft</status>
      <publishdate>2013-06-21</publishdate>
      <contributor>DISA FSP</contributor>
      <definition>The organization defines the unclassified, national security systems that are prohibited from directly connecting to an external network without the use of an organization-defined boundary protection device.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002073">
      <status>draft</status>
      <publishdate>2013-06-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the boundary protection device to be used to connect organization-defined unclassified, national security systems to an external network.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002074">
      <status>draft</status>
      <publishdate>2013-06-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the boundary protection device to be used for the direct connection of classified, national security system to an external network.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002075">
      <status>draft</status>
      <publishdate>2013-06-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prohibits the direct connection of an organization-defined unclassified, non-national security system to an external network without the use of organization-defined boundary protection device.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002076">
      <status>draft</status>
      <publishdate>2013-06-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the unclassified, non-national security system that is prohibited from directly connecting to an external network without the use of an organization-defined boundary protection device.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002077">
      <status>draft</status>
      <publishdate>2013-06-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the boundary protection device to be used to directly connect an organization-defined unclassified, non-national security system to an external network.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002078">
      <status>draft</status>
      <publishdate>2013-06-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prohibits the direct connection of an organization-defined information system to a public network.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002079">
      <status>draft</status>
      <publishdate>2013-06-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the information system that is prohibited from directly connecting to a public network.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002080">
      <status>draft</status>
      <publishdate>2013-06-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs either an allow-all, deny-by-exception or a deny-all, permit-by-exception policy for allowing organization-defined information systems to connect to external information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-3 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002081">
      <status>draft</status>
      <publishdate>2013-06-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the information systems that employ either an allow-all, deny-by-exception or a deny-all, permit-by-exception policy for allowing connections to external information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-3 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002082">
      <status>draft</status>
      <publishdate>2013-06-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization selects either an allow-all, deny-by-exception or a deny-all, permit-by-exception policy for allowing organization-defined information systems to connect to external information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-3 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002083">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the agreements on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-3 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002084">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency at which reviews and updates to the agreements must be conducted.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-3 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002085">
      <status>draft</status>
      <publishdate>2013-06-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the level of independence the assessors or assessment teams must have to monitor the security controls in the information system on an ongoing basis.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002086">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ trend analyses to determine if control implementations, the frequency of continuous monitoring activities, and the types of activities used in the continuous monitoring process need to be modified based on empirical data.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-7 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002087">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish organization-defined system-level metrics to be monitored.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002088">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish organization-defined frequencies for monitoring.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002089">
      <status>draft</status>
      <publishdate>2013-06-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes and defines the frequencies for assessments supporting continuous monitoring.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002090">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement ongoing monitoring of system and organization-defined metrics in accordance with the continuous monitoring strategy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-7 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002091">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a continuous monitoring program that includes correlation and analysis of information generated by assessments and monitoring.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-7 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-002092">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a continuous monitoring program that includes response actions to address results of the analysis of control assessment and monitoring information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 f" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-7 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-002093">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct penetration testing in accordance with organization-defined frequency on organization-defined systems or system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-8" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-002094">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for conducting penetration testing on organization-defined systems or system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-8" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-002095">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components on which penetration testing will be conducted.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-8" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-002096">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ an independent penetration agent or penetration team to perform penetration testing on the system or system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-8 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-8 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002097">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines red team exercises to simulate attempts by adversaries to compromise organizational systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-8 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002098">
      <status>draft</status>
      <publishdate>2013-06-21</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines rules of engagement for red team exercises to simulate attempts by adversaries to compromise organizational information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002099">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined red team exercises to simulate attempts by adversaries to compromise organizational systems in accordance with applicable rules of engagement.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-8 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002100">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Perform security compliance checks on constituent components prior to the establishment of the internal connection.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-9 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002101">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authorizes internal connections of organization-defined system components or classes of components to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-9 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-9 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002102">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components or classes of components that are authorized internal connections to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-9 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-9 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002103">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document, for each internal connection, the interface characteristics.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-9 (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-9 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002104">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document, for each internal connection, the security requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-9 (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-9 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002105">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document, for each internal connection, the nature of the information communicated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-9 (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CA-9 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002106">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents the access control policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002107">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to be recipients of the organization-level; mission/business process-level; and/or system-level access control policy necessary to facilitate the implementation of the access control policy and associated access controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002108">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to be recipients of the procedures necessary to facilitate the implementation of the organization-level; mission/business process-level; and/or system-level access control policy and associated access controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002109">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents procedures to facilitate the implementation of the access control policy and associated access controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-002110">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the information system account types that support the organizational missions/business functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002111">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization identifies and selects the organization-defined information system account types of information system accounts which support organizational missions/business functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002112">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Assign account managers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002113">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes conditions for role membership.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002114">
      <status>deprecated</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization specifies authorized users of the information system for each account.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002115">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Specify authorized users of the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 d 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002116">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Specify authorized users of the group.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 d 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002117">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Specify authorized users of the role membership.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 d 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002118">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Specify authorized access authorizations (i.e., privileges) for each account.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 d 3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002119">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Specify organization-attributes (as required) for each account on the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 d 3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002120">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles authorized to approve the creation of accounts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-002121">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the procedures to be employed when creating, enabling, modifying, disabling, and removing information system accounts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 f" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-002122">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor the use of accounts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 g" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-002123">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Notify account managers and organization-defined personnel or roles within an organization-defined time-period when accounts are no longer required.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 h 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 h 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002124">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Notify account managers and organization-defined personnel or roles within an organization-defined time-period when users are terminated or transferred.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 h 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 h 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-002125">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Notify account managers and organization-defined personnel or roles within an organization-defined time-period when system usage or need-to-know changes for an individual.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 h 3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 h 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-002126">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authorize access to the system based on a valid access authorization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 i 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 i 1 " />
      </references>
    </cci_item>
    <cci_item id="CCI-002127">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authorize access to the system based on intended system usage.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 i 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 i 2 " />
      </references>
    </cci_item>
    <cci_item id="CCI-002128">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authorize access to the system based on organization-defined attributes (as required).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 i 3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 i 3 " />
      </references>
    </cci_item>
    <cci_item id="CCI-002129">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish and implement a process for changing shared or group account authenticators (if deployed) when individuals are removed from the group.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 k" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 k" />
      </references>
    </cci_item>
    <cci_item id="CCI-002130">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Automatically audit account enabling actions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002131">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the personnel or roles to be notified on account creation, modification, enabling, disabling, and removal actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002132">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system notifies organization-defined personnel or roles for account enabling actions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002133">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines other conditions when users are required to log out.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002134">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a list of dynamic privilege management capabilities to be implemented.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002135">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the organization-defined list of dynamic privilege management capabilities.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002136">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the actions to be taken when privileged role assignments are no longer appropriate.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (7) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002137">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Revoke access when privileged role or attribute assignments are no longer appropriate.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (7) (d)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (7) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002138">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system accounts that can be dynamically created.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002139">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Create organization-defined system accounts dynamically.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002140">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the conditions for establishing shared/group accounts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (9)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002141">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Only permit the use of shared and group accounts that meet organization-defined conditions for establishing shared and group accounts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (9)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002142">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system terminates shared/group account credentials when members leave the group.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002143">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the circumstances and/or usage conditions that are to be enforced for organization-defined information system accounts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (11)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002144">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system accounts that are to be subject to the enforcement of organization-defined circumstances and/or usage conditions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (11)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002145">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined circumstances and/or usage conditions for organization-defined system accounts.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (11)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002146">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines atypical usage for which the system accounts are to be monitored.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (12) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (12) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002147">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor system accounts for organization-defined atypical usage.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (12) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (12) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002148">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom atypical usage of system accounts are to be reported.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (12) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (12) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002149">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Report atypical usage of system accounts to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (12) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (12) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002150">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period within which the accounts of users posing a significant risk are to be disabled after discovery of the risk.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (13)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002151">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disable accounts of individuals within an organization-defined time-period of discovery of organization-defined significant risk.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (13)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-2 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002152">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines other actions necessary for which dual authorization is to be enforced.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002153">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the mandatory access control policies that are to be enforced over all subjects and objects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002154">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The mandatory access control policy specifies that the policy is uniformly enforced across all subjects and objects within the boundary of the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002155">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined mandatory access control policy over all subjects and objects where the policy specifies that a subject that has been granted access to information is constrained from passing the information to unauthorized subjects or objects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (3) (b) (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (3) (b) (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002156">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined mandatory access control policy over all subjects and objects where the policy specifies that a subject that has been granted access to information is constrained from granting its privileges to other subjects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (3) (b) (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (3) (b) (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002157">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined mandatory access control policy over all subjects and objects where the policy specifies that a subject that has been granted access to information is constrained from changing one or more security attributes on subjects, objects, the system, or system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (3) (b) (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (3) (b) (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002158">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined mandatory access control policy over all subjects and objects where the policy specifies that a subject that has been granted access to information is constrained from choosing the security attributes to be associated with newly created or modified objects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (3) (b) (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (3) (b) (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002159">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined mandatory access control policy over all subjects and objects where the policy specifies that a subject that has been granted access to information is constrained from choosing the attribute values to be associated with newly created or modified objects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (3) (b) (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (3) (b) (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002160">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined mandatory access control policy over all subjects and objects where the policy specifies that a subject that has been granted access to information is constrained from changing the rules governing access control.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (3) (b) (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (3) (b) (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002161">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines subjects which may explicitly be granted organization-defined privileges such that they are not limited by any of the mandatory access control constraints.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (3) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (3) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002162">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the privileges that may explicitly be granted to organization-defined subjects such that they are not limited by any of the mandatory access control constraints.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (3) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (3) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002163">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the discretionary access control policies the information system is to enforce over subjects and objects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002164">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined discretionary access control policy that over the set of covered subjects and objects specified in the policy, and where the policy specifies that a subject that has been granted access to information can do one or more of the following: pass the information to any other subjects or objects; grant its privileges to other subjects; change security attributes on subjects, objects, the information system, or the information system's components; choose the security attributes to be associated with newly created or revised objects; and/or change the rules governing access control.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (4) " />
      </references>
    </cci_item>
    <cci_item id="CCI-002165">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined discretionary access control policies over defined subjects and objects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002166">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the role-based access control policies to enforce over all subjects and objects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002167">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the subjects over which the information system will enforce a role-based access control policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002168">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the objects over which the information system will enforce a role-based access control policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002169">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce a role-based access control policy over defined subjects and objects based upon organization-defined roles and users authorized to assume such roles.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002170">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Control access based upon organization-defined roles and users authorized to assume such roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002171">
      <status>deprecated</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system enforces a role-based access control policy over organization-defined subjects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002172">
      <status>deprecated</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system enforces a role-based access control policy over organization-defined objects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002173">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the roles authorized to control access based upon the role-based access control policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002174">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the users authorized to control access based upon the role-based access control policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002175">
      <status>deprecated</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system controls access based upon organization-defined roles authorized to assume such roles, employing the organization-defined role-based access control policy.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002176">
      <status>deprecated</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system controls access based upon organization-defined users authorized to assume such roles, employing the organization-defined role-based access control policy.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002177">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the rules governing the timing of revocation of access authorizations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002178">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce the revocation of access authorizations resulting from changes to the security attributes of subjects based on organization-defined rules governing the timing of revocations of access authorizations.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002179">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce the revocation of access authorizations resulting from changes to the security attributes of objects based on organization-defined rules governing the timing of revocations of access authorizations.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002180">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls the organization-defined system or system component is to provide to protect information released outside the established system boundary.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (9) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (9) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002181">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines system or system components that are to provide organization-defined controls to protect information received outside the established system boundary.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (9) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (9) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002182">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Release information outside of the established system boundary only if organization-defined system or system components provides organization-defined controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (9) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (9) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002183">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls to be used to validate the appropriateness of the information designated for release.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (9) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (9) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002184">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Release information outside of the established system boundary only if organization-defined controls are used to validate the appropriateness of the information designated for release.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (9) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (9) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002185">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the conditions on which it will employ an audited override of automated access control mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002186">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ an audited override of automated access control mechanisms under organization-defined conditions by organization-defined roles.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002187">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security attributes to be used to enforce organization-defined information flow control policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002188">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information, source, and destination objects with which the organization-defined security attributes are to be associated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002189">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information flow control policies to be enforced for flow control decisions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002190">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use organization-defined security attributes associated with organization-defined information, source, and destination objects to enforce organization-defined information flow control policies as a basis for flow control decisions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002191">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information flow control policies to be enforced by the information system using protected processing domains.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002192">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the policies to enforce dynamic information flow control.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002193">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines procedures or methods to be employed to prevent encrypted information from bypassing flow control mechanisms, such as decrypting the information, blocking the flow of the encrypted information, and/or terminating communications sessions attempting to pass encrypted information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002194">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the metadata the information system uses to enforce information flow control.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002195">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information flows against which the organization-defined security or privacy policy filters are to be enforced.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (8) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002196">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information flows for which will enforce the use of human reviews under organization-defined conditions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (9)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002197">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the conditions which will require the use of human reviews of organization-defined information flows.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (9)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002198">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce the use of human reviews for organization-defined information flows under organization-defined conditions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (9)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002199">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the conditions that provides the capability for privileged administrators to enable and disable organization-defined security policy filters.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002200">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the data type identifiers to be used to validate data being transferred between different security domains.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (12)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002201">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, use organization-defined data type identifiers to validate data essential for information flow decisions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (12)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002202">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the policy-relevant subcomponents into which information being transferred between different security domains is to be decomposed for submission to policy enforcement mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (13)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002203">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the unsanctioned information when transferring information between different security domains.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (15)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (15)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002204">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security or privacy policy which prohibits the transfer of unsanctioned information between different security domains.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (15)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (15)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002205">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Uniquely identify and authenticate source by organization, system, application, service, and/or individual for information transfer.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (17)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (17)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002206">
      <status>deprecated</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system uniquely authenticates source by organization, system, application, and/or individual for information transfer.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (17)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002207">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Uniquely identify and authenticate destination points by organization, system, application, service, and/or individual for information transfer.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (17)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (17)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002208">
      <status>deprecated</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system uniquely authenticates destination by organization, system, application, and/or individual for information transfer.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (17)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002209">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the techniques to be used to bind security attributes to information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (18)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002210">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system binds security attributes to information using organization-defined binding techniques to facilitate information flow policy enforcement.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (18)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002211">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, implement organization-defined security or privacy filters on metadata.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (19)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (19)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002212">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the solutions in approved configurations to be employed to control the flow of organization-defined information across security domains.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (20)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (20)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002213">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information to be subjected to flow control across security domains.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (20)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (20)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002214">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined solutions in approved configurations to control the flow of organization-defined information across security domains.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (20)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (20)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002215">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the mechanisms and/or techniques to be used to logically or physically separate information flows.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (21)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (21)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002216">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the types of information required to accomplish logical or physical separation of information flows.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (21)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (21)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002217">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Separate information flows logically or physically using organization-defined mechanisms and/or techniques to accomplish organization-defined required separations by types of information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (21)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (21)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002218">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide access from a single device to computing platforms, applications, or data residing on multiple different security domains, while preventing any information flow between the different security domains.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (22)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-4 (22)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002219">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the duties of individuals requiring separation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-5 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002220">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Define system access authorizations to support separation of duties.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-5 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-5 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002221">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security-relevant information for which access must be explicitly authorized.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002222">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authorize access for organization-defined individuals or roles to organization-defined security functions (deployed in hardware, software, and firmware).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002223">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authorize access for organization-defined individuals or roles to organization-defined security-relevant information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002224">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the compelling operational needs that must be met in order to be authorized network access to organization-defined privileged commands.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002225">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide separate processing domains to enable finer-grained allocation of user privileges.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002226">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom privileged accounts are to be restricted on the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002227">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Restrict privileged accounts on the system to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002228">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency on which it conducts reviews of the privileges assigned to organization-defined roles or classes of users.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (7) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (7) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002229">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the roles or classes of users that are to have their privileges reviewed on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (7) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (7) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002230">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review, on an organization-defined frequency, the privileges assigned to organization-defined roles or classes of users to validate the need for such privileges.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (7) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (7) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002231">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Reassign or remove privileges, if necessary, to correctly reflect organizational mission and business needs.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (7) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (7) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002232">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the software that is prevented from executing at a higher privilege than users executing the software.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002233">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent the organization-defined software from executing at higher privilege levels than users executing the software.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002234">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Log the execution of privileged functions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (9)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002235">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent non-privileged users from executing privileged functions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-6 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002236">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period the information system will automatically lock the account or node when the maximum number of unsuccessful logon attempts is exceeded.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-7 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002237">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the delay algorithm to delay the next logon prompt when the maximum number of unsuccessful logon attempts is exceeded.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-7 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002238">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Automatically lock the account or node for either an organization-defined time period, until the locked account or node is released by an administrator, or delays the next logon prompt according to the organization-defined delay algorithm when the maximum number of unsuccessful logon attempts is exceeded.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-7 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002239">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the mobile devices that are to be purged or wiped after an organization-defined number of consecutive, unsuccessful device logon attempts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002240">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the purging or wiping requirements and techniques to be used on organization-defined mobile devices after an organization-defined number of consecutive, unsuccessful device logon attempts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002241">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the number of consecutive, unsuccessful device logon attempts after which the organization-defined mobile devices will be purged or wiped.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002242">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Purge or wipe information from organization-defined mobile devices based on organization-defined purging or wiping requirements and techniques after an organization-defined number of consecutive, unsuccessful device logon attempts.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002243">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Organization-defined system use notification message or banner is to state that users are accessing a U.S. Government system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-8 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-8 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002244">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Organization-defined system use notification message or banner is to state that system usage may be monitored, recorded, and subject to audit.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-8 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-8 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-002245">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Organization-defined system use notification message or banner is to state that unauthorized use of the system is prohibited and subject to criminal and civil penalties.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-8 a 3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-8 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-002246">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Organization-defined system use notification message or banner is to state that use of the system indicates consent to monitoring and recording.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-8 a 4" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-8 a 4" />
      </references>
    </cci_item>
    <cci_item id="CCI-002247">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the use notification message or banner the system displays to users before granting access to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-8 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002248">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the conditions of use which are to be displayed to users of the system before granting further access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-8 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-8 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002249">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the additional information to be included in the notification to the user upon successful logon.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-9 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-9 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002250">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Notify the user, upon successful logon, of the following additional information: organization-defined additional information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-9 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-9 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002251">
      <status>deprecated</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system notifies the user, upon successful logon (access), of the date and time of the last logon (access).</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-9 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002252">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the accounts and/or account types for which will limit the number of concurrent sessions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-10" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-002253">
      <status>deprecated</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the account types for which the information system will limit the number of concurrent sessions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-002254">
      <status>deprecated</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the conditions or trigger events requiring session disconnect to be employed by the information system when automatically terminating a user session.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002255">
      <status>deprecated</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the user actions that can be performed on the information system without identification and authentication.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-14 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002256">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines security attributes having organization-defined types of security attribute values which are associated with information in storage.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002257">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines security attributes having organization-defined types of security attribute values which are associated with information in process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002258">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines security attributes, having organization-defined types of security attribute values, which are associated with information in transmission.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002259">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines security attribute values associated with organization-defined types of security attributes for information in storage.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002260">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines security attribute values associated with organization-defined types of security attributes for information in process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002261">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines security attribute values associated with organization-defined types of security attributes for information in transmission.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002262">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provides the means to associate organization-defined types of security attributes having organization-defined security attribute values with information in storage.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002263">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provides the means to associate organization-defined types of security attributes having organization-defined security attribute values with information in process.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002264">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provides the means to associate organization-defined types of security attributes having organization-defined security attribute values with information in transmission.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002265">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that the security attribute associations are made with the information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002266">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that the security attribute associations are retained with the information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 b  " />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002267">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security attributes that are permitted for organization-defined systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002268">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems for which permitted organization-defined attributes are to be established.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002269">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish the following permitted organization-defined security attributes in AC-16a for organization-defined systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002270">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the attribute values or ranges permitted for each of the established security attributes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002271">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Determine the following permitted attribute value or ranges for each of the established attributes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002272">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Dynamically associate security attributes with organization-defined objects in accordance with organization-defined security policies as information is created and combined.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002273">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security policies to adhere to when dynamically associating security attributes with organization-defined subjects and objects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002274">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the subjects with which the information system is to dynamically associate security attributes as information is created and combined.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002275">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the objects with which the information system is to dynamically associate security attributes as information is created and combined.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002276">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization identifies the individuals authorized to define the value of associated security attributes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002277">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provides authorized individuals (or processes acting on behalf of individuals) the capability to define the value of associated security attributes.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002278">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security attributes for which the association and integrity to organization-defined subjects and objects is maintained.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002279">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the subjects for which the association and integrity of organization-defined security attributes is maintained.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002280">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the objects for which the association and integrity of organization-defined security attributes is maintained.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002281">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain the association of organization-defined security attributes to organization-defined subjects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002282">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain the association of organization-defined security attributes to organization-defined objects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002283">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain the integrity of organization-defined security attributes associated with organization-defined subjects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002284">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain the integrity of organization-defined security attributes associated with organization-defined objects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002285">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization identifies individuals (or processes acting on behalf of individuals) authorized to associate organization-defined security attributes with organization-defined subjects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002286">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the subjects with which organization-defined security attributes may be associated by authorized individuals (or processes acting on behalf of individuals).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002287">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the objects with which organization-defined security attributes may be associated by authorized individuals (or processes acting on behalf of individuals).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002288">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security attributes authorized individuals (or processes acting on behalf of individuals) are permitted to associate with organization-defined subjects and objects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002289">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the capability to associate organization-defined security attributes with organization-defined subjects by authorized individuals (or processes acting on behalf of individuals).</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002290">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the capability to associate organization-defined security attributes with organization-defined objects by authorized individuals (or processes acting on behalf of individuals).</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002291">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security policies to be followed by personnel when associating organization-defined security attributes with organization-defined subjects and objects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002292">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security attributes which are to be associated with organization-defined subjects and objects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002293">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the subjects to be associated, and that association maintained, with organization-defined security attributes in accordance with organization-defined security policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002294">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the objects to be associated, and that association maintained, with organization-defined security attributes in accordance with organization-defined security policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002295">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require personnel to associate organization-defined security attributes with organization-defined subjects in accordance with organization-defined security policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002296">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require personnel to associate organization-defined security attributes with organization-defined objects in accordance with organization-defined security policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002297">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require personnel to maintain the association of organization-defined security attributes with organization-defined subjects in accordance with organization-defined security policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002298">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require personnel to maintain the association of organization-defined security attributes with organization-defined objects in accordance with organization-defined security policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002299">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide a consistent interpretation of security attributes transmitted between distributed system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002300">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the techniques and technologies to be implemented when associating security attributes with information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002301">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the level of assurance to be provided when implementing organization-defined techniques and technologies in associating security attributes to information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002302">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined techniques and technologies with an organization-defined level of assurance in associating security attributes to information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002303">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the techniques or procedures to be employed to validate re-grading mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (9)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002304">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Change security attributes associated with information are reassigned only via re-grading mechanisms validated using organization-defined techniques or procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (9)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002305">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization identifies individuals authorized to define or change the type and value of security attributes available for association with subjects and objects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002306">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide authorized individuals the capability to define or change the type of security attributes available for association with subjects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002307">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide authorized individuals the capability to define or change the value of security attributes available for association with subjects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002308">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide authorized individuals the capability to define or change the type of security attributes available for association with objects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002309">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide authorized individuals the capability to define or change the type of security attributes available for association with objects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-16 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002310">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish and document usage restrictions for each type of remote access allowed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002311">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish and document configuration/connection requirements for each type of remote access allowed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002312">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish and document implementation guidance for each type of remote access allowed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002313">
      <status>deprecated</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system controls remote access methods.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002314">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ automated mechanisms to control remote access methods.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002315">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the number of managed network access control points through which the information system routes all remote access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002316">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authorize access to security-relevant information via remote access only in a format that provides assessable evidence for organization-defined needs.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002317">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the needs for when the execution of privileged commands via remote access is to be authorized.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002318">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the needs for when access to security-relevant information via remote access is to be authorized.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002319">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document the rationale for authorization of the execution of privilege commands via remote access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002320">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document the rationale for authorization of access to security-relevant information via remote access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002321">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time-period within which it disconnects or disables remote access to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 (9)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002322">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the capability to disconnect or disable remote access to the system within the organization-defined time period.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 (9)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-17 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002323">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish configuration requirements and connection requirements for wireless access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-18 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-18 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002324">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify and explicitly authorizes users allowed to independently configure wireless networking capabilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-18 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-18 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002325">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish configuration requirements for organization-controlled mobile devices, to include when such devices are outside of controlled areas.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-19 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-19 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002326">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish connection requirements for organization-controlled mobile devices, to include when such devices are outside of controlled areas.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-19 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-19 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002327">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security policies which restrict the connection of classified mobile devices to classified systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-19 (4) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-19 (4) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002328">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Restrict the connection of classified mobile devices to classified systems in accordance with organization-defined security policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-19 (4) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-19 (4) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002329">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the mobile devices that are to employ full-device or container encryption to protect the confidentiality and integrity of the information on the device.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-19 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-19 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002330">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employs full-device encryption or container encryption to protect the confidentiality of information on organization-defined mobile devices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-19 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-19 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002331">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employs full-device encryption or container encryption to protect the integrity of information on organization-defined mobile devices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-19 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-19 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002332">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish organization-defined terms and conditions, and/or identify organization-defined controls asserted to be implemented on external systems, consistent with the trust relationships established with other organizations owning, operating, and/or maintaining external systems, allowing authorized individuals to process, store, or transmit organization-controlled information using the external systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-20 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-20 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002333">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization permits authorized individuals to use an external information system to access the information system only when the organization verifies the implementation of required security controls on the external system as specified in the organization's information security policy and security plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-20 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002334">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization permits authorized individuals to use an external information system to process organization-controlled information only when the organization verifies the implementation of required security controls on the external system as specified in the organization's information security policy and security plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-20 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002335">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization permits authorized individuals to use an external information system to store organization-controlled information only when the organization verifies the implementation of required security controls on the external system as specified in the organization's information security policy and security plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-20 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002336">
      <status>draft</status>
      <publishdate>2013-06-24</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization permits authorized individuals to use an external information system to transmit organization-controlled information only when the organization verifies the implementation of required security controls on the external system as specified in the organization's information security policy and security plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-20 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002337">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Permit authorized individuals to use an external system to access the system or to process, store, or transmit organization-controlled information only after the system retains approved system connection or processing agreements with the organizational entity hosting the external system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-20 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-20 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002338">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Restrict the use of non-organizationally owned systems or system components to process, store, or transmit organizational information using organization-defined restrictions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-20 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-20 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002339">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the network accessible storage devices that are to be prohibited from being used in external systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-20 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-20 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002340">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit the use of organization-defined network accessible storage devices in external systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-20 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-20 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002341">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information sharing restrictions to be enforced when implementing information search and retrieval services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-21 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-21 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002342">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement information search and retrieval services that enforce organization-defined information sharing restrictions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-21 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-21 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002343">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the data mining prevention techniques to be employed to protect organization-defined data storage objects against data mining.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-23" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-23" />
      </references>
    </cci_item>
    <cci_item id="CCI-002344">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the data mining detection techniques to be employed to detect data mining attempts against organization-defined data storage objects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-23" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-23" />
      </references>
    </cci_item>
    <cci_item id="CCI-002345">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the data storage objects that are to be protected against data mining attempts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-23" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-23" />
      </references>
    </cci_item>
    <cci_item id="CCI-002346">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employs organization-defined data mining prevention techniques for organization-defined data storage objects to protect against unauthorized data mining.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-23" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-23" />
      </references>
    </cci_item>
    <cci_item id="CCI-002347">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined data mining detection techniques for organization-defined data storage objects to detect data mining attempts.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-23" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-23" />
      </references>
    </cci_item>
    <cci_item id="CCI-002348">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the access control decisions that are to be applied to each access request prior to access enforcement.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-24" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-24" />
      </references>
    </cci_item>
    <cci_item id="CCI-002349">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish procedures or implement mechanisms to ensure organization-defined access control decisions are applied to each access request prior to access enforcement.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-24" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-24" />
      </references>
    </cci_item>
    <cci_item id="CCI-002350">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the access authorization information that is to be transmitted using organization-defined security safeguards to organization-defined systems that enforce access control decisions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-24 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-24 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002351">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls to be employed when transmitting organization-defined access authorization information to organization-defined systems that enforce access control decisions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-24 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-24 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002352">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems that are to be recipients of organization-defined access authorization information using organization-defined security safeguards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-24 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-24 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002353">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Transmit organization-defined access authorization information using organization-defined controls to organization-defined systems that enforce access control decisions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-24 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-24 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002354">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security attributes, not to include the identity of the user or process acting on behalf of the user, to be used as the basis for enforcing access control decisions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-24 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-24 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002355">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce access control decisions based on organization-defined security or privacy attributes that do not include the identity of the user or process acting on behalf of the user.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-24 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-24 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002356">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the access control policies to be implemented by the reference monitor.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-25" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-25" />
      </references>
    </cci_item>
    <cci_item id="CCI-002357">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a reference monitor for organization-defined access control policies that is tamperproof.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-25" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-25" />
      </references>
    </cci_item>
    <cci_item id="CCI-002358">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a reference monitor for organization-defined access control policies that is always invoked.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-25" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-25" />
      </references>
    </cci_item>
    <cci_item id="CCI-002359">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a reference monitor for organization-defined access control policies that is small enough to be subject to analysis and testing, the completeness of which can be assured.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-25" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-25" />
      </references>
    </cci_item>
    <cci_item id="CCI-002360">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the conditions or trigger events requiring session disconnect when automatically terminating a user session.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002361">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Automatically terminate a user session after organization-defined conditions or trigger events requiring session disconnect.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002362">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information resources requiring authentication in order to gain access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-12 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002363">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide a logout capability for user-initiated communications sessions whenever authentication is used to gain access to organization-defined information resources.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-12 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002364">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Display an explicit logout message to users indicating the reliable termination of authenticated communications sessions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-12 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002365">
      <status>draft</status>
      <publishdate>2013-06-26</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system authenticators by requiring individuals to take specific security safeguards to protect authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 i" />
      </references>
    </cci_item>
    <cci_item id="CCI-002366">
      <status>draft</status>
      <publishdate>2013-06-26</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization manages information system authenticators by having devices implement specific security safeguards to protect authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 i" />
      </references>
    </cci_item>
    <cci_item id="CCI-002367">
      <status>draft</status>
      <publishdate>2013-06-26</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures unencrypted static authenticators are not embedded in applications.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IA-5 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002368">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the organization-level; mission/business process-level; system-level risk assessment policy is disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002369">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the risk assessment procedures are disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-002370">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate risk assessment results to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-3 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002371">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the risk assessment results will be disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-3 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002372">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Correlate the output from vulnerability scanning tools to determine the presence of multi-vulnerability and multi-hop attack vectors.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002373">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Define the breadth and depth of vulnerability scanning coverage.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002374">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the corrective actions if unintended information about the system is discovered.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002375">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Take organization-defined corrective actions if information about the system is discovered.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002376">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles with whom the information obtained from the vulnerability monitoring process and control assessments will be shared.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-002377">
      <status>draft</status>
      <publishdate>2013-07-02</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents the system and communications protection policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002378">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to be recipients of the organization-level; mission/business process-level; and/or system-level system and communications protection policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002379">
      <status>draft</status>
      <publishdate>2013-07-02</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents procedures to facilitate the implementation of the system and communications protection policy and associated system and communications protection controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-002380">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to be recipients of the procedures to facilitate the implementation of the system and communications protection policy and associated system and communications protection controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-002381">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Minimize the number of nonsecurity functions included within the isolation boundary containing security functions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-3 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002382">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement security functions as largely independent modules that maximize internal cohesiveness within modules and minimize coupling between modules.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-3 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002383">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the procedures to be employed to prevent unauthorized information transfer via shared resources when system processing explicitly switches between different information classification levels or security categories.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002384">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent unauthorized information transfer via shared resources in accordance with organization-defined procedures when system processing explicitly switches between different information classification levels or security categories.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002385">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect against or limit the effects of organization-defined types of denial of service events.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-5 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-002386">
      <status>draft</status>
      <publishdate>2013-07-02</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the security safeguards to be employed to protect the information system against, or limit the effects of, denial of service attacks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-002387">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the denial of service attacks against other systems that the system is to restrict the ability of individuals to launch.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-5 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002388">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the monitoring tools to be employed to detect indicators of denial of service attacks against the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-5 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-5 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002389">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined monitoring tools to detect indicators of denial of service attacks against, or launched from, the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-5 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-5 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002390">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system resources to be monitored to determine if sufficient resources exist to prevent effective denial of service attacks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-5 (3) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-5 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002391">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor organization-defined system resources to determine if sufficient resources exist to prevent effective denial of service attacks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-5 (3) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-5 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002392">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the resources to be allocated to protect the availability of system resources.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-6" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-002393">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls to be employed to protect the availability of system resources.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-6" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-002394">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect the availability of resources by allocating organization-defined resources based on priority, quota, and/or organization-defined controls.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-6" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-002395">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement subnetworks for publicly accessible system components that are physically and/or logically separated from internal organizational networks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002396">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect the confidentiality and integrity of the information being transmitted across each interface for each external telecommunication service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (4) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (4) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002397">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent split tunneling for remote devices connecting to organizational systems unless the split tunnel is securely provisioned using organization-defined safeguards.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002398">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Detect outgoing communications traffic posing a threat to external systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (9) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (9) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002399">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Deny outgoing communications traffic posing a threat to external systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (9) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (9) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002400">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Audit the identity of internal users associated with denied outgoing communications traffic posing a threat to external systems.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (9) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (9) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002401">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the authorized sources from which the system will allow incoming communications.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (11)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002402">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the authorized destinations for routing inbound communications.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (11)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002403">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Only allow incoming communications from organization-defined authorized sources routed to organization-defined authorized destinations.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (11)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002404">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the host-based boundary protection mechanisms that are to be implemented at organization-defined system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (12)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002405">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components at which organization-defined host-based boundary protection mechanisms will be implemented.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (12)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002406">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined host-based boundary protection mechanisms at organization-defined system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (12)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002407">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the managed interfaces at which protect against unauthorized physical connections.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (14)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (14)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002408">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the communication clients that are independently configured by end users and external service providers which will block both inbound and outbound communications traffic.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (19)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (19)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002409">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Block inbound and outbound communications traffic between organization-defined communication clients that are independently configured by end users and external service providers.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (19)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (19)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002410">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines system components that are to be dynamically isolated from other system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (20)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (20)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002411">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the capability to dynamically isolate organization-defined system components from other system components.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (20)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (20)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002412">
      <status>deprecated</status>
      <publishdate>2013-07-02</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the information system components supporting organization-defined missions and/or business functions that are to be separated using boundary protection mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (21)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002413">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components supporting organization-defined missions and/or business functions that are to be isolated using boundary protection mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (21)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (21)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002414">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the missions and/or business functions for which boundary protection mechanisms will be employed to isolate the supporting organization-defined system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (21)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (21)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002415">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ boundary protection mechanisms to isolate organization-defined system components supporting organization-defined missions and/or business functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (21)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (21)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002416">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement separate network addresses to connect to systems in different security domains.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (22)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (22)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002417">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disable feedback to senders on protocol format validation failure.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (23)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-7 (23)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002418">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect the confidentiality and/or integrity of transmitted information.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-8" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-002419">
      <status>draft</status>
      <publishdate>2013-07-02</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the alternative physical safeguards to be employed when cryptographic mechanisms are not implemented to protect information during transmission.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-8 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002420">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain the confidentiality and/or integrity of information during preparation for transmission.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-8 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002421">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement cryptographic mechanisms to prevent unauthorized disclosure of information and/or detect changes to information during transmission.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-8 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-8 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002422">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain the confidentiality and/or integrity of information during reception.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-8 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002423">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement cryptographic mechanisms to protect message externals unless otherwise protected by organization-defined alternative physical controls.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-8 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-8 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002424">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the alternative physical controls to be employed when cryptographic mechanisms to conceal or randomize communication patterns are not implemented.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-8 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-8 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002425">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement cryptographic mechanisms to conceal or randomize communication patterns unless otherwise protected by organization-defined alternative physical controls.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-8 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-8 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002426">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide a trusted communications path that is irrefutably distinguishable from other communications paths.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-11 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-11 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002427">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the alternative physical controls to be employed to protect message externals when cryptographic mechanisms are not implemented.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-8 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-8 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002428">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the requirements for cryptographic key generation to be employed within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002429">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the requirements for cryptographic key distribution to be employed within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002430">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the requirements for cryptographic key storage to be employed within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002431">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the requirements for cryptographic key access to be employed within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002432">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the requirements for cryptographic key destruction to be employed within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002433">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish cryptographic keys when cryptography employed within the system in accordance with organization-defined requirements for key generation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002434">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish cryptographic keys when cryptography employed within the system in accordance with organization-defined requirements for key distribution.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002435">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish cryptographic keys when cryptography employed within the system in accordance with organization-defined requirements for key storage.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002436">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish cryptographic keys when cryptography employed within the system in accordance with organization-defined requirements for key access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002437">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish cryptographic keys when cryptography employed within the system in accordance with organization-defined requirements for key destruction.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002438">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage cryptographic keys when cryptography employed within the system in accordance with organization-defined requirements for key generation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002439">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage cryptographic keys when cryptography employed within the system in accordance with organization-defined requirements for key distribution.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002440">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage cryptographic keys when cryptography employed within the system in accordance with organization-defined requirements for key storage.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002441">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage cryptographic keys when cryptography employed within the system in accordance with organization-defined requirements for key access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002442">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage cryptographic keys when cryptography employed within the system in accordance with organization-defined requirements for key destruction.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002443">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Produce symmetric cryptographic keys using NIST FIPS-validated or NSA-approved key management technology and processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002444">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Control symmetric cryptographic keys using NIST FIPS-validated or NSA-approved key management technology and processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002445">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Distribute symmetric cryptographic keys using NIST FIPS-validated or NSA-approved key management technology and processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002446">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Produces asymmetric cryptographic keys using: NSA-approved key management technology and processes; prepositioned keying material; DoD-approved or DoD-issued Medium Assurance PKI certificates; DoD-approved or DoD-issued Medium Hardware Assurance PKI certificates and hardware security tokens that protect the user's private key; or certificates issued in accordance with organization-defined requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002447">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Control asymmetric cryptographic keys using: NSA-approved key management technology and processes; prepositioned keying material; DoD-approved or DoD-issued Medium Assurance PKI certificates; DoD-approved or DoD-issued Medium Hardware Assurance PKI certificates and hardware security tokens that protect the user's private key; or certificates issued in accordance with organization-defined requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002448">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Distribute asymmetric cryptographic keys using: NSA-approved key management technology and processes; prepositioned keying material; DoD-approved or DoD-issued Medium Assurance PKI certificates; DoD-approved or DoD-issued Medium Hardware Assurance PKI certificates and hardware security tokens that protect the user's private key; or certificates issued in accordance with organization-defined requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002449">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the cryptographic uses, and type of cryptography required for each use, to be implemented by the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-13" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-13" />
      </references>
    </cci_item>
    <cci_item id="CCI-002450">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined types of cryptography for each specified cryptography use.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-13 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-13" />
      </references>
    </cci_item>
    <cci_item id="CCI-002451">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components from which collaborative computing devices and applications in organization-defined secure work areas are to be disabled or removed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-15 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-15 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002452">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the online meetings and teleconferences for which the system provides an explicit indication of current participants.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-15 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-15 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002453">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide an explicit indication of current participants in organization-defined online meetings and teleconferences.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-15 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-15 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002454">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security attributes to associate with the information being exchanged between systems and between system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-16" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-002455">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Associate organization-defined security attributes with information exchanged between system components.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-16" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-002456">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the certificate policy employed to issue public key certificates.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-17 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-17" />
      </references>
    </cci_item>
    <cci_item id="CCI-002457">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the corrective actions to be taken when organization-defined unacceptable mobile code is identified.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002458">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines what constitutes unacceptable mobile code by using corrective actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002459">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the unacceptable mobile code to prevent download and execution.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002460">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined actions prior to executing mobile code.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002461">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Allow execution of permitted mobile code only in confined virtual machine environments.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-18 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-18 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002462">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide additional data integrity verification artifacts along with the authoritative name resolution data the system returns in response to external name/address resolution queries.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-20 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-20 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002463">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide data origin artifacts for internal name/address resolution queries.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-20 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-20 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002464">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide data integrity protection artifacts for internal name/address resolution queries.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-20 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-20 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002465">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Request data origin authentication verification on the name/address resolution responses the system receives from authoritative sources.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-21" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-21" />
      </references>
    </cci_item>
    <cci_item id="CCI-002466">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Request data integrity verification on the name/address resolution responses the system receives from authoritative sources.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-21" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-21" />
      </references>
    </cci_item>
    <cci_item id="CCI-002467">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Perform data integrity verification on the name/address resolution responses the system receives from authoritative sources.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-21" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-21" />
      </references>
    </cci_item>
    <cci_item id="CCI-002468">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Perform data origin verification authentication on the name/address resolution responses the system receives from authoritative sources.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-21" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-21" />
      </references>
    </cci_item>
    <cci_item id="CCI-002469">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the certificate authorities allowed to be used for verification of the establishment of protected sessions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-23 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-23 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002470">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Only allow the use of organization-defined certificate authorities for verification of the establishment of protected sessions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-23 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-23 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002471">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components, with minimal functionality and information storage, to be employed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-25" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-25" />
      </references>
    </cci_item>
    <cci_item id="CCI-002472">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information at rest that is to be protected.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-28" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-28" />
      </references>
    </cci_item>
    <cci_item id="CCI-002473">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information at rest for which cryptographic mechanisms will be implemented.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-28 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-28 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002474">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components which require the implementation of cryptographic mechanisms to prevent unauthorized disclosure and modification of organization-defined information at rest.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-28 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-28 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002475">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement cryptographic mechanisms to prevent unauthorized modification of organization-defined information when at rest on organization-defined system components.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-28 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-28 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002476">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement cryptographic mechanisms to prevent unauthorized disclosure of organization-defined information at rest on organization-defined system components.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-28 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-28 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002477">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information to be removed from online storage and stored in an offline secure location.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-28 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-28 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002478">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Remove organization-defined information from online storage.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-28 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-28 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002479">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Store organization-defined information in an offline secure location.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-28 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-28 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002480">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components for which a diverse set of information technologies are to be employed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-29" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-29" />
      </references>
    </cci_item>
    <cci_item id="CCI-002481">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ virtualization techniques to support the deployment of a diversity of applications that are changed per organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-29 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-29 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002482">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the concealment and misdirection techniques employed for organization-defined systems to confuse and mislead adversaries.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-30" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-30" />
      </references>
    </cci_item>
    <cci_item id="CCI-002483">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems for which organization-defined concealment and misdirection techniques are to be employed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-30" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-30" />
      </references>
    </cci_item>
    <cci_item id="CCI-002484">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time periods at which to employ organization-defined concealment and misdirection techniques on organization-defined systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-30" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-30" />
      </references>
    </cci_item>
    <cci_item id="CCI-002485">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined concealment and misdirection techniques for organization-defined information systems at organization-defined time periods to confuse and mislead adversaries.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-30" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-30" />
      </references>
    </cci_item>
    <cci_item id="CCI-002486">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the techniques to be employed to introduce randomness into organizational operations and assets.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-30 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-30 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002487">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined techniques to introduce randomness into organizational operations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-30 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-30 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002488">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined techniques to introduce randomness into organizational assets.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-30 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-30 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002489">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the processing and/or storage locations to be changed at random intervals or at an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-30 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-30 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002490">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency at which the location of organization-defined processing and/or storage changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-30 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-30 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002491">
      <status>deprecated</status>
      <publishdate>2013-07-02</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization changes the location of organization-defined processing and/or storage at an organization-defined time frequency or at random time intervals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-30 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002492">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Change the location of organization-defined processing and/or storage at an organization-defined time frequency or at random time intervals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-30 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-30 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002493">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components in which it will employ realistic but misleading information regarding its security state or posture.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-30 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-30 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002494">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ realistic, but misleading, information in organization-defined system components about its security state or posture.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-30 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-30 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002495">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the techniques to be employed to hide or conceal organization-defined system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-30 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-30 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002496">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components to be hidden or concealed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-30 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-30 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002497">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined techniques to hide or conceal organization-defined system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-30 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-30 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002498">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Perform a covert channel analysis to identify those aspects of communications within the system that are potential avenues for covert storage and/or timing channels.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-31 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-31 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002499">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Estimate the maximum bandwidth of the covert storage and timing channels.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-31 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-31 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002500">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the maximum bandwidth values to which covert storage and/or timing channels are to be reduced.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-31 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-31 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002501">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Reduce the maximum bandwidth for identified covert storage and/or timing channels to organization-defined values.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-31 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-31 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002502">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the subset of identified covert channels in the operational environment of the system that are to have the bandwidth measured.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-31 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-31 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002503">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Measure the bandwidth of an organization-defined subset of identified covert channels in the operational environment of the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-31 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-31 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002504">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components into which the system is partitioned.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-32" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-32" />
      </references>
    </cci_item>
    <cci_item id="CCI-002505">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the circumstances under which the system components are to be physically or logically separated to support partitioning.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-32" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-32" />
      </references>
    </cci_item>
    <cci_item id="CCI-002506">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Partitions the system into organization-defined system components residing in separate physical or logical domains or environments based on organization-defined circumstances for physical or logical separation of components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-32" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-32" />
      </references>
    </cci_item>
    <cci_item id="CCI-002507">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Control read-only media after information has been recorded onto the media.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-34 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-34 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002508">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system firmware components for which hardware-based, write-protect is employed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-51 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-34 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002509">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ hardware-based, write-protect for organization-defined information system firmware components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-51 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-34 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002510">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the individuals authorized to manually disable hardware-based, write-protect for firmware modifications and re-enable the write-protect prior to returning to operational mode.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-51 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-34 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002511">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement specific procedures for organization-defined authorized individuals to manually disable hardware-based, write-protect for firmware modifications.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-51 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-34 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002512">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement specific procedures for organization-defined authorized individuals to manually re-enable hardware write-protect prior to returning to operational mode.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-51 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-34 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002513">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the processing that is to be distributed across multiple physical locations or logical domains.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-36" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-36" />
      </references>
    </cci_item>
    <cci_item id="CCI-002514">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the storage components that is to be distributed across multiple physical locations or logical domains.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-36" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-36" />
      </references>
    </cci_item>
    <cci_item id="CCI-002515">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Distributes organization-defined processing across multiple physical locations or logical domains.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-36" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-36" />
      </references>
    </cci_item>
    <cci_item id="CCI-002516">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Distributes organization-defined storage components across multiple physical locations or logical domains.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-36" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-36" />
      </references>
    </cci_item>
    <cci_item id="CCI-002517">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the distributed processing components that are to be polled to identify potential faults, errors, or compromises.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-36 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-36 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002518">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the distributed storage components that are to be polled to identify potential faults, errors, or compromises.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-36 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-36 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002519">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ polling techniques to identify potential faults, errors, or compromises to organization-defined distributed processing components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-36 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-36 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002520">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ polling techniques to identify potential faults, errors, or compromises to organization-defined distributed storage components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-36 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-36 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002521">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the out-of-band channels to be employed for the physical delivery or electronic transmission of organization-defined information, system components, or devices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-37" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-37" />
      </references>
    </cci_item>
    <cci_item id="CCI-002522">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information, system components, or devices that are to be electronically transmitted or physically delivered via organization-defined out-of-band channels.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-37" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-37" />
      </references>
    </cci_item>
    <cci_item id="CCI-002523">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the individuals or systems authorized to be recipients of organization-defined information, system components, or devices to be delivered by employing organization-defined out-of-band channels for electronic transmission or physical delivery.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-37, SC-37 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-37" />
      </references>
    </cci_item>
    <cci_item id="CCI-002524">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined out-of-band channels for the physical delivery or electronic transmission of organization-defined information, system components, or devices to organization-defined individuals or systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-37" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-37" />
      </references>
    </cci_item>
    <cci_item id="CCI-002525">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls to be employed to ensure only organization-defined individuals or information systems receive organization-defined information, information system components, or devices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-37 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-37 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002526">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information, system components, or devices which are to be received only by organization-defined individuals or systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-37 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-37 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002527">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined controls to ensure only organization-defined individuals or systems receive the organization-defined information, system components, or devices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-37 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-37 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002528">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the operations security controls to be employed to protect key organizational information throughout the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-38" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-38" />
      </references>
    </cci_item>
    <cci_item id="CCI-002529">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined operations security controls to protect key organizational information throughout the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-38" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-38" />
      </references>
    </cci_item>
    <cci_item id="CCI-002530">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain a separate execution domain for each executing system process.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-39" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-39" />
      </references>
    </cci_item>
    <cci_item id="CCI-002531">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement hardware separation mechanisms to facilitate process isolation.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-39 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-39 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002532">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the multi-threaded processing in which a separate execution domain is maintained by the system for each thread.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-39 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-39 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002533">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain a separate execution domain for each thread in organization-defined multi-threaded processing.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-39 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-39 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002534">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines types of signal parameter attacks or references to sources for such attacks from which the system protects organization-defined wireless links.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-40" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-40" />
      </references>
    </cci_item>
    <cci_item id="CCI-002535">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the external and internal wireless links the system is to protect from organization-defined types of signal parameter attacks or references to sources for such attacks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-40" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-40" />
      </references>
    </cci_item>
    <cci_item id="CCI-002536">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect organization-defined external and internal wireless links from organization-defined types of signal parameter attacks or references to sources for such attacks.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-40" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-40" />
      </references>
    </cci_item>
    <cci_item id="CCI-002537">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the level of protection against the effects of intentional electromagnetic interference to be achieved by implemented cryptographic mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-40 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-40 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002538">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement cryptographic mechanisms that achieve an organization-defined level of protection against the effects of intentional electromagnetic interference.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-40 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-40 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002539">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the level of reduction the system is to implement to reduce the detection potential of wireless links.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-40 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-40 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002540">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement cryptographic mechanisms to reduce the detection potential of wireless links to an organization-defined level of reduction.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-40 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-40 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002541">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement cryptographic mechanisms to identify and reject wireless transmissions that are deliberate attempts to achieve imitative or manipulative communications deception based on signal parameters.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-40 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-40 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002542">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the wireless transmitters that are to have cryptographic mechanisms implemented to prevent the identification of the wireless transmitters.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-40 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-40 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002543">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement cryptographic mechanisms to prevent the identification of organization-defined wireless transmitters by using the transmitter signal parameters.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-40 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-40 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002544">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components on which organization-defined connection ports or input/output devices are to be physically or logically disabled or removed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-41" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-41" />
      </references>
    </cci_item>
    <cci_item id="CCI-002545">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the connection ports or input/output devices that are to be physically or logically disabled or removed from organization-defined systems or system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-41" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-41" />
      </references>
    </cci_item>
    <cci_item id="CCI-002546">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Physically or logically disable or remove organization-defined connection ports or input/output devices on organization-defined systems or system components.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-41" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-41" />
      </references>
    </cci_item>
    <cci_item id="CCI-002547">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the exceptions where remote activation of sensors is allowed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-42 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-42 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002548">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit the use of devices possessing organization-defined environmental sensing capabilities in organization-defined facilities, areas, or systems; and/or the remote activation of environmental sensing capabilities on organizational systems or system components except for the organization-defined exceptions where remote activation of sensors is allowed.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-42 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-42 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002549">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the class of users to receive explicit indication of sensor use.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-42 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-42 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002550">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide an explicit indication of sensor use to the organization-defined class of users.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-42 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-42 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002551">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the sensors to be configured so that collected data or information is reported only to authorized individuals or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-42 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-42 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002552">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that the system is configured so that data or information collected by the organization-defined sensors is only reported to authorized individuals or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-42 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-42 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002553">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the measures to be employed to ensure data or information collected by organization-defined sensors is used only for authorized purposes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-42 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-42 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002554">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the sensors that are to collect data or information for authorized purposes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-42 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-42 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002555">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined measures, so that data or information collected by organization-defined sensors is only used for authorized purposes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-42 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-42 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002556">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the environmental sensing capabilities prohibited on devices used in organization-defined facilities, areas, or systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-42 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-42 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002557">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the facilities, areas, or systems where devices processing organization-defined environmental sensing capabilities are prohibited.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-42 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-42 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002558">
      <status>draft</status>
      <publishdate>2013-07-02</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prohibits the use of devices possessing organization-defined environmental sensing capabilities in organization-defined facilities, areas, or systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-42 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002559">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components for which usage restrictions and implementation guidance are to be established.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-43 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-43 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002560">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish usage restrictions and implementation guidance for organization-defined system components based on the potential to cause damage to the system if used maliciously.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-43 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-43 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002561">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authorize the use of organization-defined system components which have the potential to cause damage to the system if used maliciously.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-43 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-43 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002562">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor the use of organization-defined system components which have the potential to cause damage to the system if used maliciously.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-43 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-43 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002563">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Control the use of organization-defined system components which have the potential to cause damage to the system if used maliciously.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-43 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-43 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002564">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system, system component, or location where a detonation chamber capability is employed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-44" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-44" />
      </references>
    </cci_item>
    <cci_item id="CCI-002565">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ a detonation chamber capability within an organization-defined system, system component, or location.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-44" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-44" />
      </references>
    </cci_item>
    <cci_item id="CCI-002566">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines personnel or roles to whom a media protection policy and procedures will be disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002567">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and approve media sanitization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002568">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Track and document media sanitization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002569">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify media sanitization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002570">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and approve media disposal actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002571">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Track and document media disposal actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002572">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify media disposal actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002573">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce dual authorization for the sanitization of organization-defined system media.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-6 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002574">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system media that dual authorization is enforced for sanitization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-6 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002575">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines systems or system components from which information is purged or wiped, either remotely or under the organization-defined conditions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-6 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002576">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines conditions under which information from organization-defined systems or system components are to be purged or wiped.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-6 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002577">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the capability to purge or wipe information from organization-defined systems, system components either remotely or under organization-defined conditions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-6 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002578">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines system media to sanitize prior to disposal, release out of organizational control, or release for reuse using organization-defined sanitization techniques and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002579">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the sanitization techniques and procedures to be used to sanitize organization-defined system media prior to disposal, release out of organizational control, or release for reuse.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002580">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ sanitization mechanisms with the strength and integrity commensurate with the security category or classification of the information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002581">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the types of system media to restrict or prohibit on organization-defined systems or system components using organization-defined controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-7 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-002582">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components on which to restrict or prohibit the use of organization-defined types of system media using organization-defined controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-7 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-002583">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls to use for restricting or prohibiting the use of organization-defined types of system media on organization-defined systems or system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-7 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-002584">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Restrict or prohibit the use of organization-defined types of system media on organization-defined systems or system components using organization-defined controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-7 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-002585">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit the use of portable storage devices in organizational systems when such devices have no identifiable owner.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-7 (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002586">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit the use of sanitization-resistant media in organizational systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002587">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document system media downgrading actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-8 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-8 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002588">
      <status>draft</status>
      <publishdate>2013-07-09</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs organization-defined tests of downgrading equipment in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002589">
      <status>draft</status>
      <publishdate>2013-07-09</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs procedures to verify correct performance of organization-defined tests of downgrading equipment in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002590">
      <status>draft</status>
      <publishdate>2013-07-09</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines tests to employ for downgrading equipment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002591">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to test downgrading equipment and procedures to ensure correct performance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-8 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002592">
      <status>draft</status>
      <publishdate>2013-07-09</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines Controlled Unclassified Information (CUI).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-8 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002593">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Downgrade system media containing Controlled Unclassified Information (CUI) prior to public release.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-8 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-8 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002594">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Downgrade system media containing classified information prior to release to individuals without required access authorizations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-8 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-8 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002595">
      <status>deprecated</status>
      <publishdate>2013-07-09</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes an organization-defined information system media downgrading process that includes employing downgrading mechanisms with organization-defined strength and integrity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002596">
      <status>draft</status>
      <publishdate>2013-07-09</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes and defines an information system media downgrading process that includes employing downgrading mechanisms with organization-defined strength and integrity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002597">
      <status>draft</status>
      <publishdate>2013-07-09</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines strength and integrity for downgrading mechanisms to establish an organization-defined information system media downgrading process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002598">
      <status>draft</status>
      <publishdate>2013-07-09</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that the information system media downgrading process is commensurate with the security category and/or classification level of the information to be removed and the access authorizations of the potential recipients of the downgraded information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002599">
      <status>draft</status>
      <publishdate>2013-07-09</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines and identifies the information system media requiring downgrading.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002600">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Downgrade the identified system media using the established process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-8 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MP-8 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002601">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the system and information integrity policy and procedures are to be disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002602">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test firmware updates related to flaw remediation for effectiveness before installation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002603">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test firmware updates related to flaw remediation for potential side effects before installation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002604">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period following the release of updates within which security-related software updates are to be installed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002605">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Install security-relevant software updates within an organization-defined time period of the release of the updates.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002606">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period following the release of updates within which security-related firmware updates are to be installed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002607">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Install security-relevant firmware updates within an organization-defined time period of the release of the updates.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002608">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish organization-defined benchmarks for the time taken to apply corrective actions after flaw identification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (3) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002609">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components on which organization-defined security-relevant software updates will be automatically installed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002610">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components on which organization-defined security-relevant firmware updates will be automatically installed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002611">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security-relevant software updates to be automatically installed on organization-defined system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002612">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security-relevant firmware updates to be automatically installed on organization-defined system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002613">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Install organization-defined security-relevant software updates automatically to organization-defined system components.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002614">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Install organization-defined security-relevant firmware updates automatically to organization-defined system components.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002615">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the software components to remove previous versions after updated versions have been installed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002616">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the firmware components to remove previous versions after updated versions have been installed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002617">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Remove previous versions of organization-defined software components after updated versions have been installed.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002618">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Remove previous versions of organization-defined firmware components after updated versions have been installed.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-2 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002619">
      <status>draft</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs malicious code protection mechanisms at information system entry points to detect malicious code.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002620">
      <status>draft</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs malicious code protection mechanisms at information system exit points to detect malicious code.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002621">
      <status>draft</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs malicious code protection mechanisms at information system entry points to eradicate malicious code.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002622">
      <status>draft</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs malicious code protection mechanisms at information system exit points to eradicate malicious code.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002623">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for performing periodic scans of the system for malicious code.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002624">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Configure malicious code protection mechanisms to perform real-time scans of files from external sources at endpoint; and/or network entry and exit points as the files are downloaded, opened, or executed in accordance with organizational policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 c 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002625">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When testing malicious code protection mechanisms, verify the detection of the code.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 (6) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (6) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002626">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When testing malicious code protection mechanisms, verify the associated incident reporting of the code occurs.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 (6) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (6) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002627">
      <status>draft</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system implements nonsignature-based malicious code detection mechanisms.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002628">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the unauthorized operating system commands that are to be detected through the kernel application programming interface on organization-defined system hardware components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 (8) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002629">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system hardware components that are to detect organization-defined unauthorized operating system commands through the kernel programming application interface.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 (8) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002630">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Detect organization-defined unauthorized operating system commands through the kernel application programming interface at organization-defined system hardware components.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 (8) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002631">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Issue a warning; audit the command execution; and/or prevent the execution of the command when organization-defined unauthorized operating system commands are detected.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 (8) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002632">
      <status>draft</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the remote commands that are to be authenticated using organization-defined safeguards for malicious code protection.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002633">
      <status>draft</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the security safeguards to be implemented to authenticate organization-defined remote commands for malicious code protection.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002634">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the tools to be employed to analyze the characteristics and behavior of malicious code.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 (10) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (10) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002635">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the techniques to be employed to analyze the characteristics and behavior of malicious code.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 (10) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (10) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002636">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined tools to analyze the characteristics and behavior of malicious code.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 (10) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (10) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002637">
      <status>draft</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system implements organization-defined security safeguards to authenticate organization-defined remote commands for malicious code protection.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002638">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined techniques to analyze the characteristics and behavior of malicious code.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 (10) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (10) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002639">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Incorporate the results from malicious code analysis into organizational incident response processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 (10) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (10) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002640">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Incorporate the results from malicious code analysis into organizational flaw remediation processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 (10) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-3 (10) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002641">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor the system to detect attacks and indicators of potential attacks in accordance with organization-defined monitoring objectives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002642">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor the system to detect unauthorized local connections.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-002643">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor the system to detect unauthorized network connections.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-002644">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor the system to detect unauthorized remote connections.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-002645">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the techniques and methods to be used to identify unauthorized use of the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002646">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify unauthorized use of the system through organization-defined techniques and methods.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002647">
      <status>draft</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects information obtained from intrusion-monitoring tools from unauthorized access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002648">
      <status>draft</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects information obtained from intrusion-monitoring tools from unauthorized modification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002649">
      <status>draft</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects information obtained from intrusion-monitoring tools from unauthorized deletion.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002650">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system monitoring information that is to be provided the organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 g" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-002651">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles that are to be provided organization-defined system monitoring information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 g" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-002652">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency at which the organization will provide the organization-defined system monitoring information to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 g" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-002653">
      <status>deprecated</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides organization-defined information system monitoring information to organization-defined personnel or roles as needed or per organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-002654">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide organization-defined system monitoring information to organization-defined personnel or roles as needed, and/or per organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 g" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-002655">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Connects individual intrusion detection tools into an system-wide intrusion detection system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002656">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Configures individual intrusion detection tools into an system-wide intrusion detection system.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002657">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ automated tools to integrate intrusion detection tools into access control mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002658">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ automated tools to integrate intrusion detection tools into flow control mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002659">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency on which it will monitor inbound communications for unusual or unauthorized activities or conditions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002660">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency on which it will monitor outbound communications for unusual or unauthorized activities or conditions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002661">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor inbound communications traffic per organization-defined frequency for organization-defined unusual or unauthorized activities or conditions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002662">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor outbound communications traffic per organization-defined frequency for organization-defined unusual or unauthorized activities or conditions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002663">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to receive alerts when organization-defined indicators of compromise or potential compromise occur.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002664">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Alert organization-defined personnel or roles when organization-defined compromise indicators generate the occurrence of a compromise or a potential compromise.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002665">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the encrypted communications traffic that is to be visible to organization-defined system monitoring tools.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002666">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system monitoring tools that will have visibility into organization-defined encrypted communications traffic.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002667">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Make provisions so that organization-defined encrypted communications traffic is visible to organization-defined system monitoring tools.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002668">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the interior points within the system where outbound communications will be analyzed to discover anomalies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (11)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002669">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use the traffic and event profiles in tuning system-monitoring devices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (13) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (13) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002670">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the interior points within the system where outbound communications will be analyzed to detect covert exfiltration of information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (18)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (18)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002671">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Analyze outbound communications traffic at the external interfaces of the system to detect covert exfiltration of information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (18)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (18)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002672">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Analyze outbound communications traffic at organization-defined interior points within the system to detect covert exfiltration of information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (18)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (18)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002673">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the additional monitoring to be implemented for individuals identified as posing an increased level of risk.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (19)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (19)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002674">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the sources that may be used to identify individuals who pose an increased level of risk.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (19)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (19)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002675">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined additional monitoring of individuals who have been identified by organization-defined sources as posing an increased level of risk.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (19)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (19)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002676">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines additional monitoring to be implemented for privileged users.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (20)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (20)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002677">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined additional monitoring of privileged users.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (20)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (20)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002678">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines additional monitoring to be implemented for individuals during an organization-defined probationary period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (21)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (21)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002679">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the probationary period during which additional monitoring will be implemented for individuals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (21)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (21)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002680">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined additional monitoring of individuals during an organization-defined probationary period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (21)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (21)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002681">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the authorization or approval process for network services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (22) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (22)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002682">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to be alerted when unauthorized or unapproved network services are detected.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (22) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (22)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002683">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Detect network services that have not been authorized or approved by the organization-defined authorization or approval processes.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (22) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (22)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002684">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Audit and/or alert organization-defined personnel when unauthorized network services are detected.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (22) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (22)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002685">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the host-based monitoring mechanisms to be implemented at organization-defined information system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (23)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (23)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002686">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components at which organization-defined host-based monitoring mechanisms are to be implemented.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (23)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (23)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002687">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined host-based monitoring mechanisms at organization-defined system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (23)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (23)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002688">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Discover indicators of compromise.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (24)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (24)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002689">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Collects indicators of compromise.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (24)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (24)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002690">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Distribute indicators of compromise provided by organization-defined sources, to organization-defined personnel or roles.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (24)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (24)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002691">
      <status>draft</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system uses indicators of compromise.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-4 (24)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002692">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the external organizations from which it receives information system security alerts, advisories, and directives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-5 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002693">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the elements within the organization to whom the organization will disseminate security alerts, advisories, and directives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-5 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-5 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002694">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the external organizations to which the organization will disseminate security alerts, advisories, and directives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-5 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-5 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002695">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security functions that require verification of correct operation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002696">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify correct operation of organization-defined security functions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002697">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency at which it will verify correct operation of organization-defined security functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002698">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system transitional states when the system will verify correct operation of organization-defined security functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002699">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Perform verification of the correct operation of organization-defined security functions: when the system is in an organization-defined transitional state; upon command by a user with appropriate privileges; and/or on an organization-defined frequency.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002700">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to be notified when security verification tests fail.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-6 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002701">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines alternative action(s) to be taken when anomalies in the operation of organization-defined security functions are discovered.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-6 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002702">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Shut the system down, restart the system, and/or initiate organization-defined alternative action(s) when anomalies in the operation of the organization-defined security functions are discovered.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-6 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002703">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the software, firmware, and information which will be subjected to integrity verification tools to detect unauthorized changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-002704">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ integrity verification tools to detect unauthorized changes to organization-defined software, firmware, and information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-002705">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the software on which integrity checks will be performed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002706">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the firmware on which integrity checks will be performed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002707">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information on which integrity checks will be performed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002708">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the transitional state or security-relevant events when performing integrity checks on software, firmware, and information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002709">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency at which integrity checks of software, firmware, and information will be performed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002710">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Perform an integrity check of organization-defined software at startup, at organization-defined transitional states or security-relevant events, or on an organization-defined frequency.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002711">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Perform an integrity check of organization-defined firmware at startup, at organization-defined transitional states or security-relevant events, or on an organization-defined frequency.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002712">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Perform an integrity check of organization-defined information at startup, at organization-defined transitional states or security-relevant events, or on an organization-defined frequency.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002713">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to be notified when discrepancies are discovered during integrity verification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002714">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls that are to be employed when integrity violations are discovered.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002715">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Automatically shut the system down, restart the system, and/or implement organization-defined controls when integrity violations are discovered.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002716">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement cryptographic mechanisms to detect unauthorized changes to software.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002717">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement cryptographic mechanisms to detect unauthorized changes to firmware.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002718">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement cryptographic mechanisms to detect unauthorized changes to information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002719">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the unauthorized security-relevant changes to the system that are to be incorporated into the organizational incident response capability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002720">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Incorporate the detection of organization-defined security-relevant unauthorized changes into the organizational incident response capability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002721">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles that are to be alerted when a potential integrity violation is detected.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002722">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines other actions that can be taken when a potential integrity violation is detected.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002723">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Upon detection of a potential integrity violation, provides the capability to audit the event.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002724">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Upon detection of a potential integrity violation, initiate one or more of the following actions: generate an audit record; alert the current user; alert organization-defined personnel or roles; and/or organization-defined other actions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002725">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system component which will have the integrity of the boot process verified.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (9)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002726">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify the integrity of the boot process of organization-defined system components.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (9)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002727">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the mechanisms to be implemented to protect the integrity of the boot firmware in organization-defined system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002728">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components on which organization-defined mechanisms will be implemented to protect the integrity of the boot firmware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002729">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined mechanisms to protect the integrity of boot firmware in organization-defined system components.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002730">
      <status>draft</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the user-installed software that is to be executed in a confined physical or virtual machine environment with limited privileges.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002731">
      <status>draft</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires that organization-defined user-installed software execute in a confined physical or virtual machine environment with limited privileges.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002732">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the user-installed software that is to have its integrity verified prior to execution.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (12)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002733">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that the integrity of organization-defined user-installed software be verified prior to execution.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (12)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002734">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles which have the authority to explicitly approve binary or machine-executable code.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (13)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002735">
      <status>draft</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization allows execution of binary or machine-executable code obtained from sources with limited or no warranty and without the provision of source code only in confined physical or virtual machine environments.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002736">
      <status>draft</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization allows execution of binary or machine-executable code obtained from sources with limited or no warranty and without the provision of source code only with the explicit approval of organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002737">
      <status>draft</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prohibits the use of binary or machine-executable code from sources with limited or no warranty and without the provision of source code.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (14) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002738">
      <status>draft</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides exceptions to the source code requirement only for compelling mission/operational requirements and with the approval of the authorizing official.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (14) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002739">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the software or firmware components on which cryptographic mechanisms are to be implemented to support authentication prior to installation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (15)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (15)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002740">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement cryptographic mechanisms to authenticate organization-defined software or firmware components prior to installation.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (15)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-7 (15)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002741">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ spam protection mechanisms at system entry points to detect and take action on unsolicited messages.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-8 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002742">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ spam protection mechanisms at system exit points to detect and take action on unsolicited messages.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-8 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002743">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement spam protection mechanisms with a learning capability to more effectively identify legitimate communications traffic.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-8 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-8 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002744">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the inputs on which the system is to conduct validity checks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-10" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-002745">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the inputs defined in base control (SI-10), which provide a manual override capability for input validation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-10 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-10 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002746">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide a manual override capability for input validation of organization-defined inputs defined in base control (SI-10).</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-10 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-10 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002747">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the individuals who have the authorization to use the manual override capability for input validation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-10 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-10 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002748">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Restrict the use of the manual override capability to only organization-defined authorized individuals.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-10 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-10 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002749">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Audit the use of the manual override capability.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-10 (1) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-10 (1) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002750">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time-period within which input validation errors are to be reviewed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-10 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-10 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002751">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time-period within which input validation errors are to be resolved.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-10 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-10 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002752">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review input validation errors within an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-10 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-10 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002753">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Resolve input validation errors within an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-10 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-10 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002754">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that the system behaves in a predictable and documented manner that reflects organizational and system objectives when invalid inputs are received.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-10 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-10 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002755">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Account for timing interactions among system components in determining appropriate responses for invalid inputs.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-10 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-10 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002756">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the trusted sources to which the usage of information inputs will be restricted (e.g., whitelisting).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-10 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-10 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002757">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the acceptable formats to which information inputs are restricted.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-10 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-10 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002758">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Restrict the use of information inputs to organization-defined trusted sources and/or organization-defined formats.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-10 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-10 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002759">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom error messages are to be revealed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-11 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-11 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002760">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Determines mean time to failure (MTTF) for organization-defined system components in specific environments of operation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-13 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-13 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002761">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components in specific environments of operation for which the mean time to failure (MTTF) is to be determined.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-13 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-13 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002762">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the mean time to failure (MTTF) substitution criteria to be employed as a means to determine the need to exchange active and standby components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-13 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-13 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002763">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provides a means to exchange active and standby components in accordance with the organization-defined mean time to failure (MTTF) substitution criteria.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-13 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-13 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002764">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines non-persistent system components and services to be implemented.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-14" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-14" />
      </references>
    </cci_item>
    <cci_item id="CCI-002765">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency at which the organization-defined non-persistent system components and services will be terminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-14" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-14" />
      </references>
    </cci_item>
    <cci_item id="CCI-002766">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined non-persistence system components and services that are initiated in a known state.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-14" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-14" />
      </references>
    </cci_item>
    <cci_item id="CCI-002767">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined non-persistence system components and services that are terminated upon end of session of use and/or periodically at an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-14" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-14" />
      </references>
    </cci_item>
    <cci_item id="CCI-002768">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the trusted sources from which it obtains software and data employed during the refreshing of non-persistent system components and services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-14 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-14 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002769">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obtain software and data employed during non-persistent system component and service refreshes are obtained from organization-defined trusted sources.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-14 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-14 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002770">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the software programs and/or applications from which the system is to validate the information output to ensure the information is consistent with expected content.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-15" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-15" />
      </references>
    </cci_item>
    <cci_item id="CCI-002771">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Validate information output from organization-defined software programs and/or applications to ensure that the information is consistent with the expected content.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-15" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-15" />
      </references>
    </cci_item>
    <cci_item id="CCI-002772">
      <status>deprecated</status>
      <publishdate>2013-07-11</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the security safeguards to be implemented to protect the information system's memory from unauthorized code execution.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-15" />
      </references>
    </cci_item>
    <cci_item id="CCI-002773">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the fail-safe procedures to be implemented when organization-defined failure conditions occur.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-17" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-17" />
      </references>
    </cci_item>
    <cci_item id="CCI-002774">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the failure conditions which, when they occur, will result in the information system implementing organization-defined fail-safe procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-17" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-17" />
      </references>
    </cci_item>
    <cci_item id="CCI-002775">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined fail-safe procedures when organization-defined failure conditions occur.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-17" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-17" />
      </references>
    </cci_item>
    <cci_item id="CCI-002776">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the organization-level; mission/business process-level; and/or system-level incident response policy is disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002777">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the incident response procedures are disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-002778">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period in which system users who assume an incident response role or responsibility receive incident response training.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-2 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002779">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide incident response training to system users consistent with assigned roles and responsibilities when required by system changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-2 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002780">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Coordinate incident response testing with organizational elements responsible for related plans.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002781">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components for dynamic reconfiguration as part of the incident response capability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002782">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement an incident handling capability for incidents involving insider threats.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002783">
      <status>draft</status>
      <publishdate>2013-07-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization coordinates an incident handling capability for insider threats across organization-defined components or elements of the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002784">
      <status>draft</status>
      <publishdate>2013-07-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines components or elements of the organization across which an incident handling capability for insider threats will be coordinated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002785">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Coordinate with organization-defined external organizations to correlate and share organization-defined incident information to achieve a cross-organization perspective on incident awareness and more effective incident responses.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002786">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines external organizations with which to correlate and share organization-defined incident information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002787">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines incident information to correlate and share with organization-defined external organizations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002788">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined dynamic response capabilities to effectively respond to incidents.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (9)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002789">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines dynamic response capabilities to effectively respond to incidents.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (9)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002790">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Coordinate incident handling activities involving supply chain events with other organizations involved in the supply chain.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-4 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002791">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines authorities to whom incident information is reported.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-6 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002792">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines personnel or roles to whom system vulnerabilities associated with reported incident information are reported.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002793">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide incident information to other organizations involved in the supply chain or supply chain governance for systems or system components related to the incident.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002794">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an incident response plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002795">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an incident response plan that provides the organization with a roadmap for implementing its incident response capability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-8 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002796">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an incident response plan that describes the structure and organization of the incident response capability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-8 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-002797">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an incident response plan that provides a high-level approach for how the incident response capability fits into the overall organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 a 3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-8 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-002798">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an incident response plan that meets the unique requirements of the organization, which relate to mission, size, structure, and functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 a 4" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-8 a 4" />
      </references>
    </cci_item>
    <cci_item id="CCI-002799">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an incident response plan that defines reportable incidents.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 a 5" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-8 a 5" />
      </references>
    </cci_item>
    <cci_item id="CCI-002800">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an incident response plan that provides metrics for measuring the incident response capability within the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 a 6" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-8 a 6" />
      </references>
    </cci_item>
    <cci_item id="CCI-002801">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an incident response plan that defines the resources and management support needed to effectively maintain and mature an incident response capability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 a 7" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-8 a 7" />
      </references>
    </cci_item>
    <cci_item id="CCI-002802">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines personnel or roles to review and approve the incident response plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 a 9" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-8 a 8" />
      </references>
    </cci_item>
    <cci_item id="CCI-002803">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines incident response personnel (identified by name and/or by role) and organizational elements to whom incident response plan changes will be communicated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-8 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-002804">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect the incident response plan from unauthorized disclosure and modification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-8 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-002805">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Respond to information spills by identifying the specific information involved in the system contamination.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-9 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-9 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002806">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Respond to information spills by alerting organization-defined personnel or roles of the information spill using a method of communication not associated with the spill.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-9 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002807">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to be alerted of information spills using a method of communication not associated with the spill.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-9 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002808">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Respond to information spills by isolating the contaminated system or system component.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-9 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-9 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002809">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Respond to information spills by eradicating the information from the contaminated system or component.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-9 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-9 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002810">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Respond to information spills by identifying other systems or system components that may have been subsequently contaminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-9 f" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-9 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-002811">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Respond to information spills by performing additional organization-defined actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-9 g" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-9 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-002812">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines additional actions required to respond to information spills.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-9 g" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-9 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-002813">
      <status>draft</status>
      <publishdate>2013-07-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization assigns organization-defined personnel or roles with responsibility for responding to information spills.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002814">
      <status>deprecated</status>
      <publishdate>2013-07-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization assigns organization-defined personnel or roles with responsibility for responding to information spills.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002815">
      <status>draft</status>
      <publishdate>2013-07-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines personnel or roles to whom responsibility for responding to information spills will be assigned.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002816">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide information spillage response training according to an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-9 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002817">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to provide information spillage response training.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-9 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002818">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined procedures to ensure that organizational personnel impacted by information spills can continue to carry out assigned tasks while contaminated systems are undergoing corrective actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-9 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002819">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the procedures to be implemented to ensure that organizational personnel impacted by information spills can continue to carry out assigned tasks while contaminated systems are undergoing corrective actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-9 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002820">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined controls for personnel exposed to information not within assigned access authorizations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-9 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-9 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002821">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls to be employed for personnel exposed to information not within assigned access authorizations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-9 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-9 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002822">
      <status>draft</status>
      <publishdate>2013-07-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes an integrated team of forensic/malicious code analysts, tool developers, and real-time operations personnel.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IR-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-002823">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls to be implemented to protect the system's memory from unauthorized code execution.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-16" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-002824">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined controls to protect its memory from unauthorized code execution.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-16" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SI-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-002825">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the organizational-level; mission/business process-level; and/or system-level contingency planning policy is to be disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002826">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines personnel or roles to whom the contingency planning procedures are disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-002827">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Coordinate the contingency plan with the contingency plans of external service providers to ensure that contingency requirements can be satisfied.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002828">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify critical system assets supporting all or essential mission functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002829">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify critical system assets supporting all or essential business functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002830">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles who review and approve the contingency plan for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 a 7" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 a 6" />
      </references>
    </cci_item>
    <cci_item id="CCI-002831">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a list of key contingency personnel (identified by name and/or by role) and organizational elements to whom contingency plan changes are to be communicated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 f" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-002832">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protects the contingency plan from unauthorized disclosure and modification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 h" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-2 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-002833">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period that contingency training is to be provided to system users consistent with assigned roles and responsibilities within assuming a contingency role or responsibility.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-3 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002834">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide contingency training to system users consistent with assigned roles and responsibilities when required by system changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-3 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002835">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test the contingency plan at the alternate processing site to evaluate the capabilities of the alternate processing site to support contingency operations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-4 (2) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-4 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002836">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that the alternate storage site provides security controls equivalent to that of the primary site.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-6 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002837">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Plan for circumstances that preclude returning to the primary processing site.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-7 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-7 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002838">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prepare for circumstances that preclude returning to the primary processing site.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-7 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-7 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002839">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines system operations that are permitted to transfer and resume at an alternate processing site for essential missions/business functions when the primary processing capabilities are unavailable.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-7 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002840">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system operations to be resumed for essential mission functions within the organization-defined time period when the primary telecommunications capabilities are unavailable at either the primary or alternate processing or storage sites.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-002841">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system operations to be resumed for essential business functions within the organization-defined time period when the primary telecommunications capabilities are unavailable at either the primary or alternate processing or storage sites.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-002842">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review provider contingency plans to ensure that the plans meet organizational contingency requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002843">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to obtain evidence of contingency testing by providers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8 (4) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8 (4) (c)  " />
      </references>
    </cci_item>
    <cci_item id="CCI-002844">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to obtain evidence of contingency training by providers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8 (4) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8 (4) (c)  " />
      </references>
    </cci_item>
    <cci_item id="CCI-002845">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obtain evidence of contingency testing by providers in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8 (4) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8 (4) (c)  " />
      </references>
    </cci_item>
    <cci_item id="CCI-002846">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obtain evidence of contingency training by providers in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8 (4) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8 (4) (c)  " />
      </references>
    </cci_item>
    <cci_item id="CCI-002847">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to test alternate telecommunication services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002848">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test alternate telecommunication services per organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-8 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002849">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines critical system software and other security-related information, of which backup copies must be stored in a separate facility or in a fire-rated container.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002850">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Store backup copies of organization-defined critical system software and other security-related information in a separate facility or in a fire-rated container that is not collocated with the operational system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002851">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the backup information that requires dual authorization for deletion or destruction.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-9 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002852">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce dual authorization for the deletion or destruction of organization-defined backup information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-9 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002853">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the capability to employ organization-defined alternative communications protocols in support of maintaining continuity of operations.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-11" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-11" />
      </references>
    </cci_item>
    <cci_item id="CCI-002854">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the alternative communications protocols the system must be capable of providing in support of maintaining continuity of operations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-11" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-11" />
      </references>
    </cci_item>
    <cci_item id="CCI-002855">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When organization-defined conditions are detected, enters a safe mode of operation with organization-defined restrictions of safe mode of operation.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002856">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the conditions that, when detected, the information system enters a safe mode of operation with organization-defined restrictions of safe mode of operation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002857">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the restrictions of the safe mode of operation that the system will enter when organization-defined conditions are detected.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002858">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined alternative or supplemental security mechanisms for satisfying organization-defined security functions when the primary means of implementing the security function is unavailable or compromised.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-13" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-13" />
      </references>
    </cci_item>
    <cci_item id="CCI-002859">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the alternative or supplemental security mechanisms that will be employed for satisfying organization-defined security functions when the primary means of implementing the security function is unavailable or compromised.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-13" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-13" />
      </references>
    </cci_item>
    <cci_item id="CCI-002860">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security functions that must be satisfied when the primary means of implementing the security function is unavailable or compromised.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-13" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="CP-13" />
      </references>
    </cci_item>
    <cci_item id="CCI-002861">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom an organization-level; mission/business process-level; and/or system-level maintenance policy is disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002862">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom system maintenance procedures are to be disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-002863">
      <status>draft</status>
      <publishdate>2013-07-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms to schedule, conduct, and document repairs.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-2 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002864">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Produce up-to date, accurate, and complete records of all maintenance requested, scheduled, in process, and completed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 (2) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-2 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002865">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Produce up-to date, accurate, and complete records of all repair actions requested, scheduled, in process, and completed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 (2) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-2 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002866">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Schedule maintenance on system components in accordance with manufacturer or vendor specifications and/or organizational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002867">
      <status>draft</status>
      <publishdate>2013-07-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization performs maintenance on information system components in accordance with manufacturer or vendor specifications and/or organizational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-2 a " />
      </references>
    </cci_item>
    <cci_item id="CCI-002868">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document records of maintenance on system components in accordance with manufacturer or vendor specifications and/or organizational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002869">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review records of maintenance on system components in accordance with manufacturer or vendor specifications and/or organizational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002870">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Schedule repair on system components in accordance with manufacturer or vendor specifications and/or organizational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002871">
      <status>draft</status>
      <publishdate>2013-07-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization performs repairs on information system components in accordance with manufacturer or vendor specifications and/or organizational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002872">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document repair on system components in accordance with manufacturer or vendor specifications and/or organizational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002873">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review records of repairs on system components in accordance with manufacturer or vendor specifications and/or organizational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002874">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles who can explicitly approve the removal of the system or system components from organizational facilities for off-site maintenance, repairs or replacement.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002875">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include organization-defined information in organizational maintenance records.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 f" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-2 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-002876">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information to include in organizational maintenance records.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 f" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-2 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-002877">
      <status>deprecated</status>
      <publishdate>2013-07-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prevents the unauthorized removal of maintenance equipment containing organizational information by verifying that there is no organizational information contained on the equipment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-3 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002878">
      <status>deprecated</status>
      <publishdate>2013-07-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prevents the unauthorized removal of maintenance equipment containing organizational information by sanitizing or destroying the equipment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-3 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002879">
      <status>deprecated</status>
      <publishdate>2013-07-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prevents the unauthorized removal of maintenance equipment containing organizational information by retaining the equipment within the facility.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-3 (3) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002880">
      <status>deprecated</status>
      <publishdate>2013-07-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prevents the unauthorized removal of maintenance equipment containing organizational information by retaining the equipment within the facility.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-3 (3) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002881">
      <status>deprecated</status>
      <publishdate>2013-07-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization prevents the unauthorized removal of maintenance equipment containing organizational information by obtaining an exemption from organization-defined personnel or roles explicitly authorizing removal of the equipment from the facility.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-3 (3) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002882">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles who can provide an exemption that explicitly authorizes removal of equipment from the facility.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-3 (3) (d)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-3 (3) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002883">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Restrict the use of maintenance tools to authorized personnel only.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-3 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002884">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Log organization-defined audit events for nonlocal maintenance and diagnostic sessions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002885">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the audit events for logged for nonlocal maintenance and diagnostic sessions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002886">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review the audit records of the maintenance and diagnostic sessions to detect anomalous behavior.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002887">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the authenticators that are replay resistant which will be employed to protect nonlocal maintenance sessions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002888">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles authorized to approve each nonlocal maintenance session.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 (5) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 (5) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002889">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Notify organization-defined personnel or roles of the date and time of planned nonlocal maintenance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 (5) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002890">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined cryptographic mechanisms to protect the integrity of nonlocal maintenance and diagnostic communications.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002891">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify session and network connection termination after the completion of nonlocal maintenance and diagnostic sessions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002892">
      <status>draft</status>
      <publishdate>2013-07-22</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops and implements alternate security safeguards in the event an information system component cannot be sanitized, removed, or disconnected from the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-5 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002893">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that non-escorted personnel performing maintenance activities not directly associated with the system but in the physical proximity of the system, have required access authorization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-5 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-5 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002894">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that non-escorted personnel performing maintenance on the system possess the required access authorizations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-5 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002895">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate organizational personnel with required access authorizations and technical competence to supervise the maintenance activities of personnel who do not possess the required access authorizations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-5 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-5 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002896">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components for which it obtains maintenance support and/or spare parts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-6" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-002897">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a time period for obtaining maintenance support and/or spare parts for organization-defined system components after a failure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-6" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-002898">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Perform preventive maintenance on organization-defined information system components at organization-defined time intervals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002899">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines system components on which to perform preventive maintenance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002900">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines time intervals at which to perform preventive maintenance on organization-defined system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-6 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002901">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Perform predictive maintenance on organization-defined system components at organization-defined intervals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002902">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines system components on which to perform predictive maintenance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002903">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines time intervals at which to perform predictive maintenance on organization-defined system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002904">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Transfer predictive maintenance data to a maintenance management system using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-6 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002905">
      <status>draft</status>
      <publishdate>2013-08-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms to schedule, conduct, and document maintenance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-2 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002906">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the vulnerability scanning activities in which the system implements privileged access authorization to organization-identified information system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-5 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002907">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system mode to be invoked, such as a full system shutdown, a partial system shutdown, or a degraded operational mode with limited mission or business functionality available, in the event of organization-defined audit logging failures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AU-5 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002908">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom an organization-level; mission/business process-level; and/or system-level physical and environmental protection policy is disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002909">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the physical and environmental protection procedures are disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-002910">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Approve a list of individuals with authorized access to the facility where the system resides.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002911">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain a list of individuals with authorized access to the facility where the system resides.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002912">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a list of acceptable forms of identification for visitor access to the facility where the system resides.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-2 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002913">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Restrict unescorted access to the facility where the system resides to personnel with one or more of the following: security clearances for all information contained within the system; formal access authorizations for all information contained within the system; need for access to all information contained within the system; organization-defined physical access authorizations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002914">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the credentials required for personnel to have unescorted access to the facility where the system resides.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-2 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002915">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the entry and exit points to the facility where the system resides.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002916">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the physical access control systems or devices or guards that control ingress and egress to the facility where the system resides.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-002917">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain physical access audit logs for organization-defined entry/exit points to the facility where the system resides.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002918">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines entry and exit points to the facility where the system resides that require physical access audit logs be maintained.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002919">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Control access to areas within the facility designated as publicly accessible by implementing organization-defined access controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002920">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines physical access controls to control access to areas within the facility designated as publicly accessible.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002921">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Escort visitors in the facility where the information system resides during organization-defined circumstances requiring visitor escorts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002922">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines circumstances requiring visitor escorts in the facility where the system resides.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002923">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor visitor activity in the facility where the system resides during organization-defined circumstances requiring visitor monitoring.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002924">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines circumstances requiring visitor monitoring in the facility where the system resides.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002925">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the physical access devices to inventory.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 f" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-002926">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the physical spaces containing one or more components of the system that require physical access authorizations and controls at the facility where the system resides.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002927">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to perform security checks at the physical boundary of the facility or system for exfiltration of information or removal of system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002928">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines anti-tamper technologies to detect and prevent physical tampering or alteration of organization-defined hardware components within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002929">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines hardware components within the system for which to employ organization-defined security safeguards to detect and prevent physical tampering or alteration.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-3 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002930">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines system distribution and transmission lines within organizational facilities to control physical access to using organization-defined security controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-4" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-002931">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines security controls to control physical access to organization-defined system distribution and transmission lines within organizational facilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-4" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-002932">
      <status>draft</status>
      <publishdate>2013-08-27</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization controls physical access to output from organization-defined output devices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-5 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002933">
      <status>draft</status>
      <publishdate>2013-08-27</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines output devices for which physical access to output is controlled.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-5 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002934">
      <status>draft</status>
      <publishdate>2013-08-27</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that only authorized individuals receive output from organization-defined output devices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-5 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002935">
      <status>draft</status>
      <publishdate>2013-08-27</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system controls physical access to output from organization-defined output devices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-5 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002936">
      <status>draft</status>
      <publishdate>2013-08-27</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The information system links individual identity to receipt of output from organization-defined output devices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-5 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002937">
      <status>draft</status>
      <publishdate>2013-08-27</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization marks organization-defined information system output devices indicating the appropriate security marking of the information permitted to be output from the device.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002938">
      <status>draft</status>
      <publishdate>2013-08-27</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the information system output devices marked indicating the appropriate security marking of the information permitted to be output from the device.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-5 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002939">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor physical access to the facility where the system resides to detect and respond to physical security incidents.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002940">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review physical access logs upon occurrence of organization-defined events or potential indications of events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002941">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines events or potential indications of events requiring review of physical access logs.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002942">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Recognize organization-defined classes or types of intrusions, using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002943">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the classes or types of intrusions to recognize using automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002944">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Initiate organization-defined response actions to organization-defined classes or types of intrusions, using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002945">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the response actions to initiate when organization-defined classes or types of intrusions are recognized.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002946">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ video surveillance of organization-defined operational areas.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002947">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the operational areas in which to employ video surveillance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002948">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Retain video surveillance recordings for an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 (3) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002949">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period to retain video surveillance recordings.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 (3) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002950">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor physical access to the system in addition to the physical access monitoring of the facility as organization-defined physical spaces containing one or more components of the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-6 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002951">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines physical spaces containing one or more components of the information system in which physical access is monitored.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-6 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002952">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period to maintain visitor access records to the facility where the system resides.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-8 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002953">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ redundant power cabling paths that are physically separated by an organization-defined distance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-9 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002954">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the distance by which to physically separate redundant power cabling paths.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-9 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002955">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide an uninterruptible power supply to facilitate an orderly shutdown of the system, and/or transition of the system to long-term alternate power in the event of a primary power source loss.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-11" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-11" />
      </references>
    </cci_item>
    <cci_item id="CCI-002956">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide an alternate power supply for the system that is activated manually or automatically and that is self-contained.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-11 (2) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-11 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002957">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide an alternate power supply for the system that is activated manually or automatically and that is not reliant on external power generation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-11 (2) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-11 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002958">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide an alternate power supply for the system that is activated manually or automatically and that is capable of maintaining minimally required operational capability or full operational capability in the event of an extended loss of the primary power source.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-11 (2) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-11 (2) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002959">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provides emergency lighting for all areas within the facility supporting essential mission functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-12 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002960">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide emergency lighting for all areas within the facility supporting essential business functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-12 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002961">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ fire detection systems for the system that activate automatically.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-13 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-13 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002962">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ fire detection systems for the system that automatically activate to notify organization-defined personnel or roles and organization-defined emergency responders in the event of a fire.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-13 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-13 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002963">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to be notified in the event of a fire.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-13 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-13 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002964">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the emergency responders to be notified in the event of a fire.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-13 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-13 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002965">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ fire suppression systems for the system that activate automatically and notify organization-defined personnel or roles and organization-defined emergency responders.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-13 (2) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-13 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002966">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to be automatically notified of any activation of fire suppression systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-13 (2) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-13 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002967">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the emergency responders to be automatically notified of any activation of fire suppression systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-13 (2) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-13 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002968">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that the facility undergoes, on an organization-defined frequency, fire protection inspections by authorized and qualified inspectors.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-13 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-13 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002969">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency with which the facility undergoes fire protection inspections.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-13 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-13 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002970">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure the identified deficiencies are resolved within an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-13 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-13 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002971">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period within which to resolve deficiencies identified during facility fire protection inspections.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-13 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-13 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002972">
      <status>draft</status>
      <publishdate>2013-08-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs automated mechanisms to detect the presence of water in the vicinity of the information system and alerts organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-15 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002973">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to be alerted when automated mechanisms detect the presence of water near the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-15 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-15 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002974">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines types of system components to authorize and control entering and exiting the facility and to maintain records.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-16 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-002975">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines controls to employ at alternate work sites.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-17 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-17 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002976">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines physical and environmental hazards that could cause potential damage to system components within the facility.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-18" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-18" />
      </references>
    </cci_item>
    <cci_item id="CCI-002977">
      <status>draft</status>
      <publishdate>2013-08-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization plans the location or site of the facility where the information system resides with regard to physical and environmental hazards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-18 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002978">
      <status>draft</status>
      <publishdate>2013-08-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization considers the physical and environmental hazards in its risk mitigation strategy for existing facilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-18 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-002979">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined asset location technologies to track and monitor the location and movement of organization-defined assets within organization-defined controlled areas.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-20" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-20 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002980">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines asset location technologies to track and monitor the location and movement of organization-defined assets within organization-defined controlled areas.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-20" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-20 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002981">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the assets within the organization-defined controlled areas which are to be tracked and monitored for their location and movement.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-20" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-20 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002982">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines controlled areas where the location and movement of organization-defined assets are tracked and monitored.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-20" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-20 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-002983">
      <status>draft</status>
      <publishdate>2013-08-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that asset location technologies are employed in accordance with applicable federal laws, Executive Orders, directives, regulations, policies, standards, and guidance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PE-20 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002984">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide information security program plan that reflects the coordination among organizational entities responsible for information security.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-1 a 3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-1 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-002985">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-wide information security program plan that provides an overview of the requirements for the security program and a description of the security program management controls and common controls in place or planned for meeting those requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002986">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-wide information security program plan that includes the identification and assignment of roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-002987">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-wide information security plan that reflects the coordination among organizational entities responsible for information security.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-1 a 3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-1 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-002988">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-wide information security program plan that is approved by a senior official with responsibility and accountability for the risk being incurred to organizational operations (including mission, functions, image, and reputation), organizational assets, individuals, other organizations, and the Nation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-1 a 4" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-1 a 4" />
      </references>
    </cci_item>
    <cci_item id="CCI-002989">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect the information security program plan from unauthorized disclosure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-1 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-1 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002990">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect the information security program plan from unauthorized modification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-1 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-1 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-002991">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process to ensure that plans of action and milestones for the information security program and associated organizational systems are developed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-4 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-4 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002992">
      <status>draft</status>
      <publishdate>2013-08-29</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements a process for ensuring that plans of action and milestones for the security program and associated organizational information systems are reported in accordance with OMB FISMA reporting requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-4 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-002993">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review plans of action and milestones for the security program and associated organization systems for consistency with the organizational risk management strategy and organization-wide priorities for risk response actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-4 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-002994">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the risk management strategy in accordance with organization-defined frequency or as required, to address organizational changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-9 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-9 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002995">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the risk management strategy to address organizational changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-9 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-9 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-002996">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement an insider threat program that includes a cross-discipline insider threat incident handling team.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-002997">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish a security workforce development and improvement program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-13" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-13" />
      </references>
    </cci_item>
    <cci_item id="CCI-002998">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for ensuring that organizational plans for conducting security testing activities associated with organizational systems are developed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-14 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-002999">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for ensuring that organizational plans for conducting security testing activities associated with organizational systems are maintained.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-14 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003000">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for ensuring that organizational plans for conducting security training activities associated with organizational systems are developed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-14 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003001">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for ensuring that organizational plans for conducting security training activities associated with organizational systems are maintained.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-14 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003002">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for ensuring that organizational plans for conducting security monitoring activities associated with organizational systems are developed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-14 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003003">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for ensuring that organizational plans for conducting security monitoring activities associated with organizational information systems are maintained.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-14 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003004">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for ensuring that organizational plans for conducting security testing associated with organizational systems continue to be executed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-14 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003005">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for ensuring that organizational plans for conducting security training associated with organizational systems continue to be executed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-14 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003006">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for ensuring that organizational plans for conducting security monitoring activities associated with organizational systems continue to be executed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-14 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003007">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review testing plans for consistency with the organizational risk management strategy and organization-wide priorities for risk response actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-14 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003008">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review training plans for consistency with the organizational risk management strategy and organization-wide priorities for risk response actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-14 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003009">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review monitoring plans for consistency with the organizational risk management strategy and organization-wide priorities for risk response actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-14 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003010">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish and institutionalize contact with selected groups and associations within the security community to facilitate ongoing security education and training for organizational personnel.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-15 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-15 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003011">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish and institutionalize contact with selected groups and associations within the security community to maintain currency with recommended security practices, techniques, and technologies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-15 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-15 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003012">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish and institutionalize contact with selected groups and associations within the security community to share current security information including threats, vulnerabilities, and incidents.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-15 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-15 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003013">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a threat awareness program that includes a cross-organization information-sharing capability for threat intelligence.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-16" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PM-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-003014">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined mandatory access control policies over all subjects and objects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003015">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Specifies that organization-defined subjects may explicitly be granted organization-defined privileges such that they are not limited by any defined subset (or all) of the above constraints.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (3) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AC-3 (3) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003016">
      <status>draft</status>
      <publishdate>2013-09-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization, upon termination of individual employment, notifies organization-defined personnel or roles within an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-4 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-003017">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom an organization-level; mission/business process-level; and/or system-level personnel security policy is disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003018">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the personnel security procedures are disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003019">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that individuals accessing a system processing, storing, or transmitting information requiring special protection have valid access authorizations that are demonstrated by assigned official government duties.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-3 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-3 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003020">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that individuals accessing a system processing, storing, or transmitting information requiring special protection satisfy organization-defined additional personnel screening criteria.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-3 (3) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-3 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003021">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines additional personnel screening criteria that individuals accessing a system processing, storing, or transmitting information requiring protection must satisfy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-3 (3) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-3 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003022">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period within which to disable system access upon termination of individual employment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-4 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003023">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Upon termination of individual employment, terminate or revoke any authenticators and credentials associated with the individual.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-4 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003024">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines information security topics to be discussed while conducting exit interviews.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-4 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-4 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003025">
      <status>draft</status>
      <publishdate>2013-09-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines personnel or roles to notify upon termination of individual employment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-4 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-003026">
      <status>draft</status>
      <publishdate>2013-09-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the time period within which to notify organization-defined personnel or roles upon termination of individual employment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-4 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-003027">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Notify terminated individuals of applicable, legally binding post-employment requirements for the protection of organizational information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-4 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-4 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003028">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require terminated individuals to sign an acknowledgment of post-employment requirements as part of the organizational termination process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-4 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-4 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003029">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use organization-defined automated mechanisms to notify organization-defined personnel or roles of individual termination actions; and/or disable access to system resources.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003030">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to be notified by automated mechanism of individual termination actions, and/or disable access to system resources.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003031">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Modify access authorization as needed to correspond with any changes in operational need due to reassignment or transfer.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-5 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-5 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003032">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Notify organization-defined personnel or roles within an organization-defined time period when individuals are transferred or reassigned to other positions within the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-5 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-5 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003033">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines personnel or roles to be notified when individuals are transferred or reassigned to other positions within the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-5 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-5 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003034">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period within which organization-defined personnel or roles are to be notified when individuals are transferred or reassigned to other positions within the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-5 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-5 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003035">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document access agreements for organizational systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-6 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003036">
      <status>draft</status>
      <publishdate>2013-09-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that individuals requiring access to organizational information and information systems re-sign access agreements to maintain access to organizational information systems when access agreements have been updated or in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-6 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003037">
      <status>draft</status>
      <publishdate>2013-09-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency for individuals requiring access to organization information and information systems to re-sign access agreements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-6 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003038">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Notify individuals of applicable, legally binding post-employment requirements for protection of organizational information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-6 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-6 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003039">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require individuals to sign an acknowledgement of legally binding post-employment requirements for protection of organizational information, if applicable, as part of granting initial access to covered information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-6 (3) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-6 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003040">
      <status>draft</status>
      <publishdate>2013-09-12</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires third-party providers to comply with personnel security policies and procedures established by the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003041">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require external providers to notify organization-defined personnel or roles of any personnel transfers or terminations of external personnel who possess organizational credentials and/or badges, or who have system privileges within an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-7 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-7 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003042">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines personnel or roles whom external providers are to notify when external personnel who possess organizational credentials and /or badges or who have system privileges are transferred or terminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-7 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-7 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003043">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period for external providers to notify organization-defined personnel or roles when external personnel who possess organizational credentials and/or badges, or who have system privileges are transferred or terminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-7 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-7 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003044">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Notify organization-defined personnel or roles within an organization-defined time period when a formal employee sanctions process is initiated, identifying the individual sanctioned and the reason for the sanction.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-8 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003045">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines personnel or roles who are to be notified when a formal employee sanctions process is initiated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-8 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003046">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period within which to notify organization-defined personnel or roles when a formal employee sanctions process is initiated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-8 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PS-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003047">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the planning policy is disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003048">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the planning procedures are disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003049">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security and privacy plans for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003050">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security and privacy plans for the system that are consistent with the organization's enterprise architecture.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003051">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security and privacy plans for the system that explicitly defines the authorization boundary for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003052">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security and privacy plans for the system that describes the operational context of the system in terms of missions and business processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 a 3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-003053">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security and privacy plans for the system that provide the security categorization of the system, including supporting rationale.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 a 6" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 a 4" />
      </references>
    </cci_item>
    <cci_item id="CCI-003054">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security and privacy plans for the system that describe the operational environment for the system and any dependencies on or connections to, other systems or system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 a 9" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 a 5" />
      </references>
    </cci_item>
    <cci_item id="CCI-003055">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security and privacy plans for the system that provide an overview of the security and privacy requirements for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 a 10" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 a 6" />
      </references>
    </cci_item>
    <cci_item id="CCI-003056">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security and privacy plans for the system that identify any relevant control baselines or overlays, if applicable.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 a 11" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 a 7" />
      </references>
    </cci_item>
    <cci_item id="CCI-003057">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security and privacy plans for the system that describe the controls in place or planned for meeting the security and privacy requirements, including a rationale for any tailoring decisions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 a 12" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 a 8" />
      </references>
    </cci_item>
    <cci_item id="CCI-003058">
      <status>deprecated</status>
      <publishdate>2013-09-23</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization distributes copies of the security plan to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003059">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Distribute copies of the plans to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003060">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom copies of the plans are distributed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003061">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Communicate subsequent changes to the plans to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003062">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom changes to the plans are communicated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003063">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect the plans from unauthorized disclosure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-003064">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect the plans from unauthorized modification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-003065">
      <status>draft</status>
      <publishdate>2013-09-23</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization plans and coordinates security-related activities affecting the information system with organization-defined individuals or groups before conducting such activities in order to reduce the impact on other organizational entities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003066">
      <status>deprecated</status>
      <publishdate>2013-09-23</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the individuals or groups with whom security-related activities are planned and coordinated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003067">
      <status>draft</status>
      <publishdate>2013-09-23</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the individuals or groups with whom security-related activities are planned and coordinated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003068">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the rules of behavior in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-4 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-4 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003069">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the rules of behavior.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-4 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-4 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003070">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require individuals who have acknowledged a previous version of the rules of behavior to read and re-acknowledge, on an organization-defined frequency, and/or when the rules of behavior are revised or updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-4 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003071">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a security Concept of Operations (CONOPS) for the system describing how the organization intends to operate the system from the perspective of information security.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-7 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003072">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security architectures for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003073">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security architectures for the system that describes the requirements and approach to be taken for protecting the confidentiality, integrity, and availability of organizational information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-8 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003074">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security architectures for the system that describe how the architectures are integrated into and support the enterprise architecture.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 a 3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-8 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003075">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security architectures for the system that describe any assumptions about, and dependencies on, external systems and services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 a 4" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-8 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-003076">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the architectures in accordance with organization-defined frequency to reflect updates in the enterprise architecture.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003077">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and update the system architecture.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003078">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Reflect planned security architecture changes in the security plans.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003079">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Reflect planned security architecture changes in the security Concept of Operations (CONOPS).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003080">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Reflect planned security architecture changes in the security organizational procurements and acquisitions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003081">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Design the security architecture for the system using a defense-in-depth approach that allocates organization-defined controls to organization-defined locations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-8 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003082">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Design the security architecture for the system using a defense-in-depth approach that allocates organization-defined controls to organization-defined architectural layers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-8 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003083">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls to be allocated to organization-defined locations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-8 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003084">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls to be allocated to organization-defined architectural layers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-8 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003085">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the locations to which the system allocates organization-defined controls in the security architecture.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-8 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003086">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the architectural layers to which the system allocates organization-defined controls in the security architecture.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-8 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003087">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Design the security architecture for the system using a defense-in-depth approach that ensures that the allocated controls operate in a coordinated and mutually reinforcing manner.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-8 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003088">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that organization-defined controls allocated to organization-defined locations and architectural layers be obtained from different suppliers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003089">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the organization-level; mission/business process-level; and/or system-level system and services acquisition policy is disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 a 1 (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003090">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom procedures to facilitate the implementation of the system and services acquisition policy and associated system and services acquisition controls are disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003091">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Determine the high-level information security requirements for the system or system service in mission and business process planning.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-2 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-2 a " />
      </references>
    </cci_item>
    <cci_item id="CCI-003092">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a system development life cycle that is used to manage the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003093">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Integrate the organizational information security risk management process into system development life cycle activities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-3 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003094">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the security functional requirements, explicitly or by reference, using standardized contract language; and/or organization-defined contract language in the acquisition contract for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003095">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the strength of mechanism requirements, explicitly or by reference, using standardized contract language; and/or organization-defined contract language in the acquisition contract for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003096">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the security assurance requirements, explicitly or by reference, using standardized contract language; and/or organization-defined contract language in the acquisition contract for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003097">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the security documentation requirements, explicitly or by reference, using standardized contract language; and/or organization-defined contract language in the acquisition contract for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003098">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the requirements for protecting security documentation, explicitly or by reference, using standardized contract language; and/or organization-defined contract language in the acquisition contract for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 f" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-003099">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the description of the system development environment and environment in which the system is intended to operate, explicitly or by reference, using standardized contract language; and/or organization-defined contract language in the acquisition contract for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 g" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-003100">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the acceptance criteria, explicitly or by reference, using standardized contract language; and/or organization-defined contract language in the acquisition contract for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 i" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-003101">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to provide design information for the controls that includes security-relevant external system interfaces, high-level design, low-level design, source code, hardware schematics, and/or organization-defined design information at an organization-defined level of detail.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003102">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to provide implementation information for the controls that includes security-relevant external system interfaces, high-level design, low-level design, source code, hardware schematics, and/or organization-defined implementation information at an organization-defined level of detail.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003103">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the design information that the developer of the system, system component, or system service is required to provide for the controls to be designed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003104">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the implementation information that the developer of the system, system component, or system service is required to provide for the security controls to be implemented.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003105">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the level of detail for the design information of the controls that is required to be provided by the developer of the information system, system component, or information system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003106">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the level of detail for the implementation information of the security controls that is required to be provided by the developer of the information system, system component, or information system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003107">
      <status>draft</status>
      <publishdate>2013-09-23</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires the developer of the information system, system component, or information system service to demonstrate the use of a system development life cycle that includes organization-defined state-of-the-practice system/security engineering methods, software development methods, testing/evaluation/validation techniques, and quality control processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003108">
      <status>draft</status>
      <publishdate>2013-09-23</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the state-of-the-practice system/security engineering methods, software development methods, testing/evaluation/validation techniques, and quality control processes that the developer of the information system, system component, or information system service is required to include when demonstrating the use of a system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003109">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to deliver the system, component, or service with organization-defined security configurations implemented.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (5) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (5) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003110">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security configurations required to be implemented when the developer delivers the system, system component, or system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (5) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (5) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003111">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Requires the developer of the system, system component, or system service to use the configurations as the default for any subsequent system, component, or service reinstallation or upgrade.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (5) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003112">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to produce a plan for the continuous monitoring of control effectiveness that is consistent with the continuous monitoring program of the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003113">
      <status>draft</status>
      <publishdate>2013-09-23</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the level of detail to be contained in the plan for the continuous monitoring of security control effectiveness that the developer of the information system, system component, or information system services is required to produce.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003114">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to identify the functions, ports, protocols, and services intended for organizational use.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (9)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003115">
      <status>deprecated</status>
      <publishdate>2013-09-23</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires the developer of the information system, system component, or information system service to identify early in the system development life cycle, the functions, ports, protocols, and services intended for organizational use.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003116">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ only information technology products on the FIPS 201-approved products list for Personal Identity Verification (PIV) capability implemented within organizational systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-4 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003117">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Centrally manage organization-defined controls and related processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-9" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-003118">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls and related processes to be centrally managed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-9" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="PL-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-003119">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ a technical surveillance countermeasures survey at organization-defined locations on an organization-defined frequency or when organization-defined events or indicators occur.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-6" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-003120">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the locations where technical surveillance countermeasures surveys are to be employed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-6" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-003121">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency on which to employ technical surveillance countermeasures surveys.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-6" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-003122">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events or indicators upon which technical surveillance countermeasures surveys are to be employed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-6" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="RA-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-003123">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined cryptographic mechanisms to protect the confidentiality of nonlocal maintenance and diagnostic communications.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="MA-4 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003124">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obtain or develop administrator documentation for the system, system component, or system service that describes secure configuration of the system, component, or service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-5 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-5 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003125">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obtain or develop administrator documentation for the system, system component, or system service that describes secure installation of the system, component, or service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-5 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-5 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003126">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obtain or develop administrator documentation for the system, system component, or system service that describes secure operation of the system, component, or service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-5 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-5 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003127">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obtain or develop administrator documentation for the system, system component, or system services that describes effective use and maintenance of security functions and mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-5 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-5 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003128">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obtain or develop administrator documentation for the system, system component, or system service that describes known vulnerabilities regarding configuration and use of administrative or privileged functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-5 a 3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-5 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-003129">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obtain or develop user documentation for the system, system component, or system service that describes user-accessible security functions and mechanisms and how to effectively use those functions and mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-5 b 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-5 b 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003130">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obtain or develop user documentation for the system, system component, or system service that describes methods for user interaction which enables individuals to use the system, component, or service in a more secure manner.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-5 b 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-5 b 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003131">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obtain or develop user documentation for the system, system component, or system service that describes user responsibilities in maintaining the security of the system, component, or service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-5 b 3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-5 b 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-003132">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Take organization-defined actions in response to attempts to obtain either unavailable or nonexistent documentation for the system, system component, or system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-5 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-5 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003133">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines actions to be taken in response to attempts to obtain either unavailable or nonexistent documentation for the system, system component, or system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-5 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-5 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003134">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization protects information system, system component, or information system service documentation as required, in accordance with the risk management strategy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-5 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003135">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Distribute system, system component, or system service documentation to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-5 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-5 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-003136">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom system, system component, or system service documentation is to be distributed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-5 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-5 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-003137">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines security controls that providers of external information system services employ in accordance with applicable federal laws, Executive Orders, directives, policies, regulations, standards, and guidance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003138">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined processes, methods, and techniques to monitor control compliance by external service providers on an ongoing basis.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003139">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines processes, methods, and techniques to employ to monitor control compliance by external service providers on an ongoing basis.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003140">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct an organizational assessment of risk prior to the acquisition or outsourcing of information security services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9  (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003141">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that the acquisition or outsourcing of dedicated information security services is approved by organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003142">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles authorized to approve the acquisition or outsourcing of dedicated information security services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003143">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require providers of organization-defined external system services to identify the functions, ports, protocols, and other services required for the use of such services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003144">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the external system services for which the providers are required to identify the functions, ports, protocols, and other services required for the use of such services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003145">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish trust relationships with external service providers based on organization-defined security requirements, properties, factors, or conditions defining acceptable trust relationships.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003146">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document trust relationships with external service providers based on organization-defined security requirements, properties, factors, or conditions defining acceptable trust relationships.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003147">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain trust relationships with external service providers based on organization-defined security requirements, properties, factors, or conditions defining acceptable trust relationships.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003148">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines security requirements, properties, factors, or conditions defining acceptable trust relationships with external service providers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003149">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Take organization-defined actions to verify that the interests of organization-defined external service providers are consistent with and reflect organizational interests.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003150">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the actions taken to verify that the interests of organization-defined external service providers are consistent with and reflect organizational interests.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003151">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines external service providers whose interests are consistent with and reflect organizational interests.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003152">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Restrict the location of information processing, information or data, and/or system services to organization-defined locations based on organization-defined requirements or conditions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003153">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the locations for which to restrict information processing, information or data, and/or system services based on organization-defined requirements or conditions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003154">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the requirements or conditions on which to base restricting the location of information processing, information or data, and/or system services to organization-defined locations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-9 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003155">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to perform configuration management during system, component, or service design, development, implementation, operation and/or disposal.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003156">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to document the integrity of changes to organization-defined configuration items under configuration management.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003157">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to manage the integrity of changes to organization-defined configuration items under configuration management.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003158">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to control the integrity of changes to organization-defined configuration items under configuration management.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003159">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the configuration items under configuration management that require the integrity of changes to be documented, managed and controlled.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003160">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to document the potential security impacts of approved changes to the system, component, or service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003161">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to track security flaws within the system, component, or service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-003162">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to track flaw resolution within the system, component, or service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-003163">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to report findings of security flaws and flaw resolution within the system, component, or service to organization-defined personnel.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-003164">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel to whom security flaw findings and flaw resolution within the system, component, or service are reported.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-003165">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to enable integrity verification of hardware components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 (3)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003166">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to employ tools for comparing newly generated versions of security-relevant hardware descriptions with previous versions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003167">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to employ tools for comparing newly generated versions of source code with previous versions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003168">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to employ tools for comparing newly generated versions of object code with previous versions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003169">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to maintain the integrity of the mapping between the master build data describing the current version of security-relevant hardware, software, and firmware and the on-site master copy of the data for the current version.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003170">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to execute procedures for ensuring that security-relevant hardware, software, and firmware updates distributed to the organization are exactly as specified by the master copies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-10 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003171">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service, at all post-design phases of the system development life cycle, to develop a plan for ongoing security control assessment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003172">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to implement a plan for ongoing security control assessment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003173">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Requires the developer of the system, system component, or system service, at all post-design phases of the system development life cycle, to perform unit, integration, system, and/or regression testing/evaluation on an organization-defined frequency, at an organization-defined depth and coverage.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003174">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the depth and coverage at which to perform unit, integration, system, and/or regression testing/evaluation on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003175">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Requires the developer of the system, system component, or system service, at all post-design phases of the system development life cycle, to produce evidence of the execution of the assessment plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003176">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Requires the developer of the system, system component, or system service, at all post-design phases of the system development life cycle, to produce the results of the testing and evaluation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003177">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Requires the developer of the system, system component, or system service, at all post-design phases of the system development life cycle, to implement a verifiable flaw remediation process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 d" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003178">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Requires the developer of the system, system component, or system service, at all post-design phases of the system development life cycle, to correct flaws identified during testing/evaluation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 e" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-003179">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to employ static code analysis tools to identify common flaws.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003180">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to document the results of static code analysis.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (1)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003181">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to perform threat modeling and vulnerability analyses during development.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003182">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to perform threat modeling and vulnerability analysis during subsequent testing and evaluation of the system, component, or service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003183">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require an independent agent satisfying organization-defined independence criteria to verify the correct implementation of the developer security assessment plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003184">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require an independent agent satisfying organization-defined independence criteria to verify the evidence produced during security testing and evaluation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003185">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the independence criteria the independent agent must satisfy prior to verifying the correct implementation of the developer security assessment plan and the evidence produced during security testing and evaluation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003186">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that the independent agent either is provided with sufficient information to complete the verification process or has been granted the authority to obtain such information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (3) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003187">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to perform a manual code review of organization-defined specific code using organization-defined processes, procedures, and/or techniques.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003188">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the specific code for which the developer of the system, system component, or system service is required to perform a manual code review using organization-defined process, procedures, and/or techniques.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003189">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the processes, procedures, and/or techniques to be used by the developer of the system, system component, or system service to perform a manual code review of organization-defined specific code.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (4)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003190">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires the developer of the information system, system component, or information system service to perform penetration testing at an organization-defined breadth/depth and with organization-defined constraints.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003191">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the breadth and depth at which the developer of the system, system component, or system service is required to perform penetration testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (5) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003192">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the constraints on penetration testing performed by the developer of the system, system component, or system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (5) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003193">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to perform attack surface reviews.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003194">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to verify that the scope of testing and evaluation provides complete coverage of required controls at an organization-defined depth of testing and evaluation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003195">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the depth of testing and evaluation to which the developer of the system, system component, or system service is required to verify that the scope of security testing and evaluation provides complete coverage of the required controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003196">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to employ dynamic code analysis tools to identify common flaws.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003197">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to document the results of the dynamic code analysis.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-11 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003198">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs organization-defined tailored acquisition strategies, contract tools, and procurement methods for the purchase of the information system, system component, or information system service from suppliers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003199">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines tailored acquisition strategies, contract tools, and procurement methods to employ for the purchase of the information system, system component, or information system service from suppliers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003200">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization conducts a supplier review prior to entering into a contractual agreement to acquire the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003201">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs organization-defined security safeguards to limit harm from potential adversaries identifying and targeting the organizational supply chain.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003202">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines security safeguards to employ to limit harm from potential adversaries identifying and targeting the organizational supply chain.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003203">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization conducts an assessment of the information system, system component, or information system service prior to selection, acceptance, or update.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003204">
      <status>deprecated</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization conducts an assessment of the information system, system component, or information system service prior to selection, acceptance, or update.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003205">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization uses all-source intelligence analysis of suppliers and potential suppliers of the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003206">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs organization-defined Operations Security (OPSEC) safeguards in accordance with classification guides to protect supply chain-related information for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003207">
      <status>deprecated</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs organization-defined tailored acquisition strategies, contract tools, and procurement methods for the purchase of the information system, system component, or information system service from suppliers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003208">
      <status>deprecated</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs organization-defined tailored acquisition strategies, contract tools, and procurement methods for the purchase of the information system, system component, or information system service from suppliers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003209">
      <status>deprecated</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs organization-defined tailored acquisition strategies, contract tools, and procurement methods for the purchase of the information system, system component, or information system service from suppliers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003210">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the Operations Security (OPSEC) safeguards to be employed in accordance with classification guides to protect supply chain-related information for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003211">
      <status>deprecated</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the Operations Security (OPSEC) safeguards to be employed in accordance with classification guides to protect supply chain-related information for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003212">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs organization-defined security safeguards to validate that the information system or system component received is genuine and has not been altered.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003213">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the security safeguards to be employed to validate that the information system or system component received is genuine and has not been altered.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003214">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs organizational analysis, independent third-party analysis, organizational penetration testing and/or independent third-party penetration testing of organization-defined supply chain elements, processes, and actors associated with the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003215">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the supply chain elements, processes, and actors associated with the information system, system component, or information system service for organizational analysis, independent third-party analysis, organizational penetration testing and/or independent third-party penetration testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003216">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes inter-organizational agreements with entities involved in the supply chain for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003217">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes inter-organizational procedures with entities involved in the supply chain for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003218">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs organization-defined security safeguards to ensure an adequate supply of organization-defined critical information system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003219">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the security safeguards to be employed to ensure an adequate supply of organization-defined critical information system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003220">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the critical information system components for which organization-defined security safeguards are employed to ensure adequate supply.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003221">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes unique identification of organization-defined supply chain elements, processes, and actors for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (14)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003222">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization retains unique identification of organization-defined supply chain elements, processes, and actors for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (14)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003223">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the supply chain elements, processes, and actors for the information system, system component, or information system service to establish and retain unique identification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (14)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003224">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes a process to address weaknesses or deficiencies in supply chain elements identified during independent or organizational assessments of such elements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-12 (15)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003225">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization describes the trustworthiness required in the organization-defined information system, information system component, or information system service supporting its critical missions/business functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-13 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003226">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the information system, information system component, or information system service supporting its critical missions/business functions in which the trustworthiness must be described.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-13 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003227">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements an organization-defined assurance overlay to achieve trustworthiness required to support its critical missions/business functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-13 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003228">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines an assurance overlay to be implemented to achieve trustworthiness required to support its critical missions/business functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-13 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003229">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization identifies critical information system components by performing a criticality analysis for organization-defined information systems, information system components, or information system services at organization-defined decision points in the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-14" />
      </references>
    </cci_item>
    <cci_item id="CCI-003230">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization identifies critical information system functions by performing a criticality analysis for organization-defined information systems, information system components, or information system services at organization-defined decision points in the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-14" />
      </references>
    </cci_item>
    <cci_item id="CCI-003231">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the information systems, information system components, or information system services for which the organization identifies critical information system components and functions for criticality analysis.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-14" />
      </references>
    </cci_item>
    <cci_item id="CCI-003232">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the decision points in the system development life cycle at which to perform a criticality analysis to identify critical information system components and functions for organization-defined information systems, information system components, or information system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-14" />
      </references>
    </cci_item>
    <cci_item id="CCI-003233">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to follow a documented development process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15" />
      </references>
    </cci_item>
    <cci_item id="CCI-003234">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to follow a documented development process that explicitly addresses security requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 a 1" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003235">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to follow a documented development process that identifies the standards used in the development process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003236">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to follow a documented development process that identifies the tools used in the development process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 a 2" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003237">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to follow a documented development process that documents the specific tool options and tool configurations used in the development process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 a 3" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-003238">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to follow a documented development process that documents changes to the process and/or tools used in development.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 a 4" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 a 4" />
      </references>
    </cci_item>
    <cci_item id="CCI-003239">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to follow a documented development process that manages changes to the process and/or tools used in development.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 a 4" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 a 4" />
      </references>
    </cci_item>
    <cci_item id="CCI-003240">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to follow a documented development process that ensures the integrity of changes to the process and/or tools used in development.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 a 4" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 a 4" />
      </references>
    </cci_item>
    <cci_item id="CCI-003241">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review the development process in accordance with organization-defined frequency to determine if the development process selected and employed can satisfy organization-defined security requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003242">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review the development standards in accordance with organization-defined frequency to determine if the development standards selected and employed can satisfy organization-defined security requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003243">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review the development tools in accordance with organization-defined frequency to determine if the development tools selected and employed can satisfy organization-defined security requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003244">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review the development tool options/configurations in accordance with organization-defined frequency to determine if the development tool options and tool configurations selected and employed can satisfy organization-defined security requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003245">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency on which to review the development process, standards, tools, and tool options/configurations to determine if the process, standards, tools, and tool options and tool configurations selected and employed can satisfy organization-defined security requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003246">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security requirements that must be satisfied by conducting a review of the development process, standards, tools, and tool options and tool configurations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003247">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to define quality metrics at the beginning of the development process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003248">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to provide evidence of meeting the quality metrics in accordance with organization-defined frequency, organization-defined program review milestones, and/or upon delivery.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003249">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency on which the developer of the information system, system component, or information system service is required to provide evidence of meeting the quality metrics.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003250">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the program review milestones at which the developer of the information system, system component, or information system service is required to provide evidence of meeting the quality metrics.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003251">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to select a security tracking tool for use during the development process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003252">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to employ a security tracking tool for use during the development process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (2)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003253">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires the developer of the information system, system component, or information system service to perform a criticality analysis at an organization-defined breadth/depth and at organization-defined decision points in the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003254">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the breadth/depth of criticality analysis at which the developer of the system, system component, or system service is required to perform a criticality analysis.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (3) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003255">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines decision points in the system development life cycle at which the developer of the system, system component, or system service is required to perform a criticality analysis.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003256">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires that developers perform threat modeling for the information system at an organization-defined breadth/depth.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003257">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires that developers perform a vulnerability analysis for the information system at an organization-defined breadth/depth.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003258">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the breadth/depth at which threat modeling for the information system must be performed by developers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003259">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the breadth/depth at which vulnerability analysis for the information system must be performed by developers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003260">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>Threat modeling performed by the developer for the information system uses organization-defined information concerning impact, environment of operations, known or assumed threats, and acceptable risk levels.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003261">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>Vulnerability analysis performed by the developer for the information system uses organization-defined information concerning impact, environment of operations, known or assumed threats, and acceptable risk levels.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003262">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines information concerning impact, environment of operations, known or assumed threats, and acceptable risk levels to be used to perform threat modeling for the information system by the developer.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003263">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines information concerning impact, environment of operations, known or assumed threats, and acceptable risk levels to be used to perform a vulnerability analysis for the information system by the developer.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003264">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires the threat modeling performed by the developers employ organization-defined tools and methods.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003265">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires the vulnerability analysis performed by the developers employ organization-defined tools and methods.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003266">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines tools and methods to be employed to perform threat modeling for the information system by the developer.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003267">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines tools and methods to be employed to perform a vulnerability analysis for the information system by the developer.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003268">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires that developers performing threat modeling for the information system produce evidence that meets organization-defined acceptance criteria.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (4) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003269">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires that developers performing vulnerability analysis for the information system produce evidence that meets organization-defined acceptance criteria.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (4) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003270">
      <status>draft</status>
      <publishdate>2013-09-30</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the acceptance criteria that must be met when threat modeling of the information system is performed by the developer.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (4) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003271">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the acceptance criteria that must be met when vulnerability analysis of the information system is performed by the developer.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (4) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003272">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to reduce attack surfaces to organization-defined thresholds.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003273">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the thresholds to which the developer of the system, system component, or system service is required to reduce attack surfaces.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (5)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003274">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to implement an explicit process to continuously improve the development process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003275">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system services, on an organization-defined frequency, to perform an automated vulnerability analysis using organization-defined tools.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (7) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (7) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003276">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the tools the developer of the system, system component, or system services uses to perform an automated vulnerability analysis.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (7) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (7) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003277">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system services, on an organization-defined frequency, to determine the exploitation potential for discovered vulnerabilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (7) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (7) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003278">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system services, on an organization-defined frequency, to determine potential risk mitigations for delivered vulnerabilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (7) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (7) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003279">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system services, on an organization-defined frequency, to deliver the outputs of the tools and results of the vulnerability analysis to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (7) (d)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (7) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003280">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the outputs of the tools and results of the vulnerability analysis are delivered.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (7) (d)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (7) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003281">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to use threat modeling from similar systems, components, or services to inform the current development process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003282">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to use vulnerability analysis from similar systems, components, or services to inform the current development process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (8)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003283">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization approves the use of live data in development environments for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003284">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization approves the use of live data in test environments for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003285">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents the use of live data in development environments for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003286">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents the use of live data in test environments for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003287">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization controls the use of live data in development environments for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003288">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization controls the use of live data in test environments for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003289">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to provide an incident response plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (10)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003290">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system or system component to archive the system or component to be released or delivered together with the corresponding evidence supporting the final security review.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (11)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-15 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003291">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to provide organization-defined training on the correct use and operation of the implemented security functions, controls, and/or mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-16" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-003292">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the training the developer of the system, system component, or information system service is required to provide on the correct use and operation of the implemented security functions, controls, and/or mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-16" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-003293">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to produce a design specification and security architecture.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17" />
      </references>
    </cci_item>
    <cci_item id="CCI-003294">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to produce a design specification and security architecture that is consistent with and supportive of the organization's security architecture which is established within and is an integrated part of the organization's enterprise architecture.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003295">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to produce a design specification and security architecture that accurately and completely describes the required security functionality.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003296">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to produce a design specification and security architecture that accurately and completely describes the allocation of security controls among physical and logical components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003297">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to produce a design specification and security architecture that expresses how individual security functions, mechanisms, and services work together to provide required security capabilities and a unified approach to protection.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 c" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003298">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system to produce, as an integral part of the development process, a formal policy model describing the organization-defined elements of organizational security policy to be enforced.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003299">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the elements of organizational security policy to be described in the formal policy model for enforcement on the system, system component, or system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (1) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003300">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to prove that the formal policy model is internally consistent and sufficient to enforce the defined elements of the organizational security policy when implemented.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (1) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003301">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to define security-relevant hardware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (2) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003302">
      <status>deprecated</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires the developer of the information system, system component, or information system service to define security-relevant hardware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003303">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to define security-relevant software.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (2) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003304">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to define security-relevant firmware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (2) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003305">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to provide a rationale that the definition for security-relevant hardware is complete.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (2) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003306">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to provide a rationale that the definition for security-relevant software is complete.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (2) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003307">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to provide a rationale that the definition for security-relevant firmware is complete.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (2) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003308">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to produce, as an integral part of the development process, a formal top-level specification that specifies the interfaces to security-relevant hardware in terms of exceptions, error messages, and effects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003309">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to produce, as an integral part of the development process, a formal top-level specification that specifies the interfaces to security-relevant software in terms of exceptions, error messages, and effects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003310">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to produce, as an integral part of the development process, a formal top-level specification that specifies the interfaces to security-relevant firmware in terms of exceptions, error messages, and effects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (3) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003311">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to show via proof to the extent feasible with additional informal demonstration as necessary, that the formal top-level specification is consistent with the formal policy model.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (3) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003312">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to show via informal demonstration, that the formal top-level specification completely covers the interfaces to security-relevant hardware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (3) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (3) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003313">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to show via informal demonstration, that the formal top-level specification completely covers the interfaces to security-relevant software.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (3) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (3) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003314">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to show via informal demonstration, that the formal top-level specification completely covers the interfaces to security-relevant firmware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (3) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (3) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003315">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to show that the formal top-level specification is an accurate description of the implemented security-relevant hardware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (3) (d)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (3) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003316">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to show that the formal top-level specification is an accurate description of the implemented security-relevant software.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (3) (d)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (3) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003317">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to show that the formal top-level specification is an accurate description of the implemented security-relevant firmware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (3) (d)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (3) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003318">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to describe the security-relevant hardware mechanisms not addressed in the formal top-level specification but strictly internal to the security-relevant hardware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (3) (e)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (3) (e)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003319">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to describe the security-relevant software mechanisms not addressed in the formal top-level specification but strictly internal to the security-relevant software.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (3) (e)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (3) (e)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003320">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to describe the security-relevant firmware mechanisms not addressed in the formal top-level specification but strictly internal to the security-relevant firmware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (3) (e)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (3) (e)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003321">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to produce, as an integral part of the development process, an informal descriptive top-level specification that specifies the interfaces to security-relevant hardware in terms of exceptions, error messages, and effects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003322">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to produce, as an integral part of the development process, an informal descriptive top-level specification that specifies the interfaces to security-relevant software in terms of exceptions, error messages, and effects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003323">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to produce, as an integral part of the development process, an informal descriptive top-level specification that specifies the interfaces to security-relevant firmware in terms of exceptions, error messages, and effects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (4) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003324">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to show via informal demonstration or convincing argument with formal methods as feasible that the descriptive top-level specification is consistent with the formal policy model.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (4) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003325">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to show via informal demonstration, that the descriptive top-level specification completely covers the interfaces to security-relevant hardware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (4) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (4) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003326">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to show via informal demonstration, that the descriptive top-level specification completely covers the interfaces to security-relevant software.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (4) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (4) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003327">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to show via informal demonstration, that the descriptive top-level specification completely covers the interfaces to security-relevant firmware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (4) (c)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (4) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003328">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to show that the descriptive top-level specification is an accurate description of the interfaces to security-relevant hardware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (4) (d)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (4) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003329">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to show that the descriptive top-level specification is an accurate description of the interfaces to security-relevant software.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (4) (d)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (4) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003330">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to show that the descriptive top-level specification is an accurate description of the interfaces to security-relevant firmware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (4) (d)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (4) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003331">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to describe the security-relevant hardware mechanisms not addressed in the descriptive top-level specification but strictly internal to the security-relevant hardware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (4) (e)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (4) (e)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003332">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to describe the security-relevant software mechanisms not addressed in the descriptive top-level specification but strictly internal to the security-relevant software.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (4) (e)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (4) (e)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003333">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to describe the security-relevant firmware mechanisms not addressed in the descriptive top-level specification but strictly internal to the security-relevant firmware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (4) (e)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (4) (e)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003334">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to design and structure the security-relevant hardware to use a complete, conceptually simple protection mechanism with precisely defined semantics.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (5) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (5) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003335">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to design and structure the security-relevant software to use a complete, conceptually simple protection mechanism with precisely defined semantics.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (5) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (5) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003336">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to design and structure the security-relevant firmware to use a complete, conceptually simple protection mechanism with precisely defined semantics.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (5) (a)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (5) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003337">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to internally structure the security-relevant hardware with specific regard for the complete, conceptually simple protection mechanism with precisely defined semantics.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (5) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003338">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to internally structure the security-relevant software with specific regard for the complete, conceptually simple protection mechanism with precisely defined semantics.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (5) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003339">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to internally structure the security-relevant firmware with specific regard for the complete, conceptually simple protection mechanism with precisely defined semantics.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (5) (b)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003340">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, component, or system service to structure security-relevant hardware to facilitate testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003341">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, component, or system service to structure security-relevant software to facilitate testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003342">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, component, or system service to structure security-relevant firmware to facilitate testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (6)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003343">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, component, or system service to structure security-relevant hardware to facilitate controlling access with least privilege.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003344">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, component, or system service to structure security-relevant software to facilitate controlling access with least privilege.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003345">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, component, or system service to structure security-relevant firmware to facilitate controlling access with least privilege.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (7)" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-17 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003346">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements a tamper protection program for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-18" />
      </references>
    </cci_item>
    <cci_item id="CCI-003347">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs anti-tamper technologies and techniques during multiple phases in the system development life cycle including design.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-18 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003348">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs anti-tamper technologies and techniques during multiple phases in the system development life cycle including development.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-18 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003349">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs anti-tamper technologies and techniques during multiple phases in the system development life cycle including integration.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-18 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003350">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs anti-tamper technologies and techniques during multiple phases in the system development life cycle including operations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-18 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003351">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization employs anti-tamper technologies and techniques during multiple phases in the system development life cycle including maintenance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-18 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003352">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization inspects organization-defined information systems, system components, or devices at random, at an organization-defined frequency, and/or upon organization-defined indications of need for inspection to detect tampering.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-18 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003353">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the information systems, system components, or devices to inspect at random, at an organization-defined frequency, and/or upon organization-defined indications of need for inspection to detect tampering.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-18 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003354">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency on which to inspect organization-defined information systems, system components, or devices to detect tampering.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-18 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003355">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines indications of need for inspection to detect tampering during inspections of organization-defined information systems, system components, or devices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-18 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003356">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops an anti-counterfeit policy that includes the means to detect counterfeit components from entering the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003357">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops an anti-counterfeit policy that includes the means to prevent counterfeit components from entering the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003358">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops anti-counterfeit procedures that include the means to detect counterfeit components from entering the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003359">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops anti-counterfeit procedures that include the means to prevent counterfeit components from entering the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003360">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements an anti-counterfeit policy that includes the means to detect counterfeit components from entering the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003361">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements an anti-counterfeit policy that includes the means to prevent counterfeit components from entering the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003362">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements anti-counterfeit procedures that include the means to detect counterfeit components from entering the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003363">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements anti-counterfeit procedures that include the means to prevent counterfeit components from entering the information system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003364">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization reports counterfeit information system components to the source of the counterfeit component, organization-defined external reporting organizations, and/or organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003365">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the external reporting organizations to which counterfeit information system components are to be reported.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003366">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the personnel or roles to whom counterfeit information system components are to be reported.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003367">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization trains organization-defined personnel or roles to detect counterfeit information system components (including hardware, software, and firmware).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003368">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the personnel or roles to be trained to detect counterfeit information system components (including hardware, software, and firmware).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003369">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization maintains configuration control over organization-defined information system components awaiting service/repair.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003370">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the information system components awaiting service/repair over which configuration control must be maintained.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003371">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization maintains configuration control over serviced/repaired components awaiting return to service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003372">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Define the support from external providers to be provided for alternative sources for continued support for unsupported system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-22 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-22 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003373">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide in-house support and/or organization-defined support from external providers for alternative sources for continued support for unsupported components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-22 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-22 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003374">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents approval for the continued use of unsupported system components required to satisfy mission/business needs.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-22 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003375">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides justification for the continued use of unsupported system components required to satisfy mission/business needs.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-22 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003376">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Replace system components when support for the components is no longer available from the developer, vendor, or manufacturer.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-22 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-22 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003377">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the actions the developer of the information system, system component, or information system service must take to ensure the required screening criteria are satisfied.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-21 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003378">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the actions the developer of the information system, system component, or information system service must take to ensure the required access authorizations are satisfied.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-21 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003379">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires the developer of the information system, system component, or information system service take organization-defined actions to ensure the required screening criteria are satisfied.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-21 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003380">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requires the developer of the information system, system component, or information system service take organization-defined actions to ensure the required access authorizations are satisfied.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-21 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003381">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines additional personnel screening criteria that must be satisfied by the developer of an organization-defined system, system component, or system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-21 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-21 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003382">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that the developer of an organization-defined information system, system component, or information system service satisfies organization-defined additional personnel screening criteria.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-21 b" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-21 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003383">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official government duties to be assigned to the developer of an organization-defined system, system component, or system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-21 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-21 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003384">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system, system component, or system service which requires the system developer to have appropriate access authorizations, satisfy additional personnel screening criteria, and provide information that the access authorizations and screening criteria are satisfied.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-21" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-21  " />
      </references>
    </cci_item>
    <cci_item id="CCI-003385">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that the developer of an organization-defined system, system component, or system service has appropriate access authorizations as determined by assigned organization-defined official government duties.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-21 a" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-21 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003386">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the critical system components to re-implement or custom develop.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-20" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-20" />
      </references>
    </cci_item>
    <cci_item id="CCI-003387">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Re-implement or custom develops organization-defined critical system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-20" />
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-20" />
      </references>
    </cci_item>
    <cci_item id="CCI-003388">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency on which to scan for counterfeit information system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003389">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization scans for counterfeit information system components in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003390">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the techniques and methods used to dispose of information system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003391">
      <status>draft</status>
      <publishdate>2013-10-03</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization disposes of information system components using organization-defined techniques and methods.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SA-19 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003392">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization determines and documents the legal authority that permits the collection of personally identifiable information (PII), either generally or in support of a specific program or information system need.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AP-1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003393">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization determines and documents the legal authority that permits the use of personally identifiable information (PII), either generally or in support of a specific program or information system need.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AP-1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003394">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization determines and documents the legal authority that permits the maintenance of personally identifiable information (PII), either generally or in support of a specific program or information system need.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AP-1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003395">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization determines and documents the legal authority that permits the sharing of personally identifiable information (PII), either generally or in support of a specific program or information system need.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AP-1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003396">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization describes, in its privacy notices, the purpose(s) for which personally identifiable information (PII) is collected.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AP-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003397">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization appoints a Senior Agency Official for Privacy (SAOP)/Chief Privacy Officer (CPO) accountable for developing, implementing, and maintaining an organization-wide governance and privacy program to ensure compliance with all applicable laws and regulations regarding the collection, use, maintenance, sharing, and disposal of personally identifiable information (PII) by programs and information systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003398">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization describes, in its privacy notices, the purpose(s) for which personally identifiable information (PII) is used.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AP-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003399">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization describes, in its privacy notices, the purpose(s) for which personally identifiable information (PII) is maintained.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AP-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003400">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization describes, in its privacy notices, the purpose(s) for which personally identifiable information (PII) is shared.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AP-2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003401">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization monitors federal privacy laws and policy for changes that affect the privacy program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003402">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the allocation of budget resources sufficient to implement and operate the organization-wide privacy program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-1 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003403">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the allocation of staffing resources sufficient to implement and operate the organization-wide privacy program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-1 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003404">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization allocates sufficient organization-defined budget resources to implement and operate the organization-wide privacy program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-1 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003405">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization allocates sufficient organization-defined staffing resources to implement and operate the organization-wide privacy program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-1 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003406">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a strategic organizational privacy plan for implementing applicable privacy controls, policies, and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-1 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003407">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops operational privacy policies which govern the appropriate privacy and security controls for programs, information systems, or technologies involving personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-1 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-003408">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization disseminates operational privacy policies which govern the appropriate privacy and security controls for programs, information systems, or technologies involving personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-1 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-003409">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements operational privacy policies which govern the appropriate privacy and security controls for programs, information systems, or technologies involving personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-1 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-003410">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops operational privacy procedures which govern the appropriate privacy and security controls for programs, information systems, or technologies involving personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-1 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-003411">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization disseminates operational privacy procedures which govern the appropriate privacy and security controls for programs, information systems, or technologies involving personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-1 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-003412">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements operational privacy procedures which govern the appropriate privacy and security controls for programs, information systems, or technologies involving personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-1 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-003413">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency, minimally biennially, on which the privacy plan, policies, and procedures are to be updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-1 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-003414">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization updates the privacy plan per organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-1 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-003415">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization updates the privacy policies per organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-1 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-003416">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization updates the privacy procedures per organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-1 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-003417">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents a privacy risk management process which assesses the privacy risk to individuals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003418">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements a privacy risk management process which assesses the privacy risk to individuals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003419">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization's privacy risk management process assesses the privacy risk to individuals resulting from the collection of personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003420">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization's privacy risk management process assesses the privacy risk to individuals resulting from the sharing of personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003421">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization's privacy risk management process assesses the privacy risk to individuals resulting from the storing of personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003422">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization's privacy risk management process assesses the privacy risk to individuals resulting from the transmitting of personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003423">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization's privacy risk management process assesses the privacy risk to individuals resulting from the use of personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003424">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization's privacy risk management process assesses the privacy risk to individuals resulting from the disposal of personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003425">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization conducts Privacy Impact Assessments (PIAs) for information systems, programs, or other activities that pose a privacy risk in accordance with applicable law, OMB policy, or any existing organizational policies and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003426">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes privacy roles for contractors.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003427">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes privacy responsibilities for contractors.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003428">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes access requirements for contractors.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003429">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes privacy roles for service providers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003430">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes privacy responsibilities for service providers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003431">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes access requirements for service providers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003432">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization includes privacy requirements in contracts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003433">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization includes privacy requirements in other acquisition-related documents.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003434">
      <status>deprecated</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency for monitoring privacy controls and internal privacy policy to ensure effective implementation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-003435">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency for auditing privacy controls and internal privacy policy to ensure effective implementation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-003436">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization monitors privacy controls, per organization-defined frequency, to ensure effective implementation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-003437">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization monitors internal privacy policy to ensure effective implementation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-003438">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization audits privacy controls, per organization-defined frequency, to ensure effective implementation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-003439">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization audits internal privacy policy, per organization-defined frequency, to ensure effective implementation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-003440">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a comprehensive training and awareness strategy aimed at ensuring that personnel understand privacy responsibilities and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003441">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements a comprehensive training and awareness strategy aimed at ensuring that personnel understand privacy responsibilities and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003442">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization updates a comprehensive training and awareness strategy aimed at ensuring that personnel understand privacy responsibilities and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003443">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency, minimally annually, for administering its basic privacy training.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003444">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency, minimally annually, for administering the targeted, role-based privacy training for personnel having responsibility for personally identifiable information (PII) or for activities that involve PII.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003445">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization administers basic privacy training per the organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003446">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization administers, per organization-defined frequency, targeted, role-based privacy training for personnel having responsibility for personally identifiable information (PII) or for activities that involve PII.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003447">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency, minimally annually, on which personnel certify acceptance of responsibilities for privacy requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-5 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003448">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures personnel certify (manually or electronically) acceptance of responsibilities for privacy requirements per organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-5 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003449">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops reports for the Office of Management and Budget (OMB), Congress, and other oversight bodies, as appropriate, to demonstrate accountability with specific statutory and regulatory privacy program mandates.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-003450">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization disseminates reports to the Office of Management and Budget (OMB), Congress, and other oversight bodies, as appropriate, to demonstrate accountability with specific statutory and regulatory privacy program mandates.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-003451">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization updates reports for the Office of Management and Budget (OMB), Congress, and other oversight bodies, as appropriate, to demonstrate accountability with specific statutory and regulatory privacy program mandates.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-003452">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops reports for senior management and other personnel with responsibility for monitoring privacy program progress and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-003453">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization disseminates reports to senior management and other personnel with responsibility for monitoring privacy program progress and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-003454">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization updates reports for senior management and other personnel with responsibility for monitoring privacy program progress and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-003455">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization designs information systems to support privacy by automating privacy controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-003456">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization, as part of the accurate accounting of disclosures of Privacy Act information held in each system of records under its control, includes the date of each disclosure of a record.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-8 a (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003457">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization, as part of the accurate accounting of disclosures of Privacy Act information held in each system of records under its control, includes the nature of each disclosure of a record.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-8 a (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003458">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization, as part of the accurate accounting of disclosures of Privacy Act information held in each system of records under its control, includes the purpose of each disclosure of a record.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-8 a (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003459">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization keeps an accurate accounting of disclosures of Privacy Act information held in each system of records under its control.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-8 a (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003460">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization, as part of the accurate accounting of disclosures of Privacy Act information held in each system of records under its control, includes the name and address of the person or agency to which the disclosure was made.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-8 a (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003461">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization retains the accounting of disclosures for the life of the record or five years after the disclosure is made, whichever is longer.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003462">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization makes the accounting of disclosures available to the person named in the record upon request.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="AR-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003463">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization confirms to the greatest extent practicable upon collection or creation of personally identifiable information (PII), the accuracy of that information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003464">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization confirms to the greatest extent practicable upon collection or creation of personally identifiable information (PII), the relevancy of that information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003465">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization confirms to the greatest extent practicable upon collection or creation of personally identifiable information (PII), the timeliness of that information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003466">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization confirms to the greatest extent practicable upon collection or creation of personally identifiable information (PII), the completeness of that information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003467">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization collects personally identifiable information (PII) directly from the individual to the greatest extent practicable.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003468">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency on which it will check for, and correct as necessary, inaccurate or outdated personally identifiable information (PII) used by its programs or systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-1 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003469">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization checks for, and corrects as necessary, any inaccurate or outdated personally identifiable information (PII) used by its programs or systems on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-1 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003470">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization issues guidelines ensuring the quality of disseminated Privacy Act information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-1 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003471">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization issues guidelines ensuring the utility of disseminated Privacy Act information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-1 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003472">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization issues guidelines ensuring the objectivity of disseminated Privacy Act information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-1 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003473">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization issues guidelines ensuring the integrity of disseminated Privacy Act information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-1 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003474">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization issues guidelines maximizing the quality of disseminated Privacy Act information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-1 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003475">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization issues guidelines maximizing the utility of disseminated Privacy Act information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-1 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003476">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization issues guidelines maximizing the objectivity of disseminated Privacy Act information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-1 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003477">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization issues guidelines maximizing the integrity of disseminated Privacy Act information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-1 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003478">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization requests the individual or individual's authorized representative validate personally identifiable information (PII) during the collection process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-1 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003479">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency on which it will request the individual, or individual's authorized representative, revalidate that personally identifiable information (PII) collected is still accurate.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-1 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003480">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>On an organization-defined frequency, the organization requests the individual, or individual's authorized representative, revalidate that personally identifiable information (PII) collected is still accurate.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-1 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003481">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization documents processes to ensure the integrity of personally identifiable information (PII) through existing security controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003482">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization, when appropriate, establishes a Data Integrity Board.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003483">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization's Data Integrity Board oversees the organizational Computer Matching Agreements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003484">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization's Data Integrity Board ensures the Computer Matching Agreements comply with the computer matching provisions of the Privacy Act.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003485">
      <status>draft</status>
      <publishdate>2013-11-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization publishes Computer Matching Agreements on its public website.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DI-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003486">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization identifies the minimum personally identifiable information (PII) elements that are relevant and necessary to accomplish the legally authorized purpose of collection.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003487">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization limits the collection and retention of personally identifiable information (PII) to the minimum elements identified for the purposes described in the published privacy notice.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003488">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization limits the collection and retention of personally identifiable information (PII) to the minimum elements identified for the purposes which the individual has provided consent.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003489">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency, minimally annually, for conducting reviews of its personally identifiable information (PII) holdings.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-1 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003490">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization conducts an initial evaluation of personally identifiable information (PII) holdings.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-1 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003491">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes a schedule for regularly reviewing the personally identifiable information (PII) holdings on an organization-defined frequency to ensure that only PII identified in the notice is collected and retained.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-1 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003492">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization follows a schedule for regularly reviewing the personally identifiable information (PII) holdings on an organization-defined frequency to ensure that only PII identified in the notice is collected and retained.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-1 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003493">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes a schedule for regularly reviewing the personally identifiable information (PII) holdings on an organization-defined frequency to ensure the PII continues to be necessary to accomplish the legally authorized purpose.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-1 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003494">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization follows a schedule for regularly reviewing the personally identifiable information (PII) holdings on an organization-defined frequency to ensure the PII continues to be necessary to accomplish the legally authorized purpose.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-1 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003495">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization, where feasible and within the limits of technology, locates and removes/redacts specified personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-1 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003496">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization, where feasible and within the limits of technology, uses anonymization and de-identification techniques to permit use of the retained Privacy Act information while reducing its sensitivity and reducing the risk resulting from disclosure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-1 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003497">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the time period for retaining each collection of personally identifiable information (PII) that is required to fulfill the purpose(s) identified in the published privacy notice or required by law.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003498">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization retains each collection of personally identifiable information (PII) for the organization-defined time period to fulfill the purpose(s) identified in the published privacy notice or as required by law.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003499">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization disposes of, destroys, erases, and/or anonymizes the personally identifiable information (PII), regardless of the method of storage, in accordance with a NARA-approved record retention schedule.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003500">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization disposes of, destroys, erases, and/or anonymizes the personally identifiable information (PII), regardless of the method of storage, in a manner that prevents loss, theft, misuse, or unauthorized access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003501">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the techniques or methods to be employed to ensure the secure deletion or destruction of personally identifiable information (PII) (including originals, copies, and archived records).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003502">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization uses organization-defined techniques or methods to ensure secure deletion or destruction of personally identifiable information (PII) (including originals, copies, and archived records).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003503">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization, where feasible, configures its information systems to record the date personally identifiable information (PII) is collected, created, or updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003504">
      <status>deprecated</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization, where feasible, configures its information systems to record the date personally identifiable information (PII) is created.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003505">
      <status>deprecated</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization, where feasible, configures its information systems to record the date personally identifiable information (PII) is updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003506">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization, where feasible, configures its information systems to record when personally identifiable information (PII) is to be deleted or archived under an approved record retention schedule.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003507">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops policies that minimize the use of personally identifiable information (PII) for testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003508">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops policies that minimize the use of personally identifiable information (PII) for training.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003509">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops policies that minimize the use of personally identifiable information (PII) for research.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003510">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops procedures that minimize the use of personally identifiable information (PII) for testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003511">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops procedures that minimize the use of personally identifiable information (PII) for training.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003512">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops procedures that minimize the use of personally identifiable information (PII) for research.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003513">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements controls to protect personally identifiable information (PII) used for testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003514">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements controls to protect personally identifiable information (PII) used for training.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003515">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements controls to protect personally identifiable information (PII) used for research.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003516">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization, where feasible, uses techniques to minimize the risk to privacy of using personally identifiable information (PII) for research.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003517">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization, where feasible, uses techniques to minimize the risk to privacy of using personally identifiable information (PII) for testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003518">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization, where feasible, uses techniques to minimize the risk to privacy of using personally identifiable information (PII) for training.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="DM-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003519">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides means, where feasible and appropriate, for individuals to authorize the collection of personally identifiable information (PII) prior to its collection.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003520">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides means, where feasible and appropriate, for individuals to authorize the use of personally identifiable information (PII) prior to its collection.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003521">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides means, where feasible and appropriate, for individuals to authorize the maintaining of personally identifiable information (PII) prior to its collection.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003522">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor />
      <definition>The organization provides means, where feasible and appropriate, for individuals to authorize sharing of personally identifiable information (PII) prior to its collection.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003523">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides appropriate means for individuals to understand the consequences of decisions to approve or decline the authorization of the collection of personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003524">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides appropriate means for individuals to understand the consequences of decisions to approve or decline the authorization of the use of personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003525">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides appropriate means for individuals to understand the consequences of decisions to approve or decline the authorization of the dissemination of personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003526">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides appropriate means for individuals to understand the consequences of decisions to approve or decline the authorization of the retention of personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003527">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization obtains consent, where feasible and appropriate, from individuals prior to any new uses or disclosure of previously collected personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-1 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003528">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that individuals are aware of all uses of personally identifiable information (PII) not initially described in the public notice that was in effect at the time the organization collected the PII.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-1 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003529">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures that individuals, where feasible, consent to all uses of personally identifiable information (PII) not initially described in the public notice that was in effect at the time the organization collected the PII.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-1 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003530">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements mechanisms to support itemized or tiered consent for specific uses of personally identifiable information (PII) data.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-1 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003531">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides individuals the ability to have access to their personally identifiable information (PII) maintained in its system(s) of records.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003532">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization publishes rules and regulations governing how individuals may request access to records maintained in a Privacy Act system of records.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003533">
      <status>deprecated</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization publishes regulations governing how individuals may request access to records maintained in a Privacy Act system of records.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003534">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization publishes access procedures for Privacy Act systems of records in System of Records Notices (SORNs).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003535">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization adheres to Privacy Act requirements for the proper processing of Privacy Act requests.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003536">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization adheres to OMB policies and guidance for the proper processing of Privacy Act requests.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003537">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides a process for individuals to have inaccurate personally identifiable information (PII) maintained by the organization corrected or amended, as appropriate.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003538">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes a process for disseminating corrections or amendments of the personally identifiable information (PII) to other authorized users of the PII, such as external information-sharing partners.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003539">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes a process, where feasible and appropriate, to notify affected individuals that their personally identifiable information (PII) information has been corrected or amended.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003540">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements a process for receiving complaints, concerns, or questions from individuals about the organizational privacy practices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-003541">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements a process for responding to complaints, concerns, or questions from individuals about the organizational privacy practices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-003542">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the time period within which it must respond to complaints, concerns, or questions from individuals about the organizational privacy practices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003543">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization responds to complaints, concerns, or questions from individuals about the organizational privacy practices within the organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="IP-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003544">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency on which it will update the inventory that contains a listing of all programs and information systems identified as collecting, using, maintaining, or sharing personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SE-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003545">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes an inventory that contains a listing of all programs identified as collecting, using, maintaining, or sharing personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SE-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003546">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization establishes an inventory that contains a listing of all information systems identified as collecting, using, maintaining, or sharing personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SE-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003547">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization maintains an inventory that contains a listing of all programs identified as collecting, using, maintaining, or sharing personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SE-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003548">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization maintains an inventory that contains a listing of all information systems identified as collecting, using, maintaining, or sharing personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SE-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003549">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization updates, per organization-defined frequency, an inventory that contains a listing of all programs identified as collecting, using, maintaining, or sharing personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SE-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003550">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization updates, per organization-defined frequency, an inventory that contains a listing of all information systems identified as collecting, using, maintaining, or sharing personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SE-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003551">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the frequency for providing each update of the personally identifiable information (PII) inventory to the CIO or information security official.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SE-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003552">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides each update of the personally identifiable information (PII) inventory to the CIO or information security official, per organization-defined frequency, to support the establishment of information security requirements for all new or modified information systems containing PII.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SE-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003553">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization develops a Privacy Incident Response Plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SE-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003554">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization implements a Privacy Incident Response Plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SE-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003555">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides an organized and effective response to privacy incidents in accordance with the organizational Privacy Incident Response Plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SE-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003556">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides effective notice to the public regarding its activities that impact privacy, including its collection, use, sharing, safeguarding, maintenance, and disposal of personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003557">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides effective notice to individuals regarding its activities that impact privacy, including its collection, use, sharing, safeguarding, maintenance, and disposal of personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003558">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides effective notice to the public regarding its authority for collecting personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003559">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides effective notice to individuals regarding its authority for collecting personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003560">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides effective notice to the public regarding the choices, if any, individuals may have regarding how the organization uses personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003561">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides effective notice to individuals regarding the choices, if any, individuals may have regarding how the organization uses personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003562">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides effective notice to the public regarding the consequences of exercising or not exercising the choices regarding how the organization uses personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003563">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides effective notice to individuals regarding the consequences of exercising or not exercising the choices regarding how the organization uses personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003564">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides effective notice to the public regarding the ability of individuals to access personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003565">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides effective notice to individuals regarding the ability to access personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003566">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides effective notice to the public regarding the ability to have personally identifiable information (PII) amended or corrected if necessary.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003567">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides effective notice to individuals regarding the ability to have personally identifiable information (PII) amended or corrected if necessary.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003568">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization describes the personally identifiable information (PII) the organization collects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003569">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization describes the purpose(s) for which it collects the personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003570">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization describes how the organization uses personally identifiable information (PII) internally.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003571">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization describes whether the organization shares personally identifiable information (PII) with external entities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003572">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization describes the categories of those external entities with whom personally identifiable information (PII) is shared.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003573">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization describes the purposes for sharing personally identifiable information (PII) with external entities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003574">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization describes whether individuals have the ability to consent to specific uses or sharing of personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003575">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization describes how individuals may exercise their consent regarding specific uses or sharing of personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003576">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization describes how individuals may obtain access to personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003577">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization describes how the personally identifiable information (PII) will be protected.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003578">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization revises its public notices to reflect changes in practice or policy that affect personally identifiable information (PII), before or as soon as practicable after the change.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003579">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization revises its public notices to reflect changes in practice or policy that impact privacy, before or as soon as practicable after the change.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003580">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization provides real-time notice and/or layered notice when it collects personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-1 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003581">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization publishes System of Records Notices (SORNs) in the Federal Register, subject to required oversight processes, for systems containing personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003582">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization keeps System of Records Notices (SORNs) current.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003583">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization includes Privacy Act Statements on its forms that collect personally identifiable information (PII), or on separate forms that can be retained by individuals, to provide additional formal notice to individuals from whom the information is being collected.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003584">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization publishes System of Records Notices (SORNs) on its public website.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003585">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures the public has access to information about its privacy activities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003586">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures the public is able to communicate with its Senior Agency Official for Privacy (SAOP)/Chief Privacy Officer (CPO).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003587">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization ensures its privacy practices are publicly available through organizational websites or otherwise.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="TR-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003588">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization uses personally identifiable information (PII) internally only for the authorized purpose(s) identified in the Privacy Act and/or in public notices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="UL-1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003589">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization shares personally identifiable information (PII) externally, only for the authorized purposes identified in the Privacy Act and/or described in its notice(s) or for a purpose that is compatible with those purposes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="UL-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003590">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization, where appropriate, enters into Memoranda of Understanding, Memoranda of Agreement, Letters of Intent, Computer Matching Agreements, or similar agreements, with third parties that specifically describe the personally identifiable information (PII) covered.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="UL-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003591">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization, where appropriate, enters into Memoranda of Understanding, Memoranda of Agreement, Letters of Intent, Computer Matching Agreements, or similar agreements, with third parties that specifically enumerate the purposes for which the personally identifiable information (PII) may be used.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="UL-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003592">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization monitors its staff on the authorized sharing of personally identifiable information (PII) with third parties.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="UL-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003593">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization audits its staff on the authorized sharing of personally identifiable information (PII) with third parties.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="UL-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003594">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization trains its staff on the authorized sharing of personally identifiable information (PII) with third parties.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="UL-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003595">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization trains its staff on the consequences of unauthorized use or sharing of personally identifiable information (PII).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="UL-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003596">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization evaluates any proposed new instances of sharing personally identifiable information (PII) with third parties to assess whether the sharing is authorized.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="UL-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003597">
      <status>draft</status>
      <publishdate>2013-11-08</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization evaluates any proposed new instances of sharing personally identifiable information (PII) with third parties to assess whether additional or new public notice is required.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="UL-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003599">
      <status>draft</status>
      <publishdate>2016-06-07</publishdate>
      <contributor>DISA FSO</contributor>
      <definition>The organization defines the individuals or information systems to be the only recipients of organization-defined information, information system components, or devices, by employing organization-defined security safeguards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 4" version="4" location="NIST" index="SC-37 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003601">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level access control policy that is consistent with applicable laws, Executive Orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003602">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level access control policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-1 a 1 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003603">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate the organization-level; mission/business process-level; and/or system-level access control policy that is consistent with applicable laws, Executive Orders, directives, regulations, policies, standards, and guidelines to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003604">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document procedures to facilitate the implementation of the organization-level; mission/business process-level; and/or system-level access control policy and the associated access control.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003605">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the access control policy and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003606">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the access control policy and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003607">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official designated to manage the development, documentation, and dissemination of the access control policy and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003608">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current access control policy following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003609">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current access control policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003610">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current access control procedures following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003611">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current access control procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003612">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Define and document the types of accounts allowed and specifically prohibited for use within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003613">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require organization-defined prerequisites and criteria for group membership.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003614">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require organization-defined prerequisites and criteria for role membership.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003615">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the prerequisites and criteria for group and role membership.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003616">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the attributes (as required) for each account.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 d 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-003617">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Create, enable, modify, disable, and remove system accounts in accordance with organization-defined policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-003618">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Create, enable, modify, disable, and remove system accounts in accordance with organization-defined criteria.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-003619">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Create, enable, modify, disable, and remove system accounts in accordance with organization-defined prerequisites.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-003620">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the policy to be employed when creating, enabling, modifying, disabling, and removing information system accounts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-003621">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the prerequisites to be employed when creating, enabling, modifying, disabling, and removing information system accounts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-003622">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the criteria to be employed when creating, enabling, modifying, disabling, and removing information system accounts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-003623">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles of whom to notify when accounts are no longer required; when users are terminated or transferred; and when system usage or need-to-know changes for an individual.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 h" />
      </references>
    </cci_item>
    <cci_item id="CCI-003624">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period of when to notify account managers for each situation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 h" />
      </references>
    </cci_item>
    <cci_item id="CCI-003625">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the attributes (as required) for each account.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 i 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-003626">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Align account management processes with personnel termination and transfer processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 l" />
      </references>
    </cci_item>
    <cci_item id="CCI-003627">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disable accounts when the accounts have expired.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003628">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disable accounts when the accounts are no longer associated to a user.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003629">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disable accounts when the accounts are in violation of organizational policy.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (3) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003630">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor changes to roles or attributes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (7) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003631">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system accounts that can be dynamically activated.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003632">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Activate organization-defined system accounts dynamically.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003633">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system accounts that can be dynamically managed.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003634">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage organization-defined system accounts dynamically.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003635">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system accounts that can be dynamically deactivated.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003636">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Deactivate organization-defined system accounts dynamically.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003637">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the significant risks that may be discovered requiring disabled accounts of individuals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-2 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003638">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined discretionary access control policies over defined subjects and objects where the policy specifies that a subject that has been granted access to information can pass the information to any other subjects or objects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003639">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined discretionary access control policies over defined subjects and objects where the policy specifies that a subject that has been granted access to information can grant its privileges to other subjects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003640">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined discretionary access control policies over defined subjects and objects where the policy specifies that a subject that has been granted access to information can change security attributes on subjects, objects, the system, or the system's components.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (4) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003641">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined discretionary access control policies over defined subjects and objects where the policy specifies that a subject that has been granted access to information can choose the security attributes to be associated with newly created or revised objects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (4) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003642">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined discretionary access control policies over defined subjects and objects where the policy specifies that a subject that has been granted access to information can change the rules governing access control.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (4) (e)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003643">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the organization-defined roles for which it will employ an audited override of automated access control mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003644">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Restrict direct access to data repositories containing organization-defined information types.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003645">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information types of which to restrict direct access to data repositories.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003646">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require applications to assert, as part of the installation process, the access needed to the organization-defined system applications and functions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (12) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003647">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the organization-defined system applications and functions as required of the applications as part of the installation process.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (12) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003648">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require applications to provide an enforcement mechanism to prevent other-than-asserted access.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (12) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003649">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Approve access changed after initial installations of the application.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (12) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003650">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce attribute-based access control policy over defined subjects and objects based upon organization-defined attributes to assume access permissions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003651">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the attributes to assume access permissions for enforcing attribute-based access control policy.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003652">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce attribute-based control access over defined subjects and objects based upon organization-defined attributes to assume access permissions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003653">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the attributes to assume access permissions for enforcing attribute-based control access.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003654">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide organization-defined mechanisms to enable individuals to have access to the following elements of their personally identifiable information: organization-defined elements.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (14)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003655">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the mechanisms to be provided for access to elements of personally identifiable information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (14)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003656">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the elements of personally identifiable information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (14)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003657">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined mandatory access control policy over the set of covered subjects and objects specified in the policy.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (15) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003658">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the mandatory access control policies that are to be enforced over all subjects and objects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (15) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003659">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce organization-defined discretionary access control policy over the set of covered subjects and objects specified in the policy.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (15) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003660">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the discretionary access control policies the system is to enforce over subjects and objects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-3 (15) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003661">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the privacy attributes to be used to enforce organization-defined information flow control policies.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003662">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information flow control mechanisms to prevent the bypassing of encrypted information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003663">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce information flow control using organization-defined privacy policy filters as a basis for flow control decisions for organization-defined information flows.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (8) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003664">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce information flow control using block; strip; modify and/or quarantine data after a filter processing failure in accordance with organization-defined security or privacy policy.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (8) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003665">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security or privacy policy to be enforced using block; strip; modify and/or quarantine data after a filter processing failure.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (8) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003666">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security or privacy policy filters implemented when transferring information between security domains.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (19)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003667">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between security domains, modify non-releasable information by implementing organization-defined modification action.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (23)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003668">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the modification action when transferring information between different security domains.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (23)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003669">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, parse incoming data into an internal normalized format.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (24)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003670">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, regenerate the data to be consistent with its intended specification.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (24)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003671">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, sanitize data to minimize delivery of malicious content, command and control of malicious code, malicious code augmentation, and steganography encoded data; spillage of sensitive information in accordance with organization-defined policy.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (25)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003672">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the policy when transferring information between different security domains.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (25)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003673">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, record and audit content filtering actions and results for the information being filtered.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (26)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003674">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, implement content filtering solutions that provide redundant and independent filtering mechanisms for each data type.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (27)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003675">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, implement a linear content filter pipeline that is enforced with discretionary and mandatory access controls.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (28)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003676">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, employ content filter orchestration engines to ensure that content filtering mechanisms successfully complete execution without errors.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (29) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003677">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, employ content filter orchestration engines to ensure that content filtering actions occur in the correct order and comply with organization-defined policy.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (29) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003678">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, implement content filtering mechanisms using multiple processes.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (30)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003679">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, prevent the transfer of failed content to the receiving domain.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (31)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003680">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, the process that transfers information between filter pipelines does not filter message content.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (32) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003681">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, the process that transfers information between filter pipelines validates filtering metadata.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (32) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003682">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, the process that transfers information between filter pipelines ensures the content associated with the filtering metadata has successfully completed filtering.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (32) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003683">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When transferring information between different security domains, the process that transfers information between filter pipelines transfers the content to the destination filter pipeline.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-4 (32) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003684">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify and document organization defined duties of individuals requiring separation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003685">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the individuals or roles who authorize access to organization-defined security functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003686">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the individuals or roles who authorize access to organization-defined security-relevant information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-6 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003687">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Limit the number of unsuccessful biometric logon attempts to an organization-defined number.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-7 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003688">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the number of allowed unsuccessful biometric logon attempts.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-7 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003689">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Allow the use of organization-defined authentication factors that are different from the primary authentication factors after the number of organization-defined consecutive invalid logon attempts have been exceeded.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-7 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003690">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the authentication factors after a number of organization-defined consecutive invalid logon attempts have been executed.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-7 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003691">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce a limit of organization-defined number consecutive invalid logon attempts through use of the alternative factors by a user during a organization-defined time period.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-7 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003692">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the number enforced for logon attempts.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-7 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003693">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Display an explicit message to users indicating that the session will end at an organization-defined time until end of session.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003694">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time until end of session, indicating the session will end.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003695">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the user actions that can be performed on the system without identification or authentication consistent with organizational missions/business functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-14 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003696">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines privacy attributes having organization-defined types of privacy attribute values which are associated with information in storage.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003697">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines privacy attributes having organization-defined types of privacy attribute values which are associated with information in process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003698">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines privacy attributes, having organization-defined types of privacy attribute values, which are associated with information in transmission.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003699">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines privacy attribute values associated with organization-defined types of privacy attributes for information in storage.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003700">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines privacy attribute values associated with organization-defined types of privacy attributes for information in process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003701">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines privacy attribute values associated with organization-defined types of privacy attributes for information in transmission.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003702">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that the privacy attribute associations are made with the information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003703">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that the privacy attribute associations are restrained with the information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003704">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish the following permitted organization-defined privacy attributes defined in AC-16a for organization-defined systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003705">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the privacy attributes that are permitted for organization-defined systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003706">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the attribute values or ranges permitted for each of the established privacy attributes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003707">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Audit changes to the attributes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-003708">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review organization-defined security attributes for applicability on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-003709">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review organization-defined privacy attributes for applicability on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-003710">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security and privacy attributes to be reviewed for applicability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-003711">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of which the security and privacy attributes will be reviewed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-003712">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Dynamically associate privacy attributes with organization-defined subjects in accordance with organization-defined privacy policies as information is created and combined.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003713">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Dynamically associate privacy attributes with organization-defined objects in accordance with organization-defined privacy policies as information is created and combined.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003714">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the privacy policies to adhere to when dynamically associating security attributes with organization-defined subjects and objects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003715">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provides authorized individuals (or processes acting on behalf of individuals) the capability to change the value of associated privacy attributes.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003716">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provides authorized individuals (or processes acting on behalf of individuals) the capability to define the value of associated privacy attributes.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003717">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the privacy attributes for which the association and integrity to organization-defined subjects and objects is maintained.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003718">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain the association of organization-defined privacy attributes to organization-defined subjects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003719">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain the association of organization-defined privacy attributes to organization-defined objects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003720">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain the integrity of organization-defined privacy attributes associated with organization-defined subjects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003721">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain the integrity of organization-defined privacy attributes associated with organization-defined objects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003722">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the subjects with which organization-defined privacy attributes may be associated by authorized individuals (or processes acting on behalf of individuals).</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003723">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the objects with which organization-defined privacy attributes may be associated by authorized individuals (or processes acting on behalf of individuals).</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003724">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the privacy attributes authorized individuals (or processes acting on behalf of individuals) are permitted to associate with organization-defined subjects and objects.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003725">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the capability to associate organization-defined privacy attributes with organization-defined subjects by authorized individuals (or processes acting on behalf of individuals).</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003726">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the capability to associate organization-defined privacy attributes with organization-defined objects by authorized individuals (or processes acting on behalf of individuals).</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003727">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Displays privacy attributes in human-readable form on each object that the system transmits to output devices to identify organization-identified special dissemination, handling, or distribution instructions using organization-identified human-readable, standard naming conventions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003728">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identifies special dissemination, handling, or distribution instructions for identifying privacy attributes on output.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003729">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identifies human-readable, standard naming conventions for identifying privacy attributes on output.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003730">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the privacy policies to be followed by personnel when associating organization-defined privacy attributes with organization-defined subjects and objects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003731">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the privacy attributes which are to be associated with organization-defined subjects and objects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003732">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the subjects to be associated, and that association maintained, with organization-defined privacy attributes in accordance with organization-defined privacy policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003733">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the objects to be associated, and that association maintained, with organization-defined privacy attributes in accordance with organization-defined privacy policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003734">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require personnel to associate organization-defined privacy attributes with organization-defined subjects in accordance with organization-defined privacy policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003735">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require personnel to associate organization-defined privacy attributes with organization-defined objects in accordance with organization-defined privacy policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003736">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require personnel to maintain the association of organization-defined privacy attributes with organization-defined subjects in accordance with organization-defined privacy policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003737">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require personnel to maintain the association of organization-defined privacy attributes with organization-defined objects in accordance with organization-defined privacy policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003738">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide a consistent interpretation of privacy attributes transmitted between distributed system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003739">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the techniques and technologies to be implemented when associating security attributes to information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003740">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the level of assurance to be provided when implementing organization-defined techniques and technologies in associating privacy attributes to information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003741">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined techniques and technologies with an organization-defined level of assurance in associating privacy attributes to information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003742">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Change privacy attributes associated with information are reassigned only via re-grading mechanisms validated using organization-defined techniques or procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003743">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide authorized individuals the capability to define or change the type of privacy attributes available for association with subjects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003744">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide authorized individuals the capability to define or change the value of privacy attributes available for association with subjects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003745">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide authorized individuals the capability to define or change the type of privacy attributes available for association with objects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003746">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide authorized individuals the capability to define or change the type of privacy attributes available for association with objects.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-16 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003747">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined mechanisms to authenticate organization-defined remote commands.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003748">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the mechanisms used to authenticate organization-defined remote commands.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003749">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the remote commands used for implementing organization-defined mechanisms.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-17 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003750">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the terms and conditions for accessing the system from external systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-20 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003751">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls asserted to be implemented on external systems allowing individuals to access the system from external systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-20 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003752">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the terms and conditions for processing, storing, or transmitting organization-controlled information using external systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-20 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003753">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls asserted to be implemented on external systems allowing individuals to process, store, or transmit organization-controlled information using external systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-20 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003754">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit the use of organizationally-defined types of external systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-20 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003755">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the types of external systems that are prohibited.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-20 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003756">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Permit authorized individuals to use an external system to access the system or to process, store, or transmit organization-controlled information only after verification of the implementation of controls on the external system as specified in the organization's security policy and security plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-20 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003757">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Permit authorized individuals to use an external system to access the system or to process, store, or transmit organization-controlled information only after verification of the implementation of controls on the external system as specified in the organization's privacy policy and privacy plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-20 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003758">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the restrictions for the use of organization-controlled portable storage devices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-20 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003759">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit the use of organization-controlled portable storage devices by authorized individuals on external systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-20 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003760">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the privacy attributes, not to include the identity of the user or process acting on behalf of the user, to be used as the basis for enforcing access control decisions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AC-24 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003761">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization level, mission/business process-level, or system-level awareness and training policy that is consistent with applicable laws, Executive Orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003762">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the awareness and training policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003763">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the awareness and training policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003764">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the awareness and training procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003765">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the awareness and training procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003766">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide basic privacy awareness training to system users (including managers, senior executives, and contractors) when required by system changes or following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003767">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined awareness techniques to increase the security awareness of system users.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003768">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined awareness techniques to increase the privacy awareness of system users.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003769">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the awareness techniques for to increase security and privacy awareness of system uses.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003770">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update literacy training and awareness content on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003771">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update literacy training and awareness content following organization-defined event.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003772">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for updating literacy training and awareness content.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003773">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following updating literacy training and awareness content.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003774">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Incorporate lessons learned from internal or external security incidents or breaches into literacy training and awareness techniques.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003775">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide literacy training on recognizing and reporting potential and actual instances of social engineering.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003776">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide literacy training on recognizing and reporting potential and actual instances of social mining.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003777">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide literacy training on recognize suspicious communications and anomalous behavior in organizational systems using organization-defined indicators of malicious code.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003778">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the indicators of malicious code used to recognize suspicious communications and anomalous behavior in organizational systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003779">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide literacy training on the advanced persistent threat.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003780">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide literacy training on the cyber threat environment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 (6) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003781">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Reflect current cyber threat information in system operations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 (6) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003782">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the roles and responsibilities of the personnel providing role-based security and privacy training.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003783">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide role-based privacy training to personnel with organization-defined roles and responsibilities before authorizing access to the system, information, or performing assigned duties.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003784">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide role-based privacy training to personnel with organization-defined roles and responsibilities when required by system changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003785">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update role-based training content on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003786">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of which the role-based training content is updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003787">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update role-based training content following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003788">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following updating role-based training content.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003789">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Incorporate lessons learned from internal or external security incidents or breaches into role-based training.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003790">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide practical exercises in privacy training that reinforce training objectives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003791">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for providing training in the employment and operation of personally identifiable information processing and transparency controls to personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003792">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide organization-defined personnel or roles with initial training in the employment and operation of personally identifiable information processing and transparency controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003793">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles who are to be provided training in the employment and operation of personally identifiable information processing and transparency controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-3 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003794">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document individual privacy training activities, including privacy awareness training and specific system privacy training.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003795">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor individual information privacy training activities, including privacy awareness training and specific privacy training.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003796">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide feedback on organizational training results to organization-defined personnel on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-003797">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of which feedback is provided on organizational training results.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-003798">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the organizational personnel or roles who provide feedback on organizational training results.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-003799">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level audit and accountability policy that is consistent with applicable laws, Executive Orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003800">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the audit and accountability policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003801">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the audit and accountability policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003802">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the audit and accountability procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003803">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the audit and accountability procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003804">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official designated for managing the development, documentation, and dissemination of the audit and accountability policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003805">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official designated for managing the development, documentation, and dissemination of the audit and accountability procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003806">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current audit and accountability policy following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003807">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current audit and accountability policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003808">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current audit and accountability procedures following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003809">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current audit and accountability procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003810">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the event types selected for logging on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-2 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-003811">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency at which the event types selected for logging will be reviewed and updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-2 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-003812">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Limit personally identifiable information contained in audit records to organization-defined elements identified in the privacy risk assessment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003813">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the elements identified in the privacy risk assessment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003814">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time-period for the alert in the event of an audit process failure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003815">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide an alternate audit logging capability in the event of a failure in primary audit logging capability that implements organization-defined alternate audit logging functionality.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003816">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the alternate audit logging functionality in the event of a failure in primary audit logging capability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-5 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003817">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and analyze the potential impact of the organization-defined inappropriate or unusual activity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003818">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Adjust the level of audit review and analysis within the system when there is a change in risk based on law enforcement information, intelligence information, or other credible sources of information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003819">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Adjust the level of audit reporting within the system when there is a change in risk based on law enforcement information, intelligence information, or other credible sources of information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003820">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for integrating audit record review, analysis, and reporting processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003821">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the capability to centrally review and analyze audit records from multiple components within the system.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-6 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003822">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement an audit reduction capability that supports on-demand audit review and analysis.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003823">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement an audit reduction capability that supports on-demand reporting requirements.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003824">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement an audit reduction capability that supports after-the-fact investigations of incidents.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003825">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a report generation capability that supports on-demand audit review and analysis.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003826">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a report generation capability that supports on-demand reporting requirements.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003827">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a report generation capability that supports after-the-fact investigations of incidents.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003828">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement an audit reduction capability that does not alter original content or time ordering of audit records.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003829">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a report generation capability that does not alter original content or time ordering of audit records.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003830">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the capability to process, sort, and search audit records for events of interest based on organization-defined audit fields within audit records.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003831">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Alert organization-defined personnel or roles upon detection of unauthorized access, modification, or deletion of audit information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003832">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to be alerted upon detection of unauthorized access, modification, or deletion of audit information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003833">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Store audit information on a component running a different operating system than the system component being audited.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-9 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003834">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the capability for organization-defined individuals or roles to change the auditing to be performed on organization-defined system components based on organization-defined selectable event criteria within organization-defined time thresholds.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003835">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the capability for auditing the parameters of user query events for data sets containing personally identifiable information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-12 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003836">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the capability for auditing the parameters of user query events for data sets containing personally identifiable information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-12 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003837">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>If an information disclosure is discovered, notify organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-13 b 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003838">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to be notified if an information disclosure is discovered.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-13 b 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003839">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>If an information disclosure is discovered, take organization-defined additional actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-13 b 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003840">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the additional actions to be taken if an information disclosure is discovered.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-13 b 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003841">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor open-source information and information sites using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-13 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003842">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for monitoring open-source information.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-13 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003843">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ discovery techniques, processes, and tools to determine if external entities are replicating organizational information in an unauthorized manner.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-13 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003844">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the capability for organization-defined users or roles to select a user session to record; view; hear; and/or log the content of a user session under organization-defined circumstances.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-14 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003845">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines users or roles who will provide and implement the capability to record; view; hear; and/or log the content of a user session under organization-defined circumstances.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-14 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003846">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the circumstances to record; view; hear; and/or log the content of a user session.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-14 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003847">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop, integrate, and use session auditing activities in consultation with legal counsel and in accordance with applicable laws, executive orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-14 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003848">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the capability for authorized users to remotely view and hear content related to an established user session in real time.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AU-14 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003849">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-level; mission/business process; system-level assessment, authorization, and monitoring policy that is consistent with applicable laws, Executive Orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003850">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the assessment, authorization, and monitoring policy is to be disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003851">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the assessment, authorization, and monitoring policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003852">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the assessment, authorization, and monitoring procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003853">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the assessment, authorization, and monitoring policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003854">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the assessment, authorization, and monitoring procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003855">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current assessment, authorization, and monitoring policy following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003856">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current assessment, authorization, and monitoring policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003857">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current assessment and authorization procedures following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003858">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current assessment, authorization, and monitoring procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003859">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Select the appropriate assessor or assessment team for the type of assessment to be conducted.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003860">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure the control assessment plan is reviewed and approved by the authorizing official or designated representative prior to conducting the assessment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003861">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Assess the controls in the systems and its environment of operation on an organization-defined frequency, to determine the extent to which the controls are implemented correctly, operating as intended, and producing the desired outcome with respect to meeting the privacy requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003862">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Approve and manage the exchange of information between the system and other systems using interconnection security agreements; information exchange security agreements; memoranda of understanding or agreement; service level agreements; user agreement; and/or nondisclosure agreements with an organization-defined type of agreement.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003863">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document, as part of each exchange agreement, the privacy requirements, controls and responsibilities for each system, and the impact level of the information communicated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003864">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that individuals or systems transferring data between interconnecting systems have the requisite authorizations (i.e., write permissions or privileges) prior to accepting such data.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-3 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003865">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify transitive (downstream) information exchanges with other systems through the systems identified in CA-3a.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-3 (7) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003866">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Take measures to ensure that transitive (downstream) information exchanges cease when the controls on identified transitive (downstream) systems cannot be verified or validated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-3 (7) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003867">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms to ensure the accuracy, currency, and availability of the plan of actions and milestones.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003868">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Assign a senior official as the authorizing official for common controls available for inheritance by organizational systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003869">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure the authorizing official accepts the use of common controls inherited by the system, before commencing operations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-6 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003870">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that the authorizing official for common controls authorizes the use of those controls for inheritance by organizational systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-6 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003871">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ a joint authorization process for the system that includes multiple authorizing officials from the same organization conducting the authorization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003872">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ a joint authorization process for the system that includes multiple authorizing officials with at least one authorizing official from an organization external to the organization conducting the authorization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003873">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement continuous monitoring in accordance with the organization-level continuous monitoring strategy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-003874">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system-level metrics to be monitored.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003875">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish organization-defined frequencies for assessment of control effectiveness.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003876">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequencies for monitoring of control effectiveness.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003877">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequencies for assessment of control effectiveness.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003878">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop ongoing control assessments in accordance with the continuous monitoring strategy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003879">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a continuous monitoring program that includes reporting the privacy status to organization-defined personnel or roles on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-003880">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to report the privacy status to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-003881">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure risk monitoring is an integral part of the continuous monitoring strategy that includes effectiveness monitoring.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003882">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure risk monitoring is an integral part of the continuous monitoring strategy that includes compliance monitoring.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003883">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure risk monitoring is an integral part of the continuous monitoring strategy that includes change monitoring.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 (4) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003884">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined actions to validate that policies are established.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003885">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined actions to validate that implemented controls are operating in a consistent manner.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003886">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the actions used to validate policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003887">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure the accuracy, currency, and availability of monitoring results for the system using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003888">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for ensuring accuracy, currency, and availability of monitoring results.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-7 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003889">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ a penetration testing process, on an organization-defined frequency, that includes announced or unannounced attempts to bypass or circumvent controls associated with physical access points to the facility.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-8 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003890">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency the penetration testing process will be employed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-8 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003891">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document, for each internal connection, the privacy requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-9 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003892">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Terminate internal system connections after organization-defined conditions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-9 (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003893">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the conditions for terminating internal system connections.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-9 (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003894">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review on an organization-defined frequency the continued need for each internal connection.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-9 (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003895">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for reviewing each internal connection.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-9 (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003896">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Perform privacy compliance checks on constituent components prior to the establishment of the internal connection.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CA-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003897">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level configuration management policy that is consistent with applicable laws, Executive Orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003898">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official to manage the development, documentation, and dissemination of the configuration management policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003899">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the configuration management policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003900">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the configuration management policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003901">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official to manage the development, documentation, and dissemination of the configuration management procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003902">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the configuration management procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003903">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the configuration management procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003904">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the configuration management policy following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003905">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events for when the policy will be reviewed and updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003906">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update, on an organization-defined frequency, the current configuration management procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003907">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the configuration management procedures following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003908">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events for when the procedures will be reviewed and updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003909">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document, under configuration control, a current baseline configuration of the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003910">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the baseline configuration of the system when system components are installed or upgraded.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 b 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-003911">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for maintaining the currency, completeness, accuracy, and availability of the baseline configuration of the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003912">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Approve or disapprove configuration-controlled changes to the system, with explicit consideration for privacy impact analyses.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003913">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for documenting proposed changes to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003914">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for notifying approval authorities of proposed changes to the system and request change proposal.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003915">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for highlighting proposed changes to the system that have not been approved or disapproved within an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (1) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003916">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for prohibiting changes to the system until designated approvals are received.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (1) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003917">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for documenting all changes to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (1) (e)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003918">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for notifying organization-defined personnel when approved changes to the system are completed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (1) (f)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003919">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms to implement changes to the current system baseline.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003920">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms to deploy the updated baselines across the installed base.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003921">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require an organization-defined privacy representative to be a member of the organization-defined configuration change control element.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003922">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security representatives required to be members of the configuration change control element.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003923">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the privacy representatives required to be members of the configuration change control element.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003924">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the configuration change control element required for security and privacy representatives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003925">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review changes to the system on an organization-defined frequency or when there are organization-defined circumstances to determine whether unauthorized changes have occurred.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003926">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for reviewing changes to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003927">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the circumstances for determining whether unauthorized changes to the system have occurred.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003928">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent or restrict changes to the configuration of the system under organization-defined circumstances.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003929">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the circumstances for preventing or restricting changes to the configuration of the system.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-3 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003930">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Analyze changes to the system to determine potential privacy impacts prior to change implementation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-003931">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When analyzing changes to the system, looks for security impacts due to flaws, weaknesses, incompatibility, or intentional malice.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003932">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>After system changes, verify that the impacted controls are implemented correctly, meeting the privacy requirements for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003933">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>After system changes, verify that the impacted controls are operating as intended, meeting the privacy requirements for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003934">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>After system changes, verify that the impacted controls are producing the desired outcome with regard to meeting the privacy requirements for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003935">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Define and document physical access restrictions associated with changes to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-003936">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Define and document logical access restrictions associated with changes to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-003937">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms to enforce access restrictions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-5 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003938">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Automatically generate audit records of the enforcement actions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-5 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003939">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review and reevaluate system privileges.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-5 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003940">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and reevaluate system privileges per an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-5 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003941">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish and document configuration settings for components employed within the system that reflect the most restrictive mode consistent with operational requirements using organization-defined common secure configurations.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003942">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the common secure configurations for establishing and documenting configuration settings within the system, that reflect the most restrictive mode consistent with operational requirements.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003943">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor changes to the configuration settings in accordance with organizational policies.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003944">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor changes to the configuration settings in accordance with organizational procedures.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003945">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Control changes to the configuration settings in accordance with organizational policies.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003946">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Control changes to the configuration settings in accordance with organizational procedures.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003947">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for managing, applying, and verifying configuration settings.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003948">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the mission essential capabilities for configuring the system.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003949">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that organization-defined user-installed software in a confined physical or virtual machine environment with limited privileges.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003950">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the user-installed software required for executing in a confined physical or virtual machine environment with limited privileges.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003951">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Allow execution of binary or machine-executable code only in confined physical or virtual machine environments and with the explicit approval of organization-defined personnel or roles when such code is obtained from sources with limited or no warranty.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (7) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003952">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles who allow execution of binary or machine-executable code only in confined physical or virtual machine environments when such code is obtained from sources with limited or no warranty.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (7) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003953">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Allow execution of binary or machine-executable code only in confined physical or virtual machine environments and with the explicit approval of organization-defined personnel or roles when such code is without the provision of source code.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (7) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003954">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles who allow execution of binary or machine-executable code only in confined physical or virtual machine environments when such code is without the provision of source code.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (7) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003955">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit the use of binary or machine-executable code from sources with limited or no warranty or without the provision of source code.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (8) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003956">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Allow exceptions only for compelling mission or operational requirements and with the approval of the authorizing official.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (8) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003957">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify organization-defined hardware components authorized for system use.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (9) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003958">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the hardware components to be identified for authorized system use.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (9) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003959">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit the use or connection of unauthorized hardware components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (9) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003960">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the list of authorized hardware components on an organization-defined frequency.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (9) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003961">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency the hardware components are reviewed and updated.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-7 (9) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003962">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an inventory of system components that accurately reflects the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-003963">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an inventory of system components that includes all components within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-003964">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an inventory of system components that does not include duplicate accounting of components or components assigned to any other system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-003965">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an inventory of system components that is at the level of granularity deemed necessary for tracking.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 a 4" />
      </references>
    </cci_item>
    <cci_item id="CCI-003966">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an inventory of system components that is at the level of granularity deemed necessary for reporting.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 a 4" />
      </references>
    </cci_item>
    <cci_item id="CCI-003967">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an inventory of system components that includes organization-defined information deemed necessary to achieve effective system component accountability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 a 5" />
      </references>
    </cci_item>
    <cci_item id="CCI-003968">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for maintaining the currency, completeness, accuracy, and availability of the inventory of the system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003969">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for detecting the presence of unauthorized hardware, software, and firmware components within the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003970">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for supporting the tracking of system components by geographic location.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-8 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003971">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document a configuration management plan for the system that addresses roles, responsibilities, and configuration management processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-9 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003972">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document a configuration management plan for the system that addresses roles, responsibilities, and configuration management procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-9 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003973">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document a configuration management plan for the system that establishes a process for identifying configuration items throughout the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003974">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document a configuration management plan for the system that establishes a process for managing the configuration of the configuration items.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003975">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document a configuration management plan for the system that defines the configuration items for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-9 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003976">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document a configuration management plan for the system that places the configuration items under configuration management.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-9 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003977">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document a configuration management plan for the system that is reviewed and approved by organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-9 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003978">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles for those who review and approve the configuration management plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-9 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003979">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a configuration management plan for the system that is reviewed and approved by organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-9 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-003980">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Allow user installation of software only with explicit privileged status.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-11 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003981">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce and monitor compliance with software installation policies using organization-defined automated mechanisms.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-11 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003982">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify and document the location of the organization-defined information on which the information is processed and stored.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-12 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003983">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify and document the specific system components on which the organization-defined information is processed and stored.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-12 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003984">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information on which the location and specific system components are processed and stored.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-12 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-003985">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify and document the users who have access to the system where the information is processed and stored.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-12 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003986">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify and document the users who have access to the system components where the information is processed and stored.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-12 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003987">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document changes to the location (i.e., system or system components) where the information is processed and stored.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-12 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-003988">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use automated tools to identify organization-defined information by information type on organization-defined components to ensure adequate controls are in place to protect organizational information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003989">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information by information type for identifying automated tools.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003990">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components used to ensure controls are in place to protect organizational information and individual privacy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003991">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document a map of system data actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-13" />
      </references>
    </cci_item>
    <cci_item id="CCI-003992">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent the installation of organization-defined software and firmware components without verification that the component has been digitally signed using a certificate that is recognized and approved by the organization.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-14" />
      </references>
    </cci_item>
    <cci_item id="CCI-003993">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the software and firmware for preventing installation without verification that the component has been digitally signed.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CM-14" />
      </references>
    </cci_item>
    <cci_item id="CCI-003994">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organizational-level; mission/business process-level; and/or system-level contingency planning policy that is consistent with applicable laws, Executive Orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003995">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organizational-level; mission/business process-level; and/or system-level contingency planning policy to organization-defined personnel or roles that is consistent with applicable laws, Executive Orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-003996">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage development and documentation of the contingency planning policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003997">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage dissemination of the contingency planning policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003998">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official designated to manage the development, documentation, and dissemination of the contingency policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-003999">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the contingency planning procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004000">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the contingency procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004001">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official designated to manage the development, documentation, and dissemination of the contingency procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004002">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current contingency planning policy following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004003">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events with which to review and update the current contingency planning policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004004">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current contingency planning procedures following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004005">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events with which to review and update the current contingency planning procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004006">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a contingency plan for the system that addresses maintaining essential mission functions despite a system disruption, compromise, or failure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 a 4" />
      </references>
    </cci_item>
    <cci_item id="CCI-004007">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a contingency plan for the system that addresses maintaining essential business functions despite a system disruption, compromise, or failure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 a 4" />
      </references>
    </cci_item>
    <cci_item id="CCI-004008">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a contingency plan for the system that addresses the sharing of contingency information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 a 6" />
      </references>
    </cci_item>
    <cci_item id="CCI-004009">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Incorporate lessons learned from contingency plan testing, training, or actual contingency activities into contingency testing and training.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-2 g" />
      </references>
    </cci_item>
    <cci_item id="CCI-004010">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update contingency training content on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004011">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency the contingency training content will be reviewed and updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004012">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update contingency training content following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004013">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events for which the contingency training content will be reviewed and updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004014">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms to test the contingency plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004015">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined mechanisms to organization-defined system or system component to disrupt and adversely affect the system or system component.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-4 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004016">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the mechanisms employed to disrupt and adversely affect the system or system component.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-4 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004017">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system or system component used to employ organization-defined mechanisms.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-4 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004018">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish an alternate storage site, including necessary agreements to permit the retrieval of system backup information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004019">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Request Telecommunications Service Priority for all telecommunications services used for national security emergency preparedness in the event that the primary and/or alternate telecommunications services are provided by a common carrier.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-8 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004020">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components to conduct backups of user level information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004021">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct backups of system documentation, including privacy-related documentation, per an organization-defined frequency that is consistent with recovery time and recovery point objectives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004022">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect the confidentiality of backup information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004023">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect integrity of backup information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004024">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect the availability of backup information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004025">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement cryptographic mechanisms to prevent unauthorized disclosure of organization-defined backup information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004026">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement cryptographic mechanisms to prevent unauthorized modification of organization-defined backup information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004027">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the backup information which is protected by cryptographic mechanisms preventing unauthorized disclosure and modification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-9 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004028">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide for the recovery and reconstitution of the system to a known state within an organization-defined time-period consistent with recovery time and recovery point objectives after a disruption, compromise, or failure.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-004029">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time-period consistent with recovery time and recovery point objectives for the recovery and reconstitution of the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-004030">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect system components used for recovery and reconstitution.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="CP-10 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004031">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles the organization-level; mission/business process-level; and/or system-level identification and authorization policy is disseminated to.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004032">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level identification and authorization policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination, among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-1 a 1 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004033">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level identification and authorization policy that is consistent with applicable laws, Executive Orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004034">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document the procedures to facilitate the implementation of the identification and authorization policy and the associated identification and authentication controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004035">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage development and documentation of the identification and authentication policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004036">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage dissemination of the identification and authentication policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004037">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage development and documentation of the identification and authentication procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004038">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage dissemination of the identification and authentication procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004039">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official designated to managing the development, documentation, and dissemination of the identification and authentication policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004040">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official designated to managing the development, documentation, and dissemination of the identification and authentication procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004041">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current identification and authentication policy following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004042">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current identification and authentication policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004043">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current identification and authentication procedures following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004044">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current identification and authentication procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004045">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require users to be individually authenticated before granting access to the shared accounts or resources.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-2 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004046">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement multi-factor authentication for local; network; and/or remote access to privileged accounts; and/or non-privileged accounts such that one of the factors is provided by a device separate from the system gaining access.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-2 (6) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004047">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement multi-factor authentication for local; network; and/or remote access to privileged accounts; and/or non-privileged accounts such that the device meets organization-defined strength of mechanism requirements.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-2 (6) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004048">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the strength of mechanism requirements for implementing multi-factor authentication.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-2 (6) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004049">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the dynamic identifier policy for managing individual identifiers dynamically.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-4 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004050">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Generate pairwise pseudonymous identifiers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-4 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004051">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain the attributes for each uniquely identified individual, device, or service in organization-defined protected central storage.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-4 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004052">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the protected central storage for maintaining the attributes for each uniquely individual, device or service.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-4 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004053">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage system authenticators by establishing administrative procedures for lost/compromised or damaged authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004054">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage system authenticators by implementing administrative procedures for lost/compromised or damaged authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004055">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage system authenticators by changing default authenticators prior to first use.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-004056">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events for when to change or refresh authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-004057">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for updating commonly used, expected, or compromised passwords, when they are suspected of being compromised directly or indirectly.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004058">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For password-based authentication, maintain a list of commonly used, expected, or compromised passwords on an organization-defined frequency.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004059">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For password-based authentication, update the list of passwords on an organization-defined frequency.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004060">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For password-based authentication, update the list of passwords when organizational passwords are suspected to have been compromised directly or indirectly.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004061">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For password-based authentication, verify when users create or update passwords, that the passwords are not found on the list of commonly-used, expected, or compromised passwords in IA-5 (1) (a).</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004062">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For password-based authentication, store passwords using an approved salted key derivation function, preferably using a keyed hash.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (1) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004063">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For password-based authentication, require immediate selection of a new password upon account recovery.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (1) (e)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004064">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For password-based authentication, allow user selection of long passwords and passphrases, including spaces and all printable characters.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (1) (f)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004065">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For password-based authentication, employ automated tools to assist the user in selecting strong password authenticators.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (1) (g)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004066">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For password-based authentication, enforce organization-defined composition and complexity rules.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (1) (h)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004067">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the composition and complexity rules to be enforced.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (1) (h)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004068">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For public key-based authentication, implement a local cache of revocation data to support path discovery and validation.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (2) (b) (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004069">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that the unencrypted static authenticators are not embedded in applications or other forms of static storage.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004070">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use organization-defined external organizations to federate credentials.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004071">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the external organizations used to federate credentials.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004072">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the binding rules for binding identities and authenticators.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004073">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use only General Services Administration-approved and validated products and services for identity, credential, and access management.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (15)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004074">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that the issuance of organization-defined types of and/or specific authenticators be conducted in person or by a trusted external party before the organization-defined registration authority with authorization by organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (16)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004075">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines types of and/or specific authenticators to be conducted in person or by a trusted external party before the organization-defined registration authority.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (16)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004076">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the registration authority who conducts the issuance of organization-defined types of and/or specific authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (16)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004077">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles who authorize the issuance of organization-defined types of and/or specific authenticators.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (16)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004078">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ presentation attack detection mechanisms for biometric-based authentication.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (17)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004079">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined password managers to generate and manage passwords.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (18) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004080">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the password managers employed to generate and manage passwords.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (18) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004081">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect the passwords using organization-defined controls.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (18) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004082">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls for protecting the passwords.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-5 (18) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004083">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Accept only external credentials that are NIST compliant.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-8 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004084">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document and maintain a list of accepted external authenticators.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-8 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004085">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conform to organization-defined identity management profiles for identity management.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-8 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004086">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the identity management profiles for conforming to the profiles for identity management.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-8 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004087">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the policy for accepting and verifying federated or PKI credentials.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-8 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004088">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined measures to disassociate user attributes or identifier assertion relationships among individuals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-8 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004089">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined measures to disassociate user attributes or identifier assertion relationships among credential service providers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-8 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004090">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined measures to disassociate user attributes or identifier assertion relationships among relying parties.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-8 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004091">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the measures to be implemented to disassociate user attributes or identifier assertion relationships among individuals, credential service providers, and relying parties.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-8 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004092">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identity proof users that require accounts for logical access to systems based on appropriate identity assurance level requirements as specified in applicable standards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-12 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004093">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identity proof users that require accounts for logical access to systems based on appropriate identity assurance level requirements as specified in applicable guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-12 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004094">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Resolve user identities to a unique individual.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-12 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004095">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Collect identity evidence.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-12 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004096">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Validate identity evidence.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-12 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004097">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify identity evidence.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-12 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004098">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that the registration process to receive an account for logical access includes supervisor or sponsor authorization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004099">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require evidence of individual identification be presented to the registration authority.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-12 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004100">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that the presented identity evidence be validated through organizational defined methods of validation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004101">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that the presented identity evidence be verified through organizational defined methods of verification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004102">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the methods of validation required for presenting identity evidence.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004103">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the methods of verification required for presenting identity evidence.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004104">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that the validation of identity evidence be conducted in person before a designated registration authority.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-12 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004105">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that the verification of identity evidence be conducted in person before a designated registration authority.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-12 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004106">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that a registration code or notice of proofing be delivered through an out-of-band channel to verify the users address (physical or digital) of record.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-12 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004107">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Accept externally-proofed identities at an organization-defined identity assurance level.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-12 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004108">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the identity assurance level by accepting externally-proofed identities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IA-12 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004109">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level incident response policy that is consistent with applicable laws, executive orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004110">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the incident response policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004111">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the incident response procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004112">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official designated to manage the incident response policy and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004113">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current incident response policy following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004114">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events for reviewing and updating the current incident response policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004115">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current incident response procedures following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004116">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events for reviewing and updating the current incident response procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004117">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms to provide an incident response training environment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004118">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide incident response training on how to identify and respond to a breach, including the organization's process for reporting a breach.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-2 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004119">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms to test the incident response capability.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004120">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use qualitative data from testing to determine the effectiveness of incident response processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-3 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004121">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use quantitative data from testing to determine the effectiveness of incident response processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-3 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004122">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use qualitative data from testing to continuously improve incident response processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-3 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004123">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use quantitative data from testing to continuously improve incident response processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-3 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004124">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use qualitative data from testing to provide incident response measures and metrics that are accurate.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-3 (3) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004125">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use quantitative data from testing to provide incident response measures and metrics that are accurate.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-3 (3) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004126">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use qualitative data from testing to provide incident response measures and metrics that are consistent.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-3 (3) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004127">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use quantitative data from testing to provide incident response measures and metrics that are consistent.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-3 (3) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004128">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use qualitative data from testing to provide incident response measures and metrics that are in a reproducible format.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-3 (3) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004129">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use quantitative data from testing to provide incident response measures and metrics that are in a reproducible format.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-3 (3) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004130">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Incorporate lessons learned from ongoing incident handling activities into incident response procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004131">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Incorporate lessons learned from ongoing incident handling activities into incident response training.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004132">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Incorporate lessons learned from ongoing incident handling activities into incident response testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004133">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure the rigor of incident handling activities are comparable and predictable across the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004134">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure the intensity of incident handling activities are comparable and predictable across the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004135">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure the scope of incident handling activities are comparable and predictable across the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004136">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure the results of incident handling activities are comparable and predictable across the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004137">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for supporting the incident handling process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004138">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the types of dynamic reconfiguration for system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004139">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the classes of incidents to identify actions in response to those incidents.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004140">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the actions to take in response to organization-defined classes of incidents to ensure continuation of organizational mission and business functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004141">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Coordinate an incident handling capability for insider threats that includes organization-defined entities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004142">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the organizational entities for coordinating an incident handling capability for insider threats.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004143">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish and maintain an integrated incident response team that can be deployed to any location identified by the organization in an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004144">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period for establishing and maintaining an integrated incident response team that can be deployed to any location identified by the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004145">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Analyze malicious code and/or other residual artifacts remaining in the system after the incident.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004146">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Analyze anomalous or suspected adversarial behavior in or related to organization-defined environments or resources.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004147">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the environments or resources for analyzing anomalous or suspected adversarial behavior.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004148">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish and maintain a security operations center.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (14)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004149">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage public relations associated with an incident.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (15) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004150">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ measures to repair the reputation of the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-4 (15) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004151">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Track incidents using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004152">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Collect incident information using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004153">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Analyze incident information using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004154">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms to track, collect, and analyze incident information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004155">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for reporting incidents.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004156">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide incident information to the provider of the product or service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004157">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an incident response plan that addresses the sharing of incident information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 a 8" />
      </references>
    </cci_item>
    <cci_item id="CCI-004158">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency organization-defined personnel or roles will review and approve the incident response plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 a 9" />
      </references>
    </cci_item>
    <cci_item id="CCI-004159">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an incident response plan that explicitly designates responsibility for incident response to organization-defined entities, personnel, or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 a 10" />
      </references>
    </cci_item>
    <cci_item id="CCI-004160">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include a process to determine if notice to individuals or other organizations, including oversight organizations, is needed, in the Incident Response Plan for breaches involving Personally Identifiable Information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004161">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include an assessment process to determine the extent of the harm, embarrassment, inconvenience, or unfairness to affected individuals and any mechanisms to mitigate such harms in the Incident Response Plan for breaches involving Personally Identifiable Information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004162">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include identification of applicable privacy requirements in the Incident Response Plan for breaches involving Personally Identifiable Information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-8 (1) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004163">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Respond to information spills by assigning organization-defined personnel or roles with responsibility for responding to information spills.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-9 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004164">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles who will respond to information spills.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="IR-9 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004165">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level maintenance policy that is consistent with applicable laws, Executive Orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004166">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development, documentation, and dissemination of the maintenance policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004167">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development, documentation, and dissemination of the maintenance procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004168">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official who will manage the development, documentation, and dissemination of the maintenance policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004169">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official who will manage the development, documentation, and dissemination of the maintenance procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004170">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current maintenance policy following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004171">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current maintenance policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004172">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current maintenance procedures following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004173">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current maintenance procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004174">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Schedule replacement on system components in accordance with manufacturer or vendor specifications and/or organizational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004175">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document replacement on system components in accordance with manufacturer or vendor specifications and/or organizational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004176">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review records of replacement on system components in accordance with manufacturer or vendor specifications and/or organizational requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004177">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Approve all maintenance activities, whether performed on site or remotely.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004178">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor all maintenance activities, whether performed on site or remotely.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004179">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Approve all maintenance activities, whether the system or system components are serviced on site or removed to another location.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004180">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor all maintenance activities, whether the system or system components are serviced on site or removed to another location.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004181">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information to be removed from associated media.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004182">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Schedule maintenance, repair, and replacement actions for the system using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004183">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct maintenance, repair, and replacement actions for the system using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004184">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document maintenance, repair, and replacement actions for the system using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004185">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Produce up-to date, accurate, and complete records of all replacement actions requested, scheduled, in process, and completed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-2 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004186">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review previously approved system maintenance tools on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004187">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for reviewing previously approved system maintenance tools.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004188">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor the use of maintenance tools that execute with increased privilege.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-3 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004189">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Inspect the maintenance tools to ensure the latest software updates and patches are installed.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-3 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004190">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Terminate session when nonlocal maintenance is completed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-004191">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Terminate network connection when nonlocal maintenance is completed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-004192">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect nonlocal maintenance sessions by separating the maintenance session from other network sessions with the system by logically separated communications paths.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 (4) (b) (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004193">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the cryptographic mechanisms for protecting the integrity and confidentiality of nonlocal maintenance and diagnostic communications.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-4 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004194">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop organization-defined alternate controls in the event a system component cannot be sanitized, removed, or disconnected from the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-5 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004195">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined alternate controls in the event a system component cannot be sanitized, removed, or disconnected from the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-5 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004196">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines alternate controls in the event a system component cannot be sanitized, removed, or disconnected from the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-5 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004197">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for transferring predictive maintenance data to a maintenance system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004198">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Restrict or prohibit field maintenance on organization-defined systems or system components to organization-defined trusted maintenance facilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-004199">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which restrict or prohibit field maintenance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-004200">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the trusted maintenance facilities which the systems or system components restrict or prohibit field maintenance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MA-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-004201">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level media protection policy that is consistent with applicable laws, Executive Orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004202">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the media protection policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004203">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the media protection policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004204">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage development and documentation of the media protection procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004205">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage dissemination of the media protection procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004206">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official designated to manage the development, documentation, and dissemination of the media protection policy and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004207">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current media protection policy following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004208">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current media policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004209">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current media protection procedures following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004210">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current media procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004211">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Physically control and securely store organization-defined types of digital and/or non-digital media within organization-defined controlled areas.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004212">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Securely store organization-defined types of digital and/or non-digital media within organization-defined controlled areas.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004213">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect system media types defined in MP-4a until the media are destroyed or sanitized using approved equipment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004214">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect system media types defined in MP-4a until the media are destroyed or sanitized using approved techniques.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004215">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect system media types defined in MP-4a until the media are destroyed or sanitized using approved procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-4 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004216">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms which restrict access to media storage areas and log access attempts and access granted.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004217">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect organization-defined types of system media during transport outside of controlled areas using organization-defined controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004218">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Control organization-defined types of system media during transport outside of controlled areas using organization-defined controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004219">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test sanitization equipment in accordance with the organization-defined frequency to ensure that the intended sanitization is being achieved.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004220">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test sanitization procedures in accordance with the organization-defined frequency to ensure that the intended sanitization is being achieved.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004221">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish an organization-defined system media downgrading process that includes employing downgrading mechanisms with strength and integrity commensurate with the security category or classification of the information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004222">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system media downgrading process that includes employing downgrading mechanisms with strength and integrity commensurate with the security category or classification of the information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004223">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that the system media downgrading process is commensurate with the security category and/or classification level of the information to be removed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004224">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that the system media downgrading process is commensurate with the access authorizations of the potential recipients of the downgraded information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004225">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify organization-defined system media requiring downgrading.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004226">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system media requiring downgrading.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004227">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test downgrading equipment on an organization-defined frequency to ensure that intended downgrading actions are being achieved.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004228">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test downgrading procedures on an organization-defined frequency to ensure that intended downgrading actions are being achieved.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="MP-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004229">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level physical and environmental protection policy that is consistent with applicable laws, Executive Orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004230">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the physical and environmental protection policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004231">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the physical and environmental protection policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004232">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage development and documentation of the physical and environmental protection procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004233">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage dissemination of the physical and environmental protection procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004234">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official who will manage the physical and environmental policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004235">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official who will manage the physical and environmental procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004236">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current physical and environmental protection policy following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004237">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current physical and environmental protection policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004238">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current physical and environmental protection procedures following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004239">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current physical and environmental protection procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004240">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce physical access authorizations at organization-defined entry points to the facility where the system resides.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004241">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Enforce physical access authorizations at organization-defined exit points to the facility where the system resides.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004242">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Control ingress to the facility where the information system resides using one or more organization-defined physical access control systems or devices or guards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004243">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Control egress to the facility where the information system resides using one or more organization-defined physical access control systems or devices or guards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004244">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Limit access using physical barriers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004245">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ access control vestibules at organization-defined locations within the facility.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004246">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the locations within the facility where the access control vestibules are employed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-3 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004247">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Link individual identity to receipt of output from output devices.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004248">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for recognizing organization-defined classes or types of intrusions and initiating organization-defined response actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004249">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review video recordings on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004250">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to review video recordings.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-6 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004251">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Report anomalies in visitor access records to organization-defined personnel.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004252">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel who are to report anomalies in visitor access records.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004253">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for maintaining and reviewing visitor access records.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-8 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004254">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Limit personally identifiable information contained in visitor access records to the organization-defined elements identified in the privacy risk assessment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-8 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004255">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the elements identified in the privacy risk assessment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-8 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004256">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system or individual system components that provide the capability of shutting off power in emergency situations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-10 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004257">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automatic environmental controls for preventing potentially harmful fluctuations to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-14 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004258">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles who employ environmental control monitoring that provides an alarm or notification of changes potentially harmful to personnel or equipment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-14 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004259">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Detect the presence of water near the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-15 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004260">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Alert organization-defined personnel or roles of the presence of water near the system using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-15 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004261">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for detecting the presence of water and alerting organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-15 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004262">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Determine and document the organization-defined alternate work sites allowed for use by employees.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-17 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004263">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide a means for employees to communicate with information security personnel in case of incidents.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-17 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004264">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect system components, associated data communications, and networks in accordance with national Emissions Security policies based on the security category or classification of the information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-19 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004265">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect system components, associated data communications, and networks in accordance with national Emissions Security procedures based on the security category or classification of the information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-19 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004266">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined protective measures against electromagnetic pulse damage for organization-defined systems and system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-21" />
      </references>
    </cci_item>
    <cci_item id="CCI-004267">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the protective measure employed against electromagnetic pulse damage for organization-defined systems and system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-21" />
      </references>
    </cci_item>
    <cci_item id="CCI-004268">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems and system components in which organization-defined protective measures are employed against electromagnetic pulse damage.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-21" />
      </references>
    </cci_item>
    <cci_item id="CCI-004269">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Mark organization-defined system hardware components indicating the impact or classification level of the information permitted to be processed, stored, or transmitted by the hardware component.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-22" />
      </references>
    </cci_item>
    <cci_item id="CCI-004270">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system hardware components which are marked, indicating the impact or classification level of the information permitted to be processed, stored, or transmitted by the hardware component.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-22" />
      </references>
    </cci_item>
    <cci_item id="CCI-004271">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Plan the location or site of the facility where the system resides considering physical and environmental hazards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-23 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004272">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For existing facilities, consider the physical and environmental hazards in the organizational risk management strategy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PE-23 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004273">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and or system-level planning policy that is consistent with applicable laws, Executive Orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004274">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the planning policy and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004275">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the planning policy and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004276">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current planning policy following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004277">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current planning procedures following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004278">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security and privacy plans for the system that identify the individuals that fulfill system roles and responsibilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 a 4" />
      </references>
    </cci_item>
    <cci_item id="CCI-004279">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security and privacy plans for the system that identify the information types processed, stored, and transmitted by the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 a 5" />
      </references>
    </cci_item>
    <cci_item id="CCI-004280">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security and privacy plans for the system that describe any specific threats to the system that are of concern to the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 a 7" />
      </references>
    </cci_item>
    <cci_item id="CCI-004281">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security and privacy plans for the system that provide the results of a privacy risk assessment for the systems processing personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 a 8" />
      </references>
    </cci_item>
    <cci_item id="CCI-004282">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security and privacy plans for the system that include risk determinations for security and privacy architecture and design decisions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 a 13" />
      </references>
    </cci_item>
    <cci_item id="CCI-004283">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security and privacy plans for the system that include security- and privacy-related activities affecting the system that require planning and coordination with organization-defined individuals or groups.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-2 a 14" />
      </references>
    </cci_item>
    <cci_item id="CCI-004284">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish the rules describing the responsibilities and expected behavior, for security, for individuals requiring access to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004285">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish the rules describing the responsibilities and expected behavior, for privacy, for individuals requiring access to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004286">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the rules describing the responsibilities and expected behavior, for information and system usage, for individuals requiring access to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004287">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the rules describing the responsibilities and expected behavior, for security, for individuals requiring access to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004288">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the rules describing the responsibilities and expected behavior, for privacy, for individuals requiring access to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004289">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency individuals are required to read and re-acknowledge the rules of behavior whenever the rules are revised or updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004290">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include in the rules of behavior, restrictions on use of organization-provided identifiers (e.g., email addresses) and authentication secrets (e.g., passwords) for creating accounts on external sites/applications.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-4 (1) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004291">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a security Concept of Operations (CONOPS) for the system describing how the organization intends to operate the system from the perspective of information privacy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-7 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004292">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop privacy architectures for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004293">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop privacy architectures for the system that describes the requirements and approach to be taken for protecting the confidentiality, integrity, and availability of organizational information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004294">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop security architectures for the system that describe the requirements and approach to be taken for processing personally identifiable information to minimize privacy risk to individuals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004295">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop privacy architectures for the system that describe the requirements and approach to be taken for processing personally identifiable information to minimize privacy risk to individuals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004296">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop privacy architectures for the system that describe how the architectures are integrated into and support the enterprise architecture.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-004297">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop privacy architectures for the system that describe any assumptions about, and dependencies on, external systems and services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 a 4" />
      </references>
    </cci_item>
    <cci_item id="CCI-004298">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Reflect planned privacy architecture changes in the privacy plans.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004299">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Reflect planned privacy architecture changes in the privacy Concept of Operations (CONOPS).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004300">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Reflect planned privacy architecture changes in the privacy organizational procurements and acquisitions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004301">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Design the privacy architecture for the system using a defense-in-depth approach that allocates organization-defined controls to organization-defined locations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004302">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Design the privacy architecture for the system using a defense-in-depth approach that allocates organization-defined controls to organization-defined architectural layers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004303">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls to be allocated to organization-defined locations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004304">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls to be allocated to organization-defined architectural layers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004305">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the locations to which the system allocates organization-defined controls in the privacy architecture.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004306">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the architectural layers to which the system allocates organization-defined controls in the privacy architecture.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004307">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Design the privacy architecture for the system using a defense-in-depth approach that ensures that the allocated controls operate in a coordinated and mutually reinforcing manner.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004308">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls that are allocated to the organization-defined locations and architectural layers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004309">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the locations and architectural layers that are obtained from different suppliers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004310">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Select a control baseline for the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-004311">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Tailor the selected control baseline by applying specified tailoring actions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PL-11" />
      </references>
    </cci_item>
    <cci_item id="CCI-004312">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the organization-wide information security program plan following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004313">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events for reviewing and updating the organization-wide information security program plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004314">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the resources needed to implement the information security programs in capital planning and investment requests.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004315">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the resources needed to implement the information privacy programs in capital planning and investment requests.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004316">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prepare documentation required for addressing information security programs in capital planning and investment requests in accordance with applicable laws, Executive Orders, directives, policies, regulations, and standards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004317">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prepare documentation required for addressing information privacy programs in capital planning and investment requests in accordance with applicable laws, Executive Orders, directives, policies, regulations, and standards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004318">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Make available for expenditure, the planned information privacy resources.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004319">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process to ensure that plans of action and milestones for the privacy program and the associated organizational systems are maintained.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-4 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004320">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process to ensure that plans of action and milestones for the privacy program and associated organizational systems are developed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-4 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004321">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process to ensure that plans of action and milestones for the supply chain risk management programs and the associated organizational systems are maintained.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-4 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004322">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process to ensure that plans of action and milestones for the supply chain risk management programs and the associated organizational systems are developed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-4 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004323">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process to ensure that plans of action and milestones for the privacy program and associated organizational systems document the remedial information privacy actions to adequately respond to risk to organizational operations and assets, individuals, other organizations, and the Nation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-4 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004324">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process to ensure that plans of action and milestones for the supply chain risk management program and associated organizational systems document the remedial information supply chain risk management actions to adequately respond to risk to organizational operations and assets, individuals, other organizations, and the Nation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-4 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004325">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process to ensure that plans of action and milestones for the security program and associated organizational systems are reported in accordance with established reporting requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-4 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-004326">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process to ensure that plans of action and milestones for the privacy program and associated organizational systems are reported in accordance with established reporting requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-4 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-004327">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process to ensure that plans of action and milestones for the supply chain risk management program and associated organizational systems are reported in accordance with established reporting requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-4 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-004328">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an inventory of organizational systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-004329">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update, on an organization-defined frequency, an inventory of organizational systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-004330">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency with which to update the inventory of organizational systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-004331">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish an inventory of all systems, applications, and projects that process personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004332">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain an inventory of all systems, applications, and projects that process personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004333">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update on an organization-defined frequency, an inventory of all systems, applications, and projects that process personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004334">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of which an inventory of all systems, applications, and projects that process personally identifiable information will be updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004335">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop the results of information privacy measures of performance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-004336">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor the results of information privacy measures of performance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-004337">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Report on the results of information privacy measures of performance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-004338">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an enterprise architecture with consideration for information privacy and the resulting risk to organizational operations, organizational assets, individuals, other organizations, and the Nation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-004339">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain an enterprise architecture with consideration for information security and the resulting risk to organizational operations, organizational assets, individuals, other organizations, and the Nation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-004340">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain an enterprise architecture with consideration for information privacy and the resulting risk to organizational operations, organizational assets, individuals, other organizations, and the Nation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-004341">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Offload organization-defined non-essential functions or services to other systems, system components, or an external provider.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004342">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the non-essential functions or services to be offloaded to other systems, system components, or an external provider.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-7 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004343">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Address information privacy issues in the development and documentation of a critical infrastructure and key resources protection plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-004344">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Address information privacy issues in the updating of a critical infrastructure and key resources protection plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-004345">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a comprehensive strategy to manage privacy risk to individuals resulting from the authorized processing of personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-9 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004346">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage the security state of organizational systems and the environments in which those systems operate through authorization processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-10 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004347">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage the privacy state of organizational systems and the environments in which those systems operate through authorization processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-10 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004348">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Define organizational mission and business processes with consideration for information privacy and the resulting risk to organizational operations, organizational assets, individuals, other organizations, and the Nation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-11 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004349">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Determine personally identifiable information processing needs arising from the defined mission and business processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-11 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004350">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and revise the mission and business processes on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-11 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004351">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency at which the mission and business processes are reviewed and revised.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-11 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004352">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish a privacy workforce development and improvement program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-13" />
      </references>
    </cci_item>
    <cci_item id="CCI-004353">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for ensuring that organizational plans for conducting privacy testing activities associated with organizational systems are developed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004354">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for ensuring that organizational plans for conducting privacy testing activities associated with organizational systems are maintained.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004355">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for ensuring that organizational plans for conducting privacy training activities associated with organizational systems are developed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004356">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for ensuring that organizational plans for conducting privacy training activities associated with organizational systems are maintained.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004357">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for ensuring that organizational plans for conducting privacy monitoring activities associated with organizational systems are developed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004358">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for ensuring that organizational plans for conducting privacy monitoring activities associated with organizational information systems are maintained.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004359">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for ensuring that organizational plans for conducting privacy testing associated with organizational systems continue to be executed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004360">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for ensuring that organizational plans for conducting privacy training associated with organizational systems continue to be executed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004361">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for ensuring that organizational plans for conducting privacy monitoring activities associated with organizational systems continue to be executed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-14 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004362">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish and institutionalize contact with selected groups and associations within the privacy community to facilitate ongoing privacy education and training for organizational personnel.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-15 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004363">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish and institutionalize contact with selected groups and associations within the privacy community to maintain currency with recommended privacy practices, techniques, and technologies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-15 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004364">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish and institutionalize contact with selected groups and associations within the privacy community to share current privacy information including threats, vulnerabilities, and incidents.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-15 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004365">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ automated means to maximize the effectiveness of sharing threat intelligence information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-16 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004366">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish policy to ensure that the requirements for the protection of Controlled Unclassified Information that is processed, stored or transmitted on external systems, are implemented in accordance with applicable laws, Executive Orders, directives, policies, regulations, and standards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-17 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004367">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish procedures to ensure that the requirements for the protection of Controlled Unclassified Information that is processed, stored or transmitted on external systems, are implemented in accordance with applicable laws, Executive Orders, directives, policies, regulations, and standards.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-17 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004368">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the policy for Controlled Unclassified Information on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-17 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004369">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency in which the policy for Controlled Unclassified information is reviewed and updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-17 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004370">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the procedures for Controlled Unclassified Information on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-17 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004371">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency in which the procedures for Controlled Unclassified information is reviewed and updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-17 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004372">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide privacy program plan that provides an overview of the agency's privacy program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-18 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004373">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-wide privacy program plan that provides an overview of the agency's privacy program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-18 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004374">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide privacy program plan that provides an overview of the agency's privacy program and includes a description of the structure of the privacy program and the resources dictated to the privacy program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-18 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004375">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-wide privacy program plan that provides an overview of the agency's privacy program and includes a description of the structure of the privacy program and the resources dictated to the privacy program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-18 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004376">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide privacy program plan that provides an overview of the agency's privacy program and provides an overview of the requirements for the privacy program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-18 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004377">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-wide privacy program plan that provides an overview of the agency's privacy program and provides an overview of the requirements for the privacy program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-18 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004378">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide privacy program plan that provides an overview of the agency's privacy program and a description of the privacy program management controls and common controls in place or planned for meeting those requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-18 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004379">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-wide privacy program plan that provides an overview of the agency's privacy program and a description of the privacy program management controls and common controls in place or planned for meeting those requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-18 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004380">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide privacy program plan that provides an overview of the agency's privacy program and includes the role of the Senior Agency Official for Privacy and the identification and assignment of the roles of other privacy officials and staff and their responsibilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-18 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-004381">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-wide privacy program plan that provides an overview of the agency's privacy program and includes the role of the Senior Agency Official for Privacy and the identification and assignment of the roles of other privacy officials and staff and their responsibilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-18 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-004382">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide privacy program plan that provides an overview of the agency's privacy program and describes management commitment, compliance, and the strategic goals and objectives of the privacy program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-18 a 4" />
      </references>
    </cci_item>
    <cci_item id="CCI-004383">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-wide privacy program plan that provides an overview of the agency's privacy program and describes management commitment, compliance, and the strategic goals and objectives of the privacy program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-18 a 4" />
      </references>
    </cci_item>
    <cci_item id="CCI-004384">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide privacy program plan that provides an overview of the agency's privacy program and reflects coordination among organizational entities responsible for the different aspects of privacy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-18 a 5" />
      </references>
    </cci_item>
    <cci_item id="CCI-004385">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-wide privacy program plan that provides an overview of the agency's privacy program and reflects coordination among organizational entities responsible for the different aspects of privacy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-18 a 5" />
      </references>
    </cci_item>
    <cci_item id="CCI-004386">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide privacy program plan that provides an overview of the agency's privacy program and is approved by a senior official with responsibility and accountability for the privacy risk being incurred to organizational operations (including mission, functions, image, and reputation), organizational assets, individuals, other organizations, and the Nation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-18 a 6" />
      </references>
    </cci_item>
    <cci_item id="CCI-004387">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-wide privacy program plan that provides an overview of the agency's privacy program and is approved by a senior official with responsibility and accountability for the privacy risk being incurred to organizational operations (including mission, functions, image, and reputation), organizational assets, individuals, other organizations, and the Nation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-18 a 6" />
      </references>
    </cci_item>
    <cci_item id="CCI-004388">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update the plan on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-18 a 6" />
      </references>
    </cci_item>
    <cci_item id="CCI-004389">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update the plan to address changes in federal privacy laws and policy and organizational changes and problems identified during plan implementation or privacy control assessments.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-18 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004390">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Appoint a Senior Agency Official for Privacy with the authority, mission, accountability, and resources to coordinate applicable privacy requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-19" />
      </references>
    </cci_item>
    <cci_item id="CCI-004391">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Appoint a Senior Agency Official for Privacy with the authority, mission, accountability, and resources to develop applicable privacy requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-19" />
      </references>
    </cci_item>
    <cci_item id="CCI-004392">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Appoint a Senior Agency Official for Privacy with the authority, mission, accountability, and resources to implement applicable privacy requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-19" />
      </references>
    </cci_item>
    <cci_item id="CCI-004393">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Appoint a Senior Agency Official for Privacy with the authority, mission, accountability, and resources to manage privacy risks through the organization-wide privacy program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-19" />
      </references>
    </cci_item>
    <cci_item id="CCI-004394">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain a central resource webpage on the organization's principle public website that serves as a central source of information about the organization's privacy plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-20" />
      </references>
    </cci_item>
    <cci_item id="CCI-004395">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that the public has access to information about organizational privacy activities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-20 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004396">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that the public can communicate with its Senior Agency Official for Privacy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-20 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004397">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that organizational privacy practices and reports are publicly available.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-20 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004398">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ publicly facing email addresses and/or phone lines to enable the public to provide feedback and/or direct questions to privacy offices regarding privacy practices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-20 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004399">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and post privacy policies on all external-facing websites, mobile applications, and other digital services that are written in plain language.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-20 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004400">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and post privacy policies on all external-facing websites, mobile applications, and other digital services that are organized in a way that is easy to understand and navigate.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-20 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004401">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and post privacy policies on all external-facing websites, mobile applications, and other digital services that provide information needed by the public to make an informed about whether and how to interact with the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-20 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004402">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and post privacy policies on all external-facing websites, mobile applications, and other digital services that are updated whenever the organization makes a substantive change to the practices it describes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-20 (1) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004403">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and post privacy policies on all external-facing websites, mobile applications, and other digital services that includes a time/date stamp to inform the public of the date of the most recent changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-20 (1) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004404">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an accurate accounting of disclosures of personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-21 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004405">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain an accurate accounting of disclosures of personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-21 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004406">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an accurate accounting of disclosures of personally identifiable information, including date, nature, and purpose of each disclosure of a record.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-21 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004407">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain an accurate accounting of disclosures of personally identifiable information, including date, nature, and purpose of each disclosure of a record.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-21 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004408">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an accurate accounting of disclosures of personally identifiable information, including name and address, or other contact information of the individual or organization to which the disclosure was made.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-21 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004409">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain an accurate accounting of disclosures of personally identifiable information, including name and address, or other contact information of the individual or organization to which the disclosure was made.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-21 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004410">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Retain the accounting of disclosures for the length of the time the personally identifiable information is maintained or five years after the disclosure is made, whichever is longer.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-21 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004411">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Make the accounting of disclosures available to the individual to whom the personally identifiable information relates upon request.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-21 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004412">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document organization-wide policies for reviewing for the accuracy, relevance, timeliness, and completeness of personally identifiable information across the information life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-22 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004413">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document organization-wide procedures for reviewing for the accuracy, relevance, timeliness, and completeness of personally identifiable information across the information life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-22 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004414">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document organization-wide policies for correcting or deleting inaccurate or outdated personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-22 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004415">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document organization-wide procedures for correcting or deleting inaccurate or outdated personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-22 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004416">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document organization-wide policies for disseminating notice of corrected or deleted personally identifiable information to individuals or other appropriate entities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-22 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004417">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document organization-wide procedures for disseminating notice of corrected or deleted personally identifiable information to individuals or other appropriate entities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-22 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004418">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document organization-wide policies for appeals of adverse decisions on correction or deletion requests.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-22 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004419">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document organization-wide procedures for appeals of adverse decisions on correction or deletion requests.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-22 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004420">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish a Data Governance Body consisting of organization-defined roles with organization-defined responsibilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-23" />
      </references>
    </cci_item>
    <cci_item id="CCI-004421">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the roles that are established by the Data Governance Body.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-23" />
      </references>
    </cci_item>
    <cci_item id="CCI-004422">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the responsibilities the Data Governance Body establishes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-23" />
      </references>
    </cci_item>
    <cci_item id="CCI-004423">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish a Data Integrity Board to review proposals to conduct or participate in a matching program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-24 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004424">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish a Data Integrity Board to conduct an annual review of all matching programs in which the agency has participated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-24 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004425">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document policies that address the use of personally identifiable information for internal testing, training, and research.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-25 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004426">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document procedures that address the use of personally identifiable information for internal testing, training, and research.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-25 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004427">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement policies that address the use of personally identifiable information for internal testing, training, and research.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-25 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004428">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement procedures that address the use of personally identifiable information for internal testing, training, and research.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-25 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004429">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Limit or minimize the amount of personally identifiable information used for internal testing, training, and research purposes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-25 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004430">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Authorize the use of personally identifiable information when such information is required for internal testing, training, and research.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-25 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004431">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update policies on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-25 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004432">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of which the policies should be reviewed and updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-25 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004433">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update procedures on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-25 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004434">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of which the procedures should be reviewed and updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-25 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004435">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for receiving and responding to complaints, concerns or questions from individuals about the organizational security practices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-26" />
      </references>
    </cci_item>
    <cci_item id="CCI-004436">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a process for receiving and responding to complaints, concerns or questions from individuals about the organizational privacy practices.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-26" />
      </references>
    </cci_item>
    <cci_item id="CCI-004437">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement mechanisms that are easy to use.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-26 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004438">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement mechanisms that are readily available by the public.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-26 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004439">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement all information necessary for successfully filing complaints.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-26 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004440">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement tracking mechanisms to ensure all complaints received are reviewed and appropriately addressed within an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-26 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004441">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period of which the tracking mechanisms to ensure all complaints received are reviewed and addressed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-26 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004442">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement acknowledgement of receipt of complaints, concerns, or questions from individuals within an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-26 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004443">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period for acknowledging the receipt of complaints, concerns, or questions from individuals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-26 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004444">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement response to complaints, concerns, or questions from individuals within an organization-defined time period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-26 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-004445">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period for response to complaints, concerns, or questions from individuals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-26 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-004446">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop organization-defined privacy reports.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-27" />
      </references>
    </cci_item>
    <cci_item id="CCI-004447">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the privacy reports that are to be developed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-27" />
      </references>
    </cci_item>
    <cci_item id="CCI-004448">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate privacy reports to organization-defined oversight bodies to demonstrate accountability with statutory, regulatory, and policy privacy program mandates.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-27 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004449">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop privacy reports for organization-defined officials and other personnel with responsibility for monitoring privacy program progress and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-27 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004450">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate privacy reports for organization-defined officials and other personnel with responsibility for monitoring privacy program compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-27 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004451">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the officials responsible for monitoring privacy program compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-27 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004452">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update privacy reports on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-27 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004453">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of which the privacy reports are reviewed and updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-27 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004454">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify and document assumptions affecting risk assessments, risk response, and risk monitoring.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-28 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004455">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify and document constraints affecting risk assessments, risk response, and risk monitoring.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-28 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004456">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify and document priorities and trade-offs considered by the organization for managing risk.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-28 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-004457">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify and document the organizational risk tolerance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-28 a 4" />
      </references>
    </cci_item>
    <cci_item id="CCI-004458">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Distribute the results of risk framing activities to organization-defined personnel.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-28 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004459">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel to distribute the results of risk framing activities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-28 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004460">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update risk framing considerations on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-28 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004461">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for reviewing and updating risk framing considerations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-28 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004462">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Appoint a Senior Accountable Official for Risk Management to align organizational information security management processes with strategic, operational, and budgetary planning processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-29 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004463">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Appoint a Senior Accountable Official for Risk Management to align organizational information privacy management processes with strategic, operational, and budgetary planning processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-29 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004464">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish a Risk Executive (function) to view and analyze risk from an organization-wide perspective.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-29 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004465">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish a Risk Executive (function) to ensure management of risk is consistent across the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-29 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004466">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide strategy for managing supply chain risks associated with the development of systems, system components, and system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-30 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004467">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide strategy for managing supply chain risks associated with the acquisition of systems, system components, and system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-30 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004468">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide strategy for managing supply chain risks associated with the maintenance of systems, system components, and system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-30 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004469">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide strategy for managing supply chain risks associated with the disposal of systems, system components, and system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-30 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004470">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the supply chain risk management strategy consistently across the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-30 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004471">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the supply chain risk management strategy on an organization-defined frequency or as required, to address organizational changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-30 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004472">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of which the supply chain risk management strategy will be reviewed and updated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-30 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004473">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide continuous monitoring strategy establishing organization-defined metrics to be monitored.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004474">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement continuous monitoring programs that include establishing organization-wide metrics to be monitored.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004475">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the metrics for developing and implementing continuous monitoring programs.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004476">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide continuous monitoring strategy establishing organization-defined frequencies for monitoring.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004477">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide continuous monitoring strategy establishing organization-defined frequencies for assessment of control effectiveness.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004478">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequencies for developing and implementing continuous monitoring programs for monitoring.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004479">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement continuous monitoring programs that include establishing organization-wide frequencies for monitoring.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004480">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement continuous monitoring programs that include establishing organization-wide frequencies for assessment of control effectiveness.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004481">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequencies for developing and implementing continuous monitoring programs for assessment of control effectiveness.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004482">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide continuous monitoring strategy for ongoing monitoring of organizationally-defined metrics in accordance with the continuous monitoring strategy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004483">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement continuous monitoring programs that include ongoing monitoring of organizationally-defined metrics in accordance with the continuous monitoring strategy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004484">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide continuous monitoring strategy for correlation and analysis of information generated by control assessments and monitoring.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004485">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement continuous monitoring programs that include correlation and analysis of information generated by control assessments and monitoring.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004486">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide continuous monitoring strategy for response actions to address results of the analysis of control assessment and monitoring information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-004487">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement continuous monitoring programs that include response actions to address results of the analysis of control assessment and monitoring information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-004488">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide continuous monitoring strategy for reporting the security status of organizational systems to organization-defined personnel or roles on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-004489">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop an organization-wide continuous monitoring strategy for reporting the privacy status of organizational systems to organization-defined personnel or roles on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-004490">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement continuous monitoring programs that include reporting the security status of organizational systems to organization-defined personnel or roles on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-004491">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement continuous monitoring programs that include reporting the privacy status of organizational systems to organization-defined personnel or roles on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-004492">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles for whom to report the security status of organizational systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-004493">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles for whom to report the privacy status of organizational systems.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-004494">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of reporting the security status of organizational systems to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-004495">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency of reporting the privacy status of organizational systems to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-31 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-004496">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Analyze organization-defined systems or system components supporting mission essential services or functions to ensure that the information resources are being used consistent with their intended purpose.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-32" />
      </references>
    </cci_item>
    <cci_item id="CCI-004497">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components that are used to analyze mission essential services or functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PM-32" />
      </references>
    </cci_item>
    <cci_item id="CCI-004498">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level personnel security policy that is consistent with applicable laws, Executive Orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004499">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the personnel security policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004500">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the personnel security policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004501">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official who will manage the personnel security policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004502">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage development and documentation of the personnel security procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004503">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the personnel security procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004504">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official who will manage the personnel security procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004505">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current personnel security policy following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004506">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current personnel security policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004507">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current personnel security procedures following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004508">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current personnel security procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004509">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that individuals accessing a system processing, storing, or transmitting organization-defined information types meet organization-defined citizenship requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004510">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information types that meet the organization-defined citizenship requirement.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004511">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the citizenship requirements for individuals accessing a system, storing, or transmitting organization-defined information types.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004512">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for notifying organization-defined personnel or roles of individual termination actions; and/or disable access to system resources.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004513">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that individuals requiring access to organizational information sign appropriate access agreements prior to being granted access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-6 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004514">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that individuals requiring access to organizational systems sign appropriate access agreements prior to being granted access.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-6 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004515">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that individuals requiring access to organizational information re-sign access agreements to maintain access to organizational information systems when access agreements have been updated or in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-6 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004516">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify that individuals requiring access to organizational systems re-sign access agreements to maintain access to organizational information systems when access agreements have been updated or in accordance with organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-6 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004517">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for individuals requiring access to organizational information to re-sign access agreements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-6 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004518">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for individuals requiring access to organizational systems to re-sign access agreements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-6 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004519">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require external providers to comply with personnel security policies established by the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004520">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require external providers to comply with personnel security procedures established by the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004521">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ a formal sanctions process for individuals failing to comply with established information security policies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004522">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ a formal sanctions process for individuals failing to comply with established information security procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004523">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Incorporate security roles and responsibilities into organizational position descriptions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-004524">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Incorporate privacy roles and responsibilities into organizational position descriptions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PS-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-004525">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document organization-level; mission/business process-level; and/or system level personally identifiable information processing and transparency policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-1 a 1 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004526">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate organization-level; mission/business process-level; and/or system level personally identifiable information processing and transparency policy to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004527">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to whom the organization-level; mission/business process-level; and/or system level personally identifiable information processing and transparency policy is to be disseminated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-1 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004528">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document organization-level; mission/business process-level; and/or system level personally identifiable information processing and transparency policy that is consistent with applicable laws, executive orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004529">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document procedures to facilitate the implementation of the personally identifiable information processing and transparency policy and the associated personally identifiable information processing and transparency controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004530">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the personally identifiable information processing and transparency policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004531">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the personally identifiable information processing and transparency procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004532">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official designated to manage the development, documentation, and dissemination of the personally identifiable information processing and transparency policy and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004533">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current personally identifiable information processing and transparency policy on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004534">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current personally identifiable information processing and transparency policy following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004535">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current personally identifiable processing and transparency policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004536">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current personally identifiable information processing and transparency procedures on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004537">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current personally identifiable information processing and transparency procedures following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004538">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current personally identifiable processing and transparency procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004539">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Determine and document the organization-defined authority that permits the organization-defined processing of personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004540">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the authority who will permit the organization-defined processing of personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004541">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the processing of the personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004542">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Restrict the organization-defined processing of personally identifiable information to only that which is authorized.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004543">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the processing of the personally identifiable information to only that which is authorized.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004544">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Attach data tags containing organization-defined authorized processing to organization-defined elements of personally identifiable information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004545">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the authorized processing which will attach data tags to organization-defined elements of personally identifiable information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004546">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the elements of personally identifiable information containing organization-defined authorized processing.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004547">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage enforcement of the authorized processing of personally identifiable information using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004548">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for managing enforcement of the authorized processing of personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004549">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify and document the organization-defined purpose(s) for processing personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004550">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the purpose(s) of identifying and documenting personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004551">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Describe the purpose(s) in the public privacy notices and policies of the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004552">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Restrict the organization-defined processing of personally identifiable information to only that which is compatible with the identified purpose(s).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004553">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the processing of personally identifiable information to only that which is compatible with the identified purpose(s).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004554">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor changes in processing personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-3 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004555">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined mechanisms to ensure that any changes are made in accordance with organization-defined requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-3 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004556">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the mechanisms for ensuring any changes are made in accordance with organization-defined requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-3 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004557">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the requirements for implementing organization-defined mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-3 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004558">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Attach data tags containing organization-defined processing purposes to organization-defined elements of personally identifiable information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004559">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the elements of personally identifiable information containing organization-defined processing purposes.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004560">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Track processing purposes of personally identifiable information using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004561">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined tools or mechanisms for individuals to consent to the processing of their personally identifiable information prior to its collection that facilitate individuals' informed decision-making.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-004562">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the tools or mechanisms for individuals to consent to the processing of their personally identifiable information prior to its collection that facilitate individuals' informed decision-making.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-004563">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide organization-defined mechanisms to allow individuals to tailor processing permissions to selected elements of personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004564">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the mechanisms for allowing individuals to tailor processing permissions to selected elements of personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004565">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Present organization-defined consent mechanisms to individuals at an organization-defined frequency and in conjunction with organization-defined personally identifiable information processing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004566">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for presenting organization-defined consent mechanisms to individuals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004567">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the consent mechanisms needed by individuals on an organization-defined frequency, with organization-defined personally identifiable information processing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004568">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personally identifiable information processing needed for presenting organization-defined consent mechanisms to individuals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004569">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined tools or mechanisms for individuals to revoke consent to the processing of their personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004570">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the tools or mechanisms for individuals to revoke consent to the processing of their personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004571">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide notice to individuals about the processing of personally identifiable information that is available to individuals upon first interacting with an organization, and subsequently at an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004572">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for providing notice to individuals about the processing of personally identifiable information that is available to individuals upon first interacting with an organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-5 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004573">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide notice to individuals about the processing of personally identifiable information is clear and easy-to-understand, expressing information about personally identifiable information processing in plain language.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004574">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide notice to individuals about the processing of personally identifiable information that identifies the authority that authorizes the processing of personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-5 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004575">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide notice to individuals about the processing of personally identifiable information that identifies the purposes for which personally identifiable information is to be processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-5 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004576">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide notice to individuals about the processing of personally identifiable information that includes organization-defined information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-5 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-004577">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information that includes providing notice to individuals about the processing of personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-5 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-004578">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Present notice of personally identifiable information processing to individuals at a time and location where the individual provides personally identifiable information or in conjunction with a data action or organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004579">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for presenting notice of personally identifiable information processing to individuals at a time and location where the individual provides personally identifiable information or in conjunction with a data action.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004580">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include Privacy Act statements on forms that collect information that will be maintained in a Privacy Act system of records, or provide Privacy Act statements on separate forms that can be retained by individuals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004581">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For systems that process information that will be maintained in a Privacy Act system of records: draft system of records notices in accordance with OMB guidance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004582">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For systems that process information that will be maintained in a Privacy Act system of records: submit new and significantly modified system of records notices to the OMB and appropriate committees for advance review.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004583">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For systems that process information that will be maintained in a Privacy Act system of records: publish system of records notices in the Federal Register.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004584">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For systems that process information that will be maintained in a Privacy Act system of records: keep system of records notices accurate, up-to-date, and scoped in accordance with policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-6 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004585">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review all routine uses published in the system of records notice at an organization-defined frequency to ensure continued accuracy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004586">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for reviewing all routine uses in published in the system of records notice.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004587">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review all routine uses published in the system of records notice at an organization-defined frequency to ensure that routine uses continue to be compatible with the purpose for which the information was collected.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004588">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review all Privacy Act exemptions claimed for the system of records at organization-defined frequency to ensure they remain appropriate and necessary with law.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004589">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review all Privacy Act exemptions claimed for the system of records at organization-defined frequency to ensure they have been promulgated as regulations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004590">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review all Privacy Act exemptions claimed for the system of records at organization-defined frequency to ensure that they are accurately described in the system of records notice.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004591">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for reviewing all Privacy Act exemptions claimed for the system of records.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004592">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Apply organization-defined processing conditions for specific categories of personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-004593">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the processing conditions for applying specific categories of personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-004594">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When a system processes Social Security numbers: eliminate unnecessary collection, maintenance, and use of Social Security numbers, and explore alternatives to their use as a personal identifier.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-7 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004595">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When a system processes Social Security numbers: do not deny any individuals any right, benefit, or privilege provided by law because of such individuals' refusal to disclose his or her Social Security number.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-7 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004596">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When a system processes Social Security numbers: inform any individual who is asked to disclose his or Social Security number whether that disclosure is mandatory or voluntary, by what statutory or other authority such number is solicited, and what uses will be made of it.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-7 (1) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004597">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit the processing of information describing how any individual exercises rights guaranteed by the First Amendment unless expressly authorized by statue or by the individual or unless pertinent to and within the scope of an authorized law enforcement activity.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-7 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004598">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When a system or organization processes information for the purpose of conducting a matching program: obtain approval from the Data Integrity Board to conduct the matching program.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004599">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When a system or organization processes information for the purpose of conducting a matching program: develop and enter into a computer matching agreement.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004600">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When a system or organization processes information for the purpose of conducting a matching program: publish a matching notice in the Federal Register.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-8 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004601">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When a system or organization processes information for the purpose of conducting a matching program: independently verify the information produced by the matching program before taking adverse action against an individual, if required.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-8 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004602">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>When a system or organization processes information for the purpose of conducting a matching program: provide individuals with notice and an opportunity to contest the findings before taking adverse action against an individual.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="PT-8 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-004603">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; system-level risk assessment policy that is consistent with applicable laws, Executive Orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004604">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-level; mission/business process-level; system-level risk assessment policy that is consistent with applicable laws, Executive Orders, directives, regulations, policies, standards, and guidelines, to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004605">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the risk assessment policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004606">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the risk assessment policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004607">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage development and documentation of the risk assessment procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004608">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage dissemination of the risk assessment procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004609">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official designated to manage the development, documentation, and dissemination of the risk assessment policy and procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004610">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current risk assessment policy following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004611">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current risk assessment policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004612">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current risk assessment procedures following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004613">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current risk assessment procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004614">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Categorize the system and information it processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004615">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Categorize the system and information it stores.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004616">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Categorize the system and information it transmits.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004617">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct a impact-level categorization of organizational systems to obtain additional granularity on system impact levels.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004618">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct a risk assessment, including identifying threats to the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004619">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct a risk assessment, including identifying vulnerabilities in the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004620">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct a risk assessment, including determining the likelihood and impact of adverse effects on individuals arising from the processing of personally-identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 a 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-004621">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Integrate risk assessment results from the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004622">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Integrate risk management decisions from the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004623">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Integrate mission or business process perspectives with system-level risk assessments.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004624">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Assess supply chain risks associated with organization-defined systems, system components, and system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004625">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems, system-components, and system services for assessing supply chain risks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004626">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update the supply chain risk assessment on an organization-defined frequency when there are significant changes to the relevant supply chain, or when changes to the system, environments of operation, or other conditions may necessitate a change in the supply chain.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004627">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for updating the supply chain assessment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004628">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use all-source intelligence to assist in the analysis of risk.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004629">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Determine the current cyber threat environment on an ongoing basis using organization-defined means.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004630">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the means for determining the current threat environment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004631">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined advanced automation and analytics capabilities to predict and identify risks to organization-defined systems or system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004632">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the advanced automation and analytics capabilities for predicting and identifying risks to organization-defined systems or system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004633">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components for employing advanced automation and analytics capabilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-3 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004634">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ vulnerability monitoring tools and techniques that facilitate interoperability among tools and automate parts of the vulnerability management process by using standards for: formatting checklists and test procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 b 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004635">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ vulnerability monitoring tools and techniques that facilitate interoperability among tools and automate parts of the vulnerability management process by using standards for: measuring vulnerability impact.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 b 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-004636">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ vulnerability monitoring tools that include the capability to readily update the vulnerabilities to be scanned.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-004637">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for comparing the results of multiple vulnerability scans.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004638">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system in which will be identified for determining if a vulnerability has been exploited.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004639">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period for reviewing historic audit logs to determine if a vulnerability identified has been exploited.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004640">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish a public reporting channel for receiving reports of vulnerabilities in organizational systems and system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-5 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004641">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Respond to findings from security assessments.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-004642">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Respond to findings from privacy assessments.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-004643">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Respond to findings from monitoring.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-004644">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Respond to findings from audits in accordance with organizational risk tolerance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-004645">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct privacy impact assessments for systems, programs, or other activities before developing or procuring information technology that processes personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-8 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004646">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct privacy impact assessments for systems, programs, or other activities before initiating a new collection of personally identifiable information that will be processes using information technology.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-8 b 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004647">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct privacy impact assessments for systems, programs, or other activities before initiating a new collection of personally identifiable information that includes personally identifiable information permitting the physical or virtual (online) contacting of a specific individual, if identical questions have been posed to, or identical reporting requirements imposed on, ten or more persons, other than agencies, instrumentalities, or employees of the Federal Government.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-8 b 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004648">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify critical system components and functions by performing a criticality analysis for organization-defined systems, system components, or system services at organization-defined decision points in the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-004649">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system, system components, or system services to perform a criticality analysis for identifying critical system components and functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-004650">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the decision points in the system development life cycle at which organization-defined system, system components, or system services to perform a criticality analysis for identifying critical system components and functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-004651">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish and maintain a cyber threat hunting capability to search for indicators of compromise in organizational systems.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-10 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004652">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish and maintain a cyber threat hunting capability to detect, track, and disrupt threats that evade existing controls.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-10 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004653">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ the threat hunting capability on an organization-defined frequency.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-10 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004654">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for employing the threat hunting capability.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="RA-10 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004655">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level system and services acquisition policy that is consistent with applicable laws, Executive Orders, directives, regulations, polices, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004656">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage development and documentation of the system and services acquisition policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004657">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage dissemination of the system and services acquisition policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004658">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official designated to manage development and documentation of the system and services acquisition policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004659">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the system and services acquisition procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004660">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the system and services acquisition procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004661">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official designated to manage the system and services acquisition procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004662">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current system and services acquisition policy following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004663">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current system and services acquisition policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004664">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current system and services acquisition procedures following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004665">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current system and services acquisition procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004666">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Determine the high-level information privacy requirements for the system or system service in mission and business process planning.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004667">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish a discrete line item for information privacy in organizational programming documentation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004668">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish a discrete line item for information privacy in organizational budgeting documentation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004669">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Acquire the system using an organization-defined system development life cycle that incorporates information security considerations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004670">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Acquire the system using an organization-defined system development life cycle that incorporates information privacy considerations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004671">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop the system using an organization-defined system development life cycle that incorporates information security considerations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004672">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop the system using an organization-defined system development life cycle that incorporates information privacy considerations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004673">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manage the system using an organization-defined system development life cycle that incorporates information privacy considerations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004674">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a system development life cycle that is used to develop the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004675">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a system development life cycle that is used to acquire the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004676">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Define and document information system privacy roles and responsibilities throughout the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004677">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify individuals having information system privacy roles and responsibilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004678">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Integrate the organizational information privacy risk management process into system development life cycle activities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004679">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect system preproduction environments commensurate with risk throughout the system development life cycle for the system, system component, or system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004680">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Approve the use of live data in preproduction environments for the system, system component, or system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004681">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document the use of live data in preproduction environments for the system, system component, or system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004682">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Control the use of live data in preproduction environments for the system, system component, or system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004683">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect preproduction environments for the system, system component, or system service at the same impact or classification level as any live data in use within the preproduction environments.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004684">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Plan for a technology refresh schedule to support the system throughout the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004685">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement technology refresh schedule to support the system throughout the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004686">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the organization-defined contract language for including the requirements, descriptions, and criteria in the acquisition contract for the system, system component, or system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-004687">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the privacy functional requirements, explicitly or by reference, using standardized contract language; and/or organization-defined contract language in the acquisition contract for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004688">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the privacy assurance requirements, explicitly or by reference, using standardized contract language; and/or organization-defined contract language in the acquisition contract for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004689">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the controls needed to satisfy security requirements, explicitly or by reference, using standardized contract language; and/or organization-defined contract language in the acquisition contract for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004690">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the controls needed to satisfy privacy requirements, explicitly or by reference, using standardized contract language; and/or organization-defined contract language in the acquisition contract for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004691">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the privacy documentation requirements, explicitly or by reference, using standardized contract language; and/or organization-defined contract language in the acquisition contract for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 e" />
      </references>
    </cci_item>
    <cci_item id="CCI-004692">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the requirements for protecting security documentation, explicitly or by reference, using standardized contract language; and/or organization-defined contract language in the acquisition contract for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-004693">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the requirements for protecting privacy documentation, explicitly or by reference, using standardized contract language; and/or organization-defined contract language in the acquisition contract for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 f" />
      </references>
    </cci_item>
    <cci_item id="CCI-004694">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the allocation of responsibility or identification of parties responsible for information security, explicitly or by reference, using standardized contract language; and/or organization-defined contract language in the acquisition contract for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 h" />
      </references>
    </cci_item>
    <cci_item id="CCI-004695">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the allocation of responsibility or identification of parties responsible for information privacy, explicitly or by reference, using standardized contract language; and/or organization-defined contract language in the acquisition contract for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 h" />
      </references>
    </cci_item>
    <cci_item id="CCI-004696">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include the allocation of responsibility or identification of parties responsible for supply chain risk management, explicitly or by reference, using standardized contract language; and/or organization-defined contract language in the acquisition contract for the information system, system component, or information system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 h" />
      </references>
    </cci_item>
    <cci_item id="CCI-004697">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to demonstrate the use of a system development life cycle process that includes organization-defined systems engineering methods.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004698">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems engineering methods for demonstrating the use of a system development life cycle process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004699">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to demonstrate the use of a system development life cycle process that includes organization-defined system security engineering methods and/or privacy engineering methods.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004700">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system security engineering methods and/or privacy engineering methods for demonstrating the use of a system development life cycle process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004701">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to demonstrate the use of a system development life cycle process that includes organization-defined software development methods; testing; evaluation, assessment, verification, and validation methods, and quality control processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (3) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004702">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the software development methods; testing; evaluation, assessment, verification, and validation methods, and quality control processes for demonstrating the use of a system development life cycle process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (3) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004703">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include organization-defined Privacy Act requirements in the acquisition contract for the operation of a system of records on behalf of an organization to accomplish an organizational mission or function.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004704">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the Privacy Act requirements to include in the acquisition contract.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004705">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include organizational data ownership requirements in the acquisition contract.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (12) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004706">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require all data to be removed from the contractor's system and returned to the organization within an organization-defined time frame.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (12) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004707">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time frame for returning the data removed from the contractor's system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-4 (12) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004708">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obtain or develop administrator documentation for the system, system component, or system services that describes effective use and maintenance of privacy functions and mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-5 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004709">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obtain or develop user documentation for the system, system component, or system service that describes user-accessible privacy functions and mechanisms and how to effectively use those functions and mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-5 b 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004710">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obtain or develop user documentation for the system, system component, or system service that describes methods for user interaction which enables individuals to protect individual privacy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-5 b 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004711">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Obtain or develop user documentation for the system, system component, or system service that describes user responsibilities in maintaining the privacy of individuals.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-5 b 3" />
      </references>
    </cci_item>
    <cci_item id="CCI-004712">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems security and privacy engineering principles applied to the specification of the system and system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-004713">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems security engineering principles applied to the design of the system and system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-004714">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems security engineering principles applied to the development of the system and system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-004715">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems security engineering principles applied to the implementation of the system and system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-004716">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems security engineering principles applied to the modification of the system and system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-004717">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of clear abstractions.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004718">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of least common mechanism in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004719">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of least common mechanism.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004720">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principles of modularity and layering in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004721">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principles of modularity and layering.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004722">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of partially ordered dependencies in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004723">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of partially ordered dependencies.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004724">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of efficiently mediated access in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004725">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of efficiently mediated access.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004726">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of minimized sharing in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004727">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of minimized sharing.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004728">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of reduced complexity in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004729">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of reduced complexity.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004730">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of secure evolvability in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004731">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of secure evolvability.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004732">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of trusted components in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004733">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of trusted components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004734">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of hierarchical trust in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004735">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of hierarchical trust.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004736">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of inverse modification threshold in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004737">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of inverse modification threshold.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004738">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of hierarchical protection in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004739">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of hierarchical protection.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004740">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of minimized security elements in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004741">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of minimized security elements.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (13)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004742">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of least privilege in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (14)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004743">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of least privilege.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (14)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004744">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of predicate permission in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (15)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004745">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of predicate permission.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (15)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004746">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of self-reliant trustworthiness in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (16)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004747">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of self-reliant trustworthiness.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (16)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004748">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of secure distributed composition in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (17)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004749">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of secure distributed composition.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (17)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004750">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of trusted communication channels in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (18)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004751">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of trusted communication channels.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (18)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004752">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of continuous protection in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (19)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004753">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of continuous protection.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (19)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004754">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of secure metadata management in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (20)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004755">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of secure metadata management.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (20)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004756">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of self-analysis in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (21)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004757">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of self-analysis.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (21)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004758">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of accountability and traceability in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (22)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004759">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of accountability and traceability.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (22)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004760">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of secure defaults in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (23)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004761">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of secure defaults.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (23)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004762">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of secure failure and recovery in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (24)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004763">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of secure failure and recovery.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (24)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004764">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of economic security in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (25)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004765">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of economic security.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (25)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004766">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of performance security in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (26)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004767">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of performance security.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (26)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004768">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of human factored security in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (27)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004769">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of human factored security.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (27)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004770">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of acceptable security in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (28)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004771">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of acceptable security.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (28)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004772">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of repeatable and documented procedures in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (29)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004773">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of repeatable and documented procedures.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (29)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004774">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of procedural rigor in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (30)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004775">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of procedural rigor.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (30)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004776">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of secure system modification in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (31)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004777">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of secure system modification.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (31)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004778">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the security design principle of sufficient documentation in organization-defined systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (32)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004779">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components which will implement the security design principle of sufficient documentation.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (32)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004780">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement the privacy principle of minimization using organization-defined processes.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (33)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004781">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the processes for implementing the privacy principle of minimization.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-8 (33)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004782">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that providers of external system services comply with organizational privacy requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004783">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require that providers of external system services employ organization-defined controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004784">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls for complying with organizational security and privacy requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004785">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Define and document organizational oversight with regard to external system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004786">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Define and document user roles and responsibilities with regard to external system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004787">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish trust relationships with external service providers based on organization-defined privacy requirements, properties, factors, or conditions defining acceptable trust relationships.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004788">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document trust relationships with external service providers based on organization-defined privacy requirements, properties, factors, or conditions defining acceptable trust relationships.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004789">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain trust relationships with external service providers based on organization-defined privacy requirements, properties, factors, or conditions defining acceptable trust relationships.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004790">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines privacy requirements, properties, factors, or conditions defining acceptable trust relationships with external service providers.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004791">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain exclusive control of cryptographic keys for encrypted material stored or transmitted through an external system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004792">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide the capability to check the integrity of organizational information while it resides in the external system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004793">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Restrict the geographic location of information processing and data storage to facilities located within the legal jurisdictional boundary of the United States.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-9 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004794">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to document the potential privacy impacts of approved changes to the system, component, or service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004795">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require organization-defined security and privacy representatives to be included in the organization-defined configuration change management and control process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004796">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security and privacy representatives to be included the organization-defined configuration change management and control process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004797">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the configuration change management and control process required for the organization-defined security and privacy representatives.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-10 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004798">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service, at all post-design phases of the system development life cycle, to develop a plan for ongoing security control assessment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004799">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to implement a plan for ongoing privacy control assessment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004800">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency that the unit, integration, system, and/or regression testing/evaluation is performed at an organization-defined depth and coverage.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004801">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use the following contextual information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004802">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information concerning impact, environment of operations, known or assumed threats, and acceptable risk levels.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004803">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ the following tools and methods.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004804">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the tools and methods to be employed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004805">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct the modeling and analyses as the following level of rigor.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (2) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004806">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the breadth and depth of modeling and analyses the level of rigor will be conducted.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (2) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004807">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Produces evidence that meets the following acceptance criteria.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (2) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004808">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the acceptance criteria that meets the requirement for producing evidence.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (2) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004809">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require an independent agent satisfying organization-defined independence criteria to verify the correct implementation of the developer privacy assessment plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004810">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require an independent agent satisfying organization-defined independence criteria to verify the evidence produced during privacy testing and evaluation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004811">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the independence criteria the independent agent must satisfy prior to verifying the correct implementation of the developer privacy assessment plan and the evidence produced during privacy testing and evaluation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004812">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to perform penetration testing at an organization-defined breadth and depth of testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (5) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004813">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to perform penetration testing under organization-defined constraints.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (5) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004814">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to employ interactive application security testing tools to identify flaws.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004815">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to employ interactive application security testing tools to document the results.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-11 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004816">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to follow a documented development process that explicitly addresses privacy requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004817">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review the development process in accordance with organization-defined frequency to determine if the development process selected and employed can satisfy organization-defined privacy requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004818">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review the development standards in accordance with organization-defined frequency to determine if the development standards selected and employed can satisfy organization-defined privacy requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004819">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review the development tools in accordance with organization-defined frequency to determine if the development tools selected and employed can satisfy organization-defined privacy requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004820">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review the development tool options/configurations in accordance with organization-defined frequency to determine if the development tool options and tool configurations selected and employed can satisfy organization-defined privacy requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004821">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency on which to review the development process, standards, tools, and tool options/configurations to determine if the process, standards, tools, and tool options and tool configurations selected and employed can satisfy organization-defined privacy requirements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004822">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the privacy requirements that must be satisfied by conducting a review of the development process, standards, tools, and tool options and tool configurations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004823">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to select a privacy tracking tool for use during the development process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004824">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to employ a privacy tracking tool for use during the development process.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004825">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to perform a criticality analysis at the organization-defined decision points in the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (3) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004826">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to perform a criticality analysis at an organization-defined breadth/depth of criticality analysis.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (3) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004827">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for performing an automated vulnerability analysis using organization-defined tools.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (7) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004828">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for determining the exploitation potential for discovered vulnerabilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (7) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004829">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for determining potential risk mitigations for delivered vulnerabilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (7) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004830">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for delivering the outputs of the tools and results of the vulnerability analysis to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (7) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004831">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to implement an incident response plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004832">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to test an incident response plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004833">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system or system component to archive the system or component to be released or delivered together with the corresponding evidence supporting the final privacy review.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (11)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004834">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system or system component to minimize the use of personally identifiable information in development and test environments.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-15 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004835">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to provide organization-defined training on the correct use and operation of the implemented privacy functions, controls, and/or mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-004836">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the training the developer of the system, system component, or information system service is required to provide on the correct use and operation of the implemented privacy functions, controls, and/or mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-004837">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to produce a privacy architecture.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17" />
      </references>
    </cci_item>
    <cci_item id="CCI-004838">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to produce a privacy architecture that is consistent with and supportive of the organization's privacy architecture which is established within and is an integrated part of the organization's enterprise architecture.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004839">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to produce a privacy architecture that accurately and completely describes the required privacy functionality.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004840">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to produce a privacy architecture that accurately and completely describes the allocation of privacy controls among physical and logical components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004841">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to produce a privacy architecture that expresses how individual privacy functions, mechanisms, and services work together to provide required privacy capabilities and a unified approach to protection.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004842">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system to produce, as an integral part of the development process, a formal policy model describing the organization-defined elements of organizational privacy policy to be enforced.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004843">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the elements of organizational privacy policy to be described in the formal policy model for enforcement on the system, system component, or system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004844">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Require the developer of the system, system component, or system service to prove that the formal policy model is internally consistent and sufficient to enforce the defined elements of the organizational privacy policy when implemented.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004845">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Design organization-defined critical systems or system components with coordinated behavior to implement organization-defined capabilities, by system or component.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004846">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the critical systems or system components for implementing organization-defined capabilities, by system or component.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004847">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the capabilities, by system or component, for designing organization-defined critical systems or system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004848">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use different designs for organization-defined critical systems or system components to satisfy a common set of requirements or to provide equivalent functionality.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004849">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the critical systems or system components for satisfying a common set of requirements or to provide equivalent functionality.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-17 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004850">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ design; modification; augmentation; and/or reconfiguration on organization-defined systems or system components supporting mission essential services or functions to increase the trustworthiness in those systems or components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-23" />
      </references>
    </cci_item>
    <cci_item id="CCI-004851">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components for supporting mission essential services or functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SA-23" />
      </references>
    </cci_item>
    <cci_item id="CCI-004852">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level system and communications protection policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 a 1 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004853">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system-level a system and communications protection policy that is consistent with applicable laws, Executive Orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004854">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document system and communications protection procedures to facilitate the implementation of the system and communications protection policy and associated system and communications protection controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004855">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the system and communications protection policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004856">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the system and communications protection procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004857">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the system and communications protection policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004858">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the system and communications protection procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004859">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official to manage the development, documentation, and dissemination of the system and communications protection policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004860">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official to manage the development, documentation, and dissemination of the system and communications protection procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004861">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current system and communications protection policy following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004862">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current system and communications protection policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004863">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current system and communications protection procedures following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004864">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current system and communications protection procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004865">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Store state information from applications and software separately.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004866">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined controls by type of denial-of-service to achieve the denial-of-service objective.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004867">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls by type of denial-of-service event by employing the controls to achieve the denial-of-service objective.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-5 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004868">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Connect to external networks or systems only through managed interfaces consisting of boundary protection devices arranged in accordance with an organizational privacy architecture.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004869">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent unauthorized exchange of control plane traffic with external networks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (4) (f)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004870">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Publish information to enable remote networks to detect unauthorized control plane traffic from internal networks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (4) (g)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004871">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Filter unauthorized control plane traffic from external networks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (4) (h)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004872">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems that will deny network communications traffic by default and allow network communications traffic by exception.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004873">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the safeguards to prevent split tunneling for remote devices connecting to organizational systems.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004874">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct exfiltration tests at an organization-defined frequency.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (10) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004875">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency to conduct exfiltration tests.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (10) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004876">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For systems that process personally identifiable information, apply organization-defined processing rules to data elements of personally identifiable information.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (24) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004877">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines processing rules to be applied to data elements of personally identifiable information.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (24) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004878">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For systems that process personally identifiable information, monitor for permitted processing at the external boundary of the system and at key internal boundaries within the system.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (24) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004879">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For systems that process personally identifiable information, document each processing exception.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (24) (c)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004880">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>For systems that process personally identifiable information, review and remove exceptions that are no longer supported.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (24) (d)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004881">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit the direct connection of organization-defined unclassified national security system to an external network without the use of organization-defined boundary protection device.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (25)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004882">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the unclassified national security system that is prohibited from connecting to an external network without the use of organization-defined boundary protection device.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (25)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004883">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the boundary protection device that prohibits the direct connection of organization-defined unclassified national security system to an external system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (25)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004884">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit the direct connection of a classified national security system to an external network without the use of organization-defined boundary protection device.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (26)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004885">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the boundary protection device that prohibits the direct connection of a classified national security system to an external system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (26)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004886">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit the direct connection of organization-defined unclassified non-national security system to an external network without the use of organization-defined boundary protection device.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (27)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004887">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the unclassified non-national security system that is prohibited from connecting to an external network without the use of organization-defined boundary protection device.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (27)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004888">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the boundary protection device that prohibits the direct connection of organization-defined unclassified non-national security system to an external system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (27)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004889">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit the direct connection of organization-defined system to a public network.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (28)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004890">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system that prohibits the direct connection to a public network.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (28)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004891">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement physically or logically separate subnetworks to isolate organization-defined critical system components and functions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (29)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004892">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the critical system components to implement physically or logically separate subnetworks.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-7 (29)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004893">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined protection distribution system to prevent unauthorized disclosure of information, and/or detect changes to information during transmission.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-8 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004894">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the protected distribution system for preventing unauthorized disclosure of information, and/or detect changes to information during transmission.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-8 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004895">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Permit users to invoke the trusted communications path for communications between the user and the organization-defined security functions, including at a minimum, authentication and re-authentication.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-11 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004896">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Initiates the trusted communications path for communications between the organization-defined security functions of the system and the user.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-11 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004897">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security functions to be initiated between the system and the user for trusted communications path for communications.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-11 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004898">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines requirements for certificates that are issued for producing, controlling, and distributing asymmetric cryptographic keys.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004899">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain physical control of cryptographic keys when store information is encrypted by external service providers.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-12 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004900">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Determine the organization-defined cryptographic uses.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-13 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004901">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Associate organization-defined privacy attributes with information exchanged between systems.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-004902">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Associate organization-defined privacy attributes with information exchanged between system components.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-004903">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the privacy attributes to associate with the information being exchanged between systems and between system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-16" />
      </references>
    </cci_item>
    <cci_item id="CCI-004904">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify the integrity of transmitted privacy attributes.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-16 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004905">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement anti-spoofing mechanisms to prevent adversaries from falsifying the security attributes indicating the successful application of the security process.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-16 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004906">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined mechanisms or techniques to bind security attributes to transmitted information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-16 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004907">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined mechanisms or techniques to bind privacy attributes to transmitted information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-16 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004908">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the mechanisms or techniques for binding security and privacy attributes to transmitted information.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-16 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004909">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Include only approved trust anchors in trust stores or certificate stores managed by the organization.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-17 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004910">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide protected storage for cryptographic keys with organization-defined safeguards and/or hardware protected key store.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-28 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004911">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the safeguards for providing protected storage for cryptographic keys.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-28 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004912">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Partition privileged functions into separate physical domains.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-32 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004913">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Takes organization-defined actions in response to identified faults, errors, or compromises.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-36 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004914">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines actions to take in response to identified faults, errors, or compromises.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-36 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004915">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Synchronize the organization-defined duplicate systems or system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-36 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004916">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the duplicate systems or system components to be synchronized.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-36 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004917">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines sensors to facilitate an individual's awareness that personally identifiable information is being collected.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-42 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004918">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines measures to facility an individual's awareness that personally identifiable information is being collected.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-42 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004919">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined measures to facilitate an individual's awareness that personally identifiable information is being collected by organization-defined sensors.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-42 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004920">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines sensors that are configured to minimize the collection of information about individuals that is not needed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-42 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004921">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined sensors that are configured to minimize the collection of information about individuals that is not needed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-42 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004922">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Synchronize system clocks within and between systems or system components.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-45" />
      </references>
    </cci_item>
    <cci_item id="CCI-004923">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Compare the internal system clocks on an organization-defined frequency with organization-defined authoritative time source.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-45 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004924">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for comparing the internal system clocks with organization-defined authoritative time source.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-45 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004925">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time source used for comparing the internal system clocks.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-45 (1) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004926">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Synchronize the internal system clocks to the authoritative time source when the time difference is greater than organization-defined time period.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-45 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004927">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the time period for synchronizing the internal system clocks to the authoritative time source.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-45 (1) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004928">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify a secondary authoritative time source that is in a different geographic region than the primary authoritative time source.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-45 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004929">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Synchronize the internal system clocks to the secondary authoritative time source if the primary authoritative time source is unavailable.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-45 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004930">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a policy enforcement mechanism physically or logically between the physical and/or network interfaces for the connecting security domains.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-46" />
      </references>
    </cci_item>
    <cci_item id="CCI-004931">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish organization-defined alternate communications paths for system operations organizational command and control.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-47" />
      </references>
    </cci_item>
    <cci_item id="CCI-004932">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Relocate organization-defined sensors and monitoring capabilities to organization-defined locations under organization-defined conditions or circumstances.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-48" />
      </references>
    </cci_item>
    <cci_item id="CCI-004933">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the sensors and monitoring capabilities to be relocated to organization-defined locations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-48" />
      </references>
    </cci_item>
    <cci_item id="CCI-004934">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the locations of which the organization-defined sensors and monitoring capabilities will be relocated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-48" />
      </references>
    </cci_item>
    <cci_item id="CCI-004935">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the conditions or circumstances of which the organization-defined sensors and monitoring capabilities are relocated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-48" />
      </references>
    </cci_item>
    <cci_item id="CCI-004936">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Dynamically relocate organization-defined sensors and monitoring capabilities to organization-defined locations under organization-defined conditions or circumstances.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-48 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004937">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the sensors and monitoring capabilities to be dynamically relocated to organization-defined locations.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-48 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004938">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the locations of which the organization-defined sensors and monitoring capabilities will be dynamically relocated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-48 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004939">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the conditions or circumstances of which the organization-defined sensors and monitoring capabilities are dynamically relocated.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-48 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004940">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement hardware-enforced separation and policy enforcement mechanisms between organization-defined security domains.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-49" />
      </references>
    </cci_item>
    <cci_item id="CCI-004941">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security domains for implementing hardware-enforced separation and policy enforcement mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-49" />
      </references>
    </cci_item>
    <cci_item id="CCI-004942">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement software-enforced separation and policy enforcement mechanisms between organization-defined security domains.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-50" />
      </references>
    </cci_item>
    <cci_item id="CCI-004943">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the security domains for implementing software-enforced separation and policy enforcement mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SC-50" />
      </references>
    </cci_item>
    <cci_item id="CCI-004944">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level; mission/business process-level; and/or system level system and information integrity policy that is consistent with applicable laws, Executive Orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004945">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the system and information integrity policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004946">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the system and information integrity policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004947">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the system and information integrity procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004948">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the system and information integrity procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004949">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official designated for managing the development, documentation, and dissemination of the system and information integrity policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004950">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the official designated for managing the development, documentation, and dissemination of the system and information integrity procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004951">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current system and information integrity policy following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004952">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current system and information integrity policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-004953">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current system and information integrity procedures following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004954">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current system and information integrity procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004955">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Determine if system components have applicable security-related software updates installed using organization-defined mechanisms on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004956">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Determine if system components have applicable security-related firmware updates installed using organization-defined mechanisms on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004957">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for installing security-relevant software updates using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004958">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines a frequency for installing security-relevant firmware updates using organization-defined automated mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004959">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for determining if system components have applicable security-related software updates installed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004960">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for determining if system components have applicable security-related firmware updates installed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004961">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ automated patch management tools to facilitate flaw remediation to the organization-defined system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004962">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components on which patch management tools to facilitate flaw remediation are employed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-2 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004963">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement signature based and/or non-signature based malicious code protection mechanisms at system entry and exit points to detect and eradicate malicious code.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004964">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Automatically update malicious code protection mechanisms as new releases are available in accordance with organizational configuration management policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004965">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Automatically update malicious code protection mechanisms as new releases are available in accordance with organizational configuration management procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004966">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Configure malicious code protection mechanisms to send alerts to organization-defined personnel in response to malicious code detection.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-3 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-004967">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Analyze detected events and anomalies.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004968">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ automated mechanisms to support near real-time analysis of events.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004969">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ automated mechanisms to integrate intrusion detection mechanisms into access control mechanisms.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004970">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ automated mechanisms to integrate intrusion detection mechanisms into flow control mechanisms.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004971">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Determine criteria for unusual or unauthorized activities or conditions for inbound communications traffic.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004972">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Determine criteria for unusual or unauthorized activities or conditions for outbound communications traffic.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (4) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004973">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the unusual or unauthorized activities or conditions that will be monitored for inbound communications traffic.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004974">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the unusual or unauthorized activities or conditions that will be monitored for outbound communications traffic.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004975">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Test intrusion monitoring mechanisms at an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004976">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for testing intrusion monitoring mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (9)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004977">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the encrypted communications traffic that is to be visible to organization-defined system monitoring mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004978">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system monitoring mechanisms that will have visibility into organization-defined encrypted communications traffic.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004979">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Make provisions so that organization-defined encrypted communications traffic is visible to organization-defined system monitoring mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (10)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004980">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to receive alerts when indications of inappropriate or unusual activities with security or privacy occur.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (12)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004981">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Correlate information from monitoring mechanisms employed throughout the system.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (16)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004982">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide visibility into network traffic at external and key internal system interfaces to optimize the effectiveness of monitoring devices.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-4 (25)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004983">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for broadcasting security alert and advisory information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004984">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the privacy functions that require verification of correct operation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004985">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Verify correct operation of organization-defined privacy functions.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-004986">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency at which it will verify correct operation of organization-defined privacy functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004987">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system transitional states when the system will verify correct operation of organization-defined privacy functions.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004988">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Perform verification of the correct operation of organization-defined privacy functions: when the system is in an organization-defined transitional state; upon command by a user with appropriate privileges; and/or on an organization-defined frequency.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004989">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Alert organization-defined personnel or roles of failed privacy verification tests.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004990">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles to be notified when privacy verification tests fail.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-004991">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines alternative action(s) to be taken when anomalies in the operation of organization-defined privacy functions are discovered.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004992">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Shut the system down, restart the system, and/or initiate organization-defined alternative action(s) when anomalies in the operation of the organization-defined privacy functions are discovered.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 d" />
      </references>
    </cci_item>
    <cci_item id="CCI-004993">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement automated mechanisms to support the management of distributed privacy function testing.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004994">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Report the results of privacy function verification to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004995">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles that are to receive reports on the results of privacy function verification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-6 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004996">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Take organization-defined actions when unauthorized changes to the software, firmware, and information are detected.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004997">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the actions to be taken when unauthorized changes to the software, firmware, and information are detected.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-004998">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement organization-defined controls for application self-protection at runtime.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (17)" />
      </references>
    </cci_item>
    <cci_item id="CCI-004999">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls to be implemented for runtime application self-protection.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-7 (17)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005000">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update spam protection mechanisms when new releases are available in accordance with organizational configuration management policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005001">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Update spam protection mechanisms when new releases are available in accordance with organizational configuration management procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-8 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005002">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for updating spam protection mechanisms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-8 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005003">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent untrusted data injections.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-10 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005004">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Limit personally identifiable information being processed in the information life cycle to the organization-defined elements of personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005005">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the elements of personally identifiable information being processed in the information life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-12 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005006">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use organization-defined techniques to minimize the use of personally identifiable information for research, testing, or training, in accordance with the privacy risk assessment.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-12 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005007">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the techniques for minimizing the use of personally identifiable information for research, testing, or training.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-12 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005008">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use organization-defined techniques to dispose of, destroy, or erase information following the retention period.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-12 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005009">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the percentage of the mean time to failure used to manually initiate transfer between active and standby system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-13 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005010">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the action to be taken when system failures are detected.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-13 (4) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005011">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Refresh organization-defined information on an organization-defined frequency, or generate organization-defined information on demand.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-14 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005012">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information to be refreshed on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-14 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005013">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency at which to refresh organization-defined information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-14 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005014">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information to be generated on demand.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-14 (2) (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005015">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Delete information when no longer needed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-14 (2) (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005016">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Refresh connections to the system on demand.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-14 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005017">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Terminate connections after completion of a request, or a period of non-use.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-14 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005018">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Check the accuracy, relevance, timeliness, and completeness of personally identifiable information across the information life cycle, on an organization-defined frequency.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-18 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-005019">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for checking the accuracy, relevance, timeliness, and completeness of personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-18 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-005020">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Correct or delete inaccurate or outdated personally identifiable information.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-18 b 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-005021">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Correct or delete personally identifiable information that is inaccurate or outdated, incorrectly determined regarding impact, or incorrectly de-identified using organization-defined mechanisms.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-18 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005022">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the automated mechanisms for identifying inaccurate or outdated, incorrectly determined regarding impact, or incorrectly de-identified personally identifiable information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-18 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005023">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ data tags to automate the correction or deletion of personally identifiable information across the information life cycle within organizational systems.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-18 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005024">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Collect personally identifiable information directly from the individual.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-18 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005025">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Correct or delete personally identifiable information upon request by individuals or their designated representatives.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-18 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005026">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Notify organization-defined recipients of personally identifiable information that the personally identifiable information has been corrected or deleted.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-18 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005027">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the recipients of personally identifiable information who are to be notified when the personally identifiable information is corrected or deleted.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-18 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005028">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Notify individuals that the personally identifiable information has been corrected or deleted.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-18 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005029">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Remove the following elements of personally identifiable information from datasets.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-19 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-005030">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the elements of personally identifiable information to be removed from datasets.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-19 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-005031">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Evaluate organization-defined frequency for effectiveness of de-identification.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-19 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005032">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for evaluating for effectiveness of de-identification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-19 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005033">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>De-identify the dataset upon collection by not collecting personally identifiable information.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-19 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005034">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prohibit archiving personally identifiable information elements if those elements in a dataset will not be needed after the dataset is archived.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-19 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005035">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Remove personally identifiable information elements from a dataset prior to its release if those elements in the dataset do not need to be part of the data release.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-19 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005036">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Remove, mask, encrypt, hash, or replace direct identifiers in a dataset.</definition>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-19 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005037">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Manipulate numerical data, contingency tables, and statistical findings so that no individual or organization is identifiable in the results of the analysis.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-19 (5)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005038">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Prevent disclosure of personally identifiable information by adding non-deterministic noise to the results of mathematical operations before the results are reported.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-19 (6)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005039">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Perform de-identification using validated algorithms and software that is validated to implement the algorithms.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-19 (7)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005040">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Perform a motivated intruder test on the de-identified dataset to determine if the identified data remains or if the de-identified data can be re-identified.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-19 (8)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005041">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Embed data or capabilities in the following systems or system components to determine if organizational data has been exfiltrated or improperly removed from the organization.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-20" />
      </references>
    </cci_item>
    <cci_item id="CCI-005042">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components used to determine if organizational data has been exfiltrated or improperly removed from the organization.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-20" />
      </references>
    </cci_item>
    <cci_item id="CCI-005043">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Refresh organization-defined information on an organization-defined frequency, or generate organization-defined information on demand.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-21" />
      </references>
    </cci_item>
    <cci_item id="CCI-005044">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information to be refreshed on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-21" />
      </references>
    </cci_item>
    <cci_item id="CCI-005045">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequencies for refreshing organization-defined information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-21" />
      </references>
    </cci_item>
    <cci_item id="CCI-005046">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Identify the following alternate sources of information for organization-defined essential functions and services.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-22 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-005047">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the alternative information sources for identifying organization-defined essential functions and services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-22 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-005048">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Use an alternate information source for the execution of essential functions or services on organization-defined systems or system components when the primary source of information is corrupted or unavailable.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-22 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005049">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components used as an alternate information source for the execution of essential functions or services when the primary source of information is corrupted or unavailable.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-22 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005050">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Based on organization-defined circumstances, fragment the following information.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-23 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-005051">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information for fragmentation.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-23 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-005052">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the circumstances for fragmenting organization-defined information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-23 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-005053">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Based on organization-defined circumstances, distribute the fragmented information across the following systems or system components.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-23 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005054">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems or system components used to distribute fragmented information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-23 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005055">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the circumstances for distributing fragmented information across organization-defined systems or system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SI-23 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005056">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Disseminate an organization-level, mission/business process-level, and/or system-level supply chain risk management policy to organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-1 a 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-005057">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document an organization-level, mission/business process-level, and/or system-level supply chain risk management policy that addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-1 a 1 (a)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005058">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document organization-level, mission/business process-level, and/or system-level supply chain risk management policy that is consistent with applicable laws, executive orders, directives, regulations, policies, standards, and guidelines.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-1 a 1 (b)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005059">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document procedures to facilitate the implementation of the supply chain risk management policy and the associated supply chain risk management controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-1 a 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-005060">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the supply chain risk management policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005061">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the development and documentation of the supply chain risk management procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005062">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the supply chain risk management policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005063">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Designate an organization-defined official to manage the dissemination of the supply chain risk management procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-1 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005064">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current supply chain risk management policy on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-005065">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for reviewing and updating the current supply chain risk management policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-005066">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current supply chain risk management policy following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-005067">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current supply chain risk management policy.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-1 c 1" />
      </references>
    </cci_item>
    <cci_item id="CCI-005068">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current supply chain risk management procedures on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-005069">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for reviewing and updating the current supply chain risk management procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-005070">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the current supply chain risk management procedures following organization-defined events.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-005071">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the events following reviewing and updating the current supply chain risk management procedures.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-1 c 2" />
      </references>
    </cci_item>
    <cci_item id="CCI-005072">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop a plan for managing supply chain risks associated with the research and development, design, manufacturing, acquisition, delivery, integration, operations and maintenance, and disposal of the following systems, system components, or system services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-005073">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems, system components, or system services that a plan for managing supply chain risks are developed.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-2 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-005074">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Review and update the supply chain risk management plan on an organization-defined frequency, or as required, to address threat, organizational or environmental changes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005075">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for reviewing and updating the supply chain risk management plan.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-2 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005076">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Protect the supply chain risk management plan from unauthorized disclosure and modification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-2 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-005077">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish a supply chain risk management team consisting of organization-defined personnel, roles, and responsibilities to lead and support the following SCRM activities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005078">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the supply chain risk management activities that will be led by a supply chain risk management team consisting of organization-defined personnel, roles, and responsibilities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005079">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel, roles, and responsibilities who lead and support organization-defined supply chain risk management activities.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-2 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005080">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish a process of processes to identify and address weaknesses or deficiencies in the supply chain elements of organization-defined system or system components in coordination with organization-defined supply chain personnel.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-005081">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system or system processes which establish a process or processes for identifying and addressing weaknesses or deficiencies in the supply chain elements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-005082">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the supply chain personnel who, in coordination, establish a process or processes for identifying and addressing weaknesses or deficiencies in the supply chain elements.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-005083">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish a process of processes to identify and address weaknesses or deficiencies in the processes of organization-defined system or system components in coordination with organization-defined supply chain personnel.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-005084">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system or system processes which establish a process or processes for identifying and addressing weaknesses or deficiencies in the supply chain processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-005085">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the supply chain personnel who, in coordination, establish a process or processes for identifying and addressing weaknesses or deficiencies in the supply chain processes.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-3 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-005086">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ the following controls to protect against supply chain risks to the system, system component, or system service.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005087">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Limit the harm or consequences from supply chain-related events.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005088">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the supply chain controls employed for protecting against supply chain risks to the system, system component, or system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-3 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005089">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document the selected and implemented supply chain processes and controls in security and privacy plans, supply chain risk management plan, or organization-defined document.</definition>
      <type>policy</type>
      <type>technical</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-005090">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the document which contains supply chain processes and controls.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-3 c" />
      </references>
    </cci_item>
    <cci_item id="CCI-005091">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ a diverse set of sources for the following system components and services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005092">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system or system components and services which employ a diverse set of sources.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-3 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005093">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ the following controls to limit harm from potential adversaries identifying and targeting the organizational supply chain.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005094">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls to be employed to limit harm from potential adversaries identifying and targeting the organizational supply chain.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-3 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005095">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Ensure that the controls included in the contracts of prime contractors are also included in the contracts of subcontractors.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-3 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005096">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Document valid provenance of the following systems, system components, and associated data.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-005097">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Monitor valid provenance of the following systems, system components, and associated data.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-005098">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain valid provenance of the following systems, system components, and associated data.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-005099">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems, system components, and associated data for documenting, monitoring, and maintaining valid provenance.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-4" />
      </references>
    </cci_item>
    <cci_item id="CCI-005100">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish and maintain unique identification of the following supply chain elements, processes, and personnel associated with the identified system and critical system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005101">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the supply chain elements, processes, and personnel associated with organization-defined systems and critical system components for establishing and maintaining unique identification.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-4 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005102">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish and maintain unique identification of the following systems and critical components for tracking through the supply chain.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005103">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the systems and critical system components for tracking through the supply chain.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-4 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005104">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ the following controls to validate that the system or system component received is genuine.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005105">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ the following controls to validate that the system or system component received has not been altered.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005106">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls for validating that the system or system component received is genuine.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005107">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls for validating that the system or system component received has not been altered.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-4 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005108">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organization-defined controls to ensure the integrity of the system and system components by validating the internal composition and provenance of critical or mission essential technologies, products, and services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-4 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005109">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls for ensuring the integrity of the system and system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-4 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005110">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Conduct organization-defined analysis to ensure the integrity of the system and system components by validating the internal composition and provenance of critical or mission essential technologies, products, and services.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-4 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005111">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the analysis for ensuring the integrity of the system and system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-4 (4)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005112">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ the following acquisition strategies, contract tools, and procurement methods to protect against, identify, and mitigate supply chain risks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-005113">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the acquisition strategies, contract tools, and procurement methods for protecting against, identifying, and mitigating supply chain risks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-5" />
      </references>
    </cci_item>
    <cci_item id="CCI-005114">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ the following controls to ensure an adequate supply of organization-defined critical system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005115">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the controls for ensuring an adequate supply of organization-defined critical system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005116">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the critical system components that the organization-defined controls ensure an adequate supply of.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-5 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005117">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Access the system, system component, or system service prior to selection, acceptance, modification, or update.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-5 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005118">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Access and review the supply chain-related risks associated with suppliers or contractors and the system, system component, or system service they provide on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-005119">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for assessing and reviewing the supply chain risks.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-6" />
      </references>
    </cci_item>
    <cci_item id="CCI-005120">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ organizational analysis, independent third-party analysis, organizational testing, and/or independent third-party testing of the following supply chain elements, processes, and actors associated with the system, system component, or system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005121">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the supply chain elements, processes, and actors for employing organizational analysis, independent third-party analysis, organizational testing, and/or independent third-party testing.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-6 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005122">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ the following Operations Security (OPSEC) controls to protect supply chain-related information for the system, system component, or system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-005123">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the Operations Security (OPSEC) controls that protect supply chain-related information for the system, system component, or system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-7" />
      </references>
    </cci_item>
    <cci_item id="CCI-005124">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Establish agreements and procedures with entities involved in the supply chain for the system, system component, or system service for the notification of supply chain compromises, results of assessments or audits, and/or organization-defined information.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-005125">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the information for establishing agreements and procedures with entities involved in the supply chain for the system, system component, or system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-8" />
      </references>
    </cci_item>
    <cci_item id="CCI-005126">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Implement a tamper protection program for the system, system component, or system service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-9" />
      </references>
    </cci_item>
    <cci_item id="CCI-005127">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Employ anti-tamper technologies, tool, and techniques throughout the system development life cycle.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-9 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005128">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Inspect the following systems or system components at random, at organization-defined frequency, and/or upon organization-defined indications of need for inspection to detect tampering.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-005129">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for inspecting systems or system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-005130">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the indications of need for inspection for detecting tampering.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-005131">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system or system components which will be inspected at random, at organization-defined frequency, and/or upon organization-defined indications of need for inspection to detect tampering.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-10" />
      </references>
    </cci_item>
    <cci_item id="CCI-005132">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document anti-counterfeit policy that include the means to detect and prevent counterfeit components from entering the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-11 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-005133">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Develop and document anti-counterfeit procedures that include the means to detect and prevent counterfeit components from entering the system.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-11 a" />
      </references>
    </cci_item>
    <cci_item id="CCI-005134">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Report counterfeit system components to source of counterfeit component, organization-defined external reporting organizations, and/or organization-defined personnel or roles.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-11 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005135">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the external reporting organizations who report counterfeit system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-11 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005136">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles who report counterfeit system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-11 b" />
      </references>
    </cci_item>
    <cci_item id="CCI-005137">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Train organization-defined personnel or roles to detect counterfeit system components including hardware, software, and firmware.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-11 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005138">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the personnel or roles who are trained to detect counterfeit system components (including hardware, software, and firmware).</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-11 (1)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005139">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain configuration control over the following system components awaiting service or repair.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-11 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005140">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Maintain configuration control over serviced or repaired components awaiting return to service.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-11 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005141">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the system components awaiting service or repair.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-11 (2)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005142">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Scan for counterfeit system components on an organization-defined frequency.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-11 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005143">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the frequency for which the counterfeit system components are scanned.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-11 (3)" />
      </references>
    </cci_item>
    <cci_item id="CCI-005144">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Dispose of organization-defined data, documentation, tools, or system components using the following techniques and methods.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-005145">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the data, documentation, tools, or system components which are to be disposed of using organization-defined techniques and methods.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-005146">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Defines the techniques or methods used to dispose of organization-defined data, documentation, tools, or system components.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="SR-12" />
      </references>
    </cci_item>
    <cci_item id="CCI-005147">
      <status>draft</status>
      <publishdate>2022-03-01</publishdate>
      <contributor>DISA</contributor>
      <definition>Provide basic privacy literacy training to system users (including managers, senior executives, and contractors) as part of initial training for new users.</definition>
      <type>policy</type>
      <references>
        <reference creator="NIST" title="NIST SP 800-53 Revision 5" version="5" location="NIST" index="AT-2 a 1" />
      </references>
    </cci_item>
  </cci_items>
</cci_list>`;
